import { gql } from 'urql';
import * as Urql from 'urql';
import { DocumentNode } from 'graphql';
import * as Operations from './graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AccessTokenInput = {
  externalRef: Scalars['String'];
};

export type AccessTokenResponse = {
  __typename?: 'AccessTokenResponse';
  applicationId?: Maybe<Scalars['String']>;
  citizenId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  externalRef?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type AddAmazonPayToCartInput = {
  basketId: Scalars['String'];
  orderReferenceId: Scalars['String'];
};

export type AddAmbassadorCardToCartInput = {
  basketId: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  pin: Scalars['String'];
};

export type AddCashOnDeliveryToCartInput = {
  basketId: Scalars['String'];
};

export type AddCouponToCartInput = {
  basketId: Scalars['String'];
  code: Scalars['String'];
};

export type AddCreditCardToCartInput = {
  basketId: Scalars['String'];
  card?: InputMaybe<PaymentCardInput>;
};

export type AddGiftCardInput = {
  basketId: Scalars['String'];
  cardNumber: Scalars['String'];
  pin: Scalars['String'];
};

export type AddGiftCardToCartInput = {
  amount: Scalars['Float'];
  basketId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  senderName: Scalars['String'];
};

export type AddItemToCartInput = {
  bonusItemId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  productCustomization?: InputMaybe<ProductCustomizationInput>;
  productId: Scalars['String'];
  productPersonalization?: InputMaybe<ProductPersonalizationInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type AddItemToWishListInput = {
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  swatch?: InputMaybe<Scalars['String']>;
};

export type AddItemsToCartInput = {
  basketId?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ItemToBeAddedToCart>>;
};

export type AddItemsToWishListInput = {
  items: Array<AddItemToWishListInput>;
};

export type AddPayPayToCartInput = {
  basketId: Scalars['String'];
};

export type AddPaymentPromotionInput = {
  basketId: Scalars['String'];
  paymentId: Scalars['String'];
};

export type AddStoreCreditsInput = {
  amount: Scalars['Float'];
  basketId: Scalars['String'];
};

export type AddStoreCreditsPayload = {
  __typename?: 'AddStoreCreditsPayload';
  cart?: Maybe<Cart>;
};

export type AdditionalContentListTextImage = PortableTextWithList | SanityImage;

export type AdditionalContentSection = {
  __typename?: 'AdditionalContentSection';
  _id: Scalars['ID'];
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  text?: Maybe<Array<Maybe<AdditionalContentListTextImage>>>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** @deprecated No longer in use */
  address3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstNamePronunciation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastNamePronunciation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  salutation?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  preferred: Scalars['Boolean'];
  salutation?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  couponCode?: Maybe<Scalars['String']>;
  itemText?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  promotion?: Maybe<ProductPromotion>;
  promotionId?: Maybe<Scalars['String']>;
};

export type Adyen = {
  __typename?: 'Adyen';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AdyenAction = CheckoutAwaitAction | CheckoutRedirectAction | CheckoutSdkAction;

export type AdyenGooglePayInput = {
  googlePayToken: Scalars['String'];
};

export type AdyenKlarna = {
  __typename?: 'AdyenKlarna';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AdyenKlarnaAccount = {
  __typename?: 'AdyenKlarnaAccount';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AdyenPayPal = {
  __typename?: 'AdyenPayPal';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AdyenPaymentDetailsPayload = {
  __typename?: 'AdyenPaymentDetailsPayload';
  /** @deprecated allow revert of PR 1621 */
  analytics?: Maybe<OrderAnalytics>;
  order?: Maybe<StandardOrder>;
  resultCode?: Maybe<AdyenResultCodeEnum>;
};

export type AdyenPaymentInput = {
  applePayToken?: InputMaybe<Scalars['String']>;
  browserInfo?: InputMaybe<BrowserInfo>;
  cardDetails?: InputMaybe<CardDetails>;
  checkoutAttemptId?: InputMaybe<Scalars['String']>;
  clientStateDataIndicator?: InputMaybe<Scalars['Boolean']>;
  encryptedCard?: InputMaybe<EncryptedCard>;
  googlePay?: InputMaybe<AdyenGooglePayInput>;
  issuer?: InputMaybe<Scalars['String']>;
  paymentMethodSubType?: InputMaybe<AdyenPaymentMethodSubType>;
  paymentMethodType: AdyenPaymentMethod;
  returnUrl?: InputMaybe<Scalars['String']>;
  riskData?: InputMaybe<RiskData>;
  virtualPaymentAddress?: InputMaybe<Scalars['String']>;
};

export const AdyenPaymentMethod = {
  Afterpay: 'AFTERPAY',
  Alipay: 'ALIPAY',
  ApplePay: 'APPLE_PAY',
  BilldeskOnline: 'BILLDESK_ONLINE',
  BilldeskUpi: 'BILLDESK_UPI',
  BilldeskWallet: 'BILLDESK_WALLET',
  GooglePay: 'GOOGLE_PAY',
  Klarna: 'KLARNA',
  KlarnaAccount: 'KLARNA_ACCOUNT',
  OnlinebankingIn: 'ONLINEBANKING_IN',
  Paypal: 'PAYPAL',
  PayTm: 'PAY_TM',
  Scheme: 'SCHEME',
  UpiCollect: 'UPI_COLLECT',
  WechatPay: 'WECHAT_PAY',
  ZipPay: 'ZIP_PAY'
} as const;

export type AdyenPaymentMethod = typeof AdyenPaymentMethod[keyof typeof AdyenPaymentMethod];
export const AdyenPaymentMethodSubType = {
  Redirect: 'REDIRECT',
  Sdk: 'SDK'
} as const;

export type AdyenPaymentMethodSubType = typeof AdyenPaymentMethodSubType[keyof typeof AdyenPaymentMethodSubType];
export const AdyenResultCodeEnum = {
  AuthenticationFinished: 'AuthenticationFinished',
  Authorised: 'Authorised',
  Cancelled: 'Cancelled',
  ChallengeShopper: 'ChallengeShopper',
  Error: 'Error',
  IdentifyShopper: 'IdentifyShopper',
  Pending: 'Pending',
  PresentToShopper: 'PresentToShopper',
  Received: 'Received',
  RedirectShopper: 'RedirectShopper',
  Refused: 'Refused',
  Success: 'Success'
} as const;

export type AdyenResultCodeEnum = typeof AdyenResultCodeEnum[keyof typeof AdyenResultCodeEnum];
export type AfterPay = {
  __typename?: 'AfterPay';
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AfterPayConfig = {
  __typename?: 'AfterPayConfig';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type AfterPayInput = {
  basketId: Scalars['String'];
  emailList: Scalars['Boolean'];
  feHost?: InputMaybe<Scalars['String']>;
  smsUpdate: Scalars['Boolean'];
};

export type AfterPayPayload = {
  __typename?: 'AfterPayPayload';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type Alignment = {
  __typename?: 'Alignment';
  horizontal?: Maybe<Scalars['String']>;
  vertical?: Maybe<Scalars['String']>;
};

export type Alipay = {
  __typename?: 'Alipay';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AmazonPay = {
  __typename?: 'AmazonPay';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AmazonPayAddress = {
  __typename?: 'AmazonPayAddress';
  address1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  meiName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sayName?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
};

export type AmazonPayCustomerInfoPayload = {
  __typename?: 'AmazonPayCustomerInfoPayload';
  registeredWithAmazon?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
};

export type AmazonPayInput = {
  basketId: Scalars['String'];
  orderReferenceId: Scalars['String'];
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type AmazonPayPaymentDescriptorInput = {
  amazonCheckoutSessionId: Scalars['String'];
  basketId: Scalars['String'];
};

export type AmazonPayPaymentDescriptorPayload = {
  __typename?: 'AmazonPayPaymentDescriptorPayload';
  paymentOption: Scalars['String'];
};

export type AmbassadorCard = {
  __typename?: 'AmbassadorCard';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maskedNumber: Scalars['String'];
  type: Scalars['String'];
};

export type AmbassadorCardInput = {
  basketId: Scalars['String'];
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type AppComponentWithFilters = {
  __typename?: 'AppComponentWithFilters';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  component?: Maybe<AppSlot>;
  id: Scalars['String'];
  online?: Maybe<Scalars['Boolean']>;
};

export type AppContent = {
  __typename?: 'AppContent';
  appContent?: Maybe<Array<Maybe<MobileAppHomePageContent>>>;
  appContent2?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
};

export type AppDropItem = {
  __typename?: 'AppDropItem';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  header: Scalars['String'];
  id: Scalars['ID'];
  image: SanityImage;
  link?: Maybe<MobileAppLink>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type AppSlot = FaqModule | Iframe | LinkListing | MobileAppCarousel | MobileAppProductRecommendations | MobileAppProductTileCustom | MobileAppProductTileStandard | MobileAppQuoteCallout | MobileAppTeaserTile | ProductCarousel | ProductRecommender | ProductTile | SignUpForm | SpinTheWheel | VideoHero;

export type AppVersion = {
  __typename?: 'AppVersion';
  /** @deprecated Use 'upgrade' instead to get any applicable upgrade type */
  android?: Maybe<Version>;
  /** @deprecated Use 'upgrade' instead to get any applicable upgrade type */
  ios?: Maybe<Version>;
  upgrade?: Maybe<Upgrade>;
};

export type ApplePay = {
  __typename?: 'ApplePay';
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ApplePayInput = {
  basketId: Scalars['String'];
  url: Scalars['String'];
};

export type ApplePayValidationResponse = {
  __typename?: 'ApplePayValidationResponse';
  displayName: Scalars['String'];
  domainName: Scalars['String'];
  epochTimestamp: Scalars['String'];
  expiresAt: Scalars['String'];
  merchantIdentifier: Scalars['String'];
  merchantSessionIdentifier: Scalars['String'];
  nonce: Scalars['String'];
  operationalAnalyticsIdentifier: Scalars['String'];
  retries?: Maybe<Scalars['Int']>;
  signature: Scalars['String'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String'];
  customerContext?: Maybe<CustomerContext>;
  /** @deprecated Use user instead */
  customerEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use customerContext instead */
  customerGroup?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  refreshToken: Scalars['String'];
  shoppingCartId: Scalars['String'];
  user: User;
};

export type AuthorityToLeave = {
  __typename?: 'AuthorityToLeave';
  deliveryInstructions?: Maybe<Scalars['String']>;
  leaveAt: AuthorityToLeaveOptions;
};

export type AuthorityToLeaveInput = {
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  leaveAt: AuthorityToLeaveOptions;
};

export const AuthorityToLeaveOptions = {
  LeaveAtFrontDoor: 'LEAVE_AT_FRONT_DOOR',
  LeaveAtOther: 'LEAVE_AT_OTHER',
  LeaveAtReception: 'LEAVE_AT_RECEPTION',
  LeaveInSafePlace: 'LEAVE_IN_SAFE_PLACE',
  TakeToPostOffice: 'TAKE_TO_POST_OFFICE'
} as const;

export type AuthorityToLeaveOptions = typeof AuthorityToLeaveOptions[keyof typeof AuthorityToLeaveOptions];
export type BackgroundOverlay = {
  __typename?: 'BackgroundOverlay';
  direction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  overlayColorInput?: Maybe<ColorInput>;
  overlayType?: Maybe<Scalars['String']>;
};

export type Badge = {
  __typename?: 'Badge';
  color?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type BannerIdentifier = {
  __typename?: 'BannerIdentifier';
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
};

export type BaseOrder = {
  billingAddress?: Maybe<OrderAddress>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<CustomerInfo>;
  estimatedShippingCosts?: Maybe<Scalars['Float']>;
  estimatedTotal?: Maybe<Scalars['Float']>;
  orderAdjustments: Array<Adjustment>;
  orderNo: Scalars['ID'];
  orderStatus?: Maybe<OrderStatus>;
  paymentInstruments: Array<PaymentInstrument>;
  shipment?: Maybe<Shipment>;
  shippingAdjustments: Array<Adjustment>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingSurcharge?: Maybe<ShippingSurcharge>;
  /** @deprecated Deprecated in favor of orderStatus */
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  taxTotal?: Maybe<Scalars['Float']>;
  taxation?: Maybe<Taxation>;
};

export type BodyContent = {
  __typename?: 'BodyContent';
  _id: Scalars['ID'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  logo?: Maybe<SanityImage>;
  puid?: Maybe<BannerIdentifier>;
};

export type BodyHeader = {
  __typename?: 'BodyHeader';
  _id: Scalars['ID'];
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  size?: Maybe<GenericTextSize>;
};

export type BonusItemProduct = ProductWithExclusion | VariantProduct;

export type BrowserInfo = {
  acceptHeader?: InputMaybe<Scalars['String']>;
  colorDepth?: InputMaybe<Scalars['Int']>;
  javaEnabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  screenHeight?: InputMaybe<Scalars['Int']>;
  screenWidth?: InputMaybe<Scalars['Int']>;
  timeZoneOffset?: InputMaybe<Scalars['Int']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type Cta = {
  __typename?: 'CTA';
  _type: Scalars['String'];
  action?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  link: Scalars['String'];
  linkType?: Maybe<Scalars['String']>;
  newtab?: Maybe<Scalars['Boolean']>;
  outlined?: Maybe<Scalars['Boolean']>;
  popup?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  signUpForm?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<LinkVariant>;
  width?: Maybe<Scalars['String']>;
};

export type CallToAction = {
  __typename?: 'CallToAction';
  id: Scalars['String'];
  link?: Maybe<Link>;
  outlined?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<LinkVariant>;
  width?: Maybe<Scalars['String']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  customerGroups?: Maybe<Array<Scalars['String']>>;
  puid?: Maybe<BannerIdentifier>;
  sourceCode?: Maybe<Scalars['String']>;
};

export type CancelGooglePayInput = {
  basketId?: InputMaybe<Scalars['String']>;
};

export type CancelKlarnaInput = {
  orderNo: Scalars['String'];
};

export type CancelOrderInput = {
  orderNo: Scalars['String'];
};

export type CancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  cart?: Maybe<Cart>;
  order?: Maybe<StandardOrder>;
};

export type Card = {
  __typename?: 'Card';
  badge?: Maybe<Badge>;
  /** @deprecated Use ctas2 instead */
  ctas?: Maybe<Array<CallToAction>>;
  ctas2?: Maybe<Array<Cta>>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  link?: Maybe<Link>;
  style?: Maybe<Style>;
  text?: Maybe<Text>;
};

export type CardDetails = {
  /** First 6-8 digits */
  cardBin: Scalars['String'];
  /** Last 4 digits */
  cardLastDigits: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  amountRemaining: Scalars['Float'];
  amountRemainingForFreeShipping?: Maybe<Scalars['Float']>;
  availablePaymentMethods: Array<PaymentMethod>;
  basketInStockStatus?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<OrderAddress>;
  couponItems: Array<CouponItem>;
  customer?: Maybe<CustomerInfo>;
  customizationAdjustment?: Maybe<Adjustment>;
  defaultFreeShippingThreshold?: Maybe<Scalars['Int']>;
  estimatedShippingCosts?: Maybe<Scalars['Float']>;
  estimatedTotal?: Maybe<Scalars['Float']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  giftWithPurchases: Array<GiftWithPurchasePromo>;
  hasFreeShipping?: Maybe<Scalars['Boolean']>;
  hasOfflineProducts?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isMixedCartAllowed?: Maybe<Scalars['Boolean']>;
  longTermPreOrder?: Maybe<LongTermPreOrder>;
  orderAdjustments: Array<Adjustment>;
  paymentInstruments: Array<PaymentInstrument>;
  preOrderDeliveryDate?: Maybe<Scalars['String']>;
  productAdjustments?: Maybe<Array<Adjustment>>;
  productCount?: Maybe<Scalars['Int']>;
  products: Array<CartItem>;
  shipment?: Maybe<Shipment>;
  shipmentMethodInfo: ShipmentMethodInfo;
  shippingAdjustments: Array<Adjustment>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingSurcharge?: Maybe<ShippingSurcharge>;
  subTotal?: Maybe<Scalars['Float']>;
  taxTotal?: Maybe<Scalars['Float']>;
  taxation?: Maybe<Taxation>;
  temporaryOrderNo?: Maybe<Scalars['String']>;
};

export type CartItem = GiftCardCartItem | ProductCartItem;

export type CartPage = {
  __typename?: 'CartPage';
  aboveCartContent?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  belowCartContent?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  id: Scalars['ID'];
};


export type CartPageAboveCartContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type CartPageBelowCartContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type CashOnDelivery = {
  __typename?: 'CashOnDelivery';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type CashOnDeliveryInput = {
  basketId?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  pinId?: InputMaybe<Scalars['String']>;
};

export type CashOnDeliveryResult = {
  __typename?: 'CashOnDeliveryResult';
  orderNo?: Maybe<Scalars['String']>;
  pinId?: Maybe<Scalars['String']>;
};

export type Category = {
  __typename?: 'Category';
  /** @deprecated No longer supported */
  appContent?: Maybe<Array<MobileAppHomePageContent>>;
  categories?: Maybe<Array<Category>>;
  content?: Maybe<CategoryContent>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<SanityImage>;
  name: Scalars['String'];
  navChildren?: Maybe<Array<Category>>;
  parentCategory?: Maybe<Category>;
  products: PaginatedOutput;
  seo?: Maybe<Seo>;
  sizeChartId?: Maybe<Scalars['String']>;
  sizeCharts?: Maybe<Array<SizeChart>>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
};


export type CategoryContentArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
};


export type CategoryProductsArgs = {
  input: ProductsInput;
};

export type CategoryContent = CategoryPage | ProductListingPage;

export type CategoryExclusion = {
  __typename?: 'CategoryExclusion';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type CategoryPage = Page & {
  __typename?: 'CategoryPage';
  appSlots: Array<Maybe<AppComponentWithFilters>>;
  category: Category;
  id: Scalars['ID'];
  slots: Array<Maybe<ComponentWithFilters>>;
  /** @deprecated Use category.title instead */
  title: Scalars['String'];
};


export type CategoryPageAppSlotsArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type CategoryPageSlotsArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type CheckNumberAndSendSmsResult = {
  __typename?: 'CheckNumberAndSendSmsResult';
  pinId?: Maybe<Scalars['String']>;
};

export type CheckoutAwaitAction = {
  __typename?: 'CheckoutAwaitAction';
  paymentData?: Maybe<Scalars['String']>;
  /** Specifies the payment method. */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** * **await** */
  type?: Maybe<Scalars['String']>;
  /** * Specifies the URL to redirect to. */
  url?: Maybe<Scalars['String']>;
};

export type CheckoutRedirectAction = {
  __typename?: 'CheckoutRedirectAction';
  /** When the redirect URL must be accessed via POST, use this data to post to the redirect URL. */
  data?: Maybe<Scalars['JSON']>;
  /** Specifies the HTTP method, for example GET or POST. */
  method?: Maybe<Scalars['String']>;
  /** Specifies the payment method. */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** redirect */
  type?: Maybe<Scalars['String']>;
  /** Specifies the URL to redirect to. */
  url?: Maybe<Scalars['String']>;
};

export type CheckoutSdkAction = {
  __typename?: 'CheckoutSDKAction';
  paymentData?: Maybe<Scalars['String']>;
  /** Specifies the payment method. */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** * Specifies the URL to redirect to. */
  sdkData?: Maybe<SdkData>;
  /** * **await** */
  type?: Maybe<Scalars['String']>;
};

export type Children = {
  __typename?: 'Children';
  _key: Scalars['String'];
  _type: Scalars['String'];
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type Chip = {
  __typename?: 'Chip';
  filterId: Scalars['String'];
  filterLabel: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CitizenRefLookupInput = {
  emailAddress: Scalars['String'];
};

export type CitizenRefLookupResponse = {
  __typename?: 'CitizenRefLookupResponse';
  citizenId: Scalars['String'];
  externalRef: Scalars['String'];
  locale: Scalars['String'];
};

export type CloudinaryConfig = {
  __typename?: 'CloudinaryConfig';
  status?: Maybe<Scalars['String']>;
  transformations?: Maybe<Array<Maybe<CloudinaryTransformation>>>;
};

export type CloudinaryTransformation = {
  __typename?: 'CloudinaryTransformation';
  height?: Maybe<Scalars['Int']>;
  media?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ColorInput = {
  __typename?: 'ColorInput';
  alpha: Scalars['Float'];
  hex: Scalars['String'];
  rgb: Rgba;
};

export type ComparisonField = {
  __typename?: 'ComparisonField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ComparisonProduct = {
  __typename?: 'ComparisonProduct';
  comparisonFields: Array<ComparisonField>;
  product: VariantProduct;
};

export type CompleteAdyenPaymentDetailsInput = {
  /** PayPal-generated token for recurring payments. */
  billingToken?: InputMaybe<Scalars['String']>;
  /** The SMS verification code collected from the shopper. */
  cupsecureplusSmscode?: InputMaybe<Scalars['String']>;
  /** PayPal-generated third party access token. */
  facilitatorAccessToken?: InputMaybe<Scalars['String']>;
  /** A payment session identifier returned by the card issuer. */
  mD?: InputMaybe<Scalars['String']>;
  /** A random number sent to the mobile phone number of the shopper to verify the payment. */
  oneTimePasscode?: InputMaybe<Scalars['String']>;
  /** PayPal-assigned ID for the order. */
  orderID?: InputMaybe<Scalars['String']>;
  /** (3D) Payment Authentication Request data for the card issuer. */
  paReq?: InputMaybe<Scalars['String']>;
  /** (3D) Payment Authentication Response data by the card issuer. */
  paRes?: InputMaybe<Scalars['String']>;
  /** PayPal-assigned ID for the payer (shopper). */
  payerID?: InputMaybe<Scalars['String']>;
  /** Payload appended to the returnURL as a result of the redirect. */
  payload?: InputMaybe<Scalars['String']>;
  /** PayPal-generated ID for the payment. */
  paymentID?: InputMaybe<Scalars['String']>;
  /** Value passed from the WeChat MiniProgram wx.requestPayment **complete** callback. Possible values: any value starting with requestPayment:. */
  paymentStatus?: InputMaybe<Scalars['String']>;
  /** The result of the redirect as appended to the returnURL. */
  redirectResult?: InputMaybe<Scalars['String']>;
  /** Base64-encoded string returned by the Component after the challenge flow. It contains the following parameters: transStatus, authorisationToken. */
  threeDSResult?: InputMaybe<Scalars['String']>;
  /** Base64-encoded string returned by the Component after the challenge flow. It contains the following parameter: transStatus. */
  threeds2ChallengeResult?: InputMaybe<Scalars['String']>;
  /** Base64-encoded string returned by the Component after the challenge flow. It contains the following parameter: threeDSCompInd. */
  threeds2Fingerprint?: InputMaybe<Scalars['String']>;
};

export type CompleteAdyenPaymentInput = {
  /** This needs to be the type from the "startAdyenPayment" response (AdyenAction union). Optional, used to place order for CheckoutAwaitAction. */
  checkoutActionType?: InputMaybe<Scalars['String']>;
  details: CompleteAdyenPaymentDetailsInput;
  feHost?: InputMaybe<Scalars['String']>;
  forterToken?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  paymentData?: InputMaybe<Scalars['String']>;
};

export type CompleteAmazonPaymentInput = {
  amazonCheckoutSessionId: Scalars['String'];
  orderNo: Scalars['String'];
};

export type CompleteAmazonPaymentPayload = {
  __typename?: 'CompleteAmazonPaymentPayload';
  order: StandardOrder;
};

export type ConfigureIdSettings = {
  __typename?: 'ConfigureIDSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  productID?: Maybe<Scalars['String']>;
};

export type ConfirmAfterPayInput = {
  forterToken?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  paymentId: Scalars['String'];
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
  status: Scalars['String'];
  token: Scalars['String'];
};

export type ConfirmAmazonPayInput = {
  basketId: Scalars['String'];
  orderNo: Scalars['String'];
  orderReferenceId: Scalars['String'];
};

export type ConfirmApplePayInput = {
  basketId: Scalars['String'];
  forterToken?: InputMaybe<Scalars['String']>;
  paymentData: Scalars['String'];
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type ConfirmCashOnDeliveryInput = {
  basketId?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  pin: Scalars['String'];
  pinId: Scalars['String'];
};

export type ConfirmCreditCardInput = {
  MD: Scalars['String'];
  PaRes: Scalars['String'];
  basketId?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ConfirmKlarnaInput = {
  orderNo: Scalars['String'];
  paymentMethod: Scalars['String'];
  redirectResult: Scalars['String'];
};

export type ConfirmKlarnaPaymentInput = {
  authorizationToken: Scalars['String'];
  forterToken: Scalars['String'];
  orderNo: Scalars['String'];
  products?: InputMaybe<Array<InputMaybe<KlarnaProductInfo>>>;
};

export type ConfirmKlarnaPaymentPayload = {
  __typename?: 'ConfirmKlarnaPaymentPayload';
  authorizedPaymentMethod?: Maybe<KlarnaAuthorizedPaymentMethod>;
  fraudStatus?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ConfirmOnlineBankingInput = {
  adyenResultCode?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
};

export type ConfirmPayPalInput = {
  adyenPaymentData?: InputMaybe<Scalars['String']>;
  feHost?: InputMaybe<Scalars['String']>;
  forterToken?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
  token?: InputMaybe<Scalars['String']>;
};

export type ConfirmPayPayInput = {
  basketId?: InputMaybe<Scalars['String']>;
  isSkipPaymentConfirm?: InputMaybe<Scalars['Boolean']>;
  orderNo: Scalars['String'];
  payResponse?: InputMaybe<PayPayResponse>;
};

export type ConfirmPayTmWithResultCodeInput = {
  adyenResultCode?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
};

export type ConfirmRazorPayInput = {
  /** Data returned by the Razor pay checkout */
  checkoutInfo: RazorPayCheckoutInput;
  /** CyberCat Order ID */
  orderId: Scalars['String'];
  /** Original Razor pay Order ID returned in startRazorPay mutation */
  originalRazorPayOrderId: Scalars['String'];
};

export type ConfirmRazorPayPayload = {
  __typename?: 'ConfirmRazorPayPayload';
  order: StandardOrder;
};

export type ConfirmUpiWithResultCodeInput = {
  adyenResultCode?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
};

export const ConfirmUpdatePhoneCode = {
  CustomerNotFound: 'CUSTOMER_NOT_FOUND',
  EncryptedPasswordEmpty: 'ENCRYPTED_PASSWORD_EMPTY',
  MoreThanOneCustomer: 'MORE_THAN_ONE_CUSTOMER',
  NoMorePinAttempts: 'NO_MORE_PIN_ATTEMPTS',
  Ok: 'OK'
} as const;

export type ConfirmUpdatePhoneCode = typeof ConfirmUpdatePhoneCode[keyof typeof ConfirmUpdatePhoneCode];
export type ConfirmUpdatePhoneInput = {
  phoneNo: Scalars['String'];
  pin?: InputMaybe<Scalars['String']>;
  pinId?: InputMaybe<Scalars['String']>;
  recaptchaToken?: InputMaybe<Scalars['String']>;
};

export type ConfirmUpdatePhonePayload = {
  __typename?: 'ConfirmUpdatePhonePayload';
  code?: Maybe<ConfirmUpdatePhoneCode>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ConfirmWalletWithResultCodeInput = {
  adyenResultCode?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
};

export type ContactInput = {
  address?: InputMaybe<Scalars['String']>;
  appLanguage?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactSource?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<DobInput>;
  email: Scalars['String'];
  emailPreference?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  isPushEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  montreal?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  shoppingPreference?: InputMaybe<Scalars['String']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  toronto?: InputMaybe<Scalars['Boolean']>;
};

export type ContentInput = {
  draft?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<Scalars['JSON']>;
  preview?: InputMaybe<PreviewInput>;
  query: Scalars['String'];
  src?: InputMaybe<Scalars['String']>;
};

export type ContentRecommender = MobileAppProductRecommendations | SignUpForm;

export type Coordinates = {
  __typename?: 'Coordinates';
  height: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
  z: Scalars['Int'];
};

export type CountdownClock = {
  __typename?: 'CountdownClock';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  countdownEnd: Scalars['String'];
  id: Scalars['String'];
};

export type CouponItem = {
  __typename?: 'CouponItem';
  calloutMessage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  couponFamily?: Maybe<Scalars['String']>;
  couponItemId?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Float']>;
  statusCode?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type CreateContactInput = {
  contact: ContactInput;
  returnErrorIfContactExists?: InputMaybe<Scalars['Boolean']>;
};

export type CreateShopperContextInput = {
  effectiveDateTime?: InputMaybe<Scalars['String']>;
  sourceCode?: InputMaybe<Scalars['String']>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  cardType: Scalars['String'];
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  holder?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maskedNumber: Scalars['String'];
  type: Scalars['String'];
};

export type CreditCardConfirm = {
  __typename?: 'CreditCardConfirm';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  cardType: Scalars['String'];
  id: Scalars['String'];
  maskedNumber: Scalars['String'];
  type: Scalars['String'];
};

export type CreditCardInput = {
  basketId: Scalars['String'];
  browserInfo?: InputMaybe<BrowserInfo>;
  card?: InputMaybe<PaymentCardInput>;
  cardBin?: InputMaybe<Scalars['String']>;
  cardLastDigits?: InputMaybe<Scalars['String']>;
  encryptedCard?: InputMaybe<EncryptedCard>;
  feHost?: InputMaybe<Scalars['String']>;
  forterCustomerWebId?: InputMaybe<Scalars['String']>;
  forterToken?: InputMaybe<Scalars['String']>;
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type CreditCardResult = StandardOrder | ThreeDsResponse;

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  decimalsToDisplay?: Maybe<Scalars['Int']>;
  symbol: Scalars['String'];
};

export type CustomerContext = {
  __typename?: 'CustomerContext';
  customerGroups?: Maybe<Array<Scalars['String']>>;
  hashKey?: Maybe<Scalars['String']>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  customerNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type CustomerSupport = {
  __typename?: 'CustomerSupport';
  chatHours?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  phoneHours?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Dob = {
  __typename?: 'DOB';
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type DobInput = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type DeleteAmbassadorCardInput = {
  cardId: Scalars['String'];
};

export type DeleteCardInput = {
  cardId: Scalars['String'];
};

export type DeliveryDateDays = {
  __typename?: 'DeliveryDateDays';
  endDeliveryDateDay?: Maybe<Scalars['Int']>;
  startDeliveryDateDay?: Maybe<Scalars['Int']>;
};

export type DisplayOutOfStock = {
  __typename?: 'DisplayOutOfStock';
  backsoon?: Maybe<Scalars['Boolean']>;
  comingsoon?: Maybe<Scalars['Boolean']>;
  displayValue?: Maybe<Scalars['String']>;
  presale?: Maybe<Scalars['Boolean']>;
  soldout?: Maybe<Scalars['Boolean']>;
  soldoutWithRecommender?: Maybe<Scalars['Boolean']>;
  validFrom?: Maybe<Scalars['String']>;
  validTo?: Maybe<Scalars['String']>;
};

export type DropCalendarPage = {
  __typename?: 'DropCalendarPage';
  aboveContent?: Maybe<Array<Maybe<ContentRecommender>>>;
  /** @deprecated use aboveContent that allows multiple content type */
  aboveContentRecommenders?: Maybe<Array<Maybe<MobileAppProductRecommendations>>>;
  belowContent?: Maybe<Array<Maybe<ContentRecommender>>>;
  /** @deprecated use belowContent that allows multiple content type */
  belowContentRecommenders?: Maybe<Array<Maybe<MobileAppProductRecommendations>>>;
  products?: Maybe<Array<DropCalendarProduct>>;
};

export type DropCalendarProduct = {
  __typename?: 'DropCalendarProduct';
  appOnlyDateTimeFrom?: Maybe<Scalars['String']>;
  appOnlyDateTimeTo?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  ctaCopy?: Maybe<Scalars['String']>;
  enableCountdown?: Maybe<Scalars['Boolean']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  imageUrl?: Maybe<Scalars['String']>;
  isAppExclusive?: Maybe<Scalars['Boolean']>;
  isProductLinkDisabled?: Maybe<Scalars['Boolean']>;
  launchDate: Scalars['String'];
  link?: Maybe<MobileAppLink>;
  masterId?: Maybe<Scalars['String']>;
  subHeader?: Maybe<Scalars['String']>;
};

export type DynamicYieldBranchInput = {
  dayPart?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type DynamicYieldCartInput = {
  innerProducts?: InputMaybe<Array<InputMaybe<DynamicYieldProductInput>>>;
};

export type DynamicYieldChooseVariationsInput = {
  RAW_BODY?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<DynamicYieldContextInput>;
  options?: InputMaybe<DynamicYieldOptionsInput>;
  selector?: InputMaybe<DynamicYieldSelectorInput>;
  session?: InputMaybe<DynamicYieldSessionInput>;
  user: DynamicYieldUserInput;
};

export type DynamicYieldContextInput = {
  branch?: InputMaybe<DynamicYieldBranchInput>;
  cart?: InputMaybe<DynamicYieldCartInput>;
  channel?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<DynamicYieldDeviceInput>;
  page?: InputMaybe<DynamicYieldPageInput>;
};

export type DynamicYieldDeviceInput = {
  browser?: InputMaybe<Scalars['String']>;
  dateTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type DynamicYieldOptionsInput = {
  isImplicitClientData?: InputMaybe<Scalars['Boolean']>;
  isImplicitImpressionMode?: InputMaybe<Scalars['Boolean']>;
  isImplicitPageview?: InputMaybe<Scalars['Boolean']>;
  recsProductData?: InputMaybe<DynamicYieldRecsProductDataInput>;
  returnAnalyticsMetadata?: InputMaybe<Scalars['Boolean']>;
};

export type DynamicYieldPageInput = {
  data?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
  location: Scalars['String'];
  referrer?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DynamicYieldPreviewInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DynamicYieldProductInput = {
  itemPrice?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type DynamicYieldRecsProductDataInput = {
  fieldFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skusOnly?: InputMaybe<Scalars['Boolean']>;
};

export type DynamicYieldSelectorInput = {
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  names: Array<InputMaybe<Scalars['String']>>;
  preview?: InputMaybe<DynamicYieldPreviewInput>;
};

export type DynamicYieldSessionInput = {
  dy?: InputMaybe<Scalars['String']>;
};

export type DynamicYieldUserInput = {
  active_consent_accepted?: InputMaybe<Scalars['Boolean']>;
  dyid?: InputMaybe<Scalars['String']>;
  dyid_server?: InputMaybe<Scalars['String']>;
  sharedDevice?: InputMaybe<Scalars['Boolean']>;
};

export type EinsteinProduct = {
  __typename?: 'EinsteinProduct';
  altId?: Maybe<Scalars['String']>;
  altIdType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
};

export type EmailOtpSendInput = {
  email: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};

export type EmailOtpVerificationInput = {
  email: Scalars['String'];
  otp: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  shoppingCartId?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
};

export type EncryptedCard = {
  brand?: InputMaybe<Scalars['String']>;
  encryptedCardNumber: Scalars['String'];
  encryptedExpiryMonth: Scalars['String'];
  encryptedExpiryYear: Scalars['String'];
  encryptedSecurityCode?: InputMaybe<Scalars['String']>;
  holderName: Scalars['String'];
};

export type Environment = {
  __typename?: 'Environment';
  abTestingScript?: Maybe<Scalars['String']>;
  adyenClientKey?: Maybe<Scalars['String']>;
  adyenEnv?: Maybe<Scalars['String']>;
  adyenMerchantAccount?: Maybe<Scalars['String']>;
  adyenPayPalIntent?: Maybe<Scalars['String']>;
  adyenPayPalMerchantId?: Maybe<Scalars['String']>;
  adyenPublicKey?: Maybe<Scalars['String']>;
  adyenStatusUrl?: Maybe<Scalars['String']>;
  afterpaySDKSource: Scalars['String'];
  /** @deprecated Moved to FE siteConfig */
  amazonPayButtonColor?: Maybe<Scalars['String']>;
  /** @deprecated Moved to FE siteConfig */
  amazonPayButtonSize?: Maybe<Scalars['String']>;
  amazonPayClientId?: Maybe<Scalars['String']>;
  amazonPayMerchantId?: Maybe<Scalars['String']>;
  amazonPayMode?: Maybe<Scalars['String']>;
  amazonPayPublicKeyId?: Maybe<Scalars['String']>;
  amazonPayScope?: Maybe<Scalars['String']>;
  amazonPayStoreId?: Maybe<Scalars['String']>;
  bazaarVoiceReviewFormScriptUrl?: Maybe<Scalars['String']>;
  bloomreachAccountId?: Maybe<Scalars['String']>;
  bloomreachSEOAccountId?: Maybe<Scalars['String']>;
  branchKey?: Maybe<Scalars['String']>;
  checkoutAppInMaintenance?: Maybe<Scalars['String']>;
  configureIdApiKey?: Maybe<Scalars['String']>;
  configureIdScriptUrl?: Maybe<Scalars['String']>;
  dataGuardTemplateId?: Maybe<Scalars['String']>;
  dynamicYieldDynamicUrl?: Maybe<Scalars['String']>;
  dynamicYieldStaticUrl?: Maybe<Scalars['String']>;
  emarsysSignupURL?: Maybe<Scalars['String']>;
  emplifiTurnToSite?: Maybe<Scalars['String']>;
  fitAnalyticsOrderConfirmationUrl: Scalars['String'];
  fitAnalyticsPdpUrl: Scalars['String'];
  forterSiteId?: Maybe<Scalars['String']>;
  freshChatHost?: Maybe<Scalars['String']>;
  freshChatToken?: Maybe<Scalars['String']>;
  gmoShopId: Scalars['String'];
  gmoSource: Scalars['String'];
  googleApiKey: Scalars['String'];
  /** @deprecated Google Optimize Sunset */
  googleOptimizeContainerId: Scalars['String'];
  googlePayEnvironment?: Maybe<Scalars['String']>;
  googlePayMerchantId?: Maybe<Scalars['String']>;
  googlePayMerchantName?: Maybe<Scalars['String']>;
  googlePayPaymentGateway?: Maybe<Scalars['String']>;
  googlePayPaymentGatewayMerchantId?: Maybe<Scalars['String']>;
  googleTagManagerId: Scalars['String'];
  idMeClientId?: Maybe<Scalars['String']>;
  klarnaDataClientId?: Maybe<Scalars['String']>;
  klarnaScriptUrl?: Maybe<Scalars['String']>;
  myCustomizerDomain?: Maybe<Scalars['String']>;
  myCustomizerShopId?: Maybe<Scalars['String']>;
  oneTrustApiKey?: Maybe<Scalars['String']>;
  otpVerificationTokenSecret?: Maybe<Scalars['String']>;
  payPayReloadCount?: Maybe<Scalars['Int']>;
  payPayRetryWaitingTime?: Maybe<Scalars['Int']>;
  pixleeApiKey: Scalars['String'];
  radialFingerprint?: Maybe<Scalars['String']>;
  radialStoreId?: Maybe<Scalars['String']>;
  razorPaySdkKey?: Maybe<Scalars['String']>;
  recaptchaSiteKey?: Maybe<Scalars['String']>;
  returnUrl: Scalars['String'];
  sanityDataset: Scalars['String'];
  sanityProjectId: Scalars['String'];
  sanitySiteId: Scalars['String'];
  storeRocketId?: Maybe<Scalars['String']>;
  styliticsUsername?: Maybe<Scalars['String']>;
  webInMaintenanceMode?: Maybe<Scalars['String']>;
  yottaaScriptUrl?: Maybe<Scalars['String']>;
};

export type Error404 = {
  __typename?: 'Error404';
  appContent?: Maybe<Array<Maybe<MobileApp404PageContent>>>;
  appContent2?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
  content?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  customerSupportLinks?: Maybe<CustomerSupport>;
  heading?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
};

export type EstimatedDeliveryDate = {
  __typename?: 'EstimatedDeliveryDate';
  carrierCode?: Maybe<Scalars['String']>;
  eddBegin?: Maybe<Scalars['String']>;
  eddEnd?: Maybe<Scalars['String']>;
  errorResponse?: Maybe<EstimatedDeliveryDateErrorResponse>;
  id?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  timeZoneName?: Maybe<Scalars['String']>;
};

export type EstimatedDeliveryDateErrorResponse = {
  __typename?: 'EstimatedDeliveryDateErrorResponse';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type EstimatedShippingDate = {
  __typename?: 'EstimatedShippingDate';
  carrierCode?: Maybe<Scalars['String']>;
  cutoff?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  answer?: Maybe<Array<Maybe<PortableText>>>;
  question: Scalars['String'];
};

export type FaqModule = {
  __typename?: 'FaqModule';
  _id: Scalars['ID'];
  faqs: Array<FaqItem>;
  puid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  additionalPriceTextForSaleEnabled?: Maybe<Scalars['Boolean']>;
  addressResumeInCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  afterPayEnabled?: Maybe<Scalars['Boolean']>;
  allowGuestAccessToOrderDetails?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appAmazonPayEnabled or webAmazonPayEnabled instead */
  amazonPayEnabled?: Maybe<Scalars['Boolean']>;
  appAmazonPayEnabled?: Maybe<Scalars['Boolean']>;
  appApplePayEnabled?: Maybe<Scalars['Boolean']>;
  appGooglePayEnabled?: Maybe<Scalars['Boolean']>;
  appKlarnaEnabled?: Maybe<Scalars['Boolean']>;
  appPayPalEnabled?: Maybe<Scalars['Boolean']>;
  appPayPayEnabled?: Maybe<Scalars['Boolean']>;
  appPaymentPromotionEnabled?: Maybe<Scalars['Boolean']>;
  appUseSavedCardsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appApplePayEnabled or webApplePayEnabled instead */
  applePayEnabled?: Maybe<Scalars['Boolean']>;
  autoShowNewsletterPopupEnabled?: Maybe<Scalars['Boolean']>;
  cartSummaryPromoCodeExpandedOnMobile?: Maybe<Scalars['Boolean']>;
  checkoutOrderDetailsIsExpandedOnLoad?: Maybe<Scalars['Boolean']>;
  /** @deprecated Global and PNA approved Redesign. No longer needed. */
  collapsableCheckoutOrderDetailsFullEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Global and PNA approved Redesign. No longer needed. */
  collapsableCheckoutOrderDetailsOnlyProductsEnabled?: Maybe<Scalars['Boolean']>;
  collapsableOrderDetailsIsCollapsedOnLoad?: Maybe<Scalars['Boolean']>;
  createAccountInCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  desiredDeliveryDateEnabled?: Maybe<Scalars['Boolean']>;
  giftCardEnabled?: Maybe<Scalars['Boolean']>;
  googleAddressLookupEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appGooglePayEnabled or webGooglePayEnabled instead */
  googlePayEnabled?: Maybe<Scalars['Boolean']>;
  googleReversePostalCodeLookup?: Maybe<Scalars['Boolean']>;
  hideYourSavings?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appKlarnaEnabled or webKlarnaEnabled instead */
  klarnaEnabled?: Maybe<Scalars['Boolean']>;
  miniCartSeparateViewAndCheckoutButtons?: Maybe<Scalars['Boolean']>;
  myAccountDashboardMembershipSectionEnabled?: Maybe<Scalars['Boolean']>;
  myAccountEditPasswordShowAdditionalCancelButtonEnabled?: Maybe<Scalars['Boolean']>;
  myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled?: Maybe<Scalars['Boolean']>;
  myAccountHideNewsletterSettingsInDashboard?: Maybe<Scalars['Boolean']>;
  myAccountHideNotificationSettingsInDashboard?: Maybe<Scalars['Boolean']>;
  myAccountLeaveResetPasswordConfirmPopupOpenEnabled?: Maybe<Scalars['Boolean']>;
  myAccountOrderDetailsBillingInfoEnabled?: Maybe<Scalars['Boolean']>;
  myAccountOrderDetailsContactInfoEnabled?: Maybe<Scalars['Boolean']>;
  myAccountShowAdditionalFieldsInEditEnabled?: Maybe<Scalars['Boolean']>;
  myCustomizerEnabled?: Maybe<Scalars['Boolean']>;
  nestedOrdersEnabled?: Maybe<Scalars['Boolean']>;
  opluxEnabled?: Maybe<Scalars['Boolean']>;
  otpLoginEnabled?: Maybe<Scalars['Boolean']>;
  outfitsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appPayPalEnabled or webPayPalEnabled instead */
  payPalEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appPayPayEnabled or webPayPayEnabled instead */
  payPayEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appPaymentPromotionEnabled or webPaymentPromotionEnabled instead */
  paymentPromotionEnabled?: Maybe<Scalars['Boolean']>;
  phoneInProfileEnabled?: Maybe<Scalars['Boolean']>;
  pincodeServiceabilityEnabled?: Maybe<Scalars['Boolean']>;
  priceWithDataEnabled?: Maybe<Scalars['Boolean']>;
  promoCodeAccordionIsExpandedByDefault?: Maybe<Scalars['Boolean']>;
  ratingsAndReviewsEnabled?: Maybe<Scalars['Boolean']>;
  registerOTPVerificationEnabled?: Maybe<Scalars['Boolean']>;
  returnOrderEnabled?: Maybe<Scalars['Boolean']>;
  saveAddressCheckboxEnabled?: Maybe<Scalars['Boolean']>;
  scShowCartAbandonmentModalEnabled?: Maybe<Scalars['Boolean']>;
  showDiscountAmountAndTextEnabled?: Maybe<Scalars['Boolean']>;
  showDynamicTaxMessage?: Maybe<Scalars['Boolean']>;
  showOnlyOrderableSizesEnabled?: Maybe<Scalars['Boolean']>;
  showProductKeywordsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Moved to staticFeatures in FE siteConfig */
  showSaleBadgeOnProductImageEnabled?: Maybe<Scalars['Boolean']>;
  showUserRegistrationOnCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  simplifiedAddressResumeInCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  simplifiedGoogleShoppingPdpEnabled?: Maybe<Scalars['Boolean']>;
  storeCreditsEnabled?: Maybe<Scalars['Boolean']>;
  toggleCheckoutOrderDetailsFullEnabled?: Maybe<Scalars['Boolean']>;
  toggleCheckoutOrderDetailsOnlyProductsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use appUseSavedCardsEnabled or webUseSavedCardsEnabled instead */
  useSavedCardsEnabled?: Maybe<Scalars['Boolean']>;
  webAmazonPayEnabled?: Maybe<Scalars['Boolean']>;
  webApplePayEnabled?: Maybe<Scalars['Boolean']>;
  webGooglePayEnabled?: Maybe<Scalars['Boolean']>;
  webKlarnaEnabled?: Maybe<Scalars['Boolean']>;
  webPayPalEnabled?: Maybe<Scalars['Boolean']>;
  webPayPayEnabled?: Maybe<Scalars['Boolean']>;
  webPaymentPromotionEnabled?: Maybe<Scalars['Boolean']>;
  webUseSavedCardsEnabled?: Maybe<Scalars['Boolean']>;
};

export type FeatureGridRow = {
  __typename?: 'FeatureGridRow';
  copy?: Maybe<Scalars['String']>;
  ctas?: Maybe<Array<Cta>>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  layout: LayoutDirection;
  mobilePrimaryImage?: Maybe<SanityImage>;
  primaryImage: SanityImage;
  secondaryImage?: Maybe<SanityImage>;
};

export type FeatureHero = {
  __typename?: 'FeatureHero';
  _id: Scalars['ID'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  ctas?: Maybe<Array<Cta>>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  logo?: Maybe<SanityImage>;
  primaryImage?: Maybe<SanityImage>;
  primaryVideo?: Maybe<SanityVideo>;
  secondaryImage?: Maybe<SanityImage>;
  secondaryVideo?: Maybe<SanityVideo>;
  textColor?: Maybe<Scalars['String']>;
};

export type FeaturesGrid = {
  __typename?: 'FeaturesGrid';
  _id: Scalars['ID'];
  featureRows: Array<FeatureGridRow>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
};

export type FilterInputOption = {
  id: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  id: Scalars['String'];
  label: Scalars['String'];
  /** @deprecated fixing implementation of new feature (price slider / GQL-391) */
  max?: Maybe<Scalars['Int']>;
  /** @deprecated fixing implementation of new feature (price slider / GQL-391) */
  min?: Maybe<Scalars['Int']>;
  values: Array<FilterOptionValue>;
};

export type FilterOptionValue = {
  __typename?: 'FilterOptionValue';
  hitCount: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FitOptions = {
  __typename?: 'FitOptions';
  label: Scalars['String'];
  masterProduct: Product;
};

export type FrontendConfiguration = {
  __typename?: 'FrontendConfiguration';
  environment: Environment;
  featureFlags: FeatureFlags;
  siteConfig?: Maybe<SiteConfig>;
};

export type FullBleedHero = {
  __typename?: 'FullBleedHero';
  _id: Scalars['ID'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage: SanityImage;
  backgroundOverlay?: Maybe<BackgroundOverlay>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  logo?: Maybe<SanityImage>;
  logoMobile?: Maybe<SanityImage>;
  logoPosition?: Maybe<Scalars['String']>;
  minAspectRatio: Scalars['Float'];
  mobileBackgroundImage?: Maybe<SanityImage>;
  mobileBackgroundOverlay?: Maybe<BackgroundOverlay>;
  overlayContent?: Maybe<Scalars['Boolean']>;
  puid?: Maybe<BannerIdentifier>;
  /** @deprecated No longer needed. */
  showDayFieldInCountdownClock?: Maybe<Scalars['Boolean']>;
  textAlignment?: Maybe<HorizontalAlignment>;
  textColor?: Maybe<Scalars['String']>;
  verticalAlignment?: Maybe<VerticalAlignment>;
};

export type GmoPaymentData = {
  gmoCreditCardToken?: InputMaybe<Scalars['String']>;
  gmoCreditCardToken1?: InputMaybe<Scalars['String']>;
  gmoSearchCardToken?: InputMaybe<Scalars['String']>;
  gmoTokenExpiration?: InputMaybe<Scalars['String']>;
  storedPaymentUUID?: InputMaybe<Scalars['String']>;
  useSaveCreditCard?: InputMaybe<Scalars['Boolean']>;
};

export type GmoSaveData = {
  gmoCreditCardToken?: InputMaybe<Scalars['String']>;
  gmoSearchCardToken?: InputMaybe<Scalars['String']>;
  gmoTokenExpiration?: InputMaybe<Scalars['String']>;
};

export const GenericTextSize = {
  Large: 'large',
  Medium: 'medium',
  Small: 'small'
} as const;

export type GenericTextSize = typeof GenericTextSize[keyof typeof GenericTextSize];
export type GiftCard = {
  __typename?: 'GiftCard';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maskedNumber: Scalars['String'];
  type: Scalars['String'];
};

export type GiftCardCartItem = {
  __typename?: 'GiftCardCartItem';
  amount: Scalars['Float'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  senderName: Scalars['String'];
};

export type GiftCardInput = {
  basketId: Scalars['String'];
  forterCustomerWebId?: InputMaybe<Scalars['String']>;
  forterToken?: InputMaybe<Scalars['String']>;
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type GiftCardProduct = {
  __typename?: 'GiftCardProduct';
  defaultValue: Scalars['Int'];
  id: Scalars['ID'];
  image: Scalars['String'];
  name: Scalars['String'];
  valueOptions: Array<Scalars['Int']>;
};

export type GiftWithPurchasePromo = {
  __typename?: 'GiftWithPurchasePromo';
  allowedQuantity: Scalars['Int'];
  availableProducts: Array<BonusItemProduct>;
  calloutMessage?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  fullfilled: Scalars['Boolean'];
  gwpTitle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  promotionId: Scalars['String'];
};

export type GlobalPromoBanner = {
  __typename?: 'GlobalPromoBanner';
  duration: Scalars['Int'];
  messages: Array<Message>;
};

export type GlossaryCategory = {
  __typename?: 'GlossaryCategory';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type GlossaryPage = Page & {
  __typename?: 'GlossaryPage';
  categories?: Maybe<Array<GlossaryCategory>>;
  headerBackgroundImage: SanityImage;
  headerIntroduction: Scalars['JSON'];
  id: Scalars['ID'];
  puid: Scalars['String'];
  seo?: Maybe<Seo>;
  terms?: Maybe<Array<GlossaryTermFlattened>>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type GlossaryTermFlattened = {
  __typename?: 'GlossaryTermFlattened';
  categories?: Maybe<Array<Scalars['String']>>;
  definition: Scalars['JSON'];
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  mediaType: Scalars['String'];
  puid: Scalars['String'];
  term: Scalars['String'];
  video?: Maybe<SanityVideo>;
};

export type GmoConfirmCreditCardInput = {
  errorId?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
  param?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};

export type GmoTokenInput = {
  __typename?: 'GmoTokenInput';
  cardno: Scalars['String'];
  expire: Scalars['String'];
  holdername: Scalars['String'];
  securitycode: Scalars['String'];
};

export type GooglePay = {
  __typename?: 'GooglePay';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type GooglePayInput = {
  basketId: Scalars['String'];
  forterToken?: InputMaybe<Scalars['String']>;
  paymentData: GooglePayPaymentData;
  radialFingerPrint?: InputMaybe<Scalars['String']>;
  radialFrontendContext?: InputMaybe<RadialFrontendContext>;
};

export type GooglePayPaymentData = {
  intermediateSigningKey: GooglePayPaymentDataIntermediateSigningKey;
  protocolVersion: Scalars['String'];
  signature: Scalars['String'];
  signedMessage: GooglePayPaymentDataSignedMessage;
};

export type GooglePayPaymentDataIntermediateSigningKey = {
  signatures: Array<Scalars['String']>;
  signedKey: GooglePayPaymentDataIntermediateSigningKeySignedKey;
};

export type GooglePayPaymentDataIntermediateSigningKeySignedKey = {
  keyExpiration: Scalars['String'];
  keyValue: Scalars['String'];
};

export type GooglePayPaymentDataSignedMessage = {
  encryptedMessage: Scalars['String'];
  ephemeralPublicKey: Scalars['String'];
  tag: Scalars['String'];
};

export const GraphQlError = {
  AddressIdAlreadyInUse: 'ADDRESS_ID_ALREADY_IN_USE',
  AfterpayMax: 'AFTERPAY_MAX',
  AfterpayMin: 'AFTERPAY_MIN',
  BadUserInput: 'BAD_USER_INPUT',
  CheetahResponseError: 'CHEETAH_RESPONSE_ERROR',
  ConflictingPaymentMethods: 'CONFLICTING_PAYMENT_METHODS',
  CountryError: 'COUNTRY_ERROR',
  CurrentPasswordNotValid: 'CURRENT_PASSWORD_NOT_VALID',
  DefaultError: 'DEFAULT_ERROR',
  InsufficientFunds: 'INSUFFICIENT_FUNDS',
  InternalServerError: 'INTERNAL_SERVER_ERROR',
  InvalidCreditCard: 'INVALID_CREDIT_CARD',
  InvalidGiftCard: 'INVALID_GIFT_CARD',
  InvalidOrder: 'INVALID_ORDER',
  LoginAlreadyExists: 'LOGIN_ALREADY_EXISTS',
  LongTermPaymentError: 'LONG_TERM_PAYMENT_ERROR',
  NotFound: 'NOT_FOUND',
  NoGiftcards: 'NO_GIFTCARDS',
  NumberExists: 'NUMBER_EXISTS',
  OpluxNg: 'OPLUX_NG',
  OtpDefaultError: 'OTP_DEFAULT_ERROR',
  OtpLoginDisabled: 'OTP_LOGIN_DISABLED',
  RejectedCreditCard: 'REJECTED_CREDIT_CARD',
  TtlExpired: 'TTL_EXPIRED',
  UnableToOrder: 'UNABLE_TO_ORDER',
  UnexpectedApiResponse: 'UNEXPECTED_API_RESPONSE',
  WrongPin: 'WRONG_PIN'
} as const;

export type GraphQlError = typeof GraphQlError[keyof typeof GraphQlError];
export type HighlightContent = MobileAppProductTileCustom | MobileAppProductTileStandard | MobileAppTeaserTile;

export const HorizontalAlignment = {
  Center: 'center',
  Left: 'left',
  Right: 'right'
} as const;

export type HorizontalAlignment = typeof HorizontalAlignment[keyof typeof HorizontalAlignment];
export type HotspotHero = {
  __typename?: 'HotspotHero';
  id: Scalars['String'];
};

export type HowToWearIt = {
  __typename?: 'HowToWearIt';
  _id: Scalars['ID'];
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
};

export type Iframe = {
  __typename?: 'Iframe';
  _id: Scalars['ID'];
  fullScreen: Scalars['Boolean'];
  height?: Maybe<Scalars['String']>;
  heightPercentage?: Maybe<Scalars['Int']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  identifier: Scalars['String'];
  src: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  landscape?: Maybe<SanityImage>;
  portrait?: Maybe<SanityImage>;
  square?: Maybe<SanityImage>;
};

export type Info = {
  __typename?: 'Info';
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
  label?: Maybe<Scalars['String']>;
};

export type InfoBanner = {
  __typename?: 'InfoBanner';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  backgroundOverlay?: Maybe<BackgroundOverlay>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  mobileBackgroundImage?: Maybe<SanityImage>;
  mobileBackgroundOverlay?: Maybe<BackgroundOverlay>;
  puid?: Maybe<BannerIdentifier>;
  showCountdownBeneathSubheading?: Maybe<Scalars['Boolean']>;
  textColor?: Maybe<Scalars['String']>;
};

export type Information = {
  __typename?: 'Information';
  details?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

export type Interest = {
  __typename?: 'Interest';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Array<HighlightContent>>;
  id: Scalars['ID'];
  image: SanityImage;
  name?: Maybe<Scalars['String']>;
};

/** Inventory information for a specific product variant and size */
export type Inventory = {
  __typename?: 'Inventory';
  /** Product ID e.g. 190123456789 */
  id: Scalars['ID'];
  limitedAvailability: Scalars['Boolean'];
  quantity: Scalars['Int'];
};

export type Issuer = {
  __typename?: 'Issuer';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ItemToBeAddedToCart = {
  bonusItemId?: InputMaybe<Scalars['String']>;
  masterId?: InputMaybe<Scalars['String']>;
  productCustomization?: InputMaybe<ProductCustomizationInput>;
  productId: Scalars['String'];
  productPersonalization?: InputMaybe<ProductPersonalizationInput>;
  quantity: Scalars['Int'];
};

export type KlarnaAction = CheckoutAwaitAction | CheckoutRedirectAction | CheckoutSdkAction;

export type KlarnaAddress = {
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
  organization_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street_address?: InputMaybe<Scalars['String']>;
  street_address2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type KlarnaAssetsUrl = {
  __typename?: 'KlarnaAssetsUrl';
  descriptive?: Maybe<Scalars['String']>;
  standard?: Maybe<Scalars['String']>;
};

export type KlarnaAuthorizedPaymentMethod = {
  __typename?: 'KlarnaAuthorizedPaymentMethod';
  numberOfDays?: Maybe<Scalars['Int']>;
  numberOfInstallments?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type KlarnaCreateOrderResponse = {
  __typename?: 'KlarnaCreateOrderResponse';
  authorized_payment_method?: Maybe<KlarnaAuthorizedPaymentMethod>;
  fraud_status?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
};

export type KlarnaCreateSessionInput = {
  billing_address?: InputMaybe<KlarnaAddress>;
  merchant_reference1?: InputMaybe<Scalars['String']>;
  order_amount?: InputMaybe<Scalars['Int']>;
  order_lines?: InputMaybe<Array<InputMaybe<OrderLines>>>;
  order_tax_amount?: InputMaybe<Scalars['Int']>;
  purchase_country?: InputMaybe<Scalars['String']>;
  purchase_currency?: InputMaybe<Scalars['String']>;
  shipping_address?: InputMaybe<KlarnaAddress>;
};

export type KlarnaCreateSessionPayload = {
  __typename?: 'KlarnaCreateSessionPayload';
  clientToken?: Maybe<Scalars['String']>;
  paymentMethodCategories?: Maybe<Array<Maybe<KlarnaPaymentMethodCategories>>>;
  sessionId?: Maybe<Scalars['String']>;
};

export type KlarnaCreateSessionResponse = {
  __typename?: 'KlarnaCreateSessionResponse';
  client_token?: Maybe<Scalars['String']>;
  payment_method_categories?: Maybe<Array<Maybe<KlarnaPaymentMethodCategoriesResponse>>>;
  session_id?: Maybe<Scalars['String']>;
};

export type KlarnaGooglePayInput = {
  googlePayToken: Scalars['String'];
};

export type KlarnaInput = {
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
};

export type KlarnaPaymentInput = {
  applePayToken?: InputMaybe<Scalars['String']>;
  browserInfo?: InputMaybe<BrowserInfo>;
  cardDetails?: InputMaybe<CardDetails>;
  checkoutAttemptId?: InputMaybe<Scalars['String']>;
  clientStateDataIndicator?: InputMaybe<Scalars['Boolean']>;
  encryptedCard?: InputMaybe<EncryptedCard>;
  googlePay?: InputMaybe<AdyenGooglePayInput>;
  issuer?: InputMaybe<Scalars['String']>;
  paymentMethodSubType?: InputMaybe<KlarnaPaymentMethodSubType>;
  paymentMethodType: KlarnaPaymentMethod;
  returnUrl?: InputMaybe<Scalars['String']>;
  riskData?: InputMaybe<RiskData>;
  virtualPaymentAddress?: InputMaybe<Scalars['String']>;
};

export const KlarnaPaymentMethod = {
  Klarna: 'KLARNA',
  KlarnaAccount: 'KLARNA_ACCOUNT'
} as const;

export type KlarnaPaymentMethod = typeof KlarnaPaymentMethod[keyof typeof KlarnaPaymentMethod];
export type KlarnaPaymentMethodCategories = {
  __typename?: 'KlarnaPaymentMethodCategories';
  assetUrl?: Maybe<KlarnaAssetsUrl>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type KlarnaPaymentMethodCategoriesResponse = {
  __typename?: 'KlarnaPaymentMethodCategoriesResponse';
  asset_urls?: Maybe<KlarnaAssetsUrl>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const KlarnaPaymentMethodSubType = {
  Redirect: 'REDIRECT',
  Sdk: 'SDK'
} as const;

export type KlarnaPaymentMethodSubType = typeof KlarnaPaymentMethodSubType[keyof typeof KlarnaPaymentMethodSubType];
export type KlarnaPayments = {
  __typename?: 'KlarnaPayments';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type KlarnaProductInfo = {
  product_id: Scalars['String'];
  product_url: Scalars['String'];
};

export type KlarnaResult = {
  __typename?: 'KlarnaResult';
  action: Scalars['String'];
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export const KlarnaResultCodeEnum = {
  CheckoutIncomplete: 'CHECKOUT_INCOMPLETE'
} as const;

export type KlarnaResultCodeEnum = typeof KlarnaResultCodeEnum[keyof typeof KlarnaResultCodeEnum];
export type LaunchCalendar = {
  __typename?: 'LaunchCalendar';
  _id: Scalars['ID'];
  calendarContent: Array<Media>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
};

export const LayoutDirection = {
  Left: 'left',
  Right: 'right'
} as const;

export type LayoutDirection = typeof LayoutDirection[keyof typeof LayoutDirection];
export type Link = {
  __typename?: 'Link';
  href: Scalars['String'];
  newtab?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
};

export type LinkListing = {
  __typename?: 'LinkListing';
  id: Scalars['String'];
  links?: Maybe<Array<Cta>>;
};

export const LinkVariant = {
  Black: 'black',
  Primary: 'primary',
  Secondary: 'secondary',
  White: 'white'
} as const;

export type LinkVariant = typeof LinkVariant[keyof typeof LinkVariant];
export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  shoppingCartId?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
};

export type LoginWithPhoneInput = {
  password: Scalars['String'];
  phoneNo: Scalars['String'];
  shoppingCartId?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
};

export type LongTermPreOrder = {
  __typename?: 'LongTermPreOrder';
  hasLongTermPreOrderItem?: Maybe<Scalars['Boolean']>;
  longTermPreOrderItemPaymentMethods?: Maybe<Scalars['String']>;
};

export type MainFooter = {
  __typename?: 'MainFooter';
  aboutLinks: Array<Cta>;
  featuredLinks: Array<Cta>;
  id: Scalars['String'];
  legalLinks: Array<Cta>;
  minimalLinks: Array<Cta>;
  /** @deprecated Use signUpForms instead */
  signUpForm?: Maybe<SignUpForm>;
  signUpForms?: Maybe<Array<Maybe<SignUpForm>>>;
  supportLinks: Array<Cta>;
};

export type MainNav = {
  __typename?: 'MainNav';
  children?: Maybe<Array<MainNavItem>>;
  id: Scalars['String'];
  userMenuQuicklinks?: Maybe<Array<Cta>>;
};

export type MainNavCategory = {
  __typename?: 'MainNavCategory';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<SanityImage>;
  title?: Maybe<Scalars['String']>;
};

export type MainNavItem = {
  __typename?: 'MainNavItem';
  children?: Maybe<Array<MainNavItem>>;
  id: Scalars['String'];
  image?: Maybe<SanityImage>;
  label: Scalars['String'];
  link?: Maybe<MainNavLink>;
  navChildren?: Maybe<Array<MainNavItem>>;
  navColor?: Maybe<Scalars['String']>;
};

export type MainNavLink = {
  __typename?: 'MainNavLink';
  category?: Maybe<MainNavCategory>;
  href?: Maybe<Scalars['String']>;
  newtab?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
};

export type ManageCustomerLevelNotificationInput = {
  customer: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ManageOrderLevelNotificationInput = {
  customer: Scalars['String'];
  firstName: Scalars['String'];
  isGuest: Scalars['Boolean'];
  lastName: Scalars['String'];
  orderNo: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ManufacturerInfo = {
  __typename?: 'ManufacturerInfo';
  countryOfOrigin?: Maybe<Info>;
  manufacturerAddress?: Maybe<Info>;
};

export type MarkDefs = {
  __typename?: 'MarkDefs';
  _key: Scalars['String'];
  _ref?: Maybe<Scalars['String']>;
  _type: Scalars['String'];
  href?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  newtab?: Maybe<Scalars['Boolean']>;
};

export type MarketingPage = Page & {
  __typename?: 'MarketingPage';
  id: Scalars['ID'];
  seo?: Maybe<Seo>;
  slots: Array<Maybe<ComponentWithFilters>>;
  title: Scalars['String'];
};


export type MarketingPageSlotsArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type Media = Card | Tile;

export type Message = {
  __typename?: 'Message';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  campaign?: Maybe<Array<Maybe<Campaign>>>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  id: Scalars['String'];
  information?: Maybe<Information>;
  text: Scalars['String'];
};

export type MobileApp404PageContent = MobileAppProductRecommendations | MobileAppTeaserTile;

export type MobileAppCta = {
  __typename?: 'MobileAppCTA';
  id: Scalars['ID'];
  link?: Maybe<MobileAppLink>;
  title?: Maybe<Scalars['String']>;
};

export type MobileAppCarousel = {
  __typename?: 'MobileAppCarousel';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  content?: Maybe<Array<MobileAppCarouselContent>>;
  identifier: Scalars['String'];
};

export type MobileAppCarouselContent = MobileAppProductTileCustom | MobileAppProductTileStandard | MobileAppTeaserTile | ProductTile | SanityImage;

export type MobileAppCartNotice = {
  __typename?: 'MobileAppCartNotice';
  id: Scalars['ID'];
  notices?: Maybe<Array<Scalars['String']>>;
};

export type MobileAppCategoryLink = {
  __typename?: 'MobileAppCategoryLink';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MobileAppHomePageContent = MobileAppCarousel | MobileAppProductRecommendations | MobileAppProductTileCustom | MobileAppProductTileStandard | MobileAppQuoteCallout | MobileAppTeaserTile | ProductCarousel | ProductTile | SignUpForm | VideoHero;

export type MobileAppInboxItem = {
  __typename?: 'MobileAppInboxItem';
  countdownClock?: Maybe<CountdownClock>;
  date: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  link?: Maybe<MobileAppLink>;
  messageCategory?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MobileAppLink = {
  __typename?: 'MobileAppLink';
  absolute?: Maybe<Scalars['String']>;
  category?: Maybe<MobileAppCategoryLink>;
  marketing?: Maybe<Scalars['String']>;
  product?: Maybe<MobileAppProductLink>;
  /** @deprecated No longer supported */
  pumatracLink?: Maybe<PumatracLink>;
  support?: Maybe<Scalars['String']>;
};

export type MobileAppNotificationBanner = {
  __typename?: 'MobileAppNotificationBanner';
  availableFrom: Scalars['String'];
  availableTo: Scalars['String'];
  badge?: Maybe<Scalars['String']>;
  badgeColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<MobileAppLink>;
  title?: Maybe<Scalars['String']>;
};

export type MobileAppProductLink = {
  __typename?: 'MobileAppProductLink';
  color?: Maybe<Scalars['String']>;
  masterId?: Maybe<Scalars['String']>;
};

export type MobileAppProductRecommendations = {
  __typename?: 'MobileAppProductRecommendations';
  _id: Scalars['ID'];
  header?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  promotionId?: Maybe<Scalars['String']>;
  recommendations: Array<Maybe<ProductSearchHit>>;
};

export type MobileAppProductTileCustom = {
  __typename?: 'MobileAppProductTileCustom';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  header?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  link?: Maybe<MobileAppLink>;
  product?: Maybe<Variant>;
  showPrice?: Maybe<Scalars['Boolean']>;
};

export type MobileAppProductTileStandard = {
  __typename?: 'MobileAppProductTileStandard';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  product?: Maybe<Variant>;
};

export type MobileAppQuoteCallout = {
  __typename?: 'MobileAppQuoteCallout';
  alignment?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  backgroundOverlay?: Maybe<BackgroundOverlay>;
  /** @deprecated No longer supported */
  buttonColor?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  /** @deprecated use ctas2 instead */
  ctas?: Maybe<Array<MobileAppCta>>;
  ctas2?: Maybe<Array<Cta>>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  link?: Maybe<MobileAppLink>;
  source?: Maybe<Scalars['String']>;
};

export type MobileAppRecommendedWorkout = {
  __typename?: 'MobileAppRecommendedWorkout';
  _id: Scalars['ID'];
  badge?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  header: Scalars['String'];
  image?: Maybe<SanityImage>;
  link?: Maybe<MobileAppLink>;
};

export type MobileAppStory = {
  __typename?: 'MobileAppStory';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  storyContent?: Maybe<Array<MobileAppStoryContent>>;
  thumbnail?: Maybe<SanityImage>;
};

export type MobileAppStoryContent = {
  __typename?: 'MobileAppStoryContent';
  buttonLabel?: Maybe<Scalars['String']>;
  displayLength?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<SanityImage>;
  link?: Maybe<MobileAppLink>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  videoPosterImage?: Maybe<Scalars['String']>;
  videoV2?: Maybe<Video>;
};

export type MobileAppTeaserTile = {
  __typename?: 'MobileAppTeaserTile';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  badge?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  /** @deprecated use ctas2 instead */
  ctas?: Maybe<Array<MobileAppCta>>;
  ctas2?: Maybe<Array<Cta>>;
  header?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  image: SanityImage;
  link?: Maybe<MobileAppLink>;
  textColor?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAddress: Address;
  addAmazonPayPaymentMethodToCart: Cart;
  addAmbassadorCardToCart: Cart;
  addCashOnDeliveryPaymentMethodToCart: Cart;
  addCouponToCart: Cart;
  addCreditCardPaymentMethodToCart: Cart;
  addGiftCard: Cart;
  addGiftCardToCart: Cart;
  /** @deprecated This mutation is being phased out. Use addItemsToCart instead. */
  addItemToCart: Cart;
  addItemToWishList: WishList;
  addItemsToCart: Cart;
  addItemsToWishList: WishList;
  addPayPayPaymentMethodToCart: Cart;
  addPaymentPromotion: Cart;
  addStoreCredits: AddStoreCreditsPayload;
  afterPay: AfterPayPayload;
  amazonPay: StandardOrder;
  ambassadorCard: StandardOrder;
  applePay: ApplePayValidationResponse;
  cancelAfterPay: StandardOrder;
  cancelAmazonPay: StandardOrder;
  cancelApplePay: Cart;
  cancelCashOnDelivery: StandardOrder;
  cancelCreditCard: StandardOrder;
  cancelGooglePay: Cart;
  cancelKlarna: StandardOrder;
  cancelOnlineBanking: StandardOrder;
  cancelOrder?: Maybe<CancelOrderPayload>;
  cancelPayPal: StandardOrder;
  cancelPayPay: StandardOrder;
  cancelPayTm: StandardOrder;
  cancelUpi: StandardOrder;
  cancelWallet: StandardOrder;
  cashOnDelivery: StandardOrder;
  /** @deprecated Use updatePhone. */
  checkNumberAndSendSms?: Maybe<CheckNumberAndSendSmsResult>;
  completeAdyenPayment?: Maybe<AdyenPaymentDetailsPayload>;
  /** Completes the Amazon session and marks the order to ready to export if payment in captured. */
  completeAmazonPayment: CompleteAmazonPaymentPayload;
  completeResetPassword: Scalars['Boolean'];
  confirmAfterPay: StandardOrder;
  confirmAmazonPay: StandardOrder;
  confirmApplePay: StandardOrder;
  confirmCashOnDelivery: StandardOrder;
  /** @deprecated For 3DS Credit Cards use CompleteAdyenPayment when possible. */
  confirmCreditCard: StandardOrder;
  confirmKlarna: StandardOrder;
  confirmKlarnaPayment: StandardOrder;
  /** @deprecated Not used */
  confirmLoginWithEmailOTP?: Maybe<AuthPayload>;
  /** @deprecated Use verifyLoginWithOTP instead. */
  confirmLoginWithOTP?: Maybe<AuthPayload>;
  confirmOnlineBanking: StandardOrder;
  confirmPayPal: StandardOrder;
  confirmPayPay: StandardOrder;
  /** @deprecated Use confirmPayTmWithResultCode instead */
  confirmPayTm: StandardOrder;
  confirmPayTmWithResultCode: StandardOrder;
  confirmRazorPay: ConfirmRazorPayPayload;
  confirmUpdatePhone: ConfirmUpdatePhonePayload;
  /** @deprecated Use confirmUpiTmWithResultCode instead */
  confirmUpi: StandardOrder;
  confirmUpiWithResultCode: StandardOrder;
  /** @deprecated Use confirmWalletWithResultCode instead */
  confirmWallet: StandardOrder;
  confirmWalletWithResultCode: StandardOrder;
  createCart: Cart;
  createContact?: Maybe<NewsletterSubscription>;
  createReview?: Maybe<Review>;
  createShopperContext?: Maybe<ShopperContextPayload>;
  creditCard: CreditCardResult;
  deleteAccountRequest: Scalars['Boolean'];
  deleteAddress: Scalars['Boolean'];
  deleteAmbassadorCard: User;
  deleteCreditCard: User;
  giftCard: StandardOrder;
  gmoConfirmCreditCard: StandardOrder;
  googlePay: StandardOrder;
  guestLogon: TokenPayload;
  klarna: KlarnaResult;
  login?: Maybe<AuthPayload>;
  loginWithEmailOTP?: Maybe<SendEmailOtpResult>;
  loginWithOTP?: Maybe<Scalars['String']>;
  loginWithPhone?: Maybe<AuthPayload>;
  logout?: Maybe<Scalars['Boolean']>;
  manageCustomerLevelNotification?: Maybe<Scalars['String']>;
  manageOrderLevelNotification: Scalars['Boolean'];
  onlineBanking: OnlineBankingResult;
  opluxFraudDetection?: Maybe<OpluxFraudDetectionResult>;
  payPal: PayPalResult;
  payPay: PayPayPayload;
  payTm: PayTmResult;
  /**
   * Place Order should be called when Cart.amountRemaining is 0 and all payment instruments are approved.
   * Typically this would be where the cart total is paid in full by gift cards and/or store credit
   */
  placeOrder?: Maybe<PlaceOrderPayload>;
  profilingConsent?: Maybe<ProfilingConsentResponse>;
  refreshLogon: TokenPayload;
  /** @deprecated Use refreshLogon instead */
  refreshToken?: Maybe<Scalars['String']>;
  register?: Maybe<AuthPayload>;
  /** Associates the session with the basket. Called on any redirect, when users sing in/change address/change payment method in their wallet. */
  registerAmazonPayment: RegisterAmazonPaymentPayload;
  removeAmbassadorCardFromCart: Cart;
  removeCouponFromCart: Cart;
  removeGiftCard: Cart;
  removeGiftCardFromCart: Cart;
  removeItemFromCart: Cart;
  removeItemFromWishList: Scalars['Boolean'];
  removeStoreCredits: RemoveStoreCreditsPayload;
  resendOTP?: Maybe<Scalars['String']>;
  resetPassword: Scalars['Boolean'];
  saveAmbassadorCard: User;
  saveCreditCard: User;
  saveNotificationPreferences?: Maybe<NotificationsPayload>;
  /** Signs the payload created by the frontend. Use it's response to pass to the Amazon "renderButton" method. */
  signAmazonPayload: SignAmazonPayloadResponse;
  startAdyenPayment?: Maybe<StartPaymentPayload>;
  /** Creates an order and locks down the amount to charge the user with. On success, it should return the url for the final redirection. */
  startAmazonPayment: StartAmazonPaymentPayload;
  /** Creates an order and attaches Amazon PI v2 to the sfcc Order. */
  startAmazonProcessOrderPayment: StartAmazonProcessOrderPaymentPayload;
  startCreditCardPayment: StandardOrder;
  startKlarnaPayment?: Maybe<StartKlarnaPaymentPayload>;
  startRazorPay: StartRazorPayPayload;
  trackGuestUser: Scalars['Boolean'];
  trackRegisteredUser: Scalars['Boolean'];
  trackUserEvent: Scalars['Boolean'];
  transferCart: Cart;
  updateAddress: Address;
  updateAmbassadorCards: User;
  updateBillingAddress: Cart;
  updateContact?: Maybe<NewsletterSubscription>;
  updateItemInCart: Cart;
  updateItemInWishList: WishList;
  /** @deprecated No longer needed. Use opluxFraudDetection instead. */
  updateOpluxDataToBasket?: Maybe<Cart>;
  updatePassword: Scalars['Boolean'];
  updatePayPal: StandardOrder;
  updatePhone: UpdatePhonePayload;
  updateProfile: User;
  updateShipmentMethod: Cart;
  updateShippingAddress: Cart;
  upi: UpiResult;
  validateApplePayMerchant: Scalars['String'];
  verifyLoginWithOTP: VerifyLoginWithOtpResult;
  /** @deprecated Use confirmUpdatePhone. */
  verifyOtpProfile: Scalars['Boolean'];
  verifyUserAffiliations: VerifyUserAffiliationsPayload;
  wallet: WalletResult;
};


export type MutationAddAddressArgs = {
  input: AddressInput;
};


export type MutationAddAmazonPayPaymentMethodToCartArgs = {
  input: AddAmazonPayToCartInput;
};


export type MutationAddAmbassadorCardToCartArgs = {
  input: AddAmbassadorCardToCartInput;
};


export type MutationAddCashOnDeliveryPaymentMethodToCartArgs = {
  input: AddCashOnDeliveryToCartInput;
};


export type MutationAddCouponToCartArgs = {
  input: AddCouponToCartInput;
};


export type MutationAddCreditCardPaymentMethodToCartArgs = {
  input: AddCreditCardToCartInput;
};


export type MutationAddGiftCardArgs = {
  input: AddGiftCardInput;
};


export type MutationAddGiftCardToCartArgs = {
  input: AddGiftCardToCartInput;
};


export type MutationAddItemToCartArgs = {
  input: AddItemToCartInput;
};


export type MutationAddItemToWishListArgs = {
  input: AddItemToWishListInput;
};


export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


export type MutationAddItemsToWishListArgs = {
  input: AddItemsToWishListInput;
};


export type MutationAddPayPayPaymentMethodToCartArgs = {
  input: AddPayPayToCartInput;
};


export type MutationAddPaymentPromotionArgs = {
  input: AddPaymentPromotionInput;
};


export type MutationAddStoreCreditsArgs = {
  input: AddStoreCreditsInput;
};


export type MutationAfterPayArgs = {
  input: AfterPayInput;
};


export type MutationAmazonPayArgs = {
  input: AmazonPayInput;
};


export type MutationAmbassadorCardArgs = {
  input: AmbassadorCardInput;
};


export type MutationApplePayArgs = {
  input: ApplePayInput;
};


export type MutationCancelAfterPayArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelAmazonPayArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelApplePayArgs = {
  basketId: Scalars['String'];
};


export type MutationCancelCashOnDeliveryArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelCreditCardArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelGooglePayArgs = {
  input: CancelGooglePayInput;
};


export type MutationCancelKlarnaArgs = {
  input: CancelKlarnaInput;
};


export type MutationCancelOnlineBankingArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelPayPalArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelPayPayArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelPayTmArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelUpiArgs = {
  orderNo: Scalars['String'];
};


export type MutationCancelWalletArgs = {
  orderNo: Scalars['String'];
};


export type MutationCashOnDeliveryArgs = {
  input: CashOnDeliveryInput;
};


export type MutationCheckNumberAndSendSmsArgs = {
  input: OtpSendInput;
};


export type MutationCompleteAdyenPaymentArgs = {
  input: CompleteAdyenPaymentInput;
};


export type MutationCompleteAmazonPaymentArgs = {
  input: CompleteAmazonPaymentInput;
};


export type MutationCompleteResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationConfirmAfterPayArgs = {
  input: ConfirmAfterPayInput;
};


export type MutationConfirmAmazonPayArgs = {
  input: ConfirmAmazonPayInput;
};


export type MutationConfirmApplePayArgs = {
  input: ConfirmApplePayInput;
};


export type MutationConfirmCashOnDeliveryArgs = {
  input: ConfirmCashOnDeliveryInput;
};


export type MutationConfirmCreditCardArgs = {
  input: ConfirmCreditCardInput;
};


export type MutationConfirmKlarnaArgs = {
  input: ConfirmKlarnaInput;
};


export type MutationConfirmKlarnaPaymentArgs = {
  input: ConfirmKlarnaPaymentInput;
};


export type MutationConfirmLoginWithEmailOtpArgs = {
  input: EmailOtpVerificationInput;
};


export type MutationConfirmLoginWithOtpArgs = {
  input: OtpVerificationInput;
};


export type MutationConfirmOnlineBankingArgs = {
  input: ConfirmOnlineBankingInput;
};


export type MutationConfirmPayPalArgs = {
  input: ConfirmPayPalInput;
};


export type MutationConfirmPayPayArgs = {
  input: ConfirmPayPayInput;
};


export type MutationConfirmPayTmArgs = {
  orderNo: Scalars['String'];
};


export type MutationConfirmPayTmWithResultCodeArgs = {
  input: ConfirmPayTmWithResultCodeInput;
};


export type MutationConfirmRazorPayArgs = {
  input: ConfirmRazorPayInput;
};


export type MutationConfirmUpdatePhoneArgs = {
  input: ConfirmUpdatePhoneInput;
};


export type MutationConfirmUpiArgs = {
  orderNo: Scalars['String'];
};


export type MutationConfirmUpiWithResultCodeArgs = {
  input: ConfirmUpiWithResultCodeInput;
};


export type MutationConfirmWalletArgs = {
  orderNo: Scalars['String'];
};


export type MutationConfirmWalletWithResultCodeArgs = {
  input: ConfirmWalletWithResultCodeInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateShopperContextArgs = {
  input: CreateShopperContextInput;
};


export type MutationCreditCardArgs = {
  input: CreditCardInput;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAmbassadorCardArgs = {
  input: DeleteAmbassadorCardInput;
};


export type MutationDeleteCreditCardArgs = {
  input: DeleteCardInput;
};


export type MutationGiftCardArgs = {
  input: GiftCardInput;
};


export type MutationGmoConfirmCreditCardArgs = {
  input: GmoConfirmCreditCardInput;
};


export type MutationGooglePayArgs = {
  input: GooglePayInput;
};


export type MutationKlarnaArgs = {
  input: KlarnaInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginWithEmailOtpArgs = {
  input: EmailOtpSendInput;
};


export type MutationLoginWithOtpArgs = {
  input: OtpSendInput;
};


export type MutationLoginWithPhoneArgs = {
  input: LoginWithPhoneInput;
};


export type MutationManageCustomerLevelNotificationArgs = {
  input: ManageCustomerLevelNotificationInput;
};


export type MutationManageOrderLevelNotificationArgs = {
  input: ManageOrderLevelNotificationInput;
};


export type MutationOnlineBankingArgs = {
  input: OnlineBankingInput;
};


export type MutationOpluxFraudDetectionArgs = {
  basketId: Scalars['String'];
  fraudbuster?: InputMaybe<Scalars['String']>;
  opluxEventId?: InputMaybe<Scalars['String']>;
  opluxFraudDetection?: InputMaybe<Scalars['String']>;
  opluxScreeningResult?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
};


export type MutationPayPalArgs = {
  input: PayPalInput;
};


export type MutationPayPayArgs = {
  input: PayPayInput;
};


export type MutationPayTmArgs = {
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
};


export type MutationPlaceOrderArgs = {
  input: PlaceOrderInput;
};


export type MutationProfilingConsentArgs = {
  input?: InputMaybe<ProfilingConsentInput>;
};


export type MutationRefreshLogonArgs = {
  input: RefreshLogonInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRegisterAmazonPaymentArgs = {
  input: RegisterAmazonPaymentInput;
};


export type MutationRemoveAmbassadorCardFromCartArgs = {
  input: RemoveAmbassadorCardFromCartInput;
};


export type MutationRemoveCouponFromCartArgs = {
  input: RemoveCouponFromCartInput;
};


export type MutationRemoveGiftCardArgs = {
  input: RemoveGiftCardInput;
};


export type MutationRemoveGiftCardFromCartArgs = {
  input: RemoveGiftCardFromCartInput;
};


export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


export type MutationRemoveItemFromWishListArgs = {
  input: RemoveItemFromWishListInput;
};


export type MutationRemoveStoreCreditsArgs = {
  input: RemoveStoreCreditsInput;
};


export type MutationResendOtpArgs = {
  input: OtpResendInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationSaveAmbassadorCardArgs = {
  input: SaveAmbassadorCardInput;
};


export type MutationSaveCreditCardArgs = {
  input: SaveCreditCardInput;
};


export type MutationSaveNotificationPreferencesArgs = {
  input: NotificationsPreferenceInput;
};


export type MutationSignAmazonPayloadArgs = {
  input: SignAmazonPayloadInput;
};


export type MutationStartAdyenPaymentArgs = {
  input: StartAdyenPaymentInput;
};


export type MutationStartAmazonPaymentArgs = {
  input: StartAmazonPaymentInput;
};


export type MutationStartAmazonProcessOrderPaymentArgs = {
  input: StartAmazonProcessOrderPaymentInput;
};


export type MutationStartCreditCardPaymentArgs = {
  input: StartCreditCardPaymentInput;
};


export type MutationStartKlarnaPaymentArgs = {
  input: StartKlarnaPaymentInput;
};


export type MutationStartRazorPayArgs = {
  input: StartRazorPayInput;
};


export type MutationTrackGuestUserArgs = {
  input: TrackGuestUserInput;
};


export type MutationTrackRegisteredUserArgs = {
  input: TrackRegisteredUserInput;
};


export type MutationTrackUserEventArgs = {
  input: TrackUserEventInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAmbassadorCardsArgs = {
  input: UpdateAmbassadorCardInput;
};


export type MutationUpdateBillingAddressArgs = {
  input: UpdateBillingAddressInput;
};


export type MutationUpdateContactArgs = {
  input: CreateContactInput;
};


export type MutationUpdateItemInCartArgs = {
  input: UpdateItemInCartInput;
};


export type MutationUpdateItemInWishListArgs = {
  input: UpdateItemInWishListInput;
};


export type MutationUpdateOpluxDataToBasketArgs = {
  basketId: Scalars['String'];
  isClearOpluxData?: InputMaybe<Scalars['Boolean']>;
  opluxEventId?: InputMaybe<Scalars['String']>;
  opluxScreeningResult?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePasswordArgs = {
  input: PasswordInput;
};


export type MutationUpdatePayPalArgs = {
  input: ConfirmPayPalInput;
};


export type MutationUpdatePhoneArgs = {
  input: UpdatePhoneInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileInput;
};


export type MutationUpdateShipmentMethodArgs = {
  input: UpdateShipmentMethodInput;
};


export type MutationUpdateShippingAddressArgs = {
  input: UpdateShippingAddressInput;
};


export type MutationUpiArgs = {
  input: UpiInput;
};


export type MutationValidateApplePayMerchantArgs = {
  input: ValidateApplePayMerchantInput;
};


export type MutationVerifyLoginWithOtpArgs = {
  input: VerifyLoginWithOtpInput;
};


export type MutationVerifyOtpProfileArgs = {
  input: OtpVerificationInput;
};


export type MutationVerifyUserAffiliationsArgs = {
  input: VerifyUserAffiliationsInput;
};


export type MutationWalletArgs = {
  input: WalletInput;
};

export type MyCustomizerSettings = {
  __typename?: 'MyCustomizerSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  iframeID?: Maybe<Scalars['String']>;
  startPoint?: Maybe<Scalars['String']>;
};

export type NameTranslations = {
  __typename?: 'NameTranslations';
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
};

export type NestedOrder = BaseOrder & {
  __typename?: 'NestedOrder';
  billingAddress?: Maybe<OrderAddress>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<CustomerInfo>;
  estimatedShippingCosts?: Maybe<Scalars['Float']>;
  estimatedTotal?: Maybe<Scalars['Float']>;
  exportStatus?: Maybe<Scalars['String']>;
  isReturnable: Scalars['Boolean'];
  orderAdjustments: Array<Adjustment>;
  orderNo: Scalars['ID'];
  orderStatus?: Maybe<OrderStatus>;
  payPayAsyncResultNoticed?: Maybe<Scalars['Boolean']>;
  paymentInstruments: Array<PaymentInstrument>;
  shipment?: Maybe<Shipment>;
  shippingAdjustments: Array<Adjustment>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingStatus?: Maybe<Scalars['String']>;
  shippingSurcharge?: Maybe<ShippingSurcharge>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  suborders: Array<Suborder>;
  taxTotal?: Maybe<Scalars['Float']>;
  taxation?: Maybe<Taxation>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export type NewsletterSubscription = {
  __typename?: 'NewsletterSubscription';
  dob?: Maybe<Dob>;
  email?: Maybe<Scalars['String']>;
  emailPreference?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstNamePronunciation?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  iframeURL?: Maybe<Scalars['String']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastNamePronunciation?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  shoppingPreference?: Maybe<Scalars['String']>;
};

export type NotFound = {
  __typename?: 'NotFound';
  textSection: TextSection;
};

export type NotFoundContentPage = Page & {
  __typename?: 'NotFoundContentPage';
  id: Scalars['ID'];
};

export type NotImplemented = {
  __typename?: 'NotImplemented';
  _id: Scalars['ID'];
  _type: Scalars['String'];
};

export type NotificationsPayload = {
  __typename?: 'NotificationsPayload';
  customerSmsOptIn?: Maybe<Scalars['Boolean']>;
  marketingSmsOptIn?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type NotificationsPreferenceInput = {
  customerSmsOptIn: Scalars['Boolean'];
  marketingSmsOptIn: Scalars['Boolean'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OtpResendInput = {
  pinId: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};

export type OtpSendInput = {
  phoneNo: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};

export type OtpVerificationInput = {
  phoneNo: Scalars['String'];
  pin: Scalars['String'];
  pinId: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  shoppingCartId?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
};

export type OmsEntry = {
  __typename?: 'OmsEntry';
  customerId: Scalars['String'];
  /** @deprecated Read status from Order instead */
  status?: Maybe<Scalars['String']>;
  trackingLink?: Maybe<Scalars['String']>;
};

export type OnlineBanking = {
  __typename?: 'OnlineBanking';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type OnlineBankingInput = {
  bankId?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
};

export type OnlineBankingResult = {
  __typename?: 'OnlineBankingResult';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type OpluxFraudDetectionResult = {
  __typename?: 'OpluxFraudDetectionResult';
  isOpluxNG: Scalars['Boolean'];
  opluxEventId?: Maybe<Scalars['String']>;
  opluxScreeningResult?: Maybe<Scalars['String']>;
};

export type Order = NestedOrder | StandardOrder;

export type OrderAddress = {
  __typename?: 'OrderAddress';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  /** @deprecated No longer in use */
  address3?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryTimeCode?: Maybe<Scalars['String']>;
  deliveryTimeDisplayText?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstNamePronunciation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  lastNamePronunciation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  salutation?: Maybe<Scalars['String']>;
  stateCode: Scalars['String'];
  streetNumber?: Maybe<Scalars['String']>;
};

export type OrderAnalytics = {
  __typename?: 'OrderAnalytics';
  netProratedDiscount?: Maybe<Scalars['Float']>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  nodes: Array<StandardOrder>;
  pageInfo?: Maybe<PageInfo>;
};

export type OrderLines = {
  name?: InputMaybe<Scalars['String']>;
  product_url?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  total_amount?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  unit_price?: InputMaybe<Scalars['Int']>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  code?: Maybe<OrderStatusCode>;
  label?: Maybe<Scalars['String']>;
};

export const OrderStatusCode = {
  BeingProcessed: 'BEING_PROCESSED',
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  CompletelyReturned: 'COMPLETELY_RETURNED',
  Created: 'CREATED',
  Delivered: 'DELIVERED',
  Failed: 'FAILED',
  New: 'NEW',
  Open: 'OPEN',
  OutForDelivery: 'OUT_FOR_DELIVERY',
  Packed: 'PACKED',
  PartiallyCancelled: 'PARTIALLY_CANCELLED',
  PartiallyDelivered: 'PARTIALLY_DELIVERED',
  PartiallyReturned: 'PARTIALLY_RETURNED',
  PartiallyShipped: 'PARTIALLY_SHIPPED',
  Replaced: 'REPLACED',
  Returned: 'RETURNED',
  Shipped: 'SHIPPED'
} as const;

export type OrderStatusCode = typeof OrderStatusCode[keyof typeof OrderStatusCode];
export type Page = {
  id: Scalars['ID'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit?: Maybe<Scalars['Int']>;
  nextOffset?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type PaginatedOutput = {
  __typename?: 'PaginatedOutput';
  chips: Array<Chip>;
  filteringOptions: Array<FilterOption>;
  hits: Array<SearchHitMeta>;
  limit: Scalars['Int'];
  nodes: Array<ProductSearchHit>;
  offset: Scalars['Int'];
  /** selected sorting option returned from OCAPI */
  selectedSort?: Maybe<Scalars['String']>;
  sortingOptions: Array<SortOption>;
  /** @deprecated this exists as a fallback for the mobile application reduced PLP and will be removed once we have more permanent performant PLP solution in place */
  summaries: Array<ProductSummary>;
  totalCount: Scalars['Int'];
};

export type PasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type PayPal = {
  __typename?: 'PayPal';
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type PayPalInput = {
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
  paymentPayload?: InputMaybe<Scalars['String']>;
};

export type PayPalResult = {
  __typename?: 'PayPalResult';
  action?: Maybe<Scalars['String']>;
  orderNo: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PayPay = {
  __typename?: 'PayPay';
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type PayPayContent = {
  __typename?: 'PayPayContent';
  body: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PayPayInput = {
  basketId: Scalars['String'];
  emailList: Scalars['Boolean'];
  feHost?: InputMaybe<Scalars['String']>;
  smsUpdate: Scalars['Boolean'];
};

export type PayPayPayload = {
  __typename?: 'PayPayPayload';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type PayPayResponse = {
  CheckString?: InputMaybe<Scalars['String']>;
  ErrCode?: InputMaybe<Scalars['String']>;
  ErrInfo?: InputMaybe<Scalars['String']>;
  OrderID?: InputMaybe<Scalars['String']>;
  PayPayOrderID?: InputMaybe<Scalars['String']>;
  PayPayTrackingID?: InputMaybe<Scalars['String']>;
  ShopID?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['String']>;
  TranDate?: InputMaybe<Scalars['String']>;
};

export type PayTm = {
  __typename?: 'PayTm';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type PayTmResult = {
  __typename?: 'PayTmResult';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type PaymentCardInput = {
  cardType: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  gmoSpecificPaymentData?: InputMaybe<GmoPaymentData>;
  holder?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  securityCode?: InputMaybe<Scalars['String']>;
};

export type PaymentCardSpec = {
  __typename?: 'PaymentCardSpec';
  cardType?: Maybe<Scalars['String']>;
  checksumVerificationEnabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberLengths?: Maybe<Array<Maybe<Scalars['String']>>>;
  numberPrefixes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentInstrument = Adyen | AdyenKlarna | AdyenKlarnaAccount | AdyenPayPal | AfterPay | Alipay | AmazonPay | AmbassadorCard | ApplePay | CashOnDelivery | CreditCard | CreditCardConfirm | GiftCard | GooglePay | KlarnaPayments | OnlineBanking | PayPal | PayPay | PayTm | Razorpay | Scheme | StoreCreditInstrument | Upi | Wallet | WechatPay | ZipPay;

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bank?: Maybe<Array<Issuer>>;
  c_additionalFee?: Maybe<Scalars['Int']>;
  cards?: Maybe<Array<PaymentCardSpec>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  paymentProcessorId?: Maybe<Scalars['String']>;
  wallet?: Maybe<Array<Issuer>>;
};

export type Pdp = {
  __typename?: 'Pdp';
  ProductStoryAdditionalContentSlot?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  aboveProductStory?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  belowProductGoogleShopping?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  belowProductStory?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  comingSoonSignUpForm?: Maybe<SignUpForm>;
  ctaAboveSpecialMessage?: Maybe<Array<Cta>>;
  id: Scalars['ID'];
  soldOutRecommender?: Maybe<Array<SoldOutRecommender>>;
};


export type PdpProductStoryAdditionalContentSlotArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type PdpAboveProductStoryArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type PdpBelowProductGoogleShoppingArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type PdpBelowProductStoryArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type PincodeServiceability = {
  __typename?: 'PincodeServiceability';
  city?: Maybe<Scalars['String']>;
  expectedDate?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
};

export type PixleeCdnPhotos = {
  __typename?: 'PixleeCdnPhotos';
  attributedMediumUrl?: Maybe<Scalars['String']>;
  largeUrl?: Maybe<Scalars['String']>;
  mediumUrl?: Maybe<Scalars['String']>;
  originalUrl?: Maybe<Scalars['String']>;
  smallUrl?: Maybe<Scalars['String']>;
  squareMediumUrl?: Maybe<Scalars['String']>;
};

export type PixleeConfig = {
  __typename?: 'PixleeConfig';
  advancedFilters?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enablePDPGallery: Scalars['Boolean'];
  id: Scalars['String'];
  numberPicturesGallery: Scalars['Int'];
  socialMediaIcon: Scalars['Boolean'];
};

export type PixleeSimpleWidget = {
  __typename?: 'PixleeSimpleWidget';
  _id: Scalars['ID'];
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  widgetId?: Maybe<Scalars['String']>;
};

export type PlaceOrderInput = {
  basketId: Scalars['ID'];
};

export type PlaceOrderPayload = {
  __typename?: 'PlaceOrderPayload';
  order?: Maybe<StandardOrder>;
};

export type PortableText = {
  __typename?: 'PortableText';
  _key: Scalars['String'];
  _type: Scalars['String'];
  children?: Maybe<Array<Maybe<Children>>>;
  level?: Maybe<Scalars['Int']>;
  listItem?: Maybe<Scalars['String']>;
  markDefs?: Maybe<Array<Maybe<MarkDefs>>>;
  style?: Maybe<Scalars['String']>;
};

export type PortableTextContent = Cta | PortableText;

export type PortableTextWithList = {
  __typename?: 'PortableTextWithList';
  _type: Scalars['String'];
  children?: Maybe<Array<Maybe<TextChildren>>>;
  id: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  listItem?: Maybe<Scalars['String']>;
  markDefs?: Maybe<Array<Maybe<MarkDefs>>>;
  style?: Maybe<Scalars['String']>;
};

export type PositionedTile = {
  __typename?: 'PositionedTile';
  id: Scalars['ID'];
  position: Scalars['Int'];
  tile: PromoTile;
};

export type PreviewInput = {
  abTest?: InputMaybe<Scalars['String']>;
  abTestSegment?: InputMaybe<Scalars['String']>;
  customerGroups?: InputMaybe<Array<Scalars['String']>>;
  global?: InputMaybe<Scalars['Boolean']>;
  viewAt?: InputMaybe<Scalars['String']>;
};

export type PriceInfo = {
  __typename?: 'PriceInfo';
  price?: Maybe<Scalars['Float']>;
  salePrice?: Maybe<Scalars['Float']>;
};

export type PrizeSlot = {
  __typename?: 'PrizeSlot';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  odds?: Maybe<Scalars['Int']>;
  prize?: Maybe<SanityPrize>;
};

export type Product = {
  __typename?: 'Product';
  /** @deprecated Deprecated as it was never used */
  altImageUrl?: Maybe<Scalars['String']>;
  amountOfReviews?: Maybe<Scalars['Int']>;
  appOnlyDateTimeFrom?: Maybe<Scalars['String']>;
  appOnlyDateTimeTo?: Maybe<Scalars['String']>;
  articleType?: Maybe<Scalars['String']>;
  averageRating?: Maybe<Scalars['Float']>;
  /** @deprecated Deprecated in favor of badges array */
  badge?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<ProductBadge>>;
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  /** @deprecated Deprecated in favor of colorValue */
  color: Scalars['String'];
  colorCount?: Maybe<Scalars['Int']>;
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  colors?: Maybe<Array<ProductColor>>;
  configureID?: Maybe<ConfigureIdSettings>;
  content?: Maybe<Pdp>;
  description?: Maybe<Scalars['String']>;
  displayOutOfStock?: Maybe<DisplayOutOfStock>;
  exploreMoreCTALabel?: Maybe<Scalars['String']>;
  exploreMoreCTATargetCategoryID?: Maybe<Scalars['String']>;
  fitOptions?: Maybe<Array<FitOptions>>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: ProductImage;
  /** @deprecated Deprecated in favour of image.href */
  imageUrl: Scalars['String'];
  isAppExclusive?: Maybe<Scalars['Boolean']>;
  isMixedCartAllowed?: Maybe<Scalars['Boolean']>;
  isWebExclusive?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use Query.outfits */
  look?: Maybe<Array<Maybe<StyliticsLook>>>;
  masterId: Scalars['ID'];
  myCustomizer?: Maybe<MyCustomizerSettings>;
  name: Scalars['String'];
  offline?: Maybe<Scalars['Boolean']>;
  orderable?: Maybe<Scalars['Boolean']>;
  orderableColorCount?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  primaryCategoryId?: Maybe<Scalars['String']>;
  productDivision?: Maybe<Scalars['String']>;
  productMeasurements?: Maybe<ProductMeasurements>;
  productNameTranslated?: Maybe<Scalars['JSON']>;
  productStory?: Maybe<ProductStory>;
  productVideos?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Deprecated in favor of promotions array */
  promotion?: Maybe<ProductPromotion>;
  /** Determines if the product is excluded from promotions. */
  promotionExclusion?: Maybe<Scalars['Boolean']>;
  promotions?: Maybe<Array<ProductPromotion>>;
  recommendedWorkouts?: Maybe<Array<MobileAppRecommendedWorkout>>;
  salePrice?: Maybe<Scalars['Float']>;
  score?: Maybe<Score>;
  shippingCallout?: Maybe<Array<PortableText>>;
  showExploreCollectionCTA?: Maybe<Scalars['Boolean']>;
  sizeChartId?: Maybe<Scalars['String']>;
  subHeader?: Maybe<Scalars['String']>;
  /** @deprecated Use Query.userGeneratedContent */
  userGeneratedContent?: Maybe<Array<Maybe<UserGeneratedContent>>>;
  /** @deprecated Use Query.userGeneratedContentForWeb */
  userGeneratedContentForWeb?: Maybe<Array<Maybe<UserGeneratedContent>>>;
  variantMeta?: Maybe<Scalars['JSON']>;
  variations: Array<Variant>;
  verticalProductVideos?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProductContentArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
};


export type ProductLookArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type ProductPromotionsArgs = {
  page?: InputMaybe<ProductPromotionsPageType>;
};

export type ProductBadge = {
  __typename?: 'ProductBadge';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type ProductCarousel = {
  __typename?: 'ProductCarousel';
  _id: Scalars['ID'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  products: Array<VariantProduct>;
  puid?: Maybe<BannerIdentifier>;
};

export type ProductCartItem = {
  __typename?: 'ProductCartItem';
  adjustQuantityMessage?: Maybe<Scalars['String']>;
  adjustments: Array<Adjustment>;
  bonusItemId?: Maybe<Scalars['String']>;
  cancelledQuantity?: Maybe<Scalars['Int']>;
  channelSkuCode?: Maybe<Scalars['String']>;
  customizationCost?: Maybe<Scalars['String']>;
  customizationName?: Maybe<Scalars['String']>;
  customizationNumber?: Maybe<Scalars['String']>;
  estimatedDeliveryDate?: Maybe<EstimatedDeliveryDate>;
  hasStock?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  inCartPrice: Scalars['Float'];
  isBonus?: Maybe<Scalars['Boolean']>;
  personalizationImageURL?: Maybe<Scalars['String']>;
  personalizationLargeImageURL?: Maybe<Scalars['String']>;
  personalizationName?: Maybe<Scalars['String']>;
  personalizationNumber?: Maybe<Scalars['String']>;
  personalizationPrice?: Maybe<Scalars['String']>;
  personalizationRecipeID?: Maybe<Scalars['String']>;
  personalizationSurcharge?: Maybe<Scalars['Int']>;
  popularityCount?: Maybe<Scalars['Int']>;
  product: VariantProduct;
  productReturn?: Maybe<ReturnedProduct>;
  purchasedPrice?: Maybe<ProductPrice>;
  quantity: Scalars['Int'];
  quantityInCart?: Maybe<Scalars['Int']>;
  restricted: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  stockMessage?: Maybe<Scalars['String']>;
  stockMessageCode?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
};

export type ProductColor = {
  __typename?: 'ProductColor';
  image?: Maybe<ProductImage>;
  name?: Maybe<Scalars['String']>;
  orderable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ProductComparison = {
  __typename?: 'ProductComparison';
  _id: Scalars['ID'];
  comparisonFields: Scalars['JSON'];
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  products: Array<ComparisonProduct>;
  variant?: Maybe<VariantProduct>;
};

export type ProductCustomizationInput = {
  imageUrl?: InputMaybe<Scalars['String']>;
  largeImageUrl?: InputMaybe<Scalars['String']>;
  nameText?: InputMaybe<Scalars['String']>;
  numberText?: InputMaybe<Scalars['String']>;
  recipeId?: InputMaybe<Scalars['String']>;
};

export type ProductFeature = {
  __typename?: 'ProductFeature';
  _id: Scalars['ID'];
  copy?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  image: SanityImage;
  video?: Maybe<SanityVideo>;
};

export type ProductGroupFeatures = {
  __typename?: 'ProductGroupFeatures';
  id: Scalars['String'];
  productFeatures?: Maybe<Array<ProductFeature>>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  alt: Scalars['String'];
  coverImageHref?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  proportionalImageHref?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  verticalImageHref?: Maybe<Scalars['String']>;
};

export type ProductListingPage = {
  __typename?: 'ProductListingPage';
  appContent?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
  bottomContent?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  bottomSeoContent?: Maybe<Array<Maybe<PortableText>>>;
  id: Scalars['ID'];
  mobileAppContent?: Maybe<MobileAppContent>;
  recommenderEnabled?: Maybe<Scalars['Boolean']>;
  recommenderId?: Maybe<Scalars['String']>;
  tiles?: Maybe<Array<Maybe<PositionedTile>>>;
  topContent?: Maybe<Array<Maybe<ComponentWithFilters>>>;
};


export type ProductListingPageAppContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type ProductListingPageBottomContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type ProductListingPageMobileAppContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type ProductListingPageTopContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type ProductMeasurements = {
  __typename?: 'ProductMeasurements';
  imperial: Array<Array<Scalars['String']>>;
  metric: Array<Array<Scalars['String']>>;
};

export type ProductNameTranslations = {
  __typename?: 'ProductNameTranslations';
  id: Scalars['ID'];
  name: NameTranslations;
};

export type ProductPersonalizationInput = {
  imageURL?: InputMaybe<Scalars['String']>;
  largeImageURL?: InputMaybe<Scalars['String']>;
  nameText?: InputMaybe<Scalars['String']>;
  numberText?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  recipeID?: InputMaybe<Scalars['String']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  isSalePriceElapsed?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  promotionPrice?: Maybe<Scalars['Float']>;
  salePrice?: Maybe<Scalars['Float']>;
  salePriceInitializeDate?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  validFrom?: Maybe<Scalars['String']>;
  validTo?: Maybe<Scalars['String']>;
};

export type ProductPromotion = {
  __typename?: 'ProductPromotion';
  calloutMessage?: Maybe<Scalars['String']>;
  gwpTitle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export const ProductPromotionsPageType = {
  ProductDetailsPage: 'ProductDetailsPage',
  ProductListingPage: 'ProductListingPage'
} as const;

export type ProductPromotionsPageType = typeof ProductPromotionsPageType[keyof typeof ProductPromotionsPageType];
export type ProductRecommender = {
  __typename?: 'ProductRecommender';
  _id: Scalars['ID'];
  copy?: Maybe<Scalars['String']>;
  cta?: Maybe<Array<Cta>>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  identifier: Scalars['String'];
  showAsGrid?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type ProductRef = {
  __typename?: 'ProductRef';
  color?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  masterId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  subHeader?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export const ProductSearchExpansion = {
  AllColors: 'ALL_COLORS',
  AllVariantExtendedData: 'ALL_VARIANT_EXTENDED_DATA',
  AllVariantImages: 'ALL_VARIANT_IMAGES',
  Availability: 'AVAILABILITY',
  MasterProductExtendedData: 'MASTER_PRODUCT_EXTENDED_DATA',
  Price: 'PRICE',
  QuickColors: 'QUICK_COLORS',
  VariantExtendedData: 'VARIANT_EXTENDED_DATA',
  VariantImages: 'VARIANT_IMAGES',
  VariationModel: 'VARIATION_MODEL'
} as const;

export type ProductSearchExpansion = typeof ProductSearchExpansion[keyof typeof ProductSearchExpansion];
export type ProductSearchHit = {
  __typename?: 'ProductSearchHit';
  color: Scalars['String'];
  id: Scalars['ID'];
  masterId: Scalars['ID'];
  masterProduct?: Maybe<Product>;
  variantProduct?: Maybe<Variant>;
};

export type ProductStory = {
  __typename?: 'ProductStory';
  additionalContentSections?: Maybe<Array<Maybe<ComponentWithFilters>>>;
  careInstructions?: Maybe<Array<Maybe<Scalars['String']>>>;
  longDescription?: Maybe<Scalars['String']>;
  manufacturerInfo?: Maybe<ManufacturerInfo>;
  materialComposition?: Maybe<Array<Maybe<Scalars['String']>>>;
  productKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductSuggestion = {
  __typename?: 'ProductSuggestion';
  coords?: Maybe<Coordinates>;
  id: Scalars['ID'];
  image: ProductImage;
  name: Scalars['String'];
  orderable?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  promotionPrice?: Maybe<Scalars['Float']>;
  replacements: Array<ProductSuggestion>;
  salePrice?: Maybe<Scalars['Float']>;
  styleId: Scalars['ID'];
};

export type ProductSummary = {
  __typename?: 'ProductSummary';
  /** @deprecated Deprecated in favor of badges array */
  badge?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<ProductBadge>>;
  brand?: Maybe<Scalars['String']>;
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  displayOutOfStock?: Maybe<DisplayOutOfStock>;
  id: Scalars['String'];
  images: Array<ProductImage>;
  masterId: Scalars['String'];
  name: Scalars['String'];
  orderable?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  /** @deprecated Deprecated in favor of promotions array */
  promotion?: Maybe<ProductPromotion>;
  promotions?: Maybe<Array<ProductPromotion>>;
  salePrice?: Maybe<Scalars['Float']>;
  score?: Maybe<Score>;
  variations: Array<ProductVariationSummary>;
};

export type ProductTile = {
  __typename?: 'ProductTile';
  _id: Scalars['ID'];
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  product?: Maybe<VariantProduct>;
};

export type ProductVariationSummary = {
  __typename?: 'ProductVariationSummary';
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  id: Scalars['String'];
  images: Array<ProductImage>;
  swatch: ProductImage;
};

export type ProductWithExclusion = {
  __typename?: 'ProductWithExclusion';
  excludedColors: Array<Scalars['String']>;
  product: Product;
};

export type ProductsInput = {
  expansions?: InputMaybe<Array<ProductSearchExpansion>>;
  filters: Array<FilterInputOption>;
  includeCategoryMetadata?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type ProfileInput = {
  birthday?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ProfilingConsentInput = {
  emailAddress: Scalars['String'];
};

export type ProfilingConsentResponse = {
  __typename?: 'ProfilingConsentResponse';
  citizenId?: Maybe<Scalars['String']>;
  externalRef?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type PromoTile = {
  __typename?: 'PromoTile';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  contentBelow?: Maybe<Scalars['Boolean']>;
  copy?: Maybe<Scalars['String']>;
  cta?: Maybe<Cta>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  mobileBackgroundImage?: Maybe<SanityImage>;
  puid?: Maybe<BannerIdentifier>;
  textColor?: Maybe<Scalars['String']>;
  verticalAlignment?: Maybe<VerticalAlignment>;
  video?: Maybe<SanityVideo>;
};

export type PumatracLink = {
  __typename?: 'PumatracLink';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QrCode = {
  __typename?: 'QRCode';
  _id: Scalars['ID'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  qrCodeContent: Scalars['String'];
  qrCodeImage: SanityImage;
};

export type Query = {
  __typename?: 'Query';
  activeCart?: Maybe<Cart>;
  activeCartV2?: Maybe<Cart>;
  address: Address;
  afterPayConfig: AfterPayConfig;
  allCustomerGroups: Array<Scalars['String']>;
  allProductRecommenders: Array<Recommender>;
  allProducts: Array<ProductRef>;
  allTranslations: Array<ResourceKey>;
  amazonPayPaymentDescriptor: AmazonPayPaymentDescriptorPayload;
  appStories?: Maybe<Array<MobileAppStory>>;
  /** @deprecated Use dropCalendarPage instead */
  calendar?: Maybe<Array<AppDropItem>>;
  campaignVariations?: Maybe<Scalars['JSON']>;
  cart?: Maybe<Cart>;
  cartPage?: Maybe<CartPage>;
  categories: Array<Category>;
  /** @deprecated Use categoryById or categoryByUrl instead */
  category: Category;
  categoryById: Category;
  categoryByUrl?: Maybe<Category>;
  checkAmbassadorBalance: Scalars['Float'];
  checkGiftCardBalance: Scalars['Float'];
  content?: Maybe<Scalars['JSON']>;
  dropCalendarPage?: Maybe<DropCalendarPage>;
  error404?: Maybe<Error404>;
  frontendConfiguration: FrontendConfiguration;
  getAmazonPayAddress?: Maybe<AmazonPayAddress>;
  getAmazonPayCustomerInfo?: Maybe<AmazonPayCustomerInfoPayload>;
  getPayPayContent?: Maybe<PayPayContent>;
  giftCard: GiftCardProduct;
  globalPromoBanner: GlobalPromoBanner;
  glossaryPage: GlossaryPage;
  highlights?: Maybe<Array<Interest>>;
  interests?: Maybe<Array<Interest>>;
  inventory: Inventory;
  look?: Maybe<StyliticsLook>;
  mainFooter: MainFooter;
  mainNav: MainNav;
  me: User;
  mobileAppCartNotices?: Maybe<Array<MobileAppCartNotice>>;
  mobileAppHomePage?: Maybe<AppContent>;
  /** dateTime should be in the following format: 2021-11-02T12:13:29.094Z */
  mobileAppInbox?: Maybe<Array<MobileAppInboxItem>>;
  /** dateTime should be in the following format: 2021-11-02T12:13:29.094Z */
  mobileAppNotificationBanners?: Maybe<Array<MobileAppNotificationBanner>>;
  mobileAppVersion?: Maybe<AppVersion>;
  /** @deprecated Use Error404 */
  notFound?: Maybe<NotFound>;
  notificationsPreferences?: Maybe<NotificationsPayload>;
  order?: Maybe<Order>;
  /** @deprecated order search query is deprecated please use one of the other order search queries */
  orderSearch: StandardOrder;
  outfits: Array<StyliticsLook>;
  page?: Maybe<Page>;
  /**
   * Returns the content template for a product page
   * Supports master product IDs, not variant IDs
   */
  pdp?: Maybe<Pdp>;
  pincode?: Maybe<PincodeServiceability>;
  ping?: Maybe<Scalars['String']>;
  pixleeConfig?: Maybe<PixleeConfig>;
  product?: Maybe<Product>;
  productScore?: Maybe<Score>;
  recommendations: Array<Maybe<ProductSearchHit>>;
  recommendationsWithDetails: RecommendationsOutput;
  search: PaginatedOutput;
  /** @deprecated Use Error404 */
  searchEmptyState?: Maybe<SearchEmptyState>;
  searchFlyoutRecommendedProducts: Array<Maybe<ProductSearchHit>>;
  searchOrderByEmail?: Maybe<Order>;
  searchOrderByEmailPhone?: Maybe<Order>;
  searchOrderByEmailPostcode?: Maybe<Order>;
  searchOrderByPhone?: Maybe<Order>;
  secondGlobalBanner?: Maybe<SecondGlobalBanner>;
  siblingVariants?: Maybe<Array<Variant>>;
  /** @deprecated Use SignUpForms instead */
  signUpForm?: Maybe<SignUpForm>;
  signUpFormById?: Maybe<SignUpForm>;
  signUpForms?: Maybe<Array<Maybe<SignUpForm>>>;
  sizeCharts?: Maybe<Array<SizeChart>>;
  /** @deprecated Use spinTheWheelByIds instead. */
  spinTheWheelById?: Maybe<SpinTheWheel>;
  spinTheWheelByIds?: Maybe<Array<Maybe<SpinTheWheel>>>;
  stories?: Maybe<Array<MobileAppStory>>;
  suggestions: SearchSuggestions;
  supportPage: SupportPage;
  supportPages: Array<SupportPage>;
  termsAndConditionsConfigs?: Maybe<TermsAndConditionsConfigs>;
  translate: Array<ResourceKey>;
  translationsByIds: Array<ProductNameTranslations>;
  trendingSearchTerms: Array<TrendingSearchTerm>;
  /** @deprecated Use urlRedirectV2 instead */
  urlRedirect?: Maybe<Scalars['String']>;
  urlRedirectV2: UrlRedirect;
  userGeneratedContent?: Maybe<Array<Maybe<UserGeneratedContent>>>;
  userGeneratedContentForWeb?: Maybe<Array<Maybe<UserGeneratedContent>>>;
  variant?: Maybe<VariantProduct>;
  variantInventory?: Maybe<Array<Inventory>>;
  variants?: Maybe<Array<Variant>>;
  wishList: WishList;
};


export type QueryAddressArgs = {
  id: Scalars['ID'];
};


export type QueryAllProductsArgs = {
  locale?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAmazonPayPaymentDescriptorArgs = {
  input: AmazonPayPaymentDescriptorInput;
};


export type QueryAppStoriesArgs = {
  params?: InputMaybe<StoriesParams>;
};


export type QueryCampaignVariationsArgs = {
  input: DynamicYieldChooseVariationsInput;
};


export type QueryCartArgs = {
  id: Scalars['ID'];
};


export type QueryCartPageArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type QueryCategoryByIdArgs = {
  id: Scalars['String'];
};


export type QueryCategoryByUrlArgs = {
  preview?: InputMaybe<PreviewInput>;
  url: Scalars['String'];
};


export type QueryCheckAmbassadorBalanceArgs = {
  cardNumber?: InputMaybe<Scalars['String']>;
  paymentInstrumentId?: InputMaybe<Scalars['String']>;
  pin: Scalars['String'];
};


export type QueryCheckGiftCardBalanceArgs = {
  cardNumber: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  pin: Scalars['String'];
  rateLimit?: InputMaybe<Scalars['Boolean']>;
};


export type QueryContentArgs = {
  input: ContentInput;
};


export type QueryGetAmazonPayAddressArgs = {
  addressConsentToken?: InputMaybe<Scalars['String']>;
  orderReferenceId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAmazonPayCustomerInfoArgs = {
  amazonPayToken: Scalars['String'];
};


export type QueryGetPayPayContentArgs = {
  assetId: Scalars['String'];
};


export type QueryGlobalPromoBannerArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type QueryGlossaryPageArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryHighlightsArgs = {
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryInventoryArgs = {
  id: Scalars['ID'];
};


export type QueryLookArgs = {
  id: Scalars['ID'];
};


export type QueryMainFooterArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
};


export type QueryMainNavArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<PreviewInput>;
};


export type QueryMobileAppHomePageArgs = {
  preview?: InputMaybe<PreviewInput>;
};


export type QueryMobileAppInboxArgs = {
  dateTime?: InputMaybe<Scalars['String']>;
};


export type QueryMobileAppNotificationBannersArgs = {
  dateTime?: InputMaybe<Scalars['String']>;
};


export type QueryOrderArgs = {
  orderNo: Scalars['String'];
};


export type QueryOrderSearchArgs = {
  billingPostalCode: Scalars['String'];
  orderEmail: Scalars['String'];
  orderNo: Scalars['String'];
};


export type QueryOutfitsArgs = {
  tags: Scalars['String'];
};


export type QueryPageArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<PreviewInput>;
  slug: Scalars['String'];
};


export type QueryPdpArgs = {
  id: Scalars['ID'];
};


export type QueryPincodeArgs = {
  pincode: Scalars['String'];
};


export type QueryProductArgs = {
  id: Scalars['ID'];
  viewAt?: InputMaybe<Scalars['String']>;
};


export type QueryProductScoreArgs = {
  id: Scalars['ID'];
};


export type QueryRecommendationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  pageType: Scalars['String'];
};


export type QueryRecommendationsWithDetailsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  pageType: Scalars['String'];
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySearchFlyoutRecommendedProductsArgs = {
  input?: InputMaybe<SearchFlyoutRecommendedProductsInput>;
};


export type QuerySearchOrderByEmailArgs = {
  email: Scalars['String'];
  orderNo: Scalars['String'];
};


export type QuerySearchOrderByEmailPhoneArgs = {
  email: Scalars['String'];
  orderNo: Scalars['String'];
  phone: Scalars['String'];
};


export type QuerySearchOrderByEmailPostcodeArgs = {
  email: Scalars['String'];
  orderNo: Scalars['String'];
  postcode: Scalars['String'];
};


export type QuerySearchOrderByPhoneArgs = {
  orderNo: Scalars['String'];
  phone: Scalars['String'];
};


export type QuerySecondGlobalBannerArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};


export type QuerySiblingVariantsArgs = {
  input: SiblingVariantsInput;
};


export type QuerySignUpFormByIdArgs = {
  id: Scalars['String'];
};


export type QuerySizeChartsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerySpinTheWheelByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpinTheWheelByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryStoriesArgs = {
  params?: InputMaybe<StoriesParams>;
};


export type QuerySuggestionsArgs = {
  preview?: InputMaybe<PreviewInput>;
  searchTerm: Scalars['String'];
};


export type QuerySupportPageArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<PreviewInput>;
  slug: Scalars['String'];
};


export type QuerySupportPagesArgs = {
  availableOn?: InputMaybe<SupportPageContentAvailableOn>;
  tags: Array<InputMaybe<Scalars['String']>>;
};


export type QueryTermsAndConditionsConfigsArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
};


export type QueryTranslateArgs = {
  keys: Array<Scalars['String']>;
};


export type QueryTranslationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryUrlRedirectArgs = {
  isDraft?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
};


export type QueryUrlRedirectV2Args = {
  path: Scalars['String'];
};


export type QueryUserGeneratedContentArgs = {
  productId: Scalars['ID'];
};


export type QueryUserGeneratedContentForWebArgs = {
  productId: Scalars['ID'];
};


export type QueryVariantArgs = {
  id: Scalars['ID'];
};


export type QueryVariantInventoryArgs = {
  styleNumber: Scalars['ID'];
};


export type QueryVariantsArgs = {
  input: VariantsInput;
};

export type QuoteCallout = {
  __typename?: 'QuoteCallout';
  _id: Scalars['ID'];
  copy?: Maybe<Scalars['String']>;
  copyColor?: Maybe<Scalars['String']>;
  ctas?: Maybe<Array<Cta>>;
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  quote?: Maybe<Scalars['String']>;
};

export type RadialFrontendContext = {
  HostName: Scalars['String'];
  Language: Scalars['String'];
  UserAgent: Scalars['String'];
};

export type RazorPayCheckoutInput = {
  razorPayOrderId: Scalars['String'];
  razorPayPaymentId: Scalars['String'];
  razorPaySignature: Scalars['String'];
};

export type Razorpay = {
  __typename?: 'Razorpay';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  id: Scalars['String'];
  image_url?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  product_url?: Maybe<Scalars['String']>;
};

export type RecommendationsOutput = {
  __typename?: 'RecommendationsOutput';
  recommendations: Array<Maybe<ProductSearchHit>>;
  recommenderId: Scalars['String'];
  recommenderName: Scalars['String'];
};

export type Recommender = {
  __typename?: 'Recommender';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  recommenderType?: Maybe<Scalars['String']>;
};

export type RefreshLogonInput = {
  refreshToken: Scalars['String'];
};

export type RegisterAmazonPaymentInput = {
  amazonCheckoutSessionId: Scalars['String'];
  basketId: Scalars['String'];
  updateAddress?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterAmazonPaymentPayload = {
  __typename?: 'RegisterAmazonPaymentPayload';
  cart?: Maybe<Cart>;
  shouldPromptForLogin: Scalars['Boolean'];
};

export type RegisterInput = {
  birthday?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  inflowCode?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  otpVerifyToken?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  shoppingCartId?: InputMaybe<Scalars['String']>;
};

export type RemoveAmbassadorCardFromCartInput = {
  basketId: Scalars['String'];
  id: Scalars['String'];
};

export type RemoveCouponFromCartInput = {
  basketId: Scalars['String'];
  couponItemId: Scalars['String'];
};

export type RemoveGiftCardFromCartInput = {
  basketId: Scalars['String'];
  giftCardId: Scalars['String'];
};

export type RemoveGiftCardInput = {
  basketId: Scalars['String'];
  id: Scalars['String'];
};

export type RemoveItemFromCartInput = {
  basketId: Scalars['String'];
  itemId: Scalars['String'];
};

export type RemoveItemFromWishListInput = {
  itemId: Scalars['String'];
};

export type RemoveStoreCreditsInput = {
  basketId: Scalars['String'];
};

export type RemoveStoreCreditsPayload = {
  __typename?: 'RemoveStoreCreditsPayload';
  cart?: Maybe<Cart>;
};

export type ResourceKey = {
  __typename?: 'ResourceKey';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ReturnedProduct = {
  __typename?: 'ReturnedProduct';
  channelReturnOrderTime?: Maybe<Scalars['String']>;
  forwardAwb?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  returnAwb?: Maybe<Scalars['String']>;
  returnOrderCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<TimelineStatus>>>;
  transporter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Review = {
  __typename?: 'Review';
  aspects?: Maybe<ReviewAspects>;
  cons?: Maybe<Array<Scalars['String']>>;
  consInputted?: Maybe<Array<Scalars['String']>>;
  date?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  helpfulVotes?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isRecommended?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  notification?: Maybe<Scalars['Boolean']>;
  preview?: Maybe<Scalars['Boolean']>;
  pros?: Maybe<Array<Scalars['String']>>;
  prosInputted?: Maybe<Array<Scalars['String']>>;
  rating?: Maybe<Scalars['Float']>;
  secondaryRatings?: Maybe<Array<Maybe<ReviewRating>>>;
  terms?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ReviewAspects = {
  __typename?: 'ReviewAspects';
  comfort?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  nodes: Array<Review>;
  pageInfo?: Maybe<PageInfo>;
};

export type ReviewInput = {
  comfort: Scalars['String'];
  cons?: InputMaybe<Array<Scalars['String']>>;
  consInputted?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  fingerPrint: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  nickname: Scalars['String'];
  notification?: InputMaybe<Scalars['Boolean']>;
  preview: Scalars['Boolean'];
  productId: Scalars['String'];
  pros?: InputMaybe<Array<Scalars['String']>>;
  prosInputted?: InputMaybe<Array<Scalars['String']>>;
  rating: Scalars['Int'];
  recommended?: InputMaybe<Scalars['Boolean']>;
  review: Scalars['String'];
  size: Scalars['String'];
  terms?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  width: Scalars['String'];
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  aspects?: Maybe<ReviewAspects>;
  recommendedCount?: Maybe<Scalars['Int']>;
  recommendedPercentage?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Rgba = {
  __typename?: 'Rgba';
  a?: Maybe<Scalars['Float']>;
  b?: Maybe<Scalars['Float']>;
  g?: Maybe<Scalars['Float']>;
  r?: Maybe<Scalars['Float']>;
};

export type RiskData = {
  clientData?: InputMaybe<Scalars['String']>;
};

export type SdkData = {
  __typename?: 'SDKData';
  token?: Maybe<Scalars['String']>;
};

export type Seo = {
  __typename?: 'SEO';
  pageDescription?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
};

export type SanityImage = {
  __typename?: 'SanityImage';
  _key?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
  overlay?: Maybe<BackgroundOverlay>;
};

export type SanityImageAsset = {
  __typename?: 'SanityImageAsset';
  _id: Scalars['ID'];
  assetId?: Maybe<Scalars['String']>;
  cloudinary?: Maybe<CloudinaryConfig>;
  extension: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  metadata: SanityImageMetaData;
  path: Scalars['String'];
  url: Scalars['String'];
};

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SanityImageMetaData = {
  __typename?: 'SanityImageMetaData';
  _key?: Maybe<Scalars['String']>;
  dimensions: SanityImageMetaDataDimensions;
  lqip?: Maybe<Scalars['String']>;
};

export type SanityImageMetaDataDimensions = {
  __typename?: 'SanityImageMetaDataDimensions';
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type SanityPrize = {
  __typename?: 'SanityPrize';
  _id: Scalars['ID'];
  addToInbox?: Maybe<Scalars['Boolean']>;
  androidWallet?: Maybe<Scalars['Boolean']>;
  appContent?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
  appleWallet?: Maybe<Scalars['Boolean']>;
  backgroundImage?: Maybe<SanityImage>;
  encodedPass?: Maybe<Scalars['String']>;
  googleMapsUrl?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  maps?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  prizeHeader: Scalars['String'];
  prizeLogo: SanityImage;
  prizeSubHeader?: Maybe<Scalars['String']>;
  prizeType: Scalars['String'];
  qrCode: QrCode;
  qrCodeContent?: Maybe<Scalars['String']>;
};


export type SanityPrizeAppContentArgs = {
  preview?: InputMaybe<PreviewInput>;
  src?: InputMaybe<Scalars['String']>;
};

export type SanityProduct = {
  __typename?: 'SanityProduct';
  color: Scalars['String'];
  comparisonFields?: Maybe<Scalars['JSON']>;
  masterId: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type SanityVideo = {
  __typename?: 'SanityVideo';
  autoplay: Scalars['Boolean'];
  cloudinary?: Maybe<CloudinaryConfig>;
  id: Scalars['String'];
  loop: Scalars['Boolean'];
  mute: Scalars['Boolean'];
  source: Scalars['String'];
};

export type SaveAmbassadorCardInput = {
  cardNumber: Scalars['String'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
};

export type SaveCreditCardInput = {
  cardType: Scalars['String'];
  cardexpirydate?: InputMaybe<Scalars['String']>;
  defaultCard?: InputMaybe<Scalars['Boolean']>;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  gmoCreditCardtoken?: InputMaybe<Scalars['String']>;
  gmoSpecificSaveData?: InputMaybe<GmoSaveData>;
  holder?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
};

export type SavedAmbassadorCard = {
  __typename?: 'SavedAmbassadorCard';
  id: Scalars['ID'];
  maskedNumber: Scalars['String'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
};

export type SavedCreditCard = {
  __typename?: 'SavedCreditCard';
  UUID: Scalars['ID'];
  creditCardExpirationMonth: Scalars['String'];
  creditCardExpirationYear: Scalars['String'];
  creditCardNumber: Scalars['String'];
  creditCardSeq: Scalars['String'];
  creditCardType: Scalars['String'];
  creditHolderName: Scalars['String'];
  defaultFlag: Scalars['String'];
  maskedCreditCardNumber: Scalars['String'];
};

export type ScheduledFreeShippingThreshold = {
  __typename?: 'ScheduledFreeShippingThreshold';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  threshold?: Maybe<Scalars['Float']>;
};

export type Scheme = {
  __typename?: 'Scheme';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type Score = {
  __typename?: 'Score';
  amount?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  rating: Scalars['String'];
  reviews: ReviewEdge;
  summary?: Maybe<ReviewSummary>;
};


export type ScoreReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type SearchCategory = {
  __typename?: 'SearchCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type SearchEmptyState = {
  __typename?: 'SearchEmptyState';
  productRecommender?: Maybe<ProductRecommender>;
  seo?: Maybe<Seo>;
  textSection: TextSection;
  withLiveChat?: Maybe<Scalars['Boolean']>;
};

export type SearchFlyoutRecommendedProductsInput = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type SearchHitMeta = {
  __typename?: 'SearchHitMeta';
  color?: Maybe<Scalars['String']>;
  masterId: Scalars['String'];
  variantId?: Maybe<Scalars['String']>;
};

export type SearchInput = {
  expansions?: InputMaybe<Array<ProductSearchExpansion>>;
  filters: Array<FilterInputOption>;
  includeSearchMetadata?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type SearchSuggestions = {
  __typename?: 'SearchSuggestions';
  suggestedCategories?: Maybe<Array<SearchCategory>>;
  suggestedPhrases?: Maybe<Array<SuggestedPhrase>>;
  /** @deprecated Works only with variants instead of variant/master etc */
  suggestedProducts?: Maybe<Array<Variant>>;
  suggestedProductsSummaries?: Maybe<Array<SuggestedProduct>>;
  suggestedRedirect?: Maybe<Scalars['String']>;
  suggestedRedirectLink?: Maybe<MobileAppLink>;
  suggestedTerms?: Maybe<Array<SuggestedTerm>>;
};

export type SecondGlobalBanner = {
  __typename?: 'SecondGlobalBanner';
  banners: Array<InfoBannerWithCategoryExclusion>;
};

export type SendEmailOtpResult = {
  __typename?: 'SendEmailOtpResult';
  otpExpiration: Scalars['String'];
  showResendButtonAfter: Scalars['String'];
};

export type Shipment = {
  __typename?: 'Shipment';
  address?: Maybe<OrderAddress>;
  authorityToLeave?: Maybe<AuthorityToLeave>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryTimeCode?: Maybe<Scalars['String']>;
  deliveryTimeDisplayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  shipmentMethod?: Maybe<ShipmentMethod>;
};

export type ShipmentMethod = {
  __typename?: 'ShipmentMethod';
  address?: Maybe<OrderAddress>;
  estimatedShippingDate?: Maybe<EstimatedShippingDate>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type ShipmentMethodInfo = {
  __typename?: 'ShipmentMethodInfo';
  availableShipmentMethods: Array<ShipmentMethod>;
  defaultShipmentMethodId?: Maybe<Scalars['String']>;
};

export type ShippingSurcharge = {
  __typename?: 'ShippingSurcharge';
  amount: Scalars['Int'];
  label: Scalars['String'];
  tooltip: Scalars['String'];
};

export type ShopCollection = {
  __typename?: 'ShopCollection';
  id: Scalars['String'];
};

export type ShopperContextPayload = {
  __typename?: 'ShopperContextPayload';
  effectiveDateTime?: Maybe<Scalars['String']>;
  sourceCode?: Maybe<Scalars['String']>;
};

export type SiblingVariantsInput = {
  styleNumberId?: InputMaybe<Scalars['String']>;
};

export type SideBySide = {
  __typename?: 'SideBySide';
  _id: Scalars['ID'];
  componentTiles: Array<Tiles>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  /** @deprecated in favor of componentTiles */
  tiles: Array<TrendingTile>;
};

export type SignAmazonPayloadInput = {
  payload: Scalars['String'];
};

export type SignAmazonPayloadResponse = {
  __typename?: 'SignAmazonPayloadResponse';
  signedPayload: Scalars['String'];
};

export type SignUpForm = {
  __typename?: 'SignUpForm';
  analyticsIdentifier?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  cartPageLaunchButtonLabel?: Maybe<Scalars['String']>;
  contactSource: Scalars['String'];
  copy?: Maybe<Scalars['String']>;
  ctas?: Maybe<Array<Cta>>;
  customText?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Array<Maybe<PortableText>>>;
  disclaimerText?: Maybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inverted?: Maybe<Scalars['Boolean']>;
  launchButtonLabel?: Maybe<Scalars['String']>;
  launchLinkText?: Maybe<Scalars['String']>;
  mobileBackgroundImage?: Maybe<SanityImage>;
  optionalFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  portableDisclaimerText?: Maybe<Array<Maybe<PortableText>>>;
  sourceId?: Maybe<Scalars['String']>;
  /** @deprecated Use inverted instead */
  submitButtonColor?: Maybe<Scalars['String']>;
  submitButtonText: Scalars['String'];
  /** @deprecated Use inverted instead */
  submitButtonTextColor?: Maybe<Scalars['String']>;
  successCopy?: Maybe<Scalars['String']>;
  /** @deprecated Use inverted instead */
  successCopyTextColor?: Maybe<Scalars['String']>;
  successFootnote?: Maybe<Scalars['String']>;
  /** @deprecated Use inverted instead */
  successFootnoteTextColor?: Maybe<Scalars['String']>;
  successHeader: Scalars['String'];
  /** @deprecated Use inverted instead */
  successHeaderTextColor?: Maybe<Scalars['String']>;
  successImage?: Maybe<SanityImage>;
  /** @deprecated Use inverted instead */
  textColor?: Maybe<Scalars['String']>;
};

export type SiteConfig = {
  __typename?: 'SiteConfig';
  currency: Currency;
  deliveryDateDays?: Maybe<DeliveryDateDays>;
  enableEstimatedDeliverDatesByItem?: Maybe<Scalars['Boolean']>;
  /** Default free shipping threshold. Use this as a fallback when there is no a scheduledFreeShippingThresholds */
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDaysForReturn?: Maybe<Scalars['Int']>;
  /**
   * Scheduled free shipping thresholds. Client apps should calculate freeShippingThreshold using the thresholds defined here.
   * Fallback to freeShippingThreshold when there is no scheduled free shipping threshold for a specific date
   */
  scheduledFreeShippingThresholds?: Maybe<Array<ScheduledFreeShippingThreshold>>;
};

export type Size = {
  __typename?: 'Size';
  id: Scalars['String'];
  label: Scalars['String'];
  maxOrderableQuantity: Scalars['Int'];
  orderable: Scalars['Boolean'];
  productId: Scalars['String'];
  value: Scalars['String'];
};

export type SizeChart = {
  __typename?: 'SizeChart';
  body: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SizeGroup = {
  __typename?: 'SizeGroup';
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  sizes: Array<Size>;
};

export type Slot = AdditionalContentSection | BodyContent | BodyHeader | CountdownClock | FaqModule | FeatureHero | FeaturesGrid | FullBleedHero | HotspotHero | HowToWearIt | Iframe | InfoBanner | LaunchCalendar | LinkListing | NotImplemented | PixleeSimpleWidget | ProductCarousel | ProductComparison | ProductGroupFeatures | ProductRecommender | QuoteCallout | ShopCollection | SideBySide | SignUpForm | SpinTheWheel | SplitHero | StyliticsCarousel | TrendingInline | VideoHero | YouTubeVideoCarousel;

export type SoldOutRecommender = ProductCarousel | ProductRecommender;

export type SortOption = {
  __typename?: 'SortOption';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type SpinTheWheel = {
  __typename?: 'SpinTheWheel';
  SpinTheWheelBackgroundImage: SanityImage;
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  buttonText: Scalars['String'];
  identifier: Scalars['String'];
  logo: SanityImage;
  name: Scalars['String'];
  prizes: Array<PrizeSlot>;
  subtitle?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SplitHero = {
  __typename?: 'SplitHero';
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage: SanityImage;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  id: Scalars['String'];
  layout?: Maybe<HorizontalAlignment>;
  logo?: Maybe<SanityImage>;
  mobileBackgroundImage?: Maybe<SanityImage>;
  puid?: Maybe<BannerIdentifier>;
  /** @deprecated No longer needed. */
  showDayFieldInCountdownClock?: Maybe<Scalars['Boolean']>;
  textColor?: Maybe<Scalars['String']>;
};

export type StandardOrder = BaseOrder & {
  __typename?: 'StandardOrder';
  billingAddress?: Maybe<OrderAddress>;
  couponItems?: Maybe<Array<Maybe<CouponItem>>>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<CustomerInfo>;
  customizationAdjustment?: Maybe<Adjustment>;
  estimatedShippingCosts?: Maybe<Scalars['Float']>;
  estimatedTotal?: Maybe<Scalars['Float']>;
  exportStatus?: Maybe<Scalars['String']>;
  gmoAccessID?: Maybe<Scalars['String']>;
  gmoAccessPass?: Maybe<Scalars['String']>;
  gmoChallengeUrl?: Maybe<Scalars['String']>;
  gmoFlow?: Maybe<Scalars['String']>;
  gmoRedirectUrl?: Maybe<Scalars['String']>;
  hasFreeShipping?: Maybe<Scalars['Boolean']>;
  isMixedCartAllowed?: Maybe<Scalars['Boolean']>;
  isReturnable: Scalars['Boolean'];
  /** @deprecated allow revert of PR 1621 */
  netProratedDiscount?: Maybe<Scalars['Float']>;
  oms?: Maybe<OmsEntry>;
  orderAdjustments: Array<Adjustment>;
  orderNo: Scalars['ID'];
  orderStatus?: Maybe<OrderStatus>;
  orderToken: Scalars['String'];
  payPayAsyncResultNoticed?: Maybe<Scalars['Boolean']>;
  paymentInstruments: Array<PaymentInstrument>;
  pin?: Maybe<Scalars['String']>;
  pinId?: Maybe<Scalars['String']>;
  products: Array<CartItem>;
  promoDiscountValue?: Maybe<Scalars['Float']>;
  refundInformation?: Maybe<Scalars['String']>;
  revenue?: Maybe<Scalars['Float']>;
  shipment?: Maybe<Shipment>;
  shippingAdjustments: Array<Adjustment>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingStatus?: Maybe<Scalars['String']>;
  shippingSurcharge?: Maybe<ShippingSurcharge>;
  status?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<TimelineStatus>>>;
  subTotal?: Maybe<Scalars['Float']>;
  taxTotal?: Maybe<Scalars['Float']>;
  taxation?: Maybe<Taxation>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export type StartAdyenPaymentInput = {
  adyenPaymentData: AdyenPaymentInput;
  basketId: Scalars['String'];
  forterToken?: InputMaybe<Scalars['String']>;
};

export type StartAmazonPaymentInput = {
  amazonCheckoutSessionId: Scalars['String'];
  basketId: Scalars['String'];
  feHost: Scalars['String'];
};

export type StartAmazonPaymentPayload = {
  __typename?: 'StartAmazonPaymentPayload';
  order: StandardOrder;
  url?: Maybe<Scalars['String']>;
};

export type StartAmazonProcessOrderPaymentInput = {
  basketId: Scalars['String'];
};

export type StartAmazonProcessOrderPaymentPayload = {
  __typename?: 'StartAmazonProcessOrderPaymentPayload';
  order: StandardOrder;
};

export type StartCreditCardPaymentInput = {
  basketId: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
};

export type StartKlarnaPaymentInput = {
  basketId: Scalars['String'];
  products?: InputMaybe<Array<InputMaybe<KlarnaProductInfo>>>;
};

export type StartKlarnaPaymentPayload = {
  __typename?: 'StartKlarnaPaymentPayload';
  clientToken?: Maybe<Scalars['String']>;
  orderNo?: Maybe<Scalars['String']>;
  paymentMethodCategories?: Maybe<Array<Maybe<KlarnaPaymentMethodCategories>>>;
  sessionId?: Maybe<Scalars['String']>;
};

export type StartPaymentPayload = {
  __typename?: 'StartPaymentPayload';
  action?: Maybe<AdyenAction>;
  /** @deprecated allow revert of PR 1621 */
  analytics?: Maybe<OrderAnalytics>;
  orderNo?: Maybe<Scalars['String']>;
  resultCode?: Maybe<AdyenResultCodeEnum>;
  simulatorUrl?: Maybe<Scalars['String']>;
};

export type StartRazorPayInput = {
  basketId: Scalars['String'];
};

export type StartRazorPayPayload = {
  __typename?: 'StartRazorPayPayload';
  order: StandardOrder;
  razorPayOrderId: Scalars['String'];
};

export type StatelessSubmissionInput = {
  emailAddress: Scalars['String'];
};

export type StatelessSubmissionResponse = {
  __typename?: 'StatelessSubmissionResponse';
  externalRef?: Maybe<Scalars['String']>;
};

export type StoreCredit = {
  __typename?: 'StoreCredit';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type StoreCreditInstrument = {
  __typename?: 'StoreCreditInstrument';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type StoriesParams = {
  ignoreExpirationDate?: InputMaybe<Scalars['Boolean']>;
};

export type Style = {
  __typename?: 'Style';
  background?: Maybe<Scalars['String']>;
  border?: Maybe<Scalars['Boolean']>;
  rounded?: Maybe<Scalars['Boolean']>;
  shadow?: Maybe<Scalars['Boolean']>;
};

export type StyliticsCarousel = {
  __typename?: 'StyliticsCarousel';
  header?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  numberOfTiles?: Maybe<Scalars['Int']>;
  outfits: Array<Maybe<StyliticsLook>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tileLayout?: Maybe<Scalars['String']>;
  tiles?: Maybe<Array<PositionedTile>>;
};

export type StyliticsLook = {
  __typename?: 'StyliticsLook';
  id: Scalars['ID'];
  image: ProductImage;
  products: Array<Maybe<ProductSuggestion>>;
};

export type Suborder = {
  __typename?: 'Suborder';
  awbNo?: Maybe<Scalars['String']>;
  courierPartner?: Maybe<Scalars['String']>;
  isReturnable: Scalars['Boolean'];
  orderNo: Scalars['ID'];
  products: Array<CartItem>;
  returnBy?: Maybe<Scalars['String']>;
  returnUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<TimelineStatus>>>;
};

export type SuggestedPhrase = {
  __typename?: 'SuggestedPhrase';
  suggestion: Scalars['String'];
};

export type SuggestedProduct = {
  __typename?: 'SuggestedProduct';
  /** @deprecated Deprecated in favor of colorValue */
  color: Scalars['String'];
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<ProductImage>;
  isSalePriceElapsed?: Maybe<Scalars['Boolean']>;
  masterId: Scalars['ID'];
  name: Scalars['String'];
  preview: Scalars['String'];
  price: Scalars['Float'];
  salePrice?: Maybe<Scalars['Float']>;
  subHeader?: Maybe<Scalars['String']>;
};

export type SuggestedTerm = {
  __typename?: 'SuggestedTerm';
  original: Scalars['String'];
  suggestion: Scalars['String'];
};

export type SupportPage = Page & {
  __typename?: 'SupportPage';
  /** @deprecated Changed name to localeContent */
  content?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  integration?: Maybe<Scalars['String']>;
  localeContent?: Maybe<Scalars['JSON']>;
  localeTitle: Scalars['String'];
  /** @deprecated Changed name to localeTitle and type to JSON */
  title: Scalars['String'];
  url: Scalars['String'];
};

export const SupportPageContentAvailableOn = {
  MobileApp: 'mobileApp',
  Web: 'web'
} as const;

export type SupportPageContentAvailableOn = typeof SupportPageContentAvailableOn[keyof typeof SupportPageContentAvailableOn];
export const SupportedPaymentMethod = {
  Adyen: 'ADYEN',
  AdyenComponent: 'ADYEN_COMPONENT',
  AdyenPaypal: 'ADYEN_PAYPAL',
  Afterpay: 'AFTERPAY',
  AfterpayTouch: 'AFTERPAY_TOUCH',
  Alipay: 'ALIPAY',
  AmazonPay: 'AMAZON_PAY',
  AmazonPayV2: 'AMAZON_PAY_V2',
  AmbassadorCard: 'AMBASSADOR_CARD',
  ApplePay: 'APPLE_PAY',
  Cod: 'COD',
  CreditCard: 'CREDIT_CARD',
  CreditCardConfirm: 'CREDIT_CARD_CONFIRM',
  GiftCard: 'GIFT_CARD',
  GooglePay: 'GOOGLE_PAY',
  Klarna: 'KLARNA',
  KlarnaAccount: 'KLARNA_ACCOUNT',
  KlarnaPayments: 'KLARNA_PAYMENTS',
  OnlineBanking: 'ONLINE_BANKING',
  OnlineBankingIn: 'ONLINE_BANKING_IN',
  Paypal: 'PAYPAL',
  Paytm: 'PAYTM',
  PayPay: 'PAY_PAY',
  Razorpay: 'RAZORPAY',
  Scheme: 'SCHEME',
  StoreCredit: 'STORE_CREDIT',
  Upi: 'UPI',
  UpiCollect: 'UPI_COLLECT',
  Wallet: 'WALLET',
  WechatPay: 'WECHAT_PAY',
  ZipPay: 'ZIP_PAY'
} as const;

export type SupportedPaymentMethod = typeof SupportedPaymentMethod[keyof typeof SupportedPaymentMethod];
export const Taxation = {
  Gross: 'gross',
  Net: 'net'
} as const;

export type Taxation = typeof Taxation[keyof typeof Taxation];
export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  _id: Scalars['ID'];
  content?: Maybe<Array<Maybe<PortableText>>>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
};

export type TermsAndConditionsConfigs = {
  __typename?: 'TermsAndConditionsConfigs';
  id: Scalars['String'];
  showAbove?: Maybe<Scalars['Boolean']>;
  tacOnCartPage?: Maybe<TermsAndConditions>;
  tacOnCheckoutAddress?: Maybe<TermsAndConditions>;
  tacOnCheckoutConfirmation?: Maybe<TermsAndConditions>;
  tacOnCheckoutPayment?: Maybe<TermsAndConditions>;
  tacOnCheckoutSignInArea?: Maybe<TermsAndConditions>;
  tacOnCreateAccount?: Maybe<TermsAndConditions>;
  tacOnItemAddedPopup?: Maybe<TermsAndConditions>;
};

export type Text = {
  __typename?: 'Text';
  align?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
};

export const TextAlignment = {
  Center: 'center',
  Left: 'left',
  Right: 'right'
} as const;

export type TextAlignment = typeof TextAlignment[keyof typeof TextAlignment];
export type TextChildren = {
  __typename?: 'TextChildren';
  _type: Scalars['String'];
  id: Scalars['String'];
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type TextSection = {
  __typename?: 'TextSection';
  heading?: Maybe<Array<Maybe<PortableText>>>;
  label?: Maybe<Array<Maybe<PortableText>>>;
  text?: Maybe<Array<Maybe<PortableTextContent>>>;
};

export const ThreeDsMethod = {
  Get: 'GET',
  Post: 'POST'
} as const;

export type ThreeDsMethod = typeof ThreeDsMethod[keyof typeof ThreeDsMethod];
export type ThreeDsResponse = {
  __typename?: 'ThreeDSResponse';
  data: Scalars['String'];
  method: ThreeDsMethod;
  orderNo: Scalars['ID'];
  url: Scalars['ID'];
};

export type Tile = {
  __typename?: 'Tile';
  alignment?: Maybe<Alignment>;
  aspectRatio?: Maybe<Scalars['String']>;
  /** @deprecated Use ctas2 instead */
  ctas?: Maybe<Array<CallToAction>>;
  ctas2?: Maybe<Array<Cta>>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  link?: Maybe<Link>;
  style?: Maybe<Style>;
  text?: Maybe<Text>;
};

export type Tiles = ProductRecommender | TrendingTile;

export type TimelineStatus = {
  __typename?: 'TimelineStatus';
  label: Scalars['String'];
  order: Scalars['Int'];
  status: Scalars['String'];
};

export type TokenPayload = {
  __typename?: 'TokenPayload';
  accessToken: Scalars['String'];
  customerContext?: Maybe<CustomerContext>;
  /** @deprecated Use user instead */
  customerEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use customerContext instead */
  customerGroup?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  refreshToken: Scalars['String'];
  uniqueShopperId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type TrackGuestUserInput = {
  appLanguage?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  id: Scalars['String'];
};

export type TrackRegisteredUserInput = {
  appLanguage?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  prevCustomerId?: InputMaybe<Scalars['String']>;
};

export type TrackUserEventInput = {
  event: UserEvent;
  payload?: InputMaybe<UserEventPayload>;
};

export type TrendingInline = {
  __typename?: 'TrendingInline';
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  tiles: Array<TrendingTile>;
};

export type TrendingSearchTerm = {
  __typename?: 'TrendingSearchTerm';
  rank: Scalars['Int'];
  searchTerm: Scalars['String'];
};

export type TrendingTile = {
  __typename?: 'TrendingTile';
  _id: Scalars['ID'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<SanityImage>;
  backgroundOverlay?: Maybe<BackgroundOverlay>;
  backgroundType?: Maybe<Scalars['String']>;
  contentBelow?: Maybe<Scalars['Boolean']>;
  copy?: Maybe<Scalars['String']>;
  countdownClock?: Maybe<CountdownClock>;
  ctas?: Maybe<Array<Cta>>;
  einsteinRecommender?: Maybe<Scalars['String']>;
  einsteinRecommenderAltText?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  /** @deprecated Use _id: ID! instead */
  id: Scalars['String'];
  overlay?: Maybe<Scalars['Boolean']>;
  puid?: Maybe<BannerIdentifier>;
  textColor?: Maybe<Scalars['String']>;
};

export type UgcProduct = {
  __typename?: 'UGCProduct';
  id?: Maybe<Scalars['String']>;
  imageThumb?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Upi = {
  __typename?: 'UPI';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type UpiInput = {
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
};

export type UpiResult = {
  __typename?: 'UPIResult';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  preferred: Scalars['Boolean'];
  salutation?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateAmbassadorCardInput = {
  cards: Array<UpdateAmbassadorCard>;
};

export type UpdateBillingAddressInput = {
  addToAddressBook?: InputMaybe<Scalars['Boolean']>;
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateItemInCartInput = {
  basketId: Scalars['String'];
  itemId: Scalars['String'];
  masterId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productPersonalization?: InputMaybe<ProductPersonalizationInput>;
  quantity?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  swatch?: InputMaybe<Scalars['String']>;
};

export type UpdateItemInWishListInput = {
  itemId: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
  swatch?: InputMaybe<Scalars['String']>;
};

export const UpdatePhoneCode = {
  Ok: 'OK',
  PhoneAlreadyInUse: 'PHONE_ALREADY_IN_USE',
  VerificationRequired: 'VERIFICATION_REQUIRED'
} as const;

export type UpdatePhoneCode = typeof UpdatePhoneCode[keyof typeof UpdatePhoneCode];
export type UpdatePhoneInput = {
  phoneNo: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};

export type UpdatePhonePayload = {
  __typename?: 'UpdatePhonePayload';
  code?: Maybe<UpdatePhoneCode>;
  message?: Maybe<Scalars['String']>;
  pinId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UpdateProfilingConsentInput = {
  __typename?: 'UpdateProfilingConsentInput';
  expiryDate?: Maybe<Scalars['String']>;
  externalRef: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type UpdateShipmentMethodInput = {
  basketId: Scalars['String'];
  shippingMethodId?: InputMaybe<Scalars['String']>;
};

export type UpdateShippingAddressInput = {
  addToAddressBook?: InputMaybe<Scalars['Boolean']>;
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  authorityToLeave?: InputMaybe<AuthorityToLeaveInput>;
  basketId: Scalars['String'];
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  deliveryDate?: InputMaybe<Scalars['String']>;
  deliveryTimeCode?: InputMaybe<Scalars['String']>;
  deliveryTimeDisplayText?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  useAsBilling: Scalars['Boolean'];
};

export const Upgrade = {
  Mandatory: 'MANDATORY',
  Suggested: 'SUGGESTED'
} as const;

export type Upgrade = typeof Upgrade[keyof typeof Upgrade];
export type UrlRedirect = {
  __typename?: 'UrlRedirect';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  redirectType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  addresses: Array<Address>;
  ambassadorCards: Array<SavedAmbassadorCard>;
  birthday?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['String']>;
  customerNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstNamePronunciation?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  groups: Array<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastNamePronunciation?: Maybe<Scalars['String']>;
  newsletterSubscription?: Maybe<NewsletterSubscription>;
  orders: OrderEdge;
  phoneNumber?: Maybe<Scalars['String']>;
  savedCards?: Maybe<Array<SavedCreditCard>>;
  smsContactNumber?: Maybe<Scalars['String']>;
  storeCredit?: Maybe<StoreCredit>;
};


export type UserOrdersArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  until?: InputMaybe<Scalars['String']>;
};

export const UserEvent = {
  OnAppLinkClick: 'ON_APP_LINK_CLICK',
  OnLanguageChange: 'ON_LANGUAGE_CHANGE',
  OnLiveChatStart: 'ON_LIVE_CHAT_START',
  OnOrderConfirmation: 'ON_ORDER_CONFIRMATION',
  OnProductView: 'ON_PRODUCT_VIEW',
  OnRecommendationClick: 'ON_RECOMMENDATION_CLICK'
} as const;

export type UserEvent = typeof UserEvent[keyof typeof UserEvent];
export type UserEventPayload = {
  cartProducts?: InputMaybe<Array<UserEventTrackingCartProduct>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  masterId?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  recommenderId?: InputMaybe<Scalars['String']>;
  recommenderName?: InputMaybe<Scalars['String']>;
  swatch?: InputMaybe<Scalars['String']>;
};

export type UserEventTrackingCartProduct = {
  name: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  recipientEmail?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  senderName?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
  styleNumber: Scalars['String'];
};

export type UserGeneratedContent = {
  __typename?: 'UserGeneratedContent';
  altText?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  bigUrl?: Maybe<Scalars['String']>;
  collectTerm?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isInfluencer?: Maybe<Scalars['Boolean']>;
  likeCount?: Maybe<Scalars['Int']>;
  mediumUrl?: Maybe<Scalars['String']>;
  mentions?: Maybe<Array<Maybe<Scalars['String']>>>;
  photoTitle?: Maybe<Scalars['String']>;
  pixleeCdnPhotos?: Maybe<PixleeCdnPhotos>;
  platformLink?: Maybe<Scalars['String']>;
  products?: Maybe<Array<UgcProduct>>;
  source?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ValidateApplePayMerchantInput = {
  domainName: Scalars['String'];
  validationUrl: Scalars['String'];
};

export type Variant = {
  __typename?: 'Variant';
  allowUnisexSize?: Maybe<Scalars['Boolean']>;
  appOnlyDateTimeFrom?: Maybe<Scalars['String']>;
  appOnlyDateTimeTo?: Maybe<Scalars['String']>;
  apparelLength?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of badges array */
  badge?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<ProductBadge>>;
  brand?: Maybe<Scalars['String']>;
  characteristics?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of colorValue */
  color: Scalars['String'];
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  configureID?: Maybe<ConfigureIdSettings>;
  cupType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayOutOfStock?: Maybe<DisplayOutOfStock>;
  ean?: Maybe<Scalars['String']>;
  fastener?: Maybe<Scalars['String']>;
  fit?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  heelToToeDrop?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  images: Array<ProductImage>;
  isAppExclusive?: Maybe<Scalars['Boolean']>;
  isFinalSale?: Maybe<Scalars['Boolean']>;
  isWebExclusive?: Maybe<Scalars['Boolean']>;
  mainMaterial?: Maybe<Scalars['String']>;
  manufacturerInfo?: Maybe<ManufacturerInfo>;
  masterId: Scalars['ID'];
  materialComposition?: Maybe<Array<Maybe<Scalars['String']>>>;
  modelMeasurementText?: Maybe<Scalars['String']>;
  myCustomizer?: Maybe<MyCustomizerSettings>;
  name: Scalars['String'];
  offline?: Maybe<Scalars['Boolean']>;
  orderable?: Maybe<Scalars['Boolean']>;
  percentageDiscountBadge?: Maybe<Scalars['Float']>;
  playerLevel?: Maybe<Scalars['String']>;
  pocketType?: Maybe<Scalars['String']>;
  preview: Scalars['String'];
  /** @deprecated Deprecated in favor of productPrice.price */
  price: Scalars['Float'];
  primaryCategoryId?: Maybe<Scalars['String']>;
  productPrice?: Maybe<ProductPrice>;
  productStory?: Maybe<ProductStory>;
  promotionExclusion?: Maybe<Scalars['Boolean']>;
  promotions?: Maybe<Array<ProductPromotion>>;
  pronation?: Maybe<Scalars['String']>;
  refinementCushioningLevel?: Maybe<Scalars['String']>;
  returnRuleID?: Maybe<Scalars['String']>;
  runTerrain?: Maybe<Scalars['String']>;
  runnerType?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of productPrice.salePrice and productPrice.promotionPrice */
  salePrice?: Maybe<Scalars['Float']>;
  /** Group sizes by different criteria. When no grouping criteria is met, all sizes will be added in 1 group with no label/description */
  sizeGroups: Array<SizeGroup>;
  /**
   * All available sizes of the variant, without context of groupings
   * @deprecated Deprecated in favour of sizeGroups. It is not advised to fetch sizes and sizeGroups since there will be duplication of data in the response
   */
  sizes: Array<Size>;
  specialMessage?: Maybe<Scalars['String']>;
  specialMessageFrom?: Maybe<Scalars['String']>;
  specialMessageTo?: Maybe<Scalars['String']>;
  studs?: Maybe<Scalars['String']>;
  styleNumber?: Maybe<Scalars['String']>;
  subHeader?: Maybe<Scalars['String']>;
  supportLevelBra?: Maybe<Scalars['String']>;
  taxDisplayMsg?: Maybe<Scalars['String']>;
  technology?: Maybe<Scalars['String']>;
  trouserRise?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['String']>;
  variantId?: Maybe<Scalars['ID']>;
  weight?: Maybe<Scalars['Int']>;
};


export type VariantPromotionsArgs = {
  page?: InputMaybe<ProductPromotionsPageType>;
};


export type VariantSpecialMessageArgs = {
  viewAt?: InputMaybe<Scalars['String']>;
};

export type VariantColor = {
  __typename?: 'VariantColor';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type VariantProduct = {
  __typename?: 'VariantProduct';
  ageGroup?: Maybe<Scalars['String']>;
  appOnlyDateTimeFrom?: Maybe<Scalars['String']>;
  appOnlyDateTimeTo?: Maybe<Scalars['String']>;
  apparelLength?: Maybe<Scalars['String']>;
  articleGroup?: Maybe<Scalars['String']>;
  articleType?: Maybe<Scalars['String']>;
  assortmentAvailability?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of badges array */
  badge?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<ProductBadge>>;
  brand?: Maybe<Scalars['String']>;
  businessSegment?: Maybe<Scalars['String']>;
  businessSubSegment?: Maybe<Scalars['String']>;
  businessUnit?: Maybe<Scalars['String']>;
  characteristics?: Maybe<Scalars['String']>;
  collectionMark?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of colorValue and colorName */
  color: VariantColor;
  colorDescription?: Maybe<Scalars['String']>;
  colorName: Scalars['String'];
  colorValue: Scalars['String'];
  configureID?: Maybe<ConfigureIdSettings>;
  cupType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayOutOfStock?: Maybe<DisplayOutOfStock>;
  division?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  fastener?: Maybe<Scalars['String']>;
  fit?: Maybe<Scalars['String']>;
  franchise?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  heelToToeDrop?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** @deprecated Deprecated in favor of images[0].href */
  imageUrl: Scalars['String'];
  images: Array<ProductImage>;
  inventory: Scalars['Int'];
  isAppExclusive?: Maybe<Scalars['Boolean']>;
  isFinalSale?: Maybe<Scalars['Boolean']>;
  isWebExclusive?: Maybe<Scalars['Boolean']>;
  lineName?: Maybe<Scalars['String']>;
  mainMaterial?: Maybe<Scalars['String']>;
  masterId: Scalars['String'];
  masterProduct?: Maybe<Product>;
  materialComposition?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxOrderableQuantity: Scalars['Int'];
  myCustomizer?: Maybe<MyCustomizerSettings>;
  name: Scalars['String'];
  offline: Scalars['Boolean'];
  orderable: Scalars['Boolean'];
  percentageDiscountBadge?: Maybe<Scalars['Float']>;
  playerLevel?: Maybe<Scalars['String']>;
  pocketType?: Maybe<Scalars['String']>;
  popularityCount?: Maybe<Scalars['Int']>;
  /** @deprecated Deprecated in favor of productPrice.price */
  price: Scalars['Float'];
  primaryCategoryId?: Maybe<Scalars['String']>;
  productPrice?: Maybe<ProductPrice>;
  promotionExclusion?: Maybe<Scalars['Boolean']>;
  promotions?: Maybe<Array<ProductPromotion>>;
  pronation?: Maybe<Scalars['String']>;
  refinementCushioningLevel?: Maybe<Scalars['String']>;
  returnRuleID?: Maybe<Scalars['String']>;
  runTerrain?: Maybe<Scalars['String']>;
  runnerType?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of productPrice.salePrice and productPrice.promotionPrice */
  salePrice?: Maybe<Scalars['Float']>;
  size: VariantSize;
  specialMessage?: Maybe<Scalars['String']>;
  sportName?: Maybe<Scalars['String']>;
  studs?: Maybe<Scalars['String']>;
  styleNumber: Scalars['String'];
  subHeader?: Maybe<Scalars['String']>;
  supportLevelBra?: Maybe<Scalars['String']>;
  taxDisplayMsg?: Maybe<Scalars['String']>;
  technology?: Maybe<Scalars['String']>;
  trouserRise?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type VariantSize = {
  __typename?: 'VariantSize';
  label: Scalars['String'];
  /** @deprecated Deprecated in favour of label */
  name: Scalars['String'];
  value: Scalars['String'];
};

export type VariantsInput = {
  styleNumberIds?: InputMaybe<Array<Scalars['String']>>;
};

export const VerifyLoginWithOtpCode = {
  CustomerNotFound: 'CUSTOMER_NOT_FOUND',
  EncryptedPasswordEmpty: 'ENCRYPTED_PASSWORD_EMPTY',
  MoreThanOneCustomer: 'MORE_THAN_ONE_CUSTOMER',
  NoMorePinAttempts: 'NO_MORE_PIN_ATTEMPTS',
  Ok: 'OK'
} as const;

export type VerifyLoginWithOtpCode = typeof VerifyLoginWithOtpCode[keyof typeof VerifyLoginWithOtpCode];
export type VerifyLoginWithOtpInput = {
  phoneNo: Scalars['String'];
  pin: Scalars['String'];
  pinId: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
};

export type VerifyLoginWithOtpResult = {
  __typename?: 'VerifyLoginWithOTPResult';
  authPayload?: Maybe<AuthPayload>;
  code: VerifyLoginWithOtpCode;
  message?: Maybe<Scalars['String']>;
  otpVerifyToken?: Maybe<Scalars['String']>;
};

export type VerifyUserAffiliationsInput = {
  authorizationCode: Scalars['String'];
};

export type VerifyUserAffiliationsPayload = {
  __typename?: 'VerifyUserAffiliationsPayload';
  affiliations?: Maybe<Array<Scalars['String']>>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type Version = {
  __typename?: 'Version';
  latest?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['String']>;
};

export const VerticalAlignment = {
  Bottom: 'bottom',
  Middle: 'middle',
  Top: 'top'
} as const;

export type VerticalAlignment = typeof VerticalAlignment[keyof typeof VerticalAlignment];
export type Video = {
  __typename?: 'Video';
  cloudinary?: Maybe<CloudinaryConfig>;
  url?: Maybe<Scalars['String']>;
};

export type VideoHero = {
  __typename?: 'VideoHero';
  autoplay: Scalars['Boolean'];
  /** @deprecated No longer used */
  availableFrom?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  availableTo?: Maybe<Scalars['String']>;
  /** @deprecated Use backgroundVideoV2 instead. */
  backgroundVideo: Scalars['String'];
  backgroundVideoV2: Video;
  controls: Scalars['Boolean'];
  copy?: Maybe<Scalars['String']>;
  ctas?: Maybe<Array<Cta>>;
  footnote?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalAlignment?: Maybe<HorizontalAlignment>;
  id: Scalars['String'];
  loop: Scalars['Boolean'];
  minAspectRatio: Scalars['Float'];
  /** @deprecated Use mobileBackgroundVideoV2 instead. */
  mobileBackgroundVideo?: Maybe<Scalars['String']>;
  mobileBackgroundVideoV2: Video;
  mute: Scalars['Boolean'];
  overlayContent?: Maybe<Scalars['Boolean']>;
  textColor?: Maybe<Scalars['String']>;
  verticalAlignment?: Maybe<VerticalAlignment>;
  videoPosterImage?: Maybe<Scalars['String']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  amount: Scalars['Float'];
  authorizationStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type WalletInput = {
  bankId: Scalars['String'];
  basketId: Scalars['String'];
  feHost?: InputMaybe<Scalars['String']>;
};

export type WalletResult = {
  __typename?: 'WalletResult';
  orderNo: Scalars['String'];
  url: Scalars['String'];
};

export type WechatPay = {
  __typename?: 'WechatPay';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type WishList = {
  __typename?: 'WishList';
  id: Scalars['ID'];
  items: Array<WishListItem>;
};

export type WishListItem = {
  __typename?: 'WishListItem';
  creationDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  product: VariantProduct;
  quantity: Scalars['Int'];
};

export type YouTubeVideoCarousel = {
  __typename?: 'YouTubeVideoCarousel';
  autoplay: Scalars['Boolean'];
  id: Scalars['String'];
  playlistId?: Maybe<Scalars['String']>;
  showThumbnails: Scalars['Boolean'];
  videoIds?: Maybe<Array<Scalars['String']>>;
};

export type ZipPay = {
  __typename?: 'ZipPay';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ComponentWithFilters = {
  __typename?: 'componentWithFilters';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  campaign?: Maybe<Array<Campaign>>;
  component?: Maybe<Slot>;
  id: Scalars['String'];
  online?: Maybe<Scalars['Boolean']>;
  targetDevices?: Maybe<Array<Scalars['String']>>;
};

export type InfoBannerWithCategoryExclusion = {
  __typename?: 'infoBannerWithCategoryExclusion';
  availableFrom?: Maybe<Scalars['String']>;
  availableTo?: Maybe<Scalars['String']>;
  banner?: Maybe<InfoBanner>;
  campaign?: Maybe<Array<Maybe<Campaign>>>;
  exclusions?: Maybe<Array<CategoryExclusion>>;
  id: Scalars['String'];
  isSticky?: Maybe<Scalars['Boolean']>;
};

export type MobileAppContent = {
  __typename?: 'mobileAppContent';
  bottomContent?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
  topContent?: Maybe<Array<Maybe<AppComponentWithFilters>>>;
};

export type UpdateAmbassadorCard = {
  cardName: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  preferred: Scalars['Boolean'];
};

export type TokenPayloadFragment = { __typename: 'TokenPayload', accessToken: string, refreshToken: string, customerId: string, uniqueShopperId?: string | null, customerContext?: { __typename: 'CustomerContext', hashKey?: string | null, customerGroups?: Array<string> | null } | null, user?: { __typename?: 'User', customerNo?: string | null, email?: string | null } | null };

export type GuestLogonMutationVariables = Exact<{ [key: string]: never; }>;


export type GuestLogonMutation = { __typename?: 'Mutation', guestLogon: (
    { __typename?: 'TokenPayload' }
    & TokenPayloadFragment
  ) };

export type RefreshLogonMutationVariables = Exact<{
  input: RefreshLogonInput;
}>;


export type RefreshLogonMutation = { __typename?: 'Mutation', refreshLogon: (
    { __typename?: 'TokenPayload' }
    & TokenPayloadFragment
  ) };

export type AddressFieldsFragment = { __typename?: 'Address', id: string, title?: string | null, firstName?: string | null, lastName?: string | null, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, address1?: string | null, address2?: string | null, stateCode?: string | null, city?: string | null, countryCode?: string | null, phone?: string | null, preferred?: boolean | null, postalCode?: string | null, streetNumber?: string | null, salutation?: string | null, companyName?: string | null };

export type AmbassadorCardFieldsFragment = { __typename?: 'SavedAmbassadorCard', id: string, maskedNumber: string, name: string, preferred: boolean };

type AmbassadorCardPaymentFields_Adyen_Fragment = { __typename?: 'Adyen' };

type AmbassadorCardPaymentFields_AdyenKlarna_Fragment = { __typename?: 'AdyenKlarna' };

type AmbassadorCardPaymentFields_AdyenKlarnaAccount_Fragment = { __typename?: 'AdyenKlarnaAccount' };

type AmbassadorCardPaymentFields_AdyenPayPal_Fragment = { __typename?: 'AdyenPayPal' };

type AmbassadorCardPaymentFields_AfterPay_Fragment = { __typename?: 'AfterPay' };

type AmbassadorCardPaymentFields_Alipay_Fragment = { __typename?: 'Alipay' };

type AmbassadorCardPaymentFields_AmazonPay_Fragment = { __typename?: 'AmazonPay' };

type AmbassadorCardPaymentFields_AmbassadorCard_Fragment = { __typename: 'AmbassadorCard', id: string, maskedNumber: string, amount: number, authorizationStatus?: string | null, type: string };

type AmbassadorCardPaymentFields_ApplePay_Fragment = { __typename?: 'ApplePay' };

type AmbassadorCardPaymentFields_CashOnDelivery_Fragment = { __typename?: 'CashOnDelivery' };

type AmbassadorCardPaymentFields_CreditCard_Fragment = { __typename?: 'CreditCard' };

type AmbassadorCardPaymentFields_CreditCardConfirm_Fragment = { __typename?: 'CreditCardConfirm' };

type AmbassadorCardPaymentFields_GiftCard_Fragment = { __typename?: 'GiftCard' };

type AmbassadorCardPaymentFields_GooglePay_Fragment = { __typename?: 'GooglePay' };

type AmbassadorCardPaymentFields_KlarnaPayments_Fragment = { __typename?: 'KlarnaPayments' };

type AmbassadorCardPaymentFields_OnlineBanking_Fragment = { __typename?: 'OnlineBanking' };

type AmbassadorCardPaymentFields_PayPal_Fragment = { __typename?: 'PayPal' };

type AmbassadorCardPaymentFields_PayPay_Fragment = { __typename?: 'PayPay' };

type AmbassadorCardPaymentFields_PayTm_Fragment = { __typename?: 'PayTm' };

type AmbassadorCardPaymentFields_Razorpay_Fragment = { __typename?: 'Razorpay' };

type AmbassadorCardPaymentFields_Scheme_Fragment = { __typename?: 'Scheme' };

type AmbassadorCardPaymentFields_StoreCreditInstrument_Fragment = { __typename?: 'StoreCreditInstrument' };

type AmbassadorCardPaymentFields_Upi_Fragment = { __typename?: 'UPI' };

type AmbassadorCardPaymentFields_Wallet_Fragment = { __typename?: 'Wallet' };

type AmbassadorCardPaymentFields_WechatPay_Fragment = { __typename?: 'WechatPay' };

type AmbassadorCardPaymentFields_ZipPay_Fragment = { __typename?: 'ZipPay' };

export type AmbassadorCardPaymentFieldsFragment = AmbassadorCardPaymentFields_Adyen_Fragment | AmbassadorCardPaymentFields_AdyenKlarna_Fragment | AmbassadorCardPaymentFields_AdyenKlarnaAccount_Fragment | AmbassadorCardPaymentFields_AdyenPayPal_Fragment | AmbassadorCardPaymentFields_AfterPay_Fragment | AmbassadorCardPaymentFields_Alipay_Fragment | AmbassadorCardPaymentFields_AmazonPay_Fragment | AmbassadorCardPaymentFields_AmbassadorCard_Fragment | AmbassadorCardPaymentFields_ApplePay_Fragment | AmbassadorCardPaymentFields_CashOnDelivery_Fragment | AmbassadorCardPaymentFields_CreditCard_Fragment | AmbassadorCardPaymentFields_CreditCardConfirm_Fragment | AmbassadorCardPaymentFields_GiftCard_Fragment | AmbassadorCardPaymentFields_GooglePay_Fragment | AmbassadorCardPaymentFields_KlarnaPayments_Fragment | AmbassadorCardPaymentFields_OnlineBanking_Fragment | AmbassadorCardPaymentFields_PayPal_Fragment | AmbassadorCardPaymentFields_PayPay_Fragment | AmbassadorCardPaymentFields_PayTm_Fragment | AmbassadorCardPaymentFields_Razorpay_Fragment | AmbassadorCardPaymentFields_Scheme_Fragment | AmbassadorCardPaymentFields_StoreCreditInstrument_Fragment | AmbassadorCardPaymentFields_Upi_Fragment | AmbassadorCardPaymentFields_Wallet_Fragment | AmbassadorCardPaymentFields_WechatPay_Fragment | AmbassadorCardPaymentFields_ZipPay_Fragment;

export type AuthPayloadFragment = { __typename: 'AuthPayload', accessToken: string, refreshToken: string, customerId: string, customerContext?: { __typename: 'CustomerContext', hashKey?: string | null, customerGroups?: Array<string> | null } | null, user: { __typename?: 'User', customerNo?: string | null, email?: string | null } };

type OrderPaymentInstrumentFields_NestedOrder_Fragment = { __typename?: 'NestedOrder', paymentInstruments: Array<{ __typename: 'Adyen', id: string, amount: number, type: string } | { __typename: 'AdyenKlarna', id: string, amount: number, type: string } | { __typename: 'AdyenKlarnaAccount', id: string, amount: number, type: string } | { __typename?: 'AdyenPayPal' } | { __typename: 'AfterPay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'Alipay', id: string, type: string } | { __typename: 'AmazonPay', id: string, type: string, amount: number } | { __typename: 'AmbassadorCard', id: string, authorizationStatus?: string | null, maskedNumber: string, amount: number, type: string } | { __typename: 'ApplePay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'CashOnDelivery', id: string, amount: number, type: string } | { __typename: 'CreditCard', id: string, amount: number, maskedNumber: string, cardType: string, authorizationStatus?: string | null, type: string } | { __typename?: 'CreditCardConfirm' } | { __typename: 'GiftCard', id: string, maskedNumber: string, authorizationStatus?: string | null, amount: number, type: string } | { __typename?: 'GooglePay' } | { __typename: 'KlarnaPayments', id: string, type: string, amount: number } | { __typename: 'OnlineBanking', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'PayPal', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'PayPay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'PayTm', id: string, authorizationStatus?: string | null, amount: number, type: string } | { __typename: 'Razorpay', id: string, amount: number, type: string } | { __typename: 'Scheme', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'StoreCreditInstrument', id: string, amount: number, type: string } | { __typename: 'UPI', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'Wallet', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'WechatPay', id: string, type: string } | { __typename: 'ZipPay', id: string, type: string }> };

type OrderPaymentInstrumentFields_StandardOrder_Fragment = { __typename?: 'StandardOrder', paymentInstruments: Array<{ __typename: 'Adyen', id: string, amount: number, type: string } | { __typename: 'AdyenKlarna', id: string, amount: number, type: string } | { __typename: 'AdyenKlarnaAccount', id: string, amount: number, type: string } | { __typename?: 'AdyenPayPal' } | { __typename: 'AfterPay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'Alipay', id: string, type: string } | { __typename: 'AmazonPay', id: string, type: string, amount: number } | { __typename: 'AmbassadorCard', id: string, authorizationStatus?: string | null, maskedNumber: string, amount: number, type: string } | { __typename: 'ApplePay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'CashOnDelivery', id: string, amount: number, type: string } | { __typename: 'CreditCard', id: string, amount: number, maskedNumber: string, cardType: string, authorizationStatus?: string | null, type: string } | { __typename?: 'CreditCardConfirm' } | { __typename: 'GiftCard', id: string, maskedNumber: string, authorizationStatus?: string | null, amount: number, type: string } | { __typename?: 'GooglePay' } | { __typename: 'KlarnaPayments', id: string, type: string, amount: number } | { __typename: 'OnlineBanking', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'PayPal', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'PayPay', id: string, authorizationStatus?: string | null, type: string } | { __typename: 'PayTm', id: string, authorizationStatus?: string | null, amount: number, type: string } | { __typename: 'Razorpay', id: string, amount: number, type: string } | { __typename: 'Scheme', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'StoreCreditInstrument', id: string, amount: number, type: string } | { __typename: 'UPI', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'Wallet', id: string, amount: number, authorizationStatus?: string | null, type: string } | { __typename: 'WechatPay', id: string, type: string } | { __typename: 'ZipPay', id: string, type: string }> };

export type OrderPaymentInstrumentFieldsFragment = OrderPaymentInstrumentFields_NestedOrder_Fragment | OrderPaymentInstrumentFields_StandardOrder_Fragment;

export type OrderAddressFragment = { __typename?: 'OrderAddress', id: string, salutation?: string | null, firstName: string, lastName: string, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, companyName?: string | null, address1: string, address2?: string | null, streetNumber?: string | null, postalCode: string, city: string, countryCode: string, stateCode: string, phone?: string | null };

type OrderConfirmationFields_NestedOrder_Fragment = { __typename?: 'NestedOrder', billingAddress?: (
    { __typename?: 'OrderAddress' }
    & OrderAddressFragment
  ) | null, shipment?: { __typename?: 'Shipment', id: string, deliveryDate?: string | null, deliveryTimeDisplayText?: string | null, shipmentMethod?: { __typename?: 'ShipmentMethod', id: string, name?: string | null, price?: number | null } | null, address?: (
      { __typename?: 'OrderAddress' }
      & OrderAddressFragment
    ) | null } | null, customer?: { __typename?: 'CustomerInfo', email?: string | null, id?: string | null } | null };

type OrderConfirmationFields_StandardOrder_Fragment = { __typename?: 'StandardOrder', billingAddress?: (
    { __typename?: 'OrderAddress' }
    & OrderAddressFragment
  ) | null, shipment?: { __typename?: 'Shipment', id: string, deliveryDate?: string | null, deliveryTimeDisplayText?: string | null, shipmentMethod?: { __typename?: 'ShipmentMethod', id: string, name?: string | null, price?: number | null } | null, address?: (
      { __typename?: 'OrderAddress' }
      & OrderAddressFragment
    ) | null } | null, customer?: { __typename?: 'CustomerInfo', email?: string | null, id?: string | null } | null };

export type OrderConfirmationFieldsFragment = OrderConfirmationFields_NestedOrder_Fragment | OrderConfirmationFields_StandardOrder_Fragment;

export type ShipmentMethodInfoFieldsFragment = { __typename?: 'ShipmentMethodInfo', defaultShipmentMethodId?: string | null, availableShipmentMethods: Array<{ __typename?: 'ShipmentMethod', id: string, name?: string | null, price?: number | null, estimatedShippingDate?: { __typename?: 'EstimatedShippingDate', min?: string | null, max?: string | null } | null }> };

export type CustomerFieldsFragment = { __typename?: 'Cart', customer?: { __typename?: 'CustomerInfo', id?: string | null, email?: string | null, customerNo?: string | null } | null };

export type ShipmentFieldsFragment = { __typename?: 'Shipment', id: string, deliveryDate?: string | null, deliveryTimeCode?: string | null, deliveryTimeDisplayText?: string | null, shipmentMethod?: { __typename?: 'ShipmentMethod', id: string, name?: string | null, price?: number | null } | null, address?: { __typename?: 'OrderAddress', id: string, firstName: string, lastName: string, address1: string, address2?: string | null, postalCode: string, city: string, countryCode: string, stateCode: string, phone?: string | null, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, streetNumber?: string | null, salutation?: string | null, companyName?: string | null } | null, authorityToLeave?: { __typename?: 'AuthorityToLeave', leaveAt: AuthorityToLeaveOptions, deliveryInstructions?: string | null } | null };

export type BillingAddressFieldsFragment = { __typename?: 'Cart', billingAddress?: { __typename?: 'OrderAddress', firstName: string, lastName: string, address1: string, address2?: string | null, postalCode: string, city: string, countryCode: string, stateCode: string, phone?: string | null, id: string, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, streetNumber?: string | null, salutation?: string | null, companyName?: string | null } | null };

export type CartCostsFieldsFragment = { __typename?: 'Cart', subTotal?: number | null, shippingCosts?: number | null, estimatedShippingCosts?: number | null, taxTotal?: number | null, taxation?: Taxation | null, estimatedTotal?: number | null, amountRemaining: number, customizationAdjustment?: { __typename?: 'Adjustment', price?: number | null } | null };

export type CartPromoFieldsFragment = { __typename?: 'Cart', couponItems: Array<{ __typename?: 'CouponItem', code?: string | null, couponItemId?: string | null, statusCode?: string | null, valid?: boolean | null, discountAmount?: number | null, calloutMessage?: string | null }>, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, productAdjustments?: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }> | null };

type CartPaymentInstrumentsFields_Adyen_Fragment = (
  { __typename?: 'Adyen' }
  & AmbassadorCardPaymentFields_Adyen_Fragment
);

type CartPaymentInstrumentsFields_AdyenKlarna_Fragment = (
  { __typename?: 'AdyenKlarna' }
  & AmbassadorCardPaymentFields_AdyenKlarna_Fragment
);

type CartPaymentInstrumentsFields_AdyenKlarnaAccount_Fragment = (
  { __typename?: 'AdyenKlarnaAccount' }
  & AmbassadorCardPaymentFields_AdyenKlarnaAccount_Fragment
);

type CartPaymentInstrumentsFields_AdyenPayPal_Fragment = (
  { __typename?: 'AdyenPayPal' }
  & AmbassadorCardPaymentFields_AdyenPayPal_Fragment
);

type CartPaymentInstrumentsFields_AfterPay_Fragment = (
  { __typename: 'AfterPay', id: string, type: string }
  & AmbassadorCardPaymentFields_AfterPay_Fragment
);

type CartPaymentInstrumentsFields_Alipay_Fragment = (
  { __typename?: 'Alipay' }
  & AmbassadorCardPaymentFields_Alipay_Fragment
);

type CartPaymentInstrumentsFields_AmazonPay_Fragment = (
  { __typename: 'AmazonPay', id: string, type: string }
  & AmbassadorCardPaymentFields_AmazonPay_Fragment
);

type CartPaymentInstrumentsFields_AmbassadorCard_Fragment = (
  { __typename?: 'AmbassadorCard' }
  & AmbassadorCardPaymentFields_AmbassadorCard_Fragment
);

type CartPaymentInstrumentsFields_ApplePay_Fragment = (
  { __typename: 'ApplePay', id: string, authorizationStatus?: string | null, type: string }
  & AmbassadorCardPaymentFields_ApplePay_Fragment
);

type CartPaymentInstrumentsFields_CashOnDelivery_Fragment = (
  { __typename: 'CashOnDelivery', id: string, type: string }
  & AmbassadorCardPaymentFields_CashOnDelivery_Fragment
);

type CartPaymentInstrumentsFields_CreditCard_Fragment = (
  { __typename: 'CreditCard', id: string, maskedNumber: string, expirationMonth?: number | null, expirationYear?: number | null, holder?: string | null, type: string }
  & AmbassadorCardPaymentFields_CreditCard_Fragment
);

type CartPaymentInstrumentsFields_CreditCardConfirm_Fragment = (
  { __typename?: 'CreditCardConfirm' }
  & AmbassadorCardPaymentFields_CreditCardConfirm_Fragment
);

type CartPaymentInstrumentsFields_GiftCard_Fragment = (
  { __typename: 'GiftCard', id: string, maskedNumber: string, amount: number, type: string }
  & AmbassadorCardPaymentFields_GiftCard_Fragment
);

type CartPaymentInstrumentsFields_GooglePay_Fragment = (
  { __typename?: 'GooglePay' }
  & AmbassadorCardPaymentFields_GooglePay_Fragment
);

type CartPaymentInstrumentsFields_KlarnaPayments_Fragment = (
  { __typename?: 'KlarnaPayments' }
  & AmbassadorCardPaymentFields_KlarnaPayments_Fragment
);

type CartPaymentInstrumentsFields_OnlineBanking_Fragment = (
  { __typename: 'OnlineBanking', id: string, type: string }
  & AmbassadorCardPaymentFields_OnlineBanking_Fragment
);

type CartPaymentInstrumentsFields_PayPal_Fragment = (
  { __typename: 'PayPal', id: string, type: string }
  & AmbassadorCardPaymentFields_PayPal_Fragment
);

type CartPaymentInstrumentsFields_PayPay_Fragment = (
  { __typename: 'PayPay', id: string, type: string }
  & AmbassadorCardPaymentFields_PayPay_Fragment
);

type CartPaymentInstrumentsFields_PayTm_Fragment = (
  { __typename: 'PayTm', id: string, type: string }
  & AmbassadorCardPaymentFields_PayTm_Fragment
);

type CartPaymentInstrumentsFields_Razorpay_Fragment = (
  { __typename: 'Razorpay', id: string, type: string }
  & AmbassadorCardPaymentFields_Razorpay_Fragment
);

type CartPaymentInstrumentsFields_Scheme_Fragment = (
  { __typename: 'Scheme', id: string, type: string }
  & AmbassadorCardPaymentFields_Scheme_Fragment
);

type CartPaymentInstrumentsFields_StoreCreditInstrument_Fragment = (
  { __typename: 'StoreCreditInstrument', id: string, type: string, amount: number }
  & AmbassadorCardPaymentFields_StoreCreditInstrument_Fragment
);

type CartPaymentInstrumentsFields_Upi_Fragment = (
  { __typename: 'UPI', id: string, type: string }
  & AmbassadorCardPaymentFields_Upi_Fragment
);

type CartPaymentInstrumentsFields_Wallet_Fragment = (
  { __typename: 'Wallet', id: string, type: string }
  & AmbassadorCardPaymentFields_Wallet_Fragment
);

type CartPaymentInstrumentsFields_WechatPay_Fragment = (
  { __typename?: 'WechatPay' }
  & AmbassadorCardPaymentFields_WechatPay_Fragment
);

type CartPaymentInstrumentsFields_ZipPay_Fragment = (
  { __typename?: 'ZipPay' }
  & AmbassadorCardPaymentFields_ZipPay_Fragment
);

export type CartPaymentInstrumentsFieldsFragment = CartPaymentInstrumentsFields_Adyen_Fragment | CartPaymentInstrumentsFields_AdyenKlarna_Fragment | CartPaymentInstrumentsFields_AdyenKlarnaAccount_Fragment | CartPaymentInstrumentsFields_AdyenPayPal_Fragment | CartPaymentInstrumentsFields_AfterPay_Fragment | CartPaymentInstrumentsFields_Alipay_Fragment | CartPaymentInstrumentsFields_AmazonPay_Fragment | CartPaymentInstrumentsFields_AmbassadorCard_Fragment | CartPaymentInstrumentsFields_ApplePay_Fragment | CartPaymentInstrumentsFields_CashOnDelivery_Fragment | CartPaymentInstrumentsFields_CreditCard_Fragment | CartPaymentInstrumentsFields_CreditCardConfirm_Fragment | CartPaymentInstrumentsFields_GiftCard_Fragment | CartPaymentInstrumentsFields_GooglePay_Fragment | CartPaymentInstrumentsFields_KlarnaPayments_Fragment | CartPaymentInstrumentsFields_OnlineBanking_Fragment | CartPaymentInstrumentsFields_PayPal_Fragment | CartPaymentInstrumentsFields_PayPay_Fragment | CartPaymentInstrumentsFields_PayTm_Fragment | CartPaymentInstrumentsFields_Razorpay_Fragment | CartPaymentInstrumentsFields_Scheme_Fragment | CartPaymentInstrumentsFields_StoreCreditInstrument_Fragment | CartPaymentInstrumentsFields_Upi_Fragment | CartPaymentInstrumentsFields_Wallet_Fragment | CartPaymentInstrumentsFields_WechatPay_Fragment | CartPaymentInstrumentsFields_ZipPay_Fragment;

export type GiftWithPurchaseFieldsFragment = { __typename?: 'GiftWithPurchasePromo', id: string, allowedQuantity: number, promotionId: string, calloutMessage?: string | null, gwpTitle?: string | null, details?: string | null, fullfilled: boolean, availableProducts: Array<{ __typename: 'ProductWithExclusion', excludedColors: Array<string>, product: { __typename?: 'Product', id: string, name: string, variations: Array<{ __typename?: 'Variant', id: string, colorValue: string, colorName: string, salePrice?: number | null, price: number, preview: string, orderable?: boolean | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', displayValue?: string | null, soldout?: boolean | null } | null, sizeGroups: Array<{ __typename?: 'SizeGroup', label?: string | null, description?: string | null, sizes: Array<{ __typename?: 'Size', id: string, label: string, value: string, productId: string, orderable: boolean, maxOrderableQuantity: number }> }>, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }> }> } } | { __typename: 'VariantProduct', masterId: string, id: string, name: string, price: number, inventory: number, primaryCategoryId?: string | null, styleNumber: string, colorValue: string, colorName: string, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }>, size: { __typename?: 'VariantSize', label: string, value: string } }> };

type ProductCartItemFields_GiftCardCartItem_Fragment = { __typename: 'GiftCardCartItem', id: string, imageUrl: string, amount: number, recipientEmail: string, recipientName: string, senderName: string };

type ProductCartItemFields_ProductCartItem_Fragment = { __typename: 'ProductCartItem', id: string, inCartPrice: number, bonusItemId?: string | null, restricted: boolean, quantity: number, customizationName?: string | null, customizationNumber?: string | null, customizationCost?: string | null, quantityInCart?: number | null, stockMessage?: string | null, stockMessageCode?: string | null, hasStock?: boolean | null, adjustQuantityMessage?: string | null, personalizationSurcharge?: number | null, personalizationImageURL?: string | null, personalizationLargeImageURL?: string | null, personalizationName?: string | null, personalizationNumber?: string | null, personalizationPrice?: string | null, personalizationRecipeID?: string | null, popularityCount?: number | null, purchasedPrice?: { __typename?: 'ProductPrice', price?: number | null, promotionPrice?: number | null } | null, adjustments: Array<{ __typename: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null, promotion?: { __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null, name?: string | null } | null }>, product: { __typename?: 'VariantProduct', masterId: string, id: string, isAppExclusive?: boolean | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, promotionExclusion?: boolean | null, name: string, header?: string | null, subHeader?: string | null, price: number, brand?: string | null, salePrice?: number | null, inventory: number, maxOrderableQuantity: number, primaryCategoryId?: string | null, styleNumber: string, ean?: string | null, upc?: string | null, colorValue: string, colorName: string, offline: boolean, orderable: boolean, assortmentAvailability?: string | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }>, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, validTo?: string | null } | null, size: { __typename?: 'VariantSize', label: string, value: string } }, estimatedDeliveryDate?: { __typename?: 'EstimatedDeliveryDate', id?: string | null, carrierCode?: string | null, eddBegin?: string | null, eddEnd?: string | null, serviceCode?: string | null, timeZoneName?: string | null, errorResponse?: { __typename?: 'EstimatedDeliveryDateErrorResponse', code?: string | null, message?: string | null } | null } | null };

export type ProductCartItemFieldsFragment = ProductCartItemFields_GiftCardCartItem_Fragment | ProductCartItemFields_ProductCartItem_Fragment;

type ProductCartItemAnalyticsDimensionsFields_GiftCardCartItem_Fragment = { __typename?: 'GiftCardCartItem' };

type ProductCartItemAnalyticsDimensionsFields_ProductCartItem_Fragment = { __typename?: 'ProductCartItem', taxRate?: number | null, product: (
    { __typename?: 'VariantProduct' }
    & ProductAnalyticsDimensionsFieldsFragment
  ) };

export type ProductCartItemAnalyticsDimensionsFieldsFragment = ProductCartItemAnalyticsDimensionsFields_GiftCardCartItem_Fragment | ProductCartItemAnalyticsDimensionsFields_ProductCartItem_Fragment;

export type AvailablePaymentMethodsFieldsFragment = { __typename?: 'PaymentMethod', id: string, description?: string | null, name?: string | null, paymentProcessorId?: string | null, c_additionalFee?: number | null, cards?: Array<{ __typename?: 'PaymentCardSpec', id: string, cardType?: string | null, name?: string | null }> | null, bank?: Array<{ __typename?: 'Issuer', id: string, name: string }> | null, wallet?: Array<{ __typename?: 'Issuer', id: string, name: string }> | null };

export type CartFieldsFragment = (
  { __typename?: 'Cart', id: string, productCount?: number | null, amountRemainingForFreeShipping?: number | null, basketInStockStatus?: string | null, hasFreeShipping?: boolean | null, hasOfflineProducts?: boolean | null, preOrderDeliveryDate?: string | null, shippingSurcharge?: { __typename?: 'ShippingSurcharge', amount: number, label: string, tooltip: string } | null, products: Array<(
    { __typename?: 'GiftCardCartItem' }
    & ProductCartItemFields_GiftCardCartItem_Fragment
  ) | (
    { __typename?: 'ProductCartItem' }
    & ProductCartItemFields_ProductCartItem_Fragment
  )>, giftWithPurchases: Array<(
    { __typename?: 'GiftWithPurchasePromo' }
    & GiftWithPurchaseFieldsFragment
  )>, paymentInstruments: Array<(
    { __typename?: 'Adyen' }
    & CartPaymentInstrumentsFields_Adyen_Fragment
  ) | (
    { __typename?: 'AdyenKlarna' }
    & CartPaymentInstrumentsFields_AdyenKlarna_Fragment
  ) | (
    { __typename?: 'AdyenKlarnaAccount' }
    & CartPaymentInstrumentsFields_AdyenKlarnaAccount_Fragment
  ) | (
    { __typename?: 'AdyenPayPal' }
    & CartPaymentInstrumentsFields_AdyenPayPal_Fragment
  ) | (
    { __typename?: 'AfterPay' }
    & CartPaymentInstrumentsFields_AfterPay_Fragment
  ) | (
    { __typename?: 'Alipay' }
    & CartPaymentInstrumentsFields_Alipay_Fragment
  ) | (
    { __typename?: 'AmazonPay' }
    & CartPaymentInstrumentsFields_AmazonPay_Fragment
  ) | (
    { __typename?: 'AmbassadorCard' }
    & CartPaymentInstrumentsFields_AmbassadorCard_Fragment
  ) | (
    { __typename?: 'ApplePay' }
    & CartPaymentInstrumentsFields_ApplePay_Fragment
  ) | (
    { __typename?: 'CashOnDelivery' }
    & CartPaymentInstrumentsFields_CashOnDelivery_Fragment
  ) | (
    { __typename?: 'CreditCard' }
    & CartPaymentInstrumentsFields_CreditCard_Fragment
  ) | (
    { __typename?: 'CreditCardConfirm' }
    & CartPaymentInstrumentsFields_CreditCardConfirm_Fragment
  ) | (
    { __typename?: 'GiftCard' }
    & CartPaymentInstrumentsFields_GiftCard_Fragment
  ) | (
    { __typename?: 'GooglePay' }
    & CartPaymentInstrumentsFields_GooglePay_Fragment
  ) | (
    { __typename?: 'KlarnaPayments' }
    & CartPaymentInstrumentsFields_KlarnaPayments_Fragment
  ) | (
    { __typename?: 'OnlineBanking' }
    & CartPaymentInstrumentsFields_OnlineBanking_Fragment
  ) | (
    { __typename?: 'PayPal' }
    & CartPaymentInstrumentsFields_PayPal_Fragment
  ) | (
    { __typename?: 'PayPay' }
    & CartPaymentInstrumentsFields_PayPay_Fragment
  ) | (
    { __typename?: 'PayTm' }
    & CartPaymentInstrumentsFields_PayTm_Fragment
  ) | (
    { __typename?: 'Razorpay' }
    & CartPaymentInstrumentsFields_Razorpay_Fragment
  ) | (
    { __typename?: 'Scheme' }
    & CartPaymentInstrumentsFields_Scheme_Fragment
  ) | (
    { __typename?: 'StoreCreditInstrument' }
    & CartPaymentInstrumentsFields_StoreCreditInstrument_Fragment
  ) | (
    { __typename?: 'UPI' }
    & CartPaymentInstrumentsFields_Upi_Fragment
  ) | (
    { __typename?: 'Wallet' }
    & CartPaymentInstrumentsFields_Wallet_Fragment
  ) | (
    { __typename?: 'WechatPay' }
    & CartPaymentInstrumentsFields_WechatPay_Fragment
  ) | (
    { __typename?: 'ZipPay' }
    & CartPaymentInstrumentsFields_ZipPay_Fragment
  )>, shipment?: (
    { __typename?: 'Shipment' }
    & ShipmentFieldsFragment
  ) | null, shipmentMethodInfo: (
    { __typename?: 'ShipmentMethodInfo' }
    & ShipmentMethodInfoFieldsFragment
  ), longTermPreOrder?: { __typename?: 'LongTermPreOrder', hasLongTermPreOrderItem?: boolean | null, longTermPreOrderItemPaymentMethods?: string | null } | null }
  & CustomerFieldsFragment
  & CartCostsFieldsFragment
  & CartPromoFieldsFragment
  & BillingAddressFieldsFragment
);

export type CategoryFragment = { __typename?: 'Category', id: string, name: string, title?: string | null, url: string, visible?: boolean | null };

export type CtaFieldsFragment = { __typename: 'CTA', _type: string, id?: string | null, link: string, title?: string | null, variant?: LinkVariant | null, outlined?: boolean | null, newtab?: boolean | null, popup?: boolean | null, query?: string | null };

export type SignUpFormFieldsFragment = { __typename: 'SignUpForm', id: string, analyticsIdentifier?: string | null, launchButtonLabel?: string | null, launchLinkText?: string | null, cartPageLaunchButtonLabel?: string | null, header?: string | null, copy?: string | null, footnote?: string | null, contactSource: string, disclaimerText?: string | null, submitButtonText: string, customText?: string | null, submitButtonTextColor?: string | null, submitButtonColor?: string | null, fields: Array<string>, textColor?: string | null, backgroundColor?: string | null, successHeader: string, successHeaderTextColor?: string | null, successCopy?: string | null, successCopyTextColor?: string | null, successFootnote?: string | null, successFootnoteTextColor?: string | null, inverted?: boolean | null, disclaimer?: Array<(
    { __typename?: 'PortableText' }
    & PortableTextFieldsFragment
  ) | null> | null, portableDisclaimerText?: Array<(
    { __typename?: 'PortableText' }
    & PortableTextFieldsFragment
  ) | null> | null, ctas?: Array<(
    { __typename?: 'CTA' }
    & CtaFieldsFragment
  )> | null, successImage?: (
    { __typename?: 'SanityImage' }
    & SanityImageFieldsFragment
  ) | null, mobileBackgroundImage?: (
    { __typename?: 'SanityImage' }
    & SanityImageFieldsFragment
  ) | null, formBackgroundImage?: (
    { __typename?: 'SanityImage' }
    & SanityImageFieldsFragment
  ) | null };

export type SavedCreditCardFragment = { __typename?: 'SavedCreditCard', UUID: string, defaultFlag: string, creditHolderName: string, creditCardSeq: string, creditCardType: string, creditCardNumber: string, maskedCreditCardNumber: string, creditCardExpirationMonth: string, creditCardExpirationYear: string };

export type ColorInputFieldsFragment = { __typename: 'ColorInput', hex: string, alpha: number, rgb: { __typename?: 'Rgba', r?: number | null, g?: number | null, b?: number | null, a?: number | null } };

export type BackgroundOverlayFieldsFragment = { __typename: 'BackgroundOverlay', id?: string | null, overlayType?: string | null, direction?: string | null, overlayColorInput?: (
    { __typename?: 'ColorInput' }
    & ColorInputFieldsFragment
  ) | null };

export type SanityImageFieldsFragment = { __typename?: 'SanityImage', alt?: string | null, asset?: { __typename?: 'SanityImageAsset', _id: string, url: string, extension: string, metadata: { __typename?: 'SanityImageMetaData', lqip?: string | null, dimensions: { __typename?: 'SanityImageMetaDataDimensions', width: number, height: number } } } | null, overlay?: (
    { __typename?: 'BackgroundOverlay' }
    & BackgroundOverlayFieldsFragment
  ) | null };

export type NestedOrderDetailsFieldsFragment = (
  { __typename: 'NestedOrder', orderNo: string, status?: string | null, taxTotal?: number | null, subTotal?: number | null, createdAt: string, currency?: string | null, isReturnable: boolean, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null, suborders: Array<{ __typename: 'Suborder', orderNo: string, awbNo?: string | null, courierPartner?: string | null, status?: string | null, returnBy?: string | null, isReturnable: boolean, returnUrl?: string | null, statuses?: Array<{ __typename?: 'TimelineStatus', status: string, label: string, order: number } | null> | null, products: Array<{ __typename?: 'GiftCardCartItem' } | { __typename: 'ProductCartItem', id: string, status?: string | null, inCartPrice: number, bonusItemId?: string | null, restricted: boolean, quantity: number, purchasedPrice?: { __typename?: 'ProductPrice', price?: number | null, promotionPrice?: number | null } | null, product: { __typename?: 'VariantProduct', masterId: string, id: string, name: string, price: number, salePrice?: number | null, inventory: number, primaryCategoryId?: string | null, styleNumber: string, colorValue: string, colorName: string, offline: boolean, orderable: boolean, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null } | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }>, size: { __typename?: 'VariantSize', label: string, value: string } }, productReturn?: { __typename?: 'ReturnedProduct', id: string, returnOrderCode?: string | null, forwardAwb?: string | null, returnAwb?: string | null, transporter?: string | null, channelReturnOrderTime?: string | null, type?: string | null, status?: string | null, price?: string | null, quantity?: number | null, statuses?: Array<{ __typename?: 'TimelineStatus', status: string, label: string, order: number } | null> | null } | null }> }> }
  & OrderPaymentInstrumentFields_NestedOrder_Fragment
  & OrderConfirmationFields_NestedOrder_Fragment
);

export type PortableTextFieldsFragment = { __typename?: 'PortableText', _type: string, _key: string, style?: string | null, level?: number | null, listItem?: string | null, children?: Array<{ __typename?: 'Children', _type: string, _key: string, text?: string | null, marks?: Array<string | null> | null } | null> | null, markDefs?: Array<{ __typename?: 'MarkDefs', _type: string, _key: string, _ref?: string | null, href?: string | null, link?: string | null, newtab?: boolean | null } | null> | null };

export type MandatoryVariantFieldsFragment = { __typename?: 'Variant', id: string, masterId: string, variantId?: string | null, name: string, header?: string | null, subHeader?: string | null, price: number, colorValue: string, colorName: string, ean?: string | null, preview: string, sizeGroups: Array<{ __typename?: 'SizeGroup', label?: string | null, description?: string | null, sizes: Array<{ __typename?: 'Size', id: string, label: string, value: string, productId: string, orderable: boolean, maxOrderableQuantity: number }> }>, images: Array<{ __typename?: 'ProductImage', alt: string, href: string, verticalImageHref?: string | null }> };

export type PdpMandatoryVariantFieldsFragment = { __typename?: 'Variant', id: string, masterId: string, variantId?: string | null, name: string, header?: string | null, subHeader?: string | null, price: number, colorValue: string, colorName: string, ean?: string | null, preview: string, images: Array<{ __typename?: 'ProductImage', alt: string, href: string, verticalImageHref?: string | null }> };

export type PdpMandatoryExtraVariantFieldsFragment = { __typename?: 'Variant', id: string, sizeGroups: Array<{ __typename?: 'SizeGroup', label?: string | null, description?: string | null, sizes: Array<{ __typename?: 'Size', id: string, label: string, value: string, productId: string, orderable: boolean, maxOrderableQuantity: number }> }> };

export type MandatoryMasterFieldsFragment = { __typename?: 'Product', name: string, id: string, header?: string | null, subHeader?: string | null, orderableColorCount?: number | null, showExploreCollectionCTA?: boolean | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, soldoutWithRecommender?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null } | null, colors?: Array<{ __typename?: 'ProductColor', name?: string | null, value?: string | null, image?: { __typename?: 'ProductImage', href: string, verticalImageHref?: string | null, alt: string } | null }> | null, image: { __typename?: 'ProductImage', href: string, verticalImageHref?: string | null, alt: string } };

export type SizesFragment = { __typename?: 'Product', productMeasurements?: { __typename?: 'ProductMeasurements', metric: Array<Array<string>>, imperial: Array<Array<string>> } | null };

export type ProductAnalyticsDimensionsFieldsFragment = { __typename?: 'VariantProduct', colorDescription?: string | null, sportName?: string | null, technology?: string | null, gender?: string | null, ageGroup?: string | null, lineName?: string | null, businessUnit?: string | null, businessSegment?: string | null, businessSubSegment?: string | null, division?: string | null, articleGroup?: string | null, articleType?: string | null, franchise?: string | null, collectionMark?: string | null };

export type PaginatedOutputNodesFragmentFragment = { __typename?: 'PaginatedOutput', nodes: Array<{ __typename: 'ProductSearchHit', id: string, color: string, masterId: string, variantProduct?: (
      { __typename?: 'Variant', percentageDiscountBadge?: number | null, salePrice?: number | null, orderable?: boolean | null, isAppExclusive?: boolean | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, badges?: Array<{ __typename?: 'ProductBadge', id: string, label: string }> | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null } | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null }
      & MandatoryVariantFieldsFragment
    ) | null, masterProduct?: (
      { __typename?: 'Product', brand?: string | null, amountOfReviews?: number | null, averageRating?: number | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null, score?: { __typename?: 'Score', rating: string, amount?: string | null } | null }
      & MandatoryMasterFieldsFragment
    ) | null }> };

export type PaginatedOutputMetadataFragmentFragment = { __typename?: 'PaginatedOutput', selectedSort?: string | null, totalCount: number, sortingOptions: Array<{ __typename?: 'SortOption', id: string, label: string }>, filteringOptions: Array<{ __typename?: 'FilterOption', id: string, label: string, values: Array<{ __typename?: 'FilterOptionValue', value: string, label: string, hitCount: number }> }> };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, rating?: number | null, title?: string | null, text?: string | null, nickname?: string | null, location?: string | null, pros?: Array<string> | null, cons?: Array<string> | null, date?: string | null, helpfulVotes?: number | null, isRecommended?: boolean | null, secondaryRatings?: Array<{ __typename?: 'ReviewRating', id: string, label?: string | null, rating?: number | null } | null> | null, aspects?: { __typename?: 'ReviewAspects', width?: string | null, size?: string | null, comfort?: string | null } | null };

export type ReviewSummaryFieldsFragment = { __typename?: 'ReviewSummary', recommendedCount?: number | null, totalCount?: number | null, recommendedPercentage?: number | null, aspects?: { __typename?: 'ReviewAspects', width?: string | null, size?: string | null, comfort?: string | null } | null };

export type OrderPreviewFieldsFragment = { __typename?: 'StandardOrder', orderNo: string, createdAt: string, currency?: string | null, estimatedTotal?: number | null, isReturnable: boolean, refundInformation?: string | null, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null, shipment?: { __typename?: 'Shipment', address?: { __typename?: 'OrderAddress', id: string, firstName: string, lastName: string, postalCode: string, salutation?: string | null } | null } | null, products: Array<{ __typename: 'GiftCardCartItem', id: string, imageUrl: string, amount: number, recipientEmail: string, recipientName: string, senderName: string } | { __typename: 'ProductCartItem', id: string, quantity: number, inCartPrice: number, personalizationImageURL?: string | null, purchasedPrice?: { __typename?: 'ProductPrice', price?: number | null, promotionPrice?: number | null } | null, product: { __typename?: 'VariantProduct', id: string, name: string, header?: string | null, subHeader?: string | null, colorValue: string, colorName: string, masterId: string, styleNumber: string, offline: boolean, orderable: boolean, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }> } }>, customer?: { __typename?: 'CustomerInfo', email?: string | null, id?: string | null } | null };

export type StandardOrderDetailsFieldsFragment = (
  { __typename: 'StandardOrder', orderNo: string, orderToken: string, status?: string | null, refundInformation?: string | null, trackingNumber?: string | null, isReturnable: boolean, taxTotal?: number | null, taxation?: Taxation | null, createdAt: string, currency?: string | null, subTotal?: number | null, shippingCosts?: number | null, estimatedTotal?: number | null, gmoRedirectUrl?: string | null, gmoChallengeUrl?: string | null, gmoFlow?: string | null, gmoAccessID?: string | null, gmoAccessPass?: string | null, promoDiscountValue?: number | null, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null, statuses?: Array<{ __typename?: 'TimelineStatus', status: string, label: string, order: number } | null> | null, oms?: { __typename?: 'OmsEntry', trackingLink?: string | null } | null, shippingSurcharge?: { __typename?: 'ShippingSurcharge', amount: number, label: string, tooltip: string } | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, couponItems?: Array<{ __typename?: 'CouponItem', code?: string | null, couponItemId?: string | null, statusCode?: string | null, valid?: boolean | null } | null> | null, products: Array<(
    { __typename?: 'GiftCardCartItem' }
    & ProductCartItemFields_GiftCardCartItem_Fragment
  ) | (
    { __typename?: 'ProductCartItem' }
    & ProductCartItemFields_ProductCartItem_Fragment
  )> }
  & OrderPaymentInstrumentFields_StandardOrder_Fragment
  & OrderConfirmationFields_StandardOrder_Fragment
);

export type StoreCreditFieldsFragment = { __typename?: 'StoreCredit', amount: number };

export type TermsAndConditionsFieldsFragment = { __typename: 'TermsAndConditions', id: string, content?: Array<(
    { __typename?: 'PortableText' }
    & PortableTextFieldsFragment
  ) | null> | null };

export type UserFieldsFragment = { __typename?: 'User', id: string, customerNo?: string | null, creationDate?: string | null, birthday?: string | null, firstName?: string | null, lastName?: string | null, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, email?: string | null, phoneNumber?: string | null, gender?: string | null, smsContactNumber?: string | null };

export type SanityVideoFieldsFragment = { __typename?: 'SanityVideo', autoplay: boolean, loop: boolean, mute: boolean, source: string };

export type WishListFieldsFragment = { __typename?: 'WishList', id: string, items: Array<{ __typename: 'WishListItem', id: string, quantity: number, creationDate?: string | null, product: { __typename?: 'VariantProduct', id: string, name: string, header?: string | null, subHeader?: string | null, masterId: string, orderable: boolean, inventory: number, price: number, salePrice?: number | null, styleNumber: string, colorValue: string, colorName: string, offline: boolean, isAppExclusive?: boolean | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', displayValue?: string | null, presale?: boolean | null, validTo?: string | null } | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }>, size: { __typename?: 'VariantSize', label: string, value: string } } }> };

export type UpdatePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type UpdatePhoneMutationVariables = Exact<{
  input: UpdatePhoneInput;
}>;


export type UpdatePhoneMutation = { __typename?: 'Mutation', updatePhone: { __typename?: 'UpdatePhonePayload', code?: UpdatePhoneCode | null, message?: string | null, pinId?: string | null } };

export type ConfirmUpdatePhoneMutationVariables = Exact<{
  input: ConfirmUpdatePhoneInput;
}>;


export type ConfirmUpdatePhoneMutation = { __typename?: 'Mutation', confirmUpdatePhone: { __typename?: 'ConfirmUpdatePhonePayload', code?: ConfirmUpdatePhoneCode | null, message?: string | null, user?: { __typename?: 'User', id: string, phoneNumber?: string | null } | null } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type CompleteResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type CompleteResetPasswordMutation = { __typename?: 'Mutation', completeResetPassword: boolean };

export type CreateShopperContextMutationVariables = Exact<{
  input: CreateShopperContextInput;
}>;


export type CreateShopperContextMutation = { __typename?: 'Mutation', createShopperContext?: { __typename?: 'ShopperContextPayload', sourceCode?: string | null } | null };

export type VerifyUserAffiliationsMutationVariables = Exact<{
  input: VerifyUserAffiliationsInput;
}>;


export type VerifyUserAffiliationsMutation = { __typename?: 'Mutation', verifyUserAffiliations: { __typename?: 'VerifyUserAffiliationsPayload', verified?: boolean | null, affiliations?: Array<string> | null } };

export type AddAddressMutationVariables = Exact<{
  title: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  postalCode: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  preferred: Scalars['Boolean'];
  streetNumber?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
}>;


export type AddAddressMutation = { __typename?: 'Mutation', addAddress: (
    { __typename?: 'Address' }
    & AddressFieldsFragment
  ) };

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  postalCode: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  preferred: Scalars['Boolean'];
  streetNumber?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: (
    { __typename?: 'Address' }
    & AddressFieldsFragment
  ) };

export type DeleteAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteAddress: boolean };

export type SaveAmbassadorCardMutationVariables = Exact<{
  input: SaveAmbassadorCardInput;
}>;


export type SaveAmbassadorCardMutation = { __typename?: 'Mutation', saveAmbassadorCard: { __typename?: 'User', id: string, ambassadorCards: Array<(
      { __typename?: 'SavedAmbassadorCard' }
      & AmbassadorCardFieldsFragment
    )> } };

export type DeleteAmbassadorCardMutationVariables = Exact<{
  input: DeleteAmbassadorCardInput;
}>;


export type DeleteAmbassadorCardMutation = { __typename?: 'Mutation', deleteAmbassadorCard: { __typename?: 'User', id: string, ambassadorCards: Array<(
      { __typename?: 'SavedAmbassadorCard' }
      & AmbassadorCardFieldsFragment
    )> } };

export type UpdateAmbassadorCardsMutationVariables = Exact<{
  input: UpdateAmbassadorCardInput;
}>;


export type UpdateAmbassadorCardsMutation = { __typename?: 'Mutation', updateAmbassadorCards: { __typename?: 'User', id: string, ambassadorCards: Array<(
      { __typename?: 'SavedAmbassadorCard' }
      & AmbassadorCardFieldsFragment
    )> } };

export type AddItemsToCartMutationVariables = Exact<{
  input: AddItemsToCartInput;
}>;


export type AddItemsToCartMutation = { __typename?: 'Mutation', addItemsToCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type UpdateItemInCartMutationVariables = Exact<{
  input: UpdateItemInCartInput;
}>;


export type UpdateItemInCartMutation = { __typename?: 'Mutation', updateItemInCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type RemoveItemFromCartMutationVariables = Exact<{
  input: RemoveItemFromCartInput;
}>;


export type RemoveItemFromCartMutation = { __typename?: 'Mutation', removeItemFromCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddGiftCardToCartMutationVariables = Exact<{
  input: AddGiftCardToCartInput;
}>;


export type AddGiftCardToCartMutation = { __typename?: 'Mutation', addGiftCardToCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type RemoveGiftCardFromCartMutationVariables = Exact<{
  input: RemoveGiftCardFromCartInput;
}>;


export type RemoveGiftCardFromCartMutation = { __typename?: 'Mutation', removeGiftCardFromCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddGiftCardMutationVariables = Exact<{
  input: AddGiftCardInput;
}>;


export type AddGiftCardMutation = { __typename?: 'Mutation', addGiftCard: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type RemoveGiftCardMutationVariables = Exact<{
  input: RemoveGiftCardInput;
}>;


export type RemoveGiftCardMutation = { __typename?: 'Mutation', removeGiftCard: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type UpdateShippingAddressMutationVariables = Exact<{
  input: UpdateShippingAddressInput;
}>;


export type UpdateShippingAddressMutation = { __typename?: 'Mutation', updateShippingAddress: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type UpdateShipmentMethodMutationVariables = Exact<{
  input: UpdateShipmentMethodInput;
}>;


export type UpdateShipmentMethodMutation = { __typename?: 'Mutation', updateShipmentMethod: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type UpdateBillingAddressMutationVariables = Exact<{
  input: UpdateBillingAddressInput;
}>;


export type UpdateBillingAddressMutation = { __typename?: 'Mutation', updateBillingAddress: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type RemoveCouponFromCartMutationVariables = Exact<{
  input: RemoveCouponFromCartInput;
}>;


export type RemoveCouponFromCartMutation = { __typename?: 'Mutation', removeCouponFromCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddCouponToCartMutationVariables = Exact<{
  input: AddCouponToCartInput;
}>;


export type AddCouponToCartMutation = { __typename?: 'Mutation', addCouponToCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddPaymentPromotionMutationVariables = Exact<{
  input: AddPaymentPromotionInput;
}>;


export type AddPaymentPromotionMutation = { __typename?: 'Mutation', addPaymentPromotion: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddAmbassadorCardToCartMutationVariables = Exact<{
  input: AddAmbassadorCardToCartInput;
}>;


export type AddAmbassadorCardToCartMutation = { __typename?: 'Mutation', addAmbassadorCardToCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type RemoveAmbassadorCardFromCartMutationVariables = Exact<{
  input: RemoveAmbassadorCardFromCartInput;
}>;


export type RemoveAmbassadorCardFromCartMutation = { __typename?: 'Mutation', removeAmbassadorCardFromCart: (
    { __typename?: 'Cart' }
    & CartFieldsFragment
  ) };

export type AddStoreCreditsMutationVariables = Exact<{
  input: AddStoreCreditsInput;
}>;


export type AddStoreCreditsMutation = { __typename?: 'Mutation', addStoreCredits: { __typename?: 'AddStoreCreditsPayload', cart?: (
      { __typename?: 'Cart' }
      & CartFieldsFragment
    ) | null } };

export type RemoveStoreCreditsMutationVariables = Exact<{
  input: RemoveStoreCreditsInput;
}>;


export type RemoveStoreCreditsMutation = { __typename?: 'Mutation', removeStoreCredits: { __typename?: 'RemoveStoreCreditsPayload', cart?: (
      { __typename?: 'Cart' }
      & CartFieldsFragment
    ) | null } };

export type UpdateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'NewsletterSubscription', email?: string | null, gender?: string | null, firstName?: string | null, lastName?: string | null, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, emailPreference?: string | null, shoppingPreference?: string | null, dob?: { __typename?: 'DOB', day: number, month: number, year: number } | null } | null };

export type KlarnaMutationVariables = Exact<{
  input: KlarnaInput;
}>;


export type KlarnaMutation = { __typename?: 'Mutation', klarna: { __typename?: 'KlarnaResult', action: string, url: string, orderNo: string } };

export type ConfirmKlarnaMutationVariables = Exact<{
  input: ConfirmKlarnaInput;
}>;


export type ConfirmKlarnaMutation = { __typename?: 'Mutation', confirmKlarna: { __typename?: 'StandardOrder', orderNo: string, status?: string | null } };

export type CancelKlarnaMutationVariables = Exact<{
  input: CancelKlarnaInput;
}>;


export type CancelKlarnaMutation = { __typename?: 'Mutation', cancelKlarna: { __typename?: 'StandardOrder', orderNo: string, status?: string | null } };

export type StartKlarnaPaymentMutationVariables = Exact<{
  input: StartKlarnaPaymentInput;
}>;


export type StartKlarnaPaymentMutation = { __typename?: 'Mutation', startKlarnaPayment?: { __typename?: 'StartKlarnaPaymentPayload', clientToken?: string | null, orderNo?: string | null, sessionId?: string | null, paymentMethodCategories?: Array<{ __typename?: 'KlarnaPaymentMethodCategories', identifier?: string | null } | null> | null } | null };

export type ConfirmKlarnaPaymentMutationVariables = Exact<{
  input: ConfirmKlarnaPaymentInput;
}>;


export type ConfirmKlarnaPaymentMutation = { __typename?: 'Mutation', confirmKlarnaPayment: { __typename?: 'StandardOrder', orderNo: string, status?: string | null, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null } };

export type LoginWithEmailAndPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  uniqueShopperId?: InputMaybe<Scalars['String']>;
}>;


export type LoginWithEmailAndPasswordMutation = { __typename?: 'Mutation', login?: (
    { __typename?: 'AuthPayload' }
    & AuthPayloadFragment
  ) | null };

export type VerifyLoginWithOtpMutationVariables = Exact<{
  phoneNo: Scalars['String'];
  pinId: Scalars['String'];
  pin: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  uniqueShopperId?: InputMaybe<Scalars['String']>;
}>;


export type VerifyLoginWithOtpMutation = { __typename?: 'Mutation', verifyLoginWithOTP: { __typename?: 'VerifyLoginWithOTPResult', code: VerifyLoginWithOtpCode, message?: string | null, otpVerifyToken?: string | null, authPayload?: (
      { __typename?: 'AuthPayload' }
      & AuthPayloadFragment
    ) | null } };

export type LoginWithOtpMutationVariables = Exact<{
  recaptchaToken?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
}>;


export type LoginWithOtpMutation = { __typename?: 'Mutation', loginWithOTP?: string | null };

export type LoginWithPhoneMutationVariables = Exact<{
  phoneNo: Scalars['String'];
  password: Scalars['String'];
  uniqueShopperId?: InputMaybe<Scalars['String']>;
}>;


export type LoginWithPhoneMutation = { __typename?: 'Mutation', loginWithPhone?: (
    { __typename?: 'AuthPayload' }
    & AuthPayloadFragment
  ) | null };

export type ResendOtpMutationVariables = Exact<{
  pinId: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type ResendOtpMutation = { __typename?: 'Mutation', resendOTP?: string | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type ManageCustomerLevelNotificationMutationVariables = Exact<{
  input: ManageCustomerLevelNotificationInput;
}>;


export type ManageCustomerLevelNotificationMutation = { __typename?: 'Mutation', manageCustomerLevelNotification?: string | null };

export type SaveNotificationPreferencesMutationVariables = Exact<{
  input: NotificationsPreferenceInput;
}>;


export type SaveNotificationPreferencesMutation = { __typename?: 'Mutation', saveNotificationPreferences?: { __typename?: 'NotificationsPayload', phoneNumber?: string | null, marketingSmsOptIn?: boolean | null, customerSmsOptIn?: boolean | null } | null };

export type ManageOrderLevelNotificationMutationVariables = Exact<{
  input: ManageOrderLevelNotificationInput;
}>;


export type ManageOrderLevelNotificationMutation = { __typename?: 'Mutation', manageOrderLevelNotification: boolean };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'NewsletterSubscription', email?: string | null, gender?: string | null, emailPreference?: string | null, shoppingPreference?: string | null, dob?: { __typename?: 'DOB', day: number, month: number, year: number } | null } | null };

export type OpluxFraudDetectionMutationVariables = Exact<{
  basketId: Scalars['String'];
  opluxFraudDetection: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  fraudbuster?: InputMaybe<Scalars['String']>;
  opluxEventId?: InputMaybe<Scalars['String']>;
  opluxScreeningResult?: InputMaybe<Scalars['String']>;
}>;


export type OpluxFraudDetectionMutation = { __typename?: 'Mutation', opluxFraudDetection?: { __typename?: 'OpluxFraudDetectionResult', isOpluxNG: boolean, opluxEventId?: string | null, opluxScreeningResult?: string | null } | null };

export type StartAdyenPaymentMutationVariables = Exact<{
  input: StartAdyenPaymentInput;
}>;


export type StartAdyenPaymentMutation = { __typename?: 'Mutation', startAdyenPayment?: { __typename?: 'StartPaymentPayload', orderNo?: string | null, simulatorUrl?: string | null, resultCode?: AdyenResultCodeEnum | null, action?: { __typename?: 'CheckoutAwaitAction', paymentMethodType?: string | null, type?: string | null, url?: string | null, paymentData?: string | null } | { __typename?: 'CheckoutRedirectAction', data?: any | null, method?: string | null, type?: string | null, url?: string | null, paymentMethodType?: string | null } | { __typename?: 'CheckoutSDKAction', paymentMethodType?: string | null, paymentData?: string | null, type?: string | null, sdkData?: { __typename?: 'SDKData', token?: string | null } | null } | null } | null };

export type CompleteAdyenPaymentMutationVariables = Exact<{
  input: CompleteAdyenPaymentInput;
}>;


export type CompleteAdyenPaymentMutation = { __typename?: 'Mutation', completeAdyenPayment?: { __typename?: 'AdyenPaymentDetailsPayload', resultCode?: AdyenResultCodeEnum | null, order?: { __typename?: 'StandardOrder', orderNo: string } | null } | null };

export type PayWithAfterPayMutationVariables = Exact<{
  input: AfterPayInput;
}>;


export type PayWithAfterPayMutation = { __typename?: 'Mutation', afterPay: { __typename?: 'AfterPayPayload', url: string, orderNo: string } };

export type ConfirmAfterPayMutationVariables = Exact<{
  input: ConfirmAfterPayInput;
}>;


export type ConfirmAfterPayMutation = { __typename?: 'Mutation', confirmAfterPay: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type AmazonPayPaymentDescriptorQueryVariables = Exact<{
  input: AmazonPayPaymentDescriptorInput;
}>;


export type AmazonPayPaymentDescriptorQuery = { __typename?: 'Query', amazonPayPaymentDescriptor: { __typename?: 'AmazonPayPaymentDescriptorPayload', paymentOption: string } };

export type SignAmazonPayloadMutationVariables = Exact<{
  input: SignAmazonPayloadInput;
}>;


export type SignAmazonPayloadMutation = { __typename?: 'Mutation', signAmazonPayload: { __typename?: 'SignAmazonPayloadResponse', signedPayload: string } };

export type StartAmazonPaymentMutationVariables = Exact<{
  input: StartAmazonPaymentInput;
}>;


export type StartAmazonPaymentMutation = { __typename?: 'Mutation', startAmazonPayment: { __typename?: 'StartAmazonPaymentPayload', url?: string | null, order: { __typename?: 'StandardOrder', orderNo: string } } };

export type StartAmazonProcessOrderPaymentMutationVariables = Exact<{
  input: StartAmazonProcessOrderPaymentInput;
}>;


export type StartAmazonProcessOrderPaymentMutation = { __typename?: 'Mutation', startAmazonProcessOrderPayment: { __typename?: 'StartAmazonProcessOrderPaymentPayload', order: { __typename?: 'StandardOrder', orderNo: string } } };

export type CompleteAmazonPaymentMutationVariables = Exact<{
  input: CompleteAmazonPaymentInput;
}>;


export type CompleteAmazonPaymentMutation = { __typename?: 'Mutation', completeAmazonPayment: { __typename?: 'CompleteAmazonPaymentPayload', order: { __typename?: 'StandardOrder', orderNo: string } } };

export type RegisterAmazonPaymentMutationVariables = Exact<{
  input: RegisterAmazonPaymentInput;
}>;


export type RegisterAmazonPaymentMutation = { __typename?: 'Mutation', registerAmazonPayment: { __typename?: 'RegisterAmazonPaymentPayload', shouldPromptForLogin: boolean, cart?: (
      { __typename?: 'Cart', shipment?: (
        { __typename?: 'Shipment' }
        & ShipmentFieldsFragment
      ) | null, shipmentMethodInfo: (
        { __typename?: 'ShipmentMethodInfo' }
        & ShipmentMethodInfoFieldsFragment
      ), availablePaymentMethods: Array<(
        { __typename?: 'PaymentMethod' }
        & AvailablePaymentMethodsFieldsFragment
      )> }
      & CartFieldsFragment
    ) | null } };

export type PayWithAmbassadorCardMutationVariables = Exact<{
  input: AmbassadorCardInput;
}>;


export type PayWithAmbassadorCardMutation = { __typename?: 'Mutation', ambassadorCard: (
    { __typename?: 'StandardOrder', orderNo: string }
    & OrderConfirmationFields_StandardOrder_Fragment
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
  ) };

export type PayWithApplePayMutationVariables = Exact<{
  input: ApplePayInput;
}>;


export type PayWithApplePayMutation = { __typename?: 'Mutation', applePay: { __typename?: 'ApplePayValidationResponse', epochTimestamp: string, expiresAt: string, merchantSessionIdentifier: string, nonce: string, merchantIdentifier: string, domainName: string, displayName: string, signature: string, operationalAnalyticsIdentifier: string, retries?: number | null } };

export type ValidateApplePayMerchantMutationVariables = Exact<{
  input: ValidateApplePayMerchantInput;
}>;


export type ValidateApplePayMerchantMutation = { __typename?: 'Mutation', validateApplePayMerchant: string };

export type ConfirmApplePayMutationVariables = Exact<{
  input: ConfirmApplePayInput;
}>;


export type ConfirmApplePayMutation = { __typename?: 'Mutation', confirmApplePay: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type CancelApplePayMutationVariables = Exact<{
  basketId: Scalars['String'];
}>;


export type CancelApplePayMutation = { __typename?: 'Mutation', cancelApplePay: { __typename?: 'Cart', id: string } };

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: { __typename?: 'CancelOrderPayload', order?: { __typename?: 'StandardOrder', orderNo: string } | null, cart?: (
      { __typename?: 'Cart' }
      & CartFieldsFragment
    ) | null } | null };

export type PayWithCashOnDeliveryMutationVariables = Exact<{
  input: CashOnDeliveryInput;
}>;


export type PayWithCashOnDeliveryMutation = { __typename?: 'Mutation', cashOnDelivery: (
    { __typename?: 'StandardOrder', orderNo: string, pinId?: string | null, estimatedTotal?: number | null, taxTotal?: number | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, products: Array<(
      { __typename?: 'GiftCardCartItem' }
      & ProductCartItemFields_GiftCardCartItem_Fragment
    ) | (
      { __typename?: 'ProductCartItem' }
      & ProductCartItemFields_ProductCartItem_Fragment
    )> }
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type PayWithCashOnDeliveryInCartMutationVariables = Exact<{
  input: AddCashOnDeliveryToCartInput;
}>;


export type PayWithCashOnDeliveryInCartMutation = { __typename?: 'Mutation', addCashOnDeliveryPaymentMethodToCart: { __typename?: 'Cart', id: string, estimatedTotal?: number | null, amountRemaining: number, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, paymentInstruments: Array<{ __typename?: 'Adyen' } | { __typename?: 'AdyenKlarna' } | { __typename?: 'AdyenKlarnaAccount' } | { __typename?: 'AdyenPayPal' } | { __typename?: 'AfterPay' } | { __typename?: 'Alipay' } | { __typename?: 'AmazonPay' } | { __typename?: 'AmbassadorCard' } | { __typename?: 'ApplePay' } | { __typename?: 'CashOnDelivery' } | { __typename: 'CreditCard', id: string, amount: number } | { __typename?: 'CreditCardConfirm' } | { __typename?: 'GiftCard' } | { __typename?: 'GooglePay' } | { __typename?: 'KlarnaPayments' } | { __typename?: 'OnlineBanking' } | { __typename?: 'PayPal' } | { __typename?: 'PayPay' } | { __typename?: 'PayTm' } | { __typename?: 'Razorpay' } | { __typename?: 'Scheme' } | { __typename?: 'StoreCreditInstrument' } | { __typename?: 'UPI' } | { __typename?: 'Wallet' } | { __typename?: 'WechatPay' } | { __typename?: 'ZipPay' }> } };

export type ConfirmCashOnDeliveryMutationVariables = Exact<{
  input: ConfirmCashOnDeliveryInput;
}>;


export type ConfirmCashOnDeliveryMutation = { __typename?: 'Mutation', confirmCashOnDelivery: (
    { __typename?: 'StandardOrder', orderNo: string, pin?: string | null, pinId?: string | null }
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type PayWithCreditCardMutationVariables = Exact<{
  input: CreditCardInput;
}>;


export type PayWithCreditCardMutation = { __typename?: 'Mutation', creditCard: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null, subTotal?: number | null, taxTotal?: number | null, estimatedTotal?: number | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, couponItems?: Array<{ __typename?: 'CouponItem', code?: string | null, couponItemId?: string | null, statusCode?: string | null, valid?: boolean | null } | null> | null, products: Array<(
      { __typename?: 'GiftCardCartItem' }
      & ProductCartItemFields_GiftCardCartItem_Fragment
    ) | (
      { __typename?: 'ProductCartItem' }
      & ProductCartItemFields_ProductCartItem_Fragment
    )> }
    & OrderConfirmationFields_StandardOrder_Fragment
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
  ) | { __typename?: 'ThreeDSResponse', url: string, method: ThreeDsMethod, data: string, orderNo: string } };

export type PayWithCreditCardInCartMutationVariables = Exact<{
  input: AddCreditCardToCartInput;
}>;


export type PayWithCreditCardInCartMutation = { __typename?: 'Mutation', addCreditCardPaymentMethodToCart: { __typename?: 'Cart', id: string, estimatedTotal?: number | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, paymentInstruments: Array<{ __typename?: 'Adyen' } | { __typename?: 'AdyenKlarna' } | { __typename?: 'AdyenKlarnaAccount' } | { __typename?: 'AdyenPayPal' } | { __typename?: 'AfterPay' } | { __typename?: 'Alipay' } | { __typename?: 'AmazonPay' } | { __typename?: 'AmbassadorCard' } | { __typename?: 'ApplePay' } | { __typename?: 'CashOnDelivery' } | { __typename: 'CreditCard', id: string, amount: number, maskedNumber: string, cardType: string, authorizationStatus?: string | null } | { __typename?: 'CreditCardConfirm' } | { __typename?: 'GiftCard' } | { __typename?: 'GooglePay' } | { __typename?: 'KlarnaPayments' } | { __typename?: 'OnlineBanking' } | { __typename?: 'PayPal' } | { __typename?: 'PayPay' } | { __typename?: 'PayTm' } | { __typename?: 'Razorpay' } | { __typename?: 'Scheme' } | { __typename?: 'StoreCreditInstrument' } | { __typename?: 'UPI' } | { __typename?: 'Wallet' } | { __typename?: 'WechatPay' } | { __typename?: 'ZipPay' }> } };

export type ConfirmCreditCardMutationVariables = Exact<{
  input: ConfirmCreditCardInput;
}>;


export type ConfirmCreditCardMutation = { __typename?: 'Mutation', confirmCreditCard: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type SaveCreditCardMutationVariables = Exact<{
  cardType: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  number: Scalars['String'];
  holder?: InputMaybe<Scalars['String']>;
  gmoSpecificSaveData?: InputMaybe<GmoSaveData>;
  defaultCard?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveCreditCardMutation = { __typename?: 'Mutation', saveCreditCard: { __typename?: 'User', savedCards?: Array<(
      { __typename?: 'SavedCreditCard' }
      & SavedCreditCardFragment
    )> | null } };

export type DeleteCreditCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type DeleteCreditCardMutation = { __typename?: 'Mutation', deleteCreditCard: { __typename?: 'User', savedCards?: Array<(
      { __typename?: 'SavedCreditCard' }
      & SavedCreditCardFragment
    )> | null } };

export type StartCreditCardPaymentMutationVariables = Exact<{
  input: StartCreditCardPaymentInput;
}>;


export type StartCreditCardPaymentMutation = { __typename?: 'Mutation', startCreditCardPayment: (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) };

export type GmoConfirmCreditCardMutationVariables = Exact<{
  input: GmoConfirmCreditCardInput;
}>;


export type GmoConfirmCreditCardMutation = { __typename?: 'Mutation', gmoConfirmCreditCard: (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) };

export type PlaceOrderMutationVariables = Exact<{
  input: PlaceOrderInput;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder?: { __typename?: 'PlaceOrderPayload', order?: (
      { __typename?: 'StandardOrder', orderNo: string, status?: string | null, subTotal?: number | null, taxTotal?: number | null, estimatedTotal?: number | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, products: Array<(
        { __typename?: 'GiftCardCartItem' }
        & ProductCartItemFields_GiftCardCartItem_Fragment
      ) | (
        { __typename?: 'ProductCartItem' }
        & ProductCartItemFields_ProductCartItem_Fragment
      )> }
      & OrderConfirmationFields_StandardOrder_Fragment
      & OrderPaymentInstrumentFields_StandardOrder_Fragment
    ) | null } | null };

export type PayWithGiftCardMutationVariables = Exact<{
  input: GiftCardInput;
}>;


export type PayWithGiftCardMutation = { __typename?: 'Mutation', giftCard: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null, subTotal?: number | null, taxTotal?: number | null, estimatedTotal?: number | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, products: Array<(
      { __typename?: 'GiftCardCartItem' }
      & ProductCartItemFields_GiftCardCartItem_Fragment
    ) | (
      { __typename?: 'ProductCartItem' }
      & ProductCartItemFields_ProductCartItem_Fragment
    )> }
    & OrderConfirmationFields_StandardOrder_Fragment
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
  ) };

export type PayWithGooglePayMutationVariables = Exact<{
  input: GooglePayInput;
}>;


export type PayWithGooglePayMutation = { __typename?: 'Mutation', googlePay: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type CancelGooglePayMutationVariables = Exact<{
  input: CancelGooglePayInput;
}>;


export type CancelGooglePayMutation = { __typename?: 'Mutation', cancelGooglePay: { __typename?: 'Cart', id: string } };

export type PayWithPayPalMutationVariables = Exact<{
  input: PayPalInput;
}>;


export type PayWithPayPalMutation = { __typename?: 'Mutation', payPal: { __typename?: 'PayPalResult', token?: string | null, url?: string | null, action?: string | null, orderNo: string } };

export type ConfirmPayPalMutationVariables = Exact<{
  input: ConfirmPayPalInput;
}>;


export type ConfirmPayPalMutation = { __typename?: 'Mutation', confirmPayPal: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type UpdatePayPalMutationVariables = Exact<{
  input: ConfirmPayPalInput;
}>;


export type UpdatePayPalMutation = { __typename?: 'Mutation', updatePayPal: (
    { __typename?: 'StandardOrder', subTotal?: number | null, shippingCosts?: number | null, orderNo: string, taxTotal?: number | null, taxation?: Taxation | null, estimatedTotal?: number | null, status?: string | null, createdAt: string, shippingSurcharge?: { __typename?: 'ShippingSurcharge', amount: number, label: string, tooltip: string } | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null, products: Array<(
      { __typename?: 'GiftCardCartItem' }
      & ProductCartItemFields_GiftCardCartItem_Fragment
    ) | (
      { __typename?: 'ProductCartItem' }
      & ProductCartItemFields_ProductCartItem_Fragment
    )> }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type PayWithPayPayMutationVariables = Exact<{
  input: PayPayInput;
}>;


export type PayWithPayPayMutation = { __typename?: 'Mutation', payPay: { __typename?: 'PayPayPayload', url: string, orderNo: string } };

export type ConfirmPayPayMutationVariables = Exact<{
  input: ConfirmPayPayInput;
}>;


export type ConfirmPayPayMutation = { __typename?: 'Mutation', confirmPayPay: (
    { __typename?: 'StandardOrder', orderNo: string, status?: string | null }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type PayWithPayPayInCartMutationVariables = Exact<{
  input: AddPayPayToCartInput;
}>;


export type PayWithPayPayInCartMutation = { __typename?: 'Mutation', addPayPayPaymentMethodToCart: { __typename?: 'Cart', id: string, estimatedTotal?: number | null, amountRemaining: number, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, paymentInstruments: Array<{ __typename?: 'Adyen' } | { __typename?: 'AdyenKlarna' } | { __typename?: 'AdyenKlarnaAccount' } | { __typename?: 'AdyenPayPal' } | { __typename?: 'AfterPay' } | { __typename?: 'Alipay' } | { __typename?: 'AmazonPay' } | { __typename?: 'AmbassadorCard' } | { __typename?: 'ApplePay' } | { __typename?: 'CashOnDelivery' } | { __typename: 'CreditCard', id: string, amount: number } | { __typename?: 'CreditCardConfirm' } | { __typename?: 'GiftCard' } | { __typename?: 'GooglePay' } | { __typename?: 'KlarnaPayments' } | { __typename?: 'OnlineBanking' } | { __typename?: 'PayPal' } | { __typename?: 'PayPay' } | { __typename?: 'PayTm' } | { __typename?: 'Razorpay' } | { __typename?: 'Scheme' } | { __typename?: 'StoreCreditInstrument' } | { __typename?: 'UPI' } | { __typename?: 'Wallet' } | { __typename?: 'WechatPay' } | { __typename?: 'ZipPay' }> } };

export type PayWithPayTmMutationVariables = Exact<{
  basketId: Scalars['String'];
}>;


export type PayWithPayTmMutation = { __typename?: 'Mutation', payTm: { __typename?: 'PayTmResult', orderNo: string, url: string } };

export type ConfirmPayTmMutationVariables = Exact<{
  orderNo: Scalars['String'];
}>;


export type ConfirmPayTmMutation = { __typename?: 'Mutation', confirmPayTm: (
    { __typename?: 'StandardOrder', orderNo: string }
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type StartRazorPayMutationVariables = Exact<{
  input: StartRazorPayInput;
}>;


export type StartRazorPayMutation = { __typename?: 'Mutation', startRazorPay: { __typename?: 'StartRazorPayPayload', razorPayOrderId: string, order: { __typename?: 'StandardOrder', orderNo: string } } };

export type ConfirmRazorPayMutationVariables = Exact<{
  input: ConfirmRazorPayInput;
}>;


export type ConfirmRazorPayMutation = { __typename?: 'Mutation', confirmRazorPay: { __typename?: 'ConfirmRazorPayPayload', order: { __typename?: 'StandardOrder', orderNo: string } } };

export type PayWithWalletMutationVariables = Exact<{
  input: WalletInput;
}>;


export type PayWithWalletMutation = { __typename?: 'Mutation', wallet: { __typename?: 'WalletResult', url: string, orderNo: string } };

export type ConfirmWalletMutationVariables = Exact<{
  orderNo: Scalars['String'];
}>;


export type ConfirmWalletMutation = { __typename?: 'Mutation', confirmWallet: (
    { __typename?: 'StandardOrder', orderNo: string }
    & OrderConfirmationFields_StandardOrder_Fragment
  ) };

export type UpdateProfileMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: (
    { __typename?: 'User' }
    & UserFieldsFragment
  ) };

export type RegisterMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNamePronunciation?: InputMaybe<Scalars['String']>;
  lastNamePronunciation?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  inflowCode?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  otpVerifyToken?: InputMaybe<Scalars['String']>;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: (
    { __typename?: 'AuthPayload' }
    & AuthPayloadFragment
  ) | null };

export type CreateReviewMutationVariables = Exact<{
  input: ReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview?: { __typename?: 'Review', id: string, nickname?: string | null, email?: string | null, isRecommended?: boolean | null, date?: string | null, location?: string | null, rating?: number | null, title?: string | null, text?: string | null, pros?: Array<string> | null, cons?: Array<string> | null, prosInputted?: Array<string> | null, consInputted?: Array<string> | null, helpfulVotes?: number | null, preview?: boolean | null, terms?: boolean | null, notification?: boolean | null, aspects?: { __typename?: 'ReviewAspects', width?: string | null, comfort?: string | null, size?: string | null } | null } | null };

export type TrackAppLinkClickMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type TrackAppLinkClickMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type TrackLanguageChangeMutationVariables = Exact<{
  language: Scalars['String'];
}>;


export type TrackLanguageChangeMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type TrackLiveChatStartMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type TrackLiveChatStartMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type TrackOrderConfirmationMutationVariables = Exact<{
  cartProducts: Array<UserEventTrackingCartProduct> | UserEventTrackingCartProduct;
  email?: InputMaybe<Scalars['String']>;
  orderNo: Scalars['String'];
}>;


export type TrackOrderConfirmationMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type TrackRecommendationClickMutationVariables = Exact<{
  masterId: Scalars['String'];
  swatch: Scalars['String'];
  recommenderId: Scalars['String'];
  recommenderName: Scalars['String'];
}>;


export type TrackRecommendationClickMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type TrackProductViewMutationVariables = Exact<{
  masterId: Scalars['String'];
}>;


export type TrackProductViewMutation = { __typename?: 'Mutation', trackUserEvent: boolean };

export type AddItemToWishListMutationVariables = Exact<{
  input: AddItemToWishListInput;
}>;


export type AddItemToWishListMutation = { __typename?: 'Mutation', addItemToWishList: (
    { __typename?: 'WishList' }
    & WishListFieldsFragment
  ) };

export type UpdateItemInWishListMutationVariables = Exact<{
  input: UpdateItemInWishListInput;
}>;


export type UpdateItemInWishListMutation = { __typename?: 'Mutation', updateItemInWishList: (
    { __typename?: 'WishList' }
    & WishListFieldsFragment
  ) };

export type RemoveItemFromWishListMutationVariables = Exact<{
  input: RemoveItemFromWishListInput;
}>;


export type RemoveItemFromWishListMutation = { __typename?: 'Mutation', removeItemFromWishList: boolean };

export type AddressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AddressQuery = { __typename?: 'Query', address: (
    { __typename?: 'Address' }
    & AddressFieldsFragment
  ) };

export type AfterPayConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AfterPayConfigQuery = { __typename?: 'Query', afterPayConfig: { __typename?: 'AfterPayConfig', min: number, max: number } };

export type AllCustomerGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCustomerGroupsQuery = { __typename?: 'Query', allCustomerGroups: Array<string> };

export type CheckAmbassadorCardBalanceQueryVariables = Exact<{
  paymentInstrumentId?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['String']>;
  pin: Scalars['String'];
}>;


export type CheckAmbassadorCardBalanceQuery = { __typename?: 'Query', checkAmbassadorBalance: number };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', activeCart?: (
    { __typename?: 'Cart', isMixedCartAllowed?: boolean | null, availablePaymentMethods: Array<(
      { __typename?: 'PaymentMethod' }
      & AvailablePaymentMethodsFieldsFragment
    )> }
    & CartFieldsFragment
  ) | null };

export type CategoryByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CategoryByIdQuery = { __typename?: 'Query', categoryById: (
    { __typename?: 'Category', parentCategory?: (
      { __typename?: 'Category', parentCategory?: (
        { __typename?: 'Category', parentCategory?: (
          { __typename?: 'Category', parentCategory?: (
            { __typename?: 'Category' }
            & CategoryFragment
          ) | null }
          & CategoryFragment
        ) | null }
        & CategoryFragment
      ) | null }
      & CategoryFragment
    ) | null }
    & CategoryFragment
  ) };

export type CategorySizeChartQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CategorySizeChartQuery = { __typename?: 'Query', categoryById: { __typename?: 'Category', id: string, sizeCharts?: Array<{ __typename?: 'SizeChart', id: string, name: string, body: string }> | null } };

export type MainFooterMinimalQueryVariables = Exact<{
  isDraft?: InputMaybe<Scalars['String']>;
}>;


export type MainFooterMinimalQuery = { __typename?: 'Query', mainFooter: { __typename?: 'MainFooter', id: string, minimalLinks: Array<(
      { __typename?: 'CTA' }
      & CtaFieldsFragment
    )> } };

export type MainFooterQueryVariables = Exact<{
  isDraft?: InputMaybe<Scalars['String']>;
}>;


export type MainFooterQuery = { __typename?: 'Query', mainFooter: { __typename?: 'MainFooter', id: string, supportLinks: Array<(
      { __typename?: 'CTA' }
      & CtaFieldsFragment
    )>, aboutLinks: Array<(
      { __typename?: 'CTA' }
      & CtaFieldsFragment
    )>, legalLinks: Array<(
      { __typename?: 'CTA' }
      & CtaFieldsFragment
    )>, signUpForm?: (
      { __typename?: 'SignUpForm' }
      & SignUpFormFieldsFragment
    ) | null, signUpForms?: Array<(
      { __typename?: 'SignUpForm' }
      & SignUpFormFieldsFragment
    ) | null> | null } };

export type FrontendConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontendConfigurationQuery = { __typename?: 'Query', frontendConfiguration: { __typename?: 'FrontendConfiguration', featureFlags: { __typename?: 'FeatureFlags', afterPayEnabled?: boolean | null, applePayEnabled?: boolean | null, googlePayEnabled?: boolean | null, giftCardEnabled?: boolean | null, amazonPayEnabled?: boolean | null, payPayEnabled?: boolean | null, googleAddressLookupEnabled?: boolean | null, klarnaEnabled?: boolean | null, googleReversePostalCodeLookup?: boolean | null, myCustomizerEnabled?: boolean | null, nestedOrdersEnabled?: boolean | null, payPalEnabled?: boolean | null, pincodeServiceabilityEnabled?: boolean | null, ratingsAndReviewsEnabled?: boolean | null, addressResumeInCheckoutEnabled?: boolean | null, simplifiedAddressResumeInCheckoutEnabled?: boolean | null, useSavedCardsEnabled?: boolean | null, myAccountOrderDetailsContactInfoEnabled?: boolean | null, myAccountOrderDetailsBillingInfoEnabled?: boolean | null, additionalPriceTextForSaleEnabled?: boolean | null, returnOrderEnabled?: boolean | null, myAccountEditPasswordShowAdditionalCancelButtonEnabled?: boolean | null, myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled?: boolean | null, myAccountDashboardMembershipSectionEnabled?: boolean | null, createAccountInCheckoutEnabled?: boolean | null, showUserRegistrationOnCheckoutEnabled?: boolean | null, saveAddressCheckboxEnabled?: boolean | null, cartSummaryPromoCodeExpandedOnMobile?: boolean | null, myAccountLeaveResetPasswordConfirmPopupOpenEnabled?: boolean | null, showSaleBadgeOnProductImageEnabled?: boolean | null, desiredDeliveryDateEnabled?: boolean | null, autoShowNewsletterPopupEnabled?: boolean | null, showProductKeywordsEnabled?: boolean | null, scShowCartAbandonmentModalEnabled?: boolean | null, miniCartSeparateViewAndCheckoutButtons?: boolean | null, otpLoginEnabled?: boolean | null, registerOTPVerificationEnabled?: boolean | null, phoneInProfileEnabled?: boolean | null, myAccountShowAdditionalFieldsInEditEnabled?: boolean | null, priceWithDataEnabled?: boolean | null, showOnlyOrderableSizesEnabled?: boolean | null, myAccountHideNotificationSettingsInDashboard?: boolean | null, myAccountHideNewsletterSettingsInDashboard?: boolean | null, collapsableOrderDetailsIsCollapsedOnLoad?: boolean | null, simplifiedGoogleShoppingPdpEnabled?: boolean | null, showDynamicTaxMessage?: boolean | null, hideYourSavings?: boolean | null, paymentPromotionEnabled?: boolean | null, showDiscountAmountAndTextEnabled?: boolean | null, promoCodeAccordionIsExpandedByDefault?: boolean | null, opluxEnabled?: boolean | null, outfitsEnabled?: boolean | null, storeCreditsEnabled?: boolean | null }, environment: { __typename?: 'Environment', webInMaintenanceMode?: string | null, abTestingScript?: string | null, adyenClientKey?: string | null, adyenEnv?: string | null, adyenPayPalIntent?: string | null, adyenPayPalMerchantId?: string | null, adyenStatusUrl?: string | null, afterpaySDKSource: string, bazaarVoiceReviewFormScriptUrl?: string | null, bloomreachAccountId?: string | null, bloomreachSEOAccountId?: string | null, branchKey?: string | null, configureIdApiKey?: string | null, configureIdScriptUrl?: string | null, fitAnalyticsOrderConfirmationUrl: string, fitAnalyticsPdpUrl: string, googleApiKey: string, googleOptimizeContainerId: string, googleTagManagerId: string, freshChatToken?: string | null, freshChatHost?: string | null, idMeClientId?: string | null, klarnaDataClientId?: string | null, klarnaScriptUrl?: string | null, myCustomizerDomain?: string | null, myCustomizerShopId?: string | null, pixleeApiKey: string, radialFingerprint?: string | null, radialStoreId?: string | null, returnUrl: string, sanityDataset: string, sanitySiteId: string, sanityProjectId: string, storeRocketId?: string | null, styliticsUsername?: string | null, forterSiteId?: string | null, gmoShopId: string, gmoSource: string, emarsysSignupURL?: string | null, emplifiTurnToSite?: string | null, payPayReloadCount?: number | null, payPayRetryWaitingTime?: number | null, amazonPayMerchantId?: string | null, amazonPayClientId?: string | null, amazonPayScope?: string | null, amazonPayMode?: string | null, amazonPayButtonSize?: string | null, amazonPayButtonColor?: string | null, amazonPayPublicKeyId?: string | null, amazonPayStoreId?: string | null, oneTrustApiKey?: string | null, googlePayEnvironment?: string | null, googlePayPaymentGateway?: string | null, googlePayPaymentGatewayMerchantId?: string | null, googlePayMerchantId?: string | null, googlePayMerchantName?: string | null, dynamicYieldStaticUrl?: string | null, dynamicYieldDynamicUrl?: string | null, razorPaySdkKey?: string | null, yottaaScriptUrl?: string | null }, siteConfig?: { __typename?: 'SiteConfig', freeShippingThreshold?: number | null, maxDaysForReturn?: number | null, scheduledFreeShippingThresholds?: Array<{ __typename?: 'ScheduledFreeShippingThreshold', availableFrom?: string | null, availableTo?: string | null, threshold?: number | null }> | null, deliveryDateDays?: { __typename?: 'DeliveryDateDays', endDeliveryDateDay?: number | null, startDeliveryDateDay?: number | null } | null } | null } };

export type CheckGiftCardBalanceQueryVariables = Exact<{
  cardNumber: Scalars['String'];
  pin: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type CheckGiftCardBalanceQuery = { __typename?: 'Query', checkGiftCardBalance: number };

export type GiftCardQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardQuery = { __typename?: 'Query', giftCard: { __typename?: 'GiftCardProduct', id: string, name: string, valueOptions: Array<number>, defaultValue: number, image: string } };

export type GlossaryPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GlossaryPageQuery = { __typename?: 'Query', glossaryPage: { __typename?: 'GlossaryPage', headerIntroduction: any, id: string, puid: string, title: string, url: string, categories?: Array<{ __typename?: 'GlossaryCategory', label: string, value: string }> | null, headerBackgroundImage: (
      { __typename?: 'SanityImage' }
      & SanityImageFieldsFragment
    ), seo?: { __typename?: 'SEO', pageDescription?: string | null, pageTitle?: string | null } | null, terms?: Array<{ __typename?: 'GlossaryTermFlattened', categories?: Array<string> | null, definition: any, id: string, puid: string, mediaType: string, term: string, image?: (
        { __typename?: 'SanityImage' }
        & SanityImageFieldsFragment
      ) | null, video?: (
        { __typename?: 'SanityVideo' }
        & SanityVideoFieldsFragment
      ) | null }> | null } };

export type InventoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InventoryQuery = { __typename?: 'Query', inventory: { __typename?: 'Inventory', id: string, quantity: number, limitedAvailability: boolean } };

export type WishListTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type WishListTotalsQuery = { __typename?: 'Query', wishList: { __typename?: 'WishList', id: string, items: Array<{ __typename?: 'WishListItem', id: string, quantity: number }> } };

export type MeQueryVariables = Exact<{
  includeAddresses?: InputMaybe<Scalars['Boolean']>;
  includeOrders?: InputMaybe<Scalars['Boolean']>;
  includeAmbassadorCards?: InputMaybe<Scalars['Boolean']>;
  includeSavedCards?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Scalars['Boolean']>;
  includeNewsletter?: InputMaybe<Scalars['Boolean']>;
  includeStoreCredit?: InputMaybe<Scalars['Boolean']>;
}>;


export type MeQuery = { __typename?: 'Query', me: (
    { __typename?: 'User', groups?: Array<string>, newsletterSubscription?: { __typename?: 'NewsletterSubscription', firstName?: string | null, lastName?: string | null, firstNamePronunciation?: string | null, lastNamePronunciation?: string | null, email?: string | null, gender?: string | null, memberId?: string | null, emailPreference?: string | null, shoppingPreference?: string | null, iframeURL?: string | null, isConfirmed?: boolean | null, dob?: { __typename?: 'DOB', day: number, month: number, year: number } | null } | null, addresses?: Array<(
      { __typename?: 'Address' }
      & AddressFieldsFragment
    )>, orders?: { __typename?: 'OrderEdge', nodes: Array<(
        { __typename?: 'StandardOrder' }
        & OrderPreviewFieldsFragment
      )> }, ambassadorCards?: Array<(
      { __typename?: 'SavedAmbassadorCard' }
      & AmbassadorCardFieldsFragment
    )>, savedCards?: Array<(
      { __typename?: 'SavedCreditCard' }
      & SavedCreditCardFragment
    )> | null, storeCredit?: (
      { __typename?: 'StoreCredit' }
      & StoreCreditFieldsFragment
    ) | null }
    & UserFieldsFragment
  ) };

export type NotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesQuery = { __typename?: 'Query', notificationsPreferences?: { __typename?: 'NotificationsPayload', phoneNumber?: string | null, marketingSmsOptIn?: boolean | null, customerSmsOptIn?: boolean | null } | null };

export type OrderQueryVariables = Exact<{
  orderNo: Scalars['String'];
  includeProductAnalyticsDetails?: InputMaybe<Scalars['Boolean']>;
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'NestedOrder' } | (
    { __typename: 'StandardOrder', subTotal?: number | null, shippingCosts?: number | null, orderNo: string, taxTotal?: number | null, taxation?: Taxation | null, estimatedTotal?: number | null, promoDiscountValue?: number | null, revenue?: number | null, refundInformation?: string | null, createdAt: string, payPayAsyncResultNoticed?: boolean | null, shippingSurcharge?: { __typename?: 'ShippingSurcharge', amount: number, label: string, tooltip: string } | null, orderAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, shippingAdjustments: Array<{ __typename?: 'Adjustment', promotionId?: string | null, itemText?: string | null, price?: number | null, couponCode?: string | null }>, couponItems?: Array<{ __typename?: 'CouponItem', code?: string | null, couponItemId?: string | null, statusCode?: string | null, valid?: boolean | null } | null> | null, orderStatus?: { __typename?: 'OrderStatus', code?: OrderStatusCode | null, label?: string | null } | null, products: Array<(
      { __typename?: 'GiftCardCartItem' }
      & ProductCartItemFields_GiftCardCartItem_Fragment
      & ProductCartItemAnalyticsDimensionsFields_GiftCardCartItem_Fragment
    ) | (
      { __typename?: 'ProductCartItem' }
      & ProductCartItemFields_ProductCartItem_Fragment
      & ProductCartItemAnalyticsDimensionsFields_ProductCartItem_Fragment
    )> }
    & OrderPaymentInstrumentFields_StandardOrder_Fragment
    & OrderConfirmationFields_StandardOrder_Fragment
  ) | null };

export type OrderDetailsQueryVariables = Exact<{
  orderNo: Scalars['String'];
}>;


export type OrderDetailsQuery = { __typename?: 'Query', order?: (
    { __typename?: 'NestedOrder' }
    & NestedOrderDetailsFieldsFragment
  ) | (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) | null };

export type OrderHistoryMeQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type OrderHistoryMeQuery = { __typename?: 'Query', me: (
    { __typename?: 'User', addresses: Array<(
      { __typename?: 'Address' }
      & AddressFieldsFragment
    )>, orders: { __typename?: 'OrderEdge', nodes: Array<(
        { __typename?: 'StandardOrder' }
        & OrderPreviewFieldsFragment
      )>, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, nextOffset?: number | null, totalCount: number } | null } }
    & UserFieldsFragment
  ) };

export type SearchOrderByPhoneQueryVariables = Exact<{
  orderNo: Scalars['String'];
  phone: Scalars['String'];
}>;


export type SearchOrderByPhoneQuery = { __typename?: 'Query', searchOrderByPhone?: (
    { __typename?: 'NestedOrder' }
    & NestedOrderDetailsFieldsFragment
  ) | (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) | null };

export type SearchOrderByEmailPostcodeQueryVariables = Exact<{
  orderNo: Scalars['String'];
  email: Scalars['String'];
  postcode: Scalars['String'];
}>;


export type SearchOrderByEmailPostcodeQuery = { __typename?: 'Query', searchOrderByEmailPostcode?: (
    { __typename?: 'NestedOrder' }
    & NestedOrderDetailsFieldsFragment
  ) | (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) | null };

export type SearchOrderByEmailQueryVariables = Exact<{
  orderNo: Scalars['String'];
  email: Scalars['String'];
}>;


export type SearchOrderByEmailQuery = { __typename?: 'Query', searchOrderByEmail?: (
    { __typename?: 'NestedOrder' }
    & NestedOrderDetailsFieldsFragment
  ) | (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) | null };

export type SearchOrderByEmailPhoneQueryVariables = Exact<{
  orderNo: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
}>;


export type SearchOrderByEmailPhoneQuery = { __typename?: 'Query', searchOrderByEmailPhone?: (
    { __typename?: 'NestedOrder' }
    & NestedOrderDetailsFieldsFragment
  ) | (
    { __typename?: 'StandardOrder' }
    & StandardOrderDetailsFieldsFragment
  ) | null };

export type OutfitsQueryVariables = Exact<{
  tags: Scalars['String'];
}>;


export type OutfitsQuery = { __typename?: 'Query', outfits: Array<{ __typename?: 'StyliticsLook', id: string, image: { __typename?: 'ProductImage', href: string, coverImageHref?: string | null, alt: string }, products: Array<(
      { __typename?: 'ProductSuggestion', coords?: { __typename?: 'Coordinates', x: number, y: number, z: number, height: number, width: number } | null, replacements: Array<(
        { __typename?: 'ProductSuggestion' }
        & ProductFragment
      )> }
      & ProductFragment
    ) | null> }> };

export type GetAmazonPayCustomerInfoQueryVariables = Exact<{
  amazonPayToken: Scalars['String'];
}>;


export type GetAmazonPayCustomerInfoQuery = { __typename?: 'Query', getAmazonPayCustomerInfo?: { __typename?: 'AmazonPayCustomerInfoPayload', userEmail?: string | null, registeredWithAmazon?: boolean | null } | null };

export type GetPayPayContentQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type GetPayPayContentQuery = { __typename?: 'Query', getPayPayContent?: { __typename?: 'PayPayContent', id: string, name: string, body: string } | null };

export type PincodeQueryVariables = Exact<{
  pincode: Scalars['String'];
}>;


export type PincodeQuery = { __typename?: 'Query', pincode?: { __typename?: 'PincodeServiceability', expectedDate?: string | null, city?: string | null, stateCode?: string | null } | null };

export type PixleeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PixleeConfigQuery = { __typename?: 'Query', pixleeConfig?: { __typename?: 'PixleeConfig', id: string, enable: boolean, enablePDPGallery: boolean, socialMediaIcon: boolean, numberPicturesGallery: number } | null };

export type UserGeneratedContentQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type UserGeneratedContentQuery = { __typename?: 'Query', userGeneratedContentForWeb?: Array<{ __typename?: 'UserGeneratedContent', source?: string | null, altText?: string | null, pixleeCdnPhotos?: { __typename?: 'PixleeCdnPhotos', squareMediumUrl?: string | null } | null } | null> | null };

export type CategoryPlpQueryVariables = Exact<{
  url: Scalars['String'];
  isDraft?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInputOption> | FilterInputOption;
  expansions?: InputMaybe<Array<ProductSearchExpansion> | ProductSearchExpansion>;
  includeCategoryMetadata?: InputMaybe<Scalars['Boolean']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  preview?: InputMaybe<PreviewInput>;
}>;


export type CategoryPlpQuery = { __typename?: 'Query', categoryByUrl?: (
    { __typename?: 'Category', id: string, name: string, url: string, description?: string | null, products: (
      { __typename?: 'PaginatedOutput' }
      & PaginatedOutputNodesFragmentFragment
      & PaginatedOutputMetadataFragmentFragment
    ), seo?: { __typename?: 'SEO', pageTitle?: string | null, pageDescription?: string | null } | null, parentCategory?: (
      { __typename?: 'Category', parentCategory?: (
        { __typename?: 'Category', parentCategory?: (
          { __typename?: 'Category', parentCategory?: (
            { __typename?: 'Category' }
            & CategoryFragment
          ) | null }
          & CategoryFragment
        ) | null }
        & CategoryFragment
      ) | null }
      & CategoryFragment
    ) | null }
    & CategoryFragment
  ) | null };

export type VariantsQueryVariables = Exact<{
  input: VariantsInput;
  includeComparisonFields?: InputMaybe<Scalars['Boolean']>;
}>;


export type VariantsQuery = { __typename?: 'Query', variants?: Array<{ __typename: 'Variant', id: string, masterId: string, percentageDiscountBadge?: number | null, name: string, header?: string | null, subHeader?: string | null, orderable?: boolean | null, colorValue: string, technology?: string | null, runTerrain?: string | null, weight?: number | null, heelToToeDrop?: number | null, fastener?: string | null, pronation?: string | null, refinementCushioningLevel?: string | null, runnerType?: string | null, mainMaterial?: string | null, cupType?: string | null, trouserRise?: string | null, pocketType?: string | null, apparelLength?: string | null, characteristics?: string | null, supportLevelBra?: string | null, studs?: string | null, playerLevel?: string | null, fit?: string | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', displayValue?: string | null } | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }> }> | null };

export type SiblingVariantsQueryVariables = Exact<{
  input: SiblingVariantsInput;
}>;


export type SiblingVariantsQuery = { __typename?: 'Query', siblingVariants?: Array<(
    { __typename?: 'Variant', percentageDiscountBadge?: number | null, salePrice?: number | null, orderable?: boolean | null, isAppExclusive?: boolean | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, badges?: Array<{ __typename?: 'ProductBadge', id: string, label: string }> | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, soldoutWithRecommender?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null } | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null }
    & MandatoryVariantFieldsFragment
  )> | null };

export type VariantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VariantQuery = { __typename?: 'Query', variant?: { __typename?: 'VariantProduct', id: string, masterId: string, name: string, colorValue: string, styleNumber: string, size: { __typename?: 'VariantSize', value: string } } | null };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, header?: string | null, subHeader?: string | null, orderable?: boolean | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', displayValue?: string | null } | null, variations: Array<{ __typename?: 'Variant', id: string, name: string, colorValue: string, colorName: string, preview: string, price: number, salePrice?: number | null, orderable?: boolean | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null } | null, sizeGroups: Array<{ __typename?: 'SizeGroup', label?: string | null, description?: string | null, sizes: Array<{ __typename?: 'Size', id: string, label: string, value: string, productId: string, orderable: boolean, maxOrderableQuantity: number }> }>, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, soldoutWithRecommender?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null, validTo?: string | null } | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }> }> } | null };

export type PdpQueryVariables = Exact<{
  id: Scalars['ID'];
  viewAt?: InputMaybe<Scalars['String']>;
}>;


export type PdpQuery = { __typename?: 'Query', product?: (
    { __typename?: 'Product', productNameTranslated?: any | null, description?: string | null, primaryCategoryId?: string | null, productDivision?: string | null, brand?: string | null, sizeChartId?: string | null, productVideos?: Array<string | null> | null, verticalProductVideos?: Array<string | null> | null, promotionExclusion?: boolean | null, exploreMoreCTALabel?: string | null, showExploreCollectionCTA?: boolean | null, exploreMoreCTATargetCategoryID?: string | null, orderable?: boolean | null, badge?: string | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null, promotion?: { __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null } | null, configureID?: { __typename?: 'ConfigureIDSettings', enabled?: boolean | null, productID?: string | null } | null, productStory?: { __typename?: 'ProductStory', longDescription?: string | null, careInstructions?: Array<string | null> | null, productKeywords?: Array<string | null> | null } | null, fitOptions?: Array<{ __typename?: 'FitOptions', label: string, masterProduct: { __typename?: 'Product', id: string, name: string, variations: Array<{ __typename?: 'Variant', id: string, colorValue: string, orderable?: boolean | null }> } }> | null, variations: Array<(
      { __typename?: 'Variant', isFinalSale?: boolean | null, returnRuleID?: string | null, promotionExclusion?: boolean | null, specialMessage?: string | null, ean?: string | null, validUntil?: string | null, isAppExclusive?: boolean | null, percentageDiscountBadge?: number | null, salePrice?: number | null, styleNumber?: string | null, materialComposition?: Array<string | null> | null, orderable?: boolean | null, modelMeasurementText?: string | null, taxDisplayMsg?: string | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, badges?: Array<{ __typename?: 'ProductBadge', id: string, label: string }> | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null, isSalePriceElapsed?: boolean | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, soldoutWithRecommender?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null, validTo?: string | null } | null, manufacturerInfo?: { __typename?: 'ManufacturerInfo', manufacturerAddress?: { __typename?: 'Info', label?: string | null, content?: Array<string | null> | null } | null, countryOfOrigin?: { __typename?: 'Info', label?: string | null, content?: Array<string | null> | null } | null } | null, myCustomizer?: { __typename?: 'MyCustomizerSettings', enabled?: boolean | null, iframeID?: string | null, startPoint?: string | null } | null, configureID?: { __typename?: 'ConfigureIDSettings', enabled?: boolean | null, productID?: string | null } | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null }
      & PdpMandatoryVariantFieldsFragment
    )> }
    & MandatoryMasterFieldsFragment
    & SizesFragment
  ) | null };

export type LazyPdpQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LazyPdpQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, variations: Array<(
      { __typename?: 'Variant', description?: string | null, productStory?: { __typename?: 'ProductStory', longDescription?: string | null, materialComposition?: Array<string | null> | null, careInstructions?: Array<string | null> | null, productKeywords?: Array<string | null> | null, manufacturerInfo?: { __typename?: 'ManufacturerInfo', manufacturerAddress?: { __typename?: 'Info', label?: string | null, content?: Array<string | null> | null } | null, countryOfOrigin?: { __typename?: 'Info', label?: string | null, content?: Array<string | null> | null } | null } | null } | null }
      & PdpMandatoryExtraVariantFieldsFragment
    )> } | null };

export type ProductSizeChartQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ProductSizeChartQuery = { __typename?: 'Query', sizeCharts?: Array<{ __typename?: 'SizeChart', id: string, name: string, body: string }> | null };

export type ProductScoreQueryVariables = Exact<{
  id: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeReviews?: Scalars['Boolean'];
}>;


export type ProductScoreQuery = { __typename?: 'Query', productScore?: { __typename?: 'Score', id: string, amount?: string | null, rating: string, reviews?: { __typename?: 'ReviewEdge', nodes: Array<{ __typename?: 'Review', id: string, rating?: number | null, title?: string | null, text?: string | null, nickname?: string | null, date?: string | null }> } } | null };

export type RecommendationFieldsFragment = { __typename: 'ProductSearchHit', id: string, masterId: string, color: string, variantProduct?: (
    { __typename?: 'Variant', percentageDiscountBadge?: number | null, salePrice?: number | null, orderable?: boolean | null, isAppExclusive?: boolean | null, appOnlyDateTimeFrom?: string | null, appOnlyDateTimeTo?: string | null, badges?: Array<{ __typename?: 'ProductBadge', id: string, label: string }> | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null, promotionPrice?: number | null } | null, displayOutOfStock?: { __typename?: 'DisplayOutOfStock', soldout?: boolean | null, comingsoon?: boolean | null, backsoon?: boolean | null, presale?: boolean | null, displayValue?: string | null } | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null }
    & MandatoryVariantFieldsFragment
  ) | null, masterProduct?: (
    { __typename?: 'Product', brand?: string | null, promotions?: Array<{ __typename?: 'ProductPromotion', id: string, calloutMessage?: string | null }> | null, score?: { __typename?: 'Score', rating: string, amount?: string | null } | null }
    & MandatoryMasterFieldsFragment
  ) | null };

export type RecommendationsWithDetailsQueryVariables = Exact<{
  pageType: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RecommendationsWithDetailsQuery = { __typename?: 'Query', recommendationsWithDetails: { __typename?: 'RecommendationsOutput', recommenderId: string, recommenderName: string, recommendations: Array<(
      { __typename?: 'ProductSearchHit' }
      & RecommendationFieldsFragment
    ) | null> } };

export type ProductReviewsQueryVariables = Exact<{
  id: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ProductReviewsQuery = { __typename?: 'Query', productScore?: { __typename?: 'Score', id: string, amount?: string | null, rating: string, reviews: { __typename?: 'ReviewEdge', nodes: Array<(
        { __typename?: 'Review' }
        & ReviewFieldsFragment
      )>, pageInfo?: { __typename?: 'PageInfo', totalCount: number } | null }, summary?: (
      { __typename?: 'ReviewSummary' }
      & ReviewSummaryFieldsFragment
    ) | null } | null };

export type TrendingSearchTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrendingSearchTermsQuery = { __typename?: 'Query', trendingSearchTerms: Array<{ __typename?: 'TrendingSearchTerm', searchTerm: string, rank: number }> };

export type SearchRecommendedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchRecommendedProductsQuery = { __typename?: 'Query', searchFlyoutRecommendedProducts: Array<{ __typename: 'ProductSearchHit', id: string, variantProduct?: { __typename?: 'Variant', id: string, masterId: string, colorValue: string, name: string, header?: string | null, subHeader?: string | null, productPrice?: { __typename?: 'ProductPrice', price?: number | null, salePrice?: number | null } | null, images: Array<{ __typename?: 'ProductImage', alt: string, href: string }> } | null } | null> };

export type ProductSearchQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInputOption> | FilterInputOption;
  expansions?: InputMaybe<Array<ProductSearchExpansion> | ProductSearchExpansion>;
  includeSearchMetadata?: InputMaybe<Scalars['Boolean']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ProductSearchQuery = { __typename?: 'Query', search: (
    { __typename: 'PaginatedOutput' }
    & PaginatedOutputNodesFragmentFragment
    & PaginatedOutputMetadataFragmentFragment
  ) };

export type ProductFragment = { __typename?: 'ProductSuggestion', id: string, styleId: string, name: string, price: number, salePrice?: number | null, orderable?: boolean | null, image: { __typename?: 'ProductImage', href: string, alt: string } };

export type LookQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LookQuery = { __typename?: 'Query', look?: { __typename?: 'StyliticsLook', id: string, products: Array<(
      { __typename?: 'ProductSuggestion', coords?: { __typename?: 'Coordinates', x: number, y: number, z: number, height: number, width: number } | null, replacements: Array<(
        { __typename?: 'ProductSuggestion' }
        & ProductFragment
      )> }
      & ProductFragment
    ) | null> } | null };

export type SuggestionsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  preview?: InputMaybe<PreviewInput>;
}>;


export type SuggestionsQuery = { __typename?: 'Query', suggestions: { __typename?: 'SearchSuggestions', suggestedRedirect?: string | null, suggestedProductsSummaries?: Array<{ __typename?: 'SuggestedProduct', id: string, masterId: string, colorValue: string, name: string, header?: string | null, subHeader?: string | null, price: number, salePrice?: number | null, isSalePriceElapsed?: boolean | null, images: Array<{ __typename?: 'ProductImage', href: string, alt: string }> }> | null, suggestedTerms?: Array<{ __typename?: 'SuggestedTerm', suggestion: string, original: string }> | null, suggestedPhrases?: Array<{ __typename?: 'SuggestedPhrase', suggestion: string }> | null } };

export type TermsAndConditionsConfigsQueryVariables = Exact<{
  isDraft?: InputMaybe<Scalars['String']>;
}>;


export type TermsAndConditionsConfigsQuery = { __typename?: 'Query', termsAndConditionsConfigs?: { __typename?: 'TermsAndConditionsConfigs', id: string, showAbove?: boolean | null, tacOnCartPage?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnItemAddedPopup?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnCheckoutSignInArea?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnCheckoutConfirmation?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnCheckoutAddress?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnCreateAccount?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null, tacOnCheckoutPayment?: (
      { __typename?: 'TermsAndConditions' }
      & TermsAndConditionsFieldsFragment
    ) | null } | null };

export type UrlRedirectQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type UrlRedirectQuery = { __typename?: 'Query', urlRedirectV2: { __typename?: 'UrlRedirect', availableFrom?: string | null, availableTo?: string | null, redirectType?: string | null, url?: string | null } };

export type WishListQueryVariables = Exact<{ [key: string]: never; }>;


export type WishListQuery = { __typename?: 'Query', wishList: (
    { __typename?: 'WishList' }
    & WishListFieldsFragment
  ) };

export const TokenPayloadFragmentDoc = gql`
    fragment tokenPayload on TokenPayload {
  __typename
  accessToken
  refreshToken
  customerId
  uniqueShopperId
  customerContext {
    __typename
    hashKey
    customerGroups
  }
  user {
    customerNo
    email
  }
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  id
  title
  firstName
  lastName
  firstNamePronunciation
  lastNamePronunciation
  address1
  address2
  stateCode
  city
  countryCode
  phone
  preferred
  postalCode
  streetNumber
  salutation
  companyName
}
    `;
export const AmbassadorCardFieldsFragmentDoc = gql`
    fragment ambassadorCardFields on SavedAmbassadorCard {
  id
  maskedNumber
  name
  preferred
}
    `;
export const AuthPayloadFragmentDoc = gql`
    fragment authPayload on AuthPayload {
  __typename
  accessToken
  refreshToken
  customerId
  customerContext {
    __typename
    hashKey
    customerGroups
  }
  user {
    customerNo
    email
  }
}
    `;
export const ProductAnalyticsDimensionsFieldsFragmentDoc = gql`
    fragment productAnalyticsDimensionsFields on VariantProduct {
  colorDescription
  sportName
  technology
  gender
  ageGroup
  lineName
  businessUnit
  businessSegment
  businessSubSegment
  division
  articleGroup
  articleType
  franchise
  collectionMark
}
    `;
export const ProductCartItemAnalyticsDimensionsFieldsFragmentDoc = gql`
    fragment productCartItemAnalyticsDimensionsFields on CartItem {
  ... on ProductCartItem {
    product {
      ...productAnalyticsDimensionsFields
    }
    taxRate
  }
}
    ${ProductAnalyticsDimensionsFieldsFragmentDoc}`;
export const AvailablePaymentMethodsFieldsFragmentDoc = gql`
    fragment availablePaymentMethodsFields on PaymentMethod {
  id
  cards {
    id
    cardType
    name
  }
  bank {
    id
    name
  }
  wallet {
    id
    name
  }
  description
  name
  paymentProcessorId
  c_additionalFee
}
    `;
export const ProductCartItemFieldsFragmentDoc = gql`
    fragment productCartItemFields on CartItem {
  ... on GiftCardCartItem {
    id
    imageUrl
    amount
    recipientEmail
    recipientName
    senderName
    __typename
  }
  ... on ProductCartItem {
    __typename
    id
    inCartPrice
    bonusItemId
    restricted
    quantity
    purchasedPrice {
      price
      promotionPrice
    }
    adjustments {
      promotionId
      itemText
      price
      couponCode
      promotion {
        id
        calloutMessage
        name
      }
      __typename
    }
    product {
      masterId
      id
      isAppExclusive
      appOnlyDateTimeFrom
      appOnlyDateTimeTo
      promotionExclusion
      name
      header
      subHeader
      price
      brand
      salePrice
      productPrice {
        price
        salePrice
        promotionPrice
        isSalePriceElapsed
      }
      images {
        href
        alt
      }
      inventory
      maxOrderableQuantity
      primaryCategoryId
      styleNumber
      ean
      upc
      colorValue
      colorName
      displayOutOfStock {
        soldout
        backsoon
        presale
        validTo
      }
      size {
        label
        value
      }
      offline
      orderable
      assortmentAvailability
    }
    customizationName
    customizationNumber
    customizationCost
    quantityInCart
    stockMessage
    stockMessageCode
    hasStock
    adjustQuantityMessage
    personalizationSurcharge
    personalizationImageURL
    personalizationLargeImageURL
    personalizationName
    personalizationNumber
    personalizationPrice
    personalizationRecipeID
    popularityCount
    estimatedDeliveryDate {
      id
      carrierCode
      eddBegin
      eddEnd
      errorResponse {
        code
        message
      }
      serviceCode
      timeZoneName
    }
  }
}
    `;
export const GiftWithPurchaseFieldsFragmentDoc = gql`
    fragment giftWithPurchaseFields on GiftWithPurchasePromo {
  id
  allowedQuantity
  promotionId
  calloutMessage
  gwpTitle
  details
  fullfilled
  availableProducts {
    ... on VariantProduct {
      __typename
      masterId
      id
      name
      price
      images {
        href
        alt
      }
      inventory
      primaryCategoryId
      styleNumber
      colorValue
      colorName
      size {
        label
        value
      }
    }
    ... on ProductWithExclusion {
      __typename
      excludedColors
      product {
        id
        name
        variations {
          id
          colorValue
          colorName
          salePrice
          price
          productPrice {
            price
            salePrice
            promotionPrice
          }
          preview
          displayOutOfStock {
            displayValue
            soldout
          }
          orderable
          sizeGroups {
            label
            description
            sizes {
              id
              label
              value
              productId
              orderable
              maxOrderableQuantity
            }
          }
          images {
            href
            alt
          }
        }
      }
    }
  }
}
    `;
export const AmbassadorCardPaymentFieldsFragmentDoc = gql`
    fragment ambassadorCardPaymentFields on PaymentInstrument {
  ... on AmbassadorCard {
    __typename
    id
    maskedNumber
    amount
    authorizationStatus
    type
  }
}
    `;
export const CartPaymentInstrumentsFieldsFragmentDoc = gql`
    fragment cartPaymentInstrumentsFields on PaymentInstrument {
  ... on AfterPay {
    __typename
    id
    type
  }
  ... on AmazonPay {
    __typename
    id
    type
  }
  ... on ApplePay {
    __typename
    id
    authorizationStatus
    type
  }
  ... on CashOnDelivery {
    __typename
    id
    type
  }
  ... on CreditCard {
    __typename
    id
    maskedNumber
    expirationMonth
    expirationYear
    holder
    type
  }
  ... on GiftCard {
    __typename
    id
    maskedNumber
    amount
    type
  }
  ... on OnlineBanking {
    __typename
    id
    type
  }
  ... on PayPal {
    __typename
    id
    type
  }
  ... on PayPay {
    __typename
    id
    type
  }
  ... on PayTm {
    __typename
    id
    type
  }
  ... on Razorpay {
    __typename
    id
    type
  }
  ... on Scheme {
    __typename
    id
    type
  }
  ... on StoreCreditInstrument {
    __typename
    id
    type
    amount
  }
  ... on UPI {
    __typename
    id
    type
  }
  ... on Wallet {
    __typename
    id
    type
  }
  ...ambassadorCardPaymentFields
}
    ${AmbassadorCardPaymentFieldsFragmentDoc}`;
export const CustomerFieldsFragmentDoc = gql`
    fragment customerFields on Cart {
  customer {
    id
    email
    customerNo
  }
}
    `;
export const CartCostsFieldsFragmentDoc = gql`
    fragment cartCostsFields on Cart {
  subTotal
  shippingCosts
  estimatedShippingCosts
  taxTotal
  taxation
  estimatedTotal
  amountRemaining
  customizationAdjustment {
    price
  }
}
    `;
export const CartPromoFieldsFragmentDoc = gql`
    fragment cartPromoFields on Cart {
  couponItems {
    code
    couponItemId
    statusCode
    valid
    discountAmount
    calloutMessage
  }
  orderAdjustments {
    promotionId
    itemText
    price
    couponCode
  }
  shippingAdjustments {
    promotionId
    itemText
    price
    couponCode
  }
  productAdjustments {
    promotionId
    itemText
    price
    couponCode
  }
}
    `;
export const BillingAddressFieldsFragmentDoc = gql`
    fragment billingAddressFields on Cart {
  billingAddress {
    firstName
    lastName
    address1
    address2
    postalCode
    city
    countryCode
    stateCode
    phone
    id
    firstNamePronunciation
    lastNamePronunciation
    streetNumber
    salutation
    companyName
  }
}
    `;
export const ShipmentFieldsFragmentDoc = gql`
    fragment shipmentFields on Shipment {
  id
  shipmentMethod {
    id
    name
    price
  }
  address {
    id
    firstName
    lastName
    address1
    address2
    postalCode
    city
    countryCode
    stateCode
    phone
    firstNamePronunciation
    lastNamePronunciation
    streetNumber
    salutation
    companyName
  }
  deliveryDate
  deliveryTimeCode
  deliveryTimeDisplayText
  authorityToLeave {
    leaveAt
    deliveryInstructions
  }
}
    `;
export const ShipmentMethodInfoFieldsFragmentDoc = gql`
    fragment shipmentMethodInfoFields on ShipmentMethodInfo {
  defaultShipmentMethodId
  availableShipmentMethods {
    id
    name
    price
    estimatedShippingDate {
      min
      max
    }
  }
}
    `;
export const CartFieldsFragmentDoc = gql`
    fragment cartFields on Cart {
  id
  productCount
  amountRemainingForFreeShipping
  basketInStockStatus
  hasFreeShipping
  hasOfflineProducts
  preOrderDeliveryDate
  shippingSurcharge {
    amount
    label
    tooltip
  }
  products {
    ...productCartItemFields
  }
  giftWithPurchases {
    ...giftWithPurchaseFields
  }
  paymentInstruments {
    ...cartPaymentInstrumentsFields
  }
  ...customerFields
  ...cartCostsFields
  ...cartPromoFields
  ...billingAddressFields
  shipment {
    ...shipmentFields
  }
  shipmentMethodInfo {
    ...shipmentMethodInfoFields
  }
  longTermPreOrder {
    hasLongTermPreOrderItem
    longTermPreOrderItemPaymentMethods
  }
}
    ${ProductCartItemFieldsFragmentDoc}
${GiftWithPurchaseFieldsFragmentDoc}
${CartPaymentInstrumentsFieldsFragmentDoc}
${CustomerFieldsFragmentDoc}
${CartCostsFieldsFragmentDoc}
${CartPromoFieldsFragmentDoc}
${BillingAddressFieldsFragmentDoc}
${ShipmentFieldsFragmentDoc}
${ShipmentMethodInfoFieldsFragmentDoc}`;
export const CategoryFragmentDoc = gql`
    fragment category on Category {
  id
  name
  title
  url
  visible
}
    `;
export const PortableTextFieldsFragmentDoc = gql`
    fragment portableTextFields on PortableText {
  _type
  _key
  children {
    _type
    _key
    text
    marks
  }
  markDefs {
    _type
    _key
    _ref
    href
    link
    newtab
  }
  style
  level
  listItem
}
    `;
export const CtaFieldsFragmentDoc = gql`
    fragment ctaFields on CTA {
  __typename
  _type
  id
  link
  title
  variant
  outlined
  newtab
  popup
  query
}
    `;
export const ColorInputFieldsFragmentDoc = gql`
    fragment colorInputFields on ColorInput {
  __typename
  hex
  alpha
  rgb {
    r
    g
    b
    a
  }
}
    `;
export const BackgroundOverlayFieldsFragmentDoc = gql`
    fragment backgroundOverlayFields on BackgroundOverlay {
  __typename
  id
  overlayColorInput {
    ...colorInputFields
  }
  overlayType
  direction
}
    ${ColorInputFieldsFragmentDoc}`;
export const SanityImageFieldsFragmentDoc = gql`
    fragment sanityImageFields on SanityImage {
  alt
  asset {
    _id
    url
    metadata {
      lqip
      dimensions {
        width
        height
      }
    }
    extension
  }
  overlay {
    ...backgroundOverlayFields
  }
}
    ${BackgroundOverlayFieldsFragmentDoc}`;
export const SignUpFormFieldsFragmentDoc = gql`
    fragment signUpFormFields on SignUpForm {
  id
  __typename
  analyticsIdentifier
  launchButtonLabel
  launchLinkText
  cartPageLaunchButtonLabel
  header
  copy
  footnote
  contactSource
  disclaimer {
    ...portableTextFields
  }
  disclaimerText
  portableDisclaimerText {
    ...portableTextFields
  }
  submitButtonText
  customText
  submitButtonTextColor
  submitButtonColor
  fields
  textColor
  backgroundColor
  successHeader
  successHeaderTextColor
  successCopy
  successCopyTextColor
  successFootnote
  successFootnoteTextColor
  inverted
  ctas {
    ...ctaFields
  }
  successImage {
    ...sanityImageFields
  }
  mobileBackgroundImage {
    ...sanityImageFields
  }
  formBackgroundImage: backgroundImage {
    ...sanityImageFields
  }
}
    ${PortableTextFieldsFragmentDoc}
${CtaFieldsFragmentDoc}
${SanityImageFieldsFragmentDoc}`;
export const SavedCreditCardFragmentDoc = gql`
    fragment savedCreditCard on SavedCreditCard {
  UUID
  defaultFlag
  creditHolderName
  creditCardSeq
  creditCardType
  creditCardNumber
  maskedCreditCardNumber
  creditCardExpirationMonth
  creditCardExpirationYear
}
    `;
export const OrderPaymentInstrumentFieldsFragmentDoc = gql`
    fragment orderPaymentInstrumentFields on BaseOrder {
  paymentInstruments {
    ... on Adyen {
      id
      __typename
      amount
      type
    }
    ... on AdyenKlarna {
      id
      __typename
      amount
      type
    }
    ... on AdyenKlarnaAccount {
      id
      __typename
      amount
      type
    }
    ... on AmazonPay {
      __typename
      id
      type
    }
    ... on AmbassadorCard {
      id
      __typename
      authorizationStatus
      maskedNumber
      amount
      type
    }
    ... on Scheme {
      id
      amount
      authorizationStatus
      type
      __typename
    }
    ... on CreditCard {
      id
      amount
      maskedNumber
      cardType
      authorizationStatus
      type
      __typename
    }
    ... on AfterPay {
      id
      authorizationStatus
      type
      __typename
    }
    ... on PayPay {
      id
      authorizationStatus
      type
      __typename
    }
    ... on ApplePay {
      id
      authorizationStatus
      type
      __typename
    }
    ... on PayPal {
      id
      authorizationStatus
      type
      __typename
    }
    ... on GiftCard {
      id
      __typename
      maskedNumber
      authorizationStatus
      amount
      type
    }
    ... on CashOnDelivery {
      id
      amount
      type
      __typename
    }
    ... on UPI {
      id
      amount
      authorizationStatus
      type
      __typename
    }
    ... on Wallet {
      id
      amount
      authorizationStatus
      type
      __typename
    }
    ... on OnlineBanking {
      id
      amount
      authorizationStatus
      type
      __typename
    }
    ... on PayTm {
      id
      authorizationStatus
      amount
      type
      __typename
    }
    ... on StoreCreditInstrument {
      id
      amount
      type
      __typename
    }
    ... on ZipPay {
      id
      type
      __typename
    }
    ... on WechatPay {
      id
      type
      __typename
    }
    ... on Alipay {
      id
      type
      __typename
    }
    ... on KlarnaPayments {
      id
      type
      amount
      __typename
    }
    ... on Razorpay {
      id
      amount
      type
      __typename
    }
    ... on AmazonPay {
      id
      amount
      type
      __typename
    }
  }
}
    `;
export const OrderAddressFragmentDoc = gql`
    fragment orderAddress on OrderAddress {
  id
  salutation
  firstName
  lastName
  firstNamePronunciation
  lastNamePronunciation
  companyName
  address1
  address2
  streetNumber
  postalCode
  city
  countryCode
  stateCode
  phone
}
    `;
export const OrderConfirmationFieldsFragmentDoc = gql`
    fragment orderConfirmationFields on BaseOrder {
  billingAddress {
    ...orderAddress
  }
  shipment {
    id
    shipmentMethod {
      id
      name
      price
    }
    address {
      ...orderAddress
    }
    deliveryDate
    deliveryTimeDisplayText
  }
  customer {
    email
    id
  }
}
    ${OrderAddressFragmentDoc}`;
export const NestedOrderDetailsFieldsFragmentDoc = gql`
    fragment nestedOrderDetailsFields on NestedOrder {
  __typename
  orderNo
  status
  taxTotal
  subTotal
  createdAt
  currency
  orderStatus {
    code
    label
  }
  isReturnable
  ...orderPaymentInstrumentFields
  ...orderConfirmationFields
  suborders {
    __typename
    orderNo
    awbNo
    courierPartner
    status
    statuses {
      status
      label
      order
    }
    returnBy
    isReturnable
    returnUrl
    products {
      ... on ProductCartItem {
        __typename
        id
        status
        inCartPrice
        bonusItemId
        restricted
        quantity
        purchasedPrice {
          price
          promotionPrice
        }
        product {
          masterId
          id
          name
          price
          salePrice
          productPrice {
            price
            salePrice
            promotionPrice
          }
          images {
            href
            alt
          }
          inventory
          primaryCategoryId
          styleNumber
          colorValue
          colorName
          size {
            label
            value
          }
          offline
          orderable
        }
        productReturn {
          id
          returnOrderCode
          forwardAwb
          returnAwb
          transporter
          channelReturnOrderTime
          type
          status
          statuses {
            status
            label
            order
          }
          price
          quantity
        }
      }
    }
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;
export const PdpMandatoryVariantFieldsFragmentDoc = gql`
    fragment pdpMandatoryVariantFields on Variant {
  id
  masterId
  variantId
  name
  header
  subHeader
  price
  colorValue
  colorName
  ean
  preview
  images {
    alt
    href
    verticalImageHref
  }
}
    `;
export const PdpMandatoryExtraVariantFieldsFragmentDoc = gql`
    fragment pdpMandatoryExtraVariantFields on Variant {
  id
  sizeGroups {
    label
    description
    sizes {
      id
      label
      value
      productId
      orderable
      maxOrderableQuantity
    }
  }
}
    `;
export const SizesFragmentDoc = gql`
    fragment sizes on Product {
  productMeasurements {
    metric
    imperial
  }
}
    `;
export const MandatoryVariantFieldsFragmentDoc = gql`
    fragment mandatoryVariantFields on Variant {
  id
  masterId
  variantId
  name
  header
  subHeader
  price
  colorValue
  colorName
  ean
  sizeGroups {
    label
    description
    sizes {
      id
      label
      value
      productId
      orderable
      maxOrderableQuantity
    }
  }
  preview
  images {
    alt
    href
    verticalImageHref
  }
}
    `;
export const MandatoryMasterFieldsFragmentDoc = gql`
    fragment mandatoryMasterFields on Product {
  name
  id
  header
  subHeader
  orderableColorCount
  displayOutOfStock {
    soldout
    soldoutWithRecommender
    comingsoon
    backsoon
    presale
    displayValue
  }
  colors {
    name
    value
    image {
      href
      verticalImageHref
      alt
    }
  }
  image {
    href
    verticalImageHref
    alt
  }
  showExploreCollectionCTA
}
    `;
export const PaginatedOutputNodesFragmentFragmentDoc = gql`
    fragment PaginatedOutputNodesFragment on PaginatedOutput {
  nodes {
    __typename
    id
    color
    masterId
    variantProduct {
      ...mandatoryVariantFields
      badges {
        id
        label
      }
      percentageDiscountBadge
      salePrice
      productPrice {
        price
        salePrice
        promotionPrice
        isSalePriceElapsed
      }
      displayOutOfStock {
        soldout
        comingsoon
        backsoon
        presale
        displayValue
      }
      orderable
      promotions(page: ProductListingPage) {
        id
        calloutMessage
      }
      isAppExclusive
      appOnlyDateTimeFrom
      appOnlyDateTimeTo
    }
    masterProduct {
      ...mandatoryMasterFields
      brand
      promotions(page: ProductListingPage) {
        id
        calloutMessage
      }
      amountOfReviews
      averageRating
      score {
        rating
        amount
      }
    }
  }
}
    ${MandatoryVariantFieldsFragmentDoc}
${MandatoryMasterFieldsFragmentDoc}`;
export const PaginatedOutputMetadataFragmentFragmentDoc = gql`
    fragment PaginatedOutputMetadataFragment on PaginatedOutput {
  sortingOptions {
    id
    label
  }
  selectedSort
  filteringOptions {
    id
    label
    values {
      value
      label
      hitCount
    }
  }
  totalCount
}
    `;
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  id
  rating
  title
  text
  nickname
  location
  pros
  cons
  date
  helpfulVotes
  isRecommended
  secondaryRatings {
    id
    label
    rating
  }
  aspects {
    width
    size
    comfort
  }
}
    `;
export const ReviewSummaryFieldsFragmentDoc = gql`
    fragment ReviewSummaryFields on ReviewSummary {
  recommendedCount
  totalCount
  recommendedPercentage
  aspects {
    width
    size
    comfort
  }
}
    `;
export const OrderPreviewFieldsFragmentDoc = gql`
    fragment orderPreviewFields on StandardOrder {
  orderNo
  createdAt
  currency
  orderStatus {
    code
    label
  }
  estimatedTotal
  isReturnable
  shipment {
    address {
      id
      firstName
      lastName
      postalCode
      salutation
    }
  }
  refundInformation
  products {
    ... on ProductCartItem {
      __typename
      id
      quantity
      inCartPrice
      purchasedPrice {
        price
        promotionPrice
      }
      product {
        id
        name
        header
        subHeader
        colorValue
        colorName
        masterId
        images {
          href
          alt
        }
        styleNumber
        offline
        orderable
      }
      personalizationImageURL
    }
    ... on GiftCardCartItem {
      id
      imageUrl
      amount
      recipientEmail
      recipientName
      senderName
      __typename
    }
  }
  customer {
    email
    id
  }
}
    `;
export const StandardOrderDetailsFieldsFragmentDoc = gql`
    fragment standardOrderDetailsFields on StandardOrder {
  __typename
  orderNo
  orderToken
  status
  orderStatus {
    code
    label
  }
  refundInformation
  trackingNumber
  isReturnable
  statuses {
    status
    label
    order
  }
  taxTotal
  taxation
  createdAt
  currency
  oms {
    trackingLink
  }
  subTotal
  shippingCosts
  estimatedTotal
  gmoRedirectUrl
  gmoChallengeUrl
  gmoFlow
  gmoAccessID
  gmoAccessPass
  promoDiscountValue
  shippingSurcharge {
    amount
    label
    tooltip
  }
  orderAdjustments {
    promotionId
    itemText
    price
    couponCode
  }
  shippingAdjustments {
    promotionId
    itemText
    price
    couponCode
  }
  couponItems {
    code
    couponItemId
    statusCode
    valid
  }
  products {
    ...productCartItemFields
  }
  ...orderPaymentInstrumentFields
  ...orderConfirmationFields
}
    ${ProductCartItemFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;
export const StoreCreditFieldsFragmentDoc = gql`
    fragment storeCreditFields on StoreCredit {
  amount
}
    `;
export const TermsAndConditionsFieldsFragmentDoc = gql`
    fragment termsAndConditionsFields on TermsAndConditions {
  id
  __typename
  content {
    ...portableTextFields
  }
}
    ${PortableTextFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  customerNo
  creationDate
  birthday
  firstName
  lastName
  firstNamePronunciation
  lastNamePronunciation
  email
  phoneNumber
  gender
  birthday
  smsContactNumber
}
    `;
export const SanityVideoFieldsFragmentDoc = gql`
    fragment sanityVideoFields on SanityVideo {
  autoplay
  loop
  mute
  source
}
    `;
export const WishListFieldsFragmentDoc = gql`
    fragment wishListFields on WishList {
  id
  items {
    __typename
    id
    quantity
    creationDate
    product {
      id
      name
      header
      subHeader
      masterId
      orderable
      inventory
      displayOutOfStock {
        displayValue
        presale
        validTo
      }
      price
      salePrice
      productPrice {
        price
        salePrice
        promotionPrice
        isSalePriceElapsed
      }
      images {
        href
        alt
      }
      styleNumber
      colorValue
      colorName
      size {
        label
        value
      }
      offline
      isAppExclusive
      appOnlyDateTimeFrom
      appOnlyDateTimeTo
    }
  }
}
    `;
export const RecommendationFieldsFragmentDoc = gql`
    fragment recommendationFields on ProductSearchHit {
  __typename
  id
  masterId
  color
  variantProduct {
    ...mandatoryVariantFields
    badges {
      id
      label
    }
    percentageDiscountBadge
    salePrice
    productPrice {
      price
      salePrice
      promotionPrice
    }
    displayOutOfStock {
      soldout
      comingsoon
      backsoon
      presale
      displayValue
    }
    orderable
    promotions(page: ProductListingPage) {
      id
      calloutMessage
    }
    isAppExclusive
    appOnlyDateTimeFrom
    appOnlyDateTimeTo
  }
  masterProduct {
    ...mandatoryMasterFields
    brand
    promotions(page: ProductListingPage) {
      id
      calloutMessage
    }
    score {
      rating
      amount
    }
  }
}
    ${MandatoryVariantFieldsFragmentDoc}
${MandatoryMasterFieldsFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment product on ProductSuggestion {
  id
  styleId
  name
  price
  salePrice
  orderable
  image {
    href
    alt
  }
}
    `;
export const GuestLogonDocument = gql`
    mutation GuestLogon {
  guestLogon {
    ...tokenPayload
  }
}
    ${TokenPayloadFragmentDoc}`;

export function useGuestLogonMutation() {
  return Urql.useMutation<GuestLogonMutation, GuestLogonMutationVariables>(GuestLogonDocument);
};
export const RefreshLogonDocument = gql`
    mutation RefreshLogon($input: RefreshLogonInput!) {
  refreshLogon(input: $input) {
    ...tokenPayload
  }
}
    ${TokenPayloadFragmentDoc}`;

export function useRefreshLogonMutation() {
  return Urql.useMutation<RefreshLogonMutation, RefreshLogonMutationVariables>(RefreshLogonDocument);
};
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {
  updatePassword(
    input: {currentPassword: $currentPassword, newPassword: $newPassword}
  )
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const UpdatePhoneDocument = gql`
    mutation UpdatePhone($input: UpdatePhoneInput!) {
  updatePhone(input: $input) {
    code
    message
    pinId
  }
}
    `;

export function useUpdatePhoneMutation() {
  return Urql.useMutation<UpdatePhoneMutation, UpdatePhoneMutationVariables>(UpdatePhoneDocument);
};
export const ConfirmUpdatePhoneDocument = gql`
    mutation ConfirmUpdatePhone($input: ConfirmUpdatePhoneInput!) {
  confirmUpdatePhone(input: $input) {
    code
    message
    user {
      id
      phoneNumber
    }
  }
}
    `;

export function useConfirmUpdatePhoneMutation() {
  return Urql.useMutation<ConfirmUpdatePhoneMutation, ConfirmUpdatePhoneMutationVariables>(ConfirmUpdatePhoneDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(email: $email)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const CompleteResetPasswordDocument = gql`
    mutation CompleteResetPassword($password: String!, $token: String!) {
  completeResetPassword(password: $password, token: $token)
}
    `;

export function useCompleteResetPasswordMutation() {
  return Urql.useMutation<CompleteResetPasswordMutation, CompleteResetPasswordMutationVariables>(CompleteResetPasswordDocument);
};
export const CreateShopperContextDocument = gql`
    mutation CreateShopperContext($input: CreateShopperContextInput!) {
  createShopperContext(input: $input) {
    sourceCode
  }
}
    `;

export function useCreateShopperContextMutation() {
  return Urql.useMutation<CreateShopperContextMutation, CreateShopperContextMutationVariables>(CreateShopperContextDocument);
};
export const VerifyUserAffiliationsDocument = gql`
    mutation VerifyUserAffiliations($input: VerifyUserAffiliationsInput!) {
  verifyUserAffiliations(input: $input) {
    verified
    affiliations
  }
}
    `;

export function useVerifyUserAffiliationsMutation() {
  return Urql.useMutation<VerifyUserAffiliationsMutation, VerifyUserAffiliationsMutationVariables>(VerifyUserAffiliationsDocument);
};
export const AddAddressDocument = gql`
    mutation AddAddress($title: String!, $firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $address1: String!, $address2: String, $city: String!, $postalCode: String!, $stateCode: String, $countryCode: String!, $phone: String, $preferred: Boolean!, $streetNumber: String, $salutation: String, $companyName: String) {
  addAddress(
    input: {title: $title, firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, address1: $address1, city: $city, address2: $address2, postalCode: $postalCode, stateCode: $stateCode, countryCode: $countryCode, phone: $phone, preferred: $preferred, streetNumber: $streetNumber, salutation: $salutation, companyName: $companyName}
  ) {
    ...addressFields
  }
}
    ${AddressFieldsFragmentDoc}`;

export function useAddAddressMutation() {
  return Urql.useMutation<AddAddressMutation, AddAddressMutationVariables>(AddAddressDocument);
};
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($id: ID!, $title: String!, $firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $address1: String!, $address2: String, $city: String!, $postalCode: String!, $stateCode: String, $countryCode: String!, $phone: String, $preferred: Boolean!, $streetNumber: String, $salutation: String, $companyName: String) {
  updateAddress(
    input: {id: $id, title: $title, firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, address1: $address1, city: $city, address2: $address2, postalCode: $postalCode, stateCode: $stateCode, countryCode: $countryCode, phone: $phone, preferred: $preferred, streetNumber: $streetNumber, salutation: $salutation, companyName: $companyName}
  ) {
    ...addressFields
  }
}
    ${AddressFieldsFragmentDoc}`;

export function useUpdateAddressMutation() {
  return Urql.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument);
};
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($id: ID!) {
  deleteAddress(id: $id)
}
    `;

export function useDeleteAddressMutation() {
  return Urql.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument);
};
export const SaveAmbassadorCardDocument = gql`
    mutation SaveAmbassadorCard($input: SaveAmbassadorCardInput!) {
  saveAmbassadorCard(input: $input) {
    id
    ambassadorCards {
      ...ambassadorCardFields
    }
  }
}
    ${AmbassadorCardFieldsFragmentDoc}`;

export function useSaveAmbassadorCardMutation() {
  return Urql.useMutation<SaveAmbassadorCardMutation, SaveAmbassadorCardMutationVariables>(SaveAmbassadorCardDocument);
};
export const DeleteAmbassadorCardDocument = gql`
    mutation DeleteAmbassadorCard($input: DeleteAmbassadorCardInput!) {
  deleteAmbassadorCard(input: $input) {
    id
    ambassadorCards {
      ...ambassadorCardFields
    }
  }
}
    ${AmbassadorCardFieldsFragmentDoc}`;

export function useDeleteAmbassadorCardMutation() {
  return Urql.useMutation<DeleteAmbassadorCardMutation, DeleteAmbassadorCardMutationVariables>(DeleteAmbassadorCardDocument);
};
export const UpdateAmbassadorCardsDocument = gql`
    mutation UpdateAmbassadorCards($input: UpdateAmbassadorCardInput!) {
  updateAmbassadorCards(input: $input) {
    id
    ambassadorCards {
      ...ambassadorCardFields
    }
  }
}
    ${AmbassadorCardFieldsFragmentDoc}`;

export function useUpdateAmbassadorCardsMutation() {
  return Urql.useMutation<UpdateAmbassadorCardsMutation, UpdateAmbassadorCardsMutationVariables>(UpdateAmbassadorCardsDocument);
};
export const AddItemsToCartDocument = gql`
    mutation AddItemsToCart($input: AddItemsToCartInput!) {
  addItemsToCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddItemsToCartMutation() {
  return Urql.useMutation<AddItemsToCartMutation, AddItemsToCartMutationVariables>(AddItemsToCartDocument);
};
export const UpdateItemInCartDocument = gql`
    mutation UpdateItemInCart($input: UpdateItemInCartInput!) {
  updateItemInCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useUpdateItemInCartMutation() {
  return Urql.useMutation<UpdateItemInCartMutation, UpdateItemInCartMutationVariables>(UpdateItemInCartDocument);
};
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($input: RemoveItemFromCartInput!) {
  removeItemFromCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveItemFromCartMutation() {
  return Urql.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument);
};
export const AddGiftCardToCartDocument = gql`
    mutation AddGiftCardToCart($input: AddGiftCardToCartInput!) {
  addGiftCardToCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddGiftCardToCartMutation() {
  return Urql.useMutation<AddGiftCardToCartMutation, AddGiftCardToCartMutationVariables>(AddGiftCardToCartDocument);
};
export const RemoveGiftCardFromCartDocument = gql`
    mutation RemoveGiftCardFromCart($input: RemoveGiftCardFromCartInput!) {
  removeGiftCardFromCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveGiftCardFromCartMutation() {
  return Urql.useMutation<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>(RemoveGiftCardFromCartDocument);
};
export const AddGiftCardDocument = gql`
    mutation AddGiftCard($input: AddGiftCardInput!) {
  addGiftCard(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddGiftCardMutation() {
  return Urql.useMutation<AddGiftCardMutation, AddGiftCardMutationVariables>(AddGiftCardDocument);
};
export const RemoveGiftCardDocument = gql`
    mutation RemoveGiftCard($input: RemoveGiftCardInput!) {
  removeGiftCard(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveGiftCardMutation() {
  return Urql.useMutation<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>(RemoveGiftCardDocument);
};
export const UpdateShippingAddressDocument = gql`
    mutation UpdateShippingAddress($input: UpdateShippingAddressInput!) {
  updateShippingAddress(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useUpdateShippingAddressMutation() {
  return Urql.useMutation<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>(UpdateShippingAddressDocument);
};
export const UpdateShipmentMethodDocument = gql`
    mutation UpdateShipmentMethod($input: UpdateShipmentMethodInput!) {
  updateShipmentMethod(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useUpdateShipmentMethodMutation() {
  return Urql.useMutation<UpdateShipmentMethodMutation, UpdateShipmentMethodMutationVariables>(UpdateShipmentMethodDocument);
};
export const UpdateBillingAddressDocument = gql`
    mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {
  updateBillingAddress(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useUpdateBillingAddressMutation() {
  return Urql.useMutation<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>(UpdateBillingAddressDocument);
};
export const RemoveCouponFromCartDocument = gql`
    mutation RemoveCouponFromCart($input: RemoveCouponFromCartInput!) {
  removeCouponFromCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveCouponFromCartMutation() {
  return Urql.useMutation<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(RemoveCouponFromCartDocument);
};
export const AddCouponToCartDocument = gql`
    mutation AddCouponToCart($input: AddCouponToCartInput!) {
  addCouponToCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddCouponToCartMutation() {
  return Urql.useMutation<AddCouponToCartMutation, AddCouponToCartMutationVariables>(AddCouponToCartDocument);
};
export const AddPaymentPromotionDocument = gql`
    mutation AddPaymentPromotion($input: AddPaymentPromotionInput!) {
  addPaymentPromotion(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddPaymentPromotionMutation() {
  return Urql.useMutation<AddPaymentPromotionMutation, AddPaymentPromotionMutationVariables>(AddPaymentPromotionDocument);
};
export const AddAmbassadorCardToCartDocument = gql`
    mutation AddAmbassadorCardToCart($input: AddAmbassadorCardToCartInput!) {
  addAmbassadorCardToCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddAmbassadorCardToCartMutation() {
  return Urql.useMutation<AddAmbassadorCardToCartMutation, AddAmbassadorCardToCartMutationVariables>(AddAmbassadorCardToCartDocument);
};
export const RemoveAmbassadorCardFromCartDocument = gql`
    mutation RemoveAmbassadorCardFromCart($input: RemoveAmbassadorCardFromCartInput!) {
  removeAmbassadorCardFromCart(input: $input) {
    ...cartFields
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveAmbassadorCardFromCartMutation() {
  return Urql.useMutation<RemoveAmbassadorCardFromCartMutation, RemoveAmbassadorCardFromCartMutationVariables>(RemoveAmbassadorCardFromCartDocument);
};
export const AddStoreCreditsDocument = gql`
    mutation AddStoreCredits($input: AddStoreCreditsInput!) {
  addStoreCredits(input: $input) {
    cart {
      ...cartFields
    }
  }
}
    ${CartFieldsFragmentDoc}`;

export function useAddStoreCreditsMutation() {
  return Urql.useMutation<AddStoreCreditsMutation, AddStoreCreditsMutationVariables>(AddStoreCreditsDocument);
};
export const RemoveStoreCreditsDocument = gql`
    mutation RemoveStoreCredits($input: RemoveStoreCreditsInput!) {
  removeStoreCredits(input: $input) {
    cart {
      ...cartFields
    }
  }
}
    ${CartFieldsFragmentDoc}`;

export function useRemoveStoreCreditsMutation() {
  return Urql.useMutation<RemoveStoreCreditsMutation, RemoveStoreCreditsMutationVariables>(RemoveStoreCreditsDocument);
};
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: CreateContactInput!) {
  updateContact(input: $input) {
    email
    gender
    dob {
      day
      month
      year
    }
    firstName
    lastName
    firstNamePronunciation
    lastNamePronunciation
    emailPreference
    shoppingPreference
  }
}
    `;

export function useUpdateContactMutation() {
  return Urql.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument);
};
export const KlarnaDocument = gql`
    mutation Klarna($input: KlarnaInput!) {
  klarna(input: $input) {
    action
    url
    orderNo
  }
}
    `;

export function useKlarnaMutation() {
  return Urql.useMutation<KlarnaMutation, KlarnaMutationVariables>(KlarnaDocument);
};
export const ConfirmKlarnaDocument = gql`
    mutation ConfirmKlarna($input: ConfirmKlarnaInput!) {
  confirmKlarna(input: $input) {
    orderNo
    status
  }
}
    `;

export function useConfirmKlarnaMutation() {
  return Urql.useMutation<ConfirmKlarnaMutation, ConfirmKlarnaMutationVariables>(ConfirmKlarnaDocument);
};
export const CancelKlarnaDocument = gql`
    mutation CancelKlarna($input: CancelKlarnaInput!) {
  cancelKlarna(input: $input) {
    orderNo
    status
  }
}
    `;

export function useCancelKlarnaMutation() {
  return Urql.useMutation<CancelKlarnaMutation, CancelKlarnaMutationVariables>(CancelKlarnaDocument);
};
export const StartKlarnaPaymentDocument = gql`
    mutation startKlarnaPayment($input: StartKlarnaPaymentInput!) {
  startKlarnaPayment(input: $input) {
    clientToken
    orderNo
    paymentMethodCategories {
      identifier
    }
    sessionId
  }
}
    `;

export function useStartKlarnaPaymentMutation() {
  return Urql.useMutation<StartKlarnaPaymentMutation, StartKlarnaPaymentMutationVariables>(StartKlarnaPaymentDocument);
};
export const ConfirmKlarnaPaymentDocument = gql`
    mutation confirmKlarnaPayment($input: ConfirmKlarnaPaymentInput!) {
  confirmKlarnaPayment(input: $input) {
    orderNo
    orderStatus {
      code
      label
    }
    status
  }
}
    `;

export function useConfirmKlarnaPaymentMutation() {
  return Urql.useMutation<ConfirmKlarnaPaymentMutation, ConfirmKlarnaPaymentMutationVariables>(ConfirmKlarnaPaymentDocument);
};
export const LoginWithEmailAndPasswordDocument = gql`
    mutation LoginWithEmailAndPassword($email: String!, $password: String!, $uniqueShopperId: String) {
  login(
    input: {email: $email, password: $password, uniqueShopperId: $uniqueShopperId}
  ) {
    ...authPayload
  }
}
    ${AuthPayloadFragmentDoc}`;

export function useLoginWithEmailAndPasswordMutation() {
  return Urql.useMutation<LoginWithEmailAndPasswordMutation, LoginWithEmailAndPasswordMutationVariables>(LoginWithEmailAndPasswordDocument);
};
export const VerifyLoginWithOtpDocument = gql`
    mutation VerifyLoginWithOTP($phoneNo: String!, $pinId: String!, $pin: String!, $recaptchaToken: String, $uniqueShopperId: String) {
  verifyLoginWithOTP(
    input: {phoneNo: $phoneNo, pinId: $pinId, pin: $pin, recaptchaToken: $recaptchaToken, uniqueShopperId: $uniqueShopperId}
  ) {
    authPayload {
      ...authPayload
    }
    code
    message
    otpVerifyToken
  }
}
    ${AuthPayloadFragmentDoc}`;

export function useVerifyLoginWithOtpMutation() {
  return Urql.useMutation<VerifyLoginWithOtpMutation, VerifyLoginWithOtpMutationVariables>(VerifyLoginWithOtpDocument);
};
export const LoginWithOtpDocument = gql`
    mutation LoginWithOTP($recaptchaToken: String, $phoneNo: String!) {
  loginWithOTP(input: {recaptchaToken: $recaptchaToken, phoneNo: $phoneNo})
}
    `;

export function useLoginWithOtpMutation() {
  return Urql.useMutation<LoginWithOtpMutation, LoginWithOtpMutationVariables>(LoginWithOtpDocument);
};
export const LoginWithPhoneDocument = gql`
    mutation LoginWithPhone($phoneNo: String!, $password: String!, $uniqueShopperId: String) {
  loginWithPhone(
    input: {phoneNo: $phoneNo, password: $password, uniqueShopperId: $uniqueShopperId}
  ) {
    ...authPayload
  }
}
    ${AuthPayloadFragmentDoc}`;

export function useLoginWithPhoneMutation() {
  return Urql.useMutation<LoginWithPhoneMutation, LoginWithPhoneMutationVariables>(LoginWithPhoneDocument);
};
export const ResendOtpDocument = gql`
    mutation ResendOTP($pinId: String!, $recaptchaToken: String) {
  resendOTP(input: {pinId: $pinId, recaptchaToken: $recaptchaToken})
}
    `;

export function useResendOtpMutation() {
  return Urql.useMutation<ResendOtpMutation, ResendOtpMutationVariables>(ResendOtpDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const ManageCustomerLevelNotificationDocument = gql`
    mutation ManageCustomerLevelNotification($input: ManageCustomerLevelNotificationInput!) {
  manageCustomerLevelNotification(input: $input)
}
    `;

export function useManageCustomerLevelNotificationMutation() {
  return Urql.useMutation<ManageCustomerLevelNotificationMutation, ManageCustomerLevelNotificationMutationVariables>(ManageCustomerLevelNotificationDocument);
};
export const SaveNotificationPreferencesDocument = gql`
    mutation SaveNotificationPreferences($input: NotificationsPreferenceInput!) {
  saveNotificationPreferences(input: $input) {
    phoneNumber
    marketingSmsOptIn
    customerSmsOptIn
  }
}
    `;

export function useSaveNotificationPreferencesMutation() {
  return Urql.useMutation<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>(SaveNotificationPreferencesDocument);
};
export const ManageOrderLevelNotificationDocument = gql`
    mutation ManageOrderLevelNotification($input: ManageOrderLevelNotificationInput!) {
  manageOrderLevelNotification(input: $input)
}
    `;

export function useManageOrderLevelNotificationMutation() {
  return Urql.useMutation<ManageOrderLevelNotificationMutation, ManageOrderLevelNotificationMutationVariables>(ManageOrderLevelNotificationDocument);
};
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    email
    gender
    dob {
      day
      month
      year
    }
    emailPreference
    shoppingPreference
  }
}
    `;

export function useCreateContactMutation() {
  return Urql.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument);
};
export const OpluxFraudDetectionDocument = gql`
    mutation OpluxFraudDetection($basketId: String!, $opluxFraudDetection: String!, $paymentMethodId: String, $fraudbuster: String, $opluxEventId: String, $opluxScreeningResult: String) {
  opluxFraudDetection(
    basketId: $basketId
    opluxFraudDetection: $opluxFraudDetection
    paymentMethodId: $paymentMethodId
    fraudbuster: $fraudbuster
    opluxEventId: $opluxEventId
    opluxScreeningResult: $opluxScreeningResult
  ) {
    isOpluxNG
    opluxEventId
    opluxScreeningResult
  }
}
    `;

export function useOpluxFraudDetectionMutation() {
  return Urql.useMutation<OpluxFraudDetectionMutation, OpluxFraudDetectionMutationVariables>(OpluxFraudDetectionDocument);
};
export const StartAdyenPaymentDocument = gql`
    mutation StartAdyenPayment($input: StartAdyenPaymentInput!) {
  startAdyenPayment(input: $input) {
    orderNo
    simulatorUrl
    resultCode
    action {
      ... on CheckoutRedirectAction {
        data
        method
        type
        url
        paymentMethodType
      }
      ... on CheckoutSDKAction {
        paymentMethodType
        paymentData
        type
        sdkData {
          token
        }
      }
      ... on CheckoutAwaitAction {
        paymentMethodType
        type
        url
        paymentData
      }
    }
  }
}
    `;

export function useStartAdyenPaymentMutation() {
  return Urql.useMutation<StartAdyenPaymentMutation, StartAdyenPaymentMutationVariables>(StartAdyenPaymentDocument);
};
export const CompleteAdyenPaymentDocument = gql`
    mutation CompleteAdyenPayment($input: CompleteAdyenPaymentInput!) {
  completeAdyenPayment(input: $input) {
    order {
      orderNo
    }
    resultCode
  }
}
    `;

export function useCompleteAdyenPaymentMutation() {
  return Urql.useMutation<CompleteAdyenPaymentMutation, CompleteAdyenPaymentMutationVariables>(CompleteAdyenPaymentDocument);
};
export const PayWithAfterPayDocument = gql`
    mutation PayWithAfterPay($input: AfterPayInput!) {
  afterPay(input: $input) {
    url
    orderNo
  }
}
    `;

export function usePayWithAfterPayMutation() {
  return Urql.useMutation<PayWithAfterPayMutation, PayWithAfterPayMutationVariables>(PayWithAfterPayDocument);
};
export const ConfirmAfterPayDocument = gql`
    mutation ConfirmAfterPay($input: ConfirmAfterPayInput!) {
  confirmAfterPay(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmAfterPayMutation() {
  return Urql.useMutation<ConfirmAfterPayMutation, ConfirmAfterPayMutationVariables>(ConfirmAfterPayDocument);
};
export const AmazonPayPaymentDescriptorDocument = gql`
    query AmazonPayPaymentDescriptor($input: AmazonPayPaymentDescriptorInput!) {
  amazonPayPaymentDescriptor(input: $input) {
    paymentOption
  }
}
    `;

export function useAmazonPayPaymentDescriptorQuery(options: Omit<Urql.UseQueryArgs<AmazonPayPaymentDescriptorQueryVariables>, 'query'>) {
  return Urql.useQuery<AmazonPayPaymentDescriptorQuery, AmazonPayPaymentDescriptorQueryVariables>({ query: AmazonPayPaymentDescriptorDocument, ...options });
};
export const SignAmazonPayloadDocument = gql`
    mutation SignAmazonPayload($input: SignAmazonPayloadInput!) {
  signAmazonPayload(input: $input) {
    signedPayload
  }
}
    `;

export function useSignAmazonPayloadMutation() {
  return Urql.useMutation<SignAmazonPayloadMutation, SignAmazonPayloadMutationVariables>(SignAmazonPayloadDocument);
};
export const StartAmazonPaymentDocument = gql`
    mutation StartAmazonPayment($input: StartAmazonPaymentInput!) {
  startAmazonPayment(input: $input) {
    url
    order {
      orderNo
    }
  }
}
    `;

export function useStartAmazonPaymentMutation() {
  return Urql.useMutation<StartAmazonPaymentMutation, StartAmazonPaymentMutationVariables>(StartAmazonPaymentDocument);
};
export const StartAmazonProcessOrderPaymentDocument = gql`
    mutation StartAmazonProcessOrderPayment($input: StartAmazonProcessOrderPaymentInput!) {
  startAmazonProcessOrderPayment(input: $input) {
    order {
      orderNo
    }
  }
}
    `;

export function useStartAmazonProcessOrderPaymentMutation() {
  return Urql.useMutation<StartAmazonProcessOrderPaymentMutation, StartAmazonProcessOrderPaymentMutationVariables>(StartAmazonProcessOrderPaymentDocument);
};
export const CompleteAmazonPaymentDocument = gql`
    mutation CompleteAmazonPayment($input: CompleteAmazonPaymentInput!) {
  completeAmazonPayment(input: $input) {
    order {
      orderNo
    }
  }
}
    `;

export function useCompleteAmazonPaymentMutation() {
  return Urql.useMutation<CompleteAmazonPaymentMutation, CompleteAmazonPaymentMutationVariables>(CompleteAmazonPaymentDocument);
};
export const RegisterAmazonPaymentDocument = gql`
    mutation RegisterAmazonPayment($input: RegisterAmazonPaymentInput!) {
  registerAmazonPayment(input: $input) {
    shouldPromptForLogin
    cart {
      ...cartFields
      shipment {
        ...shipmentFields
      }
      shipmentMethodInfo {
        ...shipmentMethodInfoFields
      }
      availablePaymentMethods {
        ...availablePaymentMethodsFields
      }
    }
  }
}
    ${CartFieldsFragmentDoc}
${ShipmentFieldsFragmentDoc}
${ShipmentMethodInfoFieldsFragmentDoc}
${AvailablePaymentMethodsFieldsFragmentDoc}`;

export function useRegisterAmazonPaymentMutation() {
  return Urql.useMutation<RegisterAmazonPaymentMutation, RegisterAmazonPaymentMutationVariables>(RegisterAmazonPaymentDocument);
};
export const PayWithAmbassadorCardDocument = gql`
    mutation PayWithAmbassadorCard($input: AmbassadorCardInput!) {
  ambassadorCard(input: $input) {
    orderNo
    ...orderConfirmationFields
    ...orderPaymentInstrumentFields
  }
}
    ${OrderConfirmationFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}`;

export function usePayWithAmbassadorCardMutation() {
  return Urql.useMutation<PayWithAmbassadorCardMutation, PayWithAmbassadorCardMutationVariables>(PayWithAmbassadorCardDocument);
};
export const PayWithApplePayDocument = gql`
    mutation PayWithApplePay($input: ApplePayInput!) {
  applePay(input: $input) {
    epochTimestamp
    expiresAt
    merchantSessionIdentifier
    nonce
    merchantIdentifier
    domainName
    displayName
    signature
    operationalAnalyticsIdentifier
    retries
  }
}
    `;

export function usePayWithApplePayMutation() {
  return Urql.useMutation<PayWithApplePayMutation, PayWithApplePayMutationVariables>(PayWithApplePayDocument);
};
export const ValidateApplePayMerchantDocument = gql`
    mutation ValidateApplePayMerchant($input: ValidateApplePayMerchantInput!) {
  validateApplePayMerchant(input: $input)
}
    `;

export function useValidateApplePayMerchantMutation() {
  return Urql.useMutation<ValidateApplePayMerchantMutation, ValidateApplePayMerchantMutationVariables>(ValidateApplePayMerchantDocument);
};
export const ConfirmApplePayDocument = gql`
    mutation ConfirmApplePay($input: ConfirmApplePayInput!) {
  confirmApplePay(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmApplePayMutation() {
  return Urql.useMutation<ConfirmApplePayMutation, ConfirmApplePayMutationVariables>(ConfirmApplePayDocument);
};
export const CancelApplePayDocument = gql`
    mutation CancelApplePay($basketId: String!) {
  cancelApplePay(basketId: $basketId) {
    id
  }
}
    `;

export function useCancelApplePayMutation() {
  return Urql.useMutation<CancelApplePayMutation, CancelApplePayMutationVariables>(CancelApplePayDocument);
};
export const CancelOrderDocument = gql`
    mutation CancelOrder($input: CancelOrderInput!) {
  cancelOrder(input: $input) {
    order {
      orderNo
    }
    cart {
      ...cartFields
    }
  }
}
    ${CartFieldsFragmentDoc}`;

export function useCancelOrderMutation() {
  return Urql.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument);
};
export const PayWithCashOnDeliveryDocument = gql`
    mutation PayWithCashOnDelivery($input: CashOnDeliveryInput!) {
  cashOnDelivery(input: $input) {
    orderNo
    ...orderConfirmationFields
    orderAdjustments {
      promotionId
      itemText
      price
      couponCode
    }
    pinId
    estimatedTotal
    taxTotal
    products {
      ...productCartItemFields
    }
  }
}
    ${OrderConfirmationFieldsFragmentDoc}
${ProductCartItemFieldsFragmentDoc}`;

export function usePayWithCashOnDeliveryMutation() {
  return Urql.useMutation<PayWithCashOnDeliveryMutation, PayWithCashOnDeliveryMutationVariables>(PayWithCashOnDeliveryDocument);
};
export const PayWithCashOnDeliveryInCartDocument = gql`
    mutation PayWithCashOnDeliveryInCart($input: AddCashOnDeliveryToCartInput!) {
  addCashOnDeliveryPaymentMethodToCart(input: $input) {
    ... on Cart {
      id
      estimatedTotal
      amountRemaining
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      paymentInstruments {
        ... on CreditCard {
          id
          amount
          __typename
        }
      }
    }
  }
}
    `;

export function usePayWithCashOnDeliveryInCartMutation() {
  return Urql.useMutation<PayWithCashOnDeliveryInCartMutation, PayWithCashOnDeliveryInCartMutationVariables>(PayWithCashOnDeliveryInCartDocument);
};
export const ConfirmCashOnDeliveryDocument = gql`
    mutation ConfirmCashOnDelivery($input: ConfirmCashOnDeliveryInput!) {
  confirmCashOnDelivery(input: $input) {
    orderNo
    pin
    pinId
    ...orderConfirmationFields
  }
}
    ${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmCashOnDeliveryMutation() {
  return Urql.useMutation<ConfirmCashOnDeliveryMutation, ConfirmCashOnDeliveryMutationVariables>(ConfirmCashOnDeliveryDocument);
};
export const PayWithCreditCardDocument = gql`
    mutation PayWithCreditCard($input: CreditCardInput!) {
  creditCard(input: $input) {
    ... on ThreeDSResponse {
      url
      method
      data
      orderNo
    }
    ... on StandardOrder {
      orderNo
      status
      ...orderConfirmationFields
      subTotal
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      couponItems {
        code
        couponItemId
        statusCode
        valid
      }
      orderNo
      taxTotal
      estimatedTotal
      status
      products {
        ...productCartItemFields
      }
      ...orderPaymentInstrumentFields
    }
  }
}
    ${OrderConfirmationFieldsFragmentDoc}
${ProductCartItemFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}`;

export function usePayWithCreditCardMutation() {
  return Urql.useMutation<PayWithCreditCardMutation, PayWithCreditCardMutationVariables>(PayWithCreditCardDocument);
};
export const PayWithCreditCardInCartDocument = gql`
    mutation PayWithCreditCardInCart($input: AddCreditCardToCartInput!) {
  addCreditCardPaymentMethodToCart(input: $input) {
    ... on Cart {
      id
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      estimatedTotal
      paymentInstruments {
        ... on CreditCard {
          id
          amount
          maskedNumber
          cardType
          authorizationStatus
          __typename
        }
      }
    }
  }
}
    `;

export function usePayWithCreditCardInCartMutation() {
  return Urql.useMutation<PayWithCreditCardInCartMutation, PayWithCreditCardInCartMutationVariables>(PayWithCreditCardInCartDocument);
};
export const ConfirmCreditCardDocument = gql`
    mutation ConfirmCreditCard($input: ConfirmCreditCardInput!) {
  confirmCreditCard(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmCreditCardMutation() {
  return Urql.useMutation<ConfirmCreditCardMutation, ConfirmCreditCardMutationVariables>(ConfirmCreditCardDocument);
};
export const SaveCreditCardDocument = gql`
    mutation SaveCreditCard($cardType: String!, $expirationMonth: Int!, $expirationYear: Int!, $number: String!, $holder: String, $gmoSpecificSaveData: GMOSaveData, $defaultCard: Boolean) {
  saveCreditCard(
    input: {cardType: $cardType, expirationMonth: $expirationMonth, expirationYear: $expirationYear, number: $number, holder: $holder, gmoSpecificSaveData: $gmoSpecificSaveData, defaultCard: $defaultCard}
  ) {
    savedCards {
      ...savedCreditCard
    }
  }
}
    ${SavedCreditCardFragmentDoc}`;

export function useSaveCreditCardMutation() {
  return Urql.useMutation<SaveCreditCardMutation, SaveCreditCardMutationVariables>(SaveCreditCardDocument);
};
export const DeleteCreditCardDocument = gql`
    mutation DeleteCreditCard($cardId: String!) {
  deleteCreditCard(input: {cardId: $cardId}) {
    savedCards {
      ...savedCreditCard
    }
  }
}
    ${SavedCreditCardFragmentDoc}`;

export function useDeleteCreditCardMutation() {
  return Urql.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument);
};
export const StartCreditCardPaymentDocument = gql`
    mutation StartCreditCardPayment($input: StartCreditCardPaymentInput!) {
  startCreditCardPayment(input: $input) {
    ...standardOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}`;

export function useStartCreditCardPaymentMutation() {
  return Urql.useMutation<StartCreditCardPaymentMutation, StartCreditCardPaymentMutationVariables>(StartCreditCardPaymentDocument);
};
export const GmoConfirmCreditCardDocument = gql`
    mutation GmoConfirmCreditCard($input: GmoConfirmCreditCardInput!) {
  gmoConfirmCreditCard(input: $input) {
    ...standardOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}`;

export function useGmoConfirmCreditCardMutation() {
  return Urql.useMutation<GmoConfirmCreditCardMutation, GmoConfirmCreditCardMutationVariables>(GmoConfirmCreditCardDocument);
};
export const PlaceOrderDocument = gql`
    mutation PlaceOrder($input: PlaceOrderInput!) {
  placeOrder(input: $input) {
    order {
      orderNo
      status
      subTotal
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      orderNo
      taxTotal
      estimatedTotal
      status
      products {
        ...productCartItemFields
      }
      ...orderConfirmationFields
      ...orderPaymentInstrumentFields
    }
  }
}
    ${ProductCartItemFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}`;

export function usePlaceOrderMutation() {
  return Urql.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(PlaceOrderDocument);
};
export const PayWithGiftCardDocument = gql`
    mutation PayWithGiftCard($input: GiftCardInput!) {
  giftCard(input: $input) {
    orderNo
    status
    subTotal
    orderAdjustments {
      promotionId
      itemText
      price
      couponCode
    }
    shippingAdjustments {
      promotionId
      itemText
      price
      couponCode
    }
    orderNo
    taxTotal
    estimatedTotal
    status
    products {
      ...productCartItemFields
    }
    ...orderConfirmationFields
    ...orderPaymentInstrumentFields
  }
}
    ${ProductCartItemFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}`;

export function usePayWithGiftCardMutation() {
  return Urql.useMutation<PayWithGiftCardMutation, PayWithGiftCardMutationVariables>(PayWithGiftCardDocument);
};
export const PayWithGooglePayDocument = gql`
    mutation PayWithGooglePay($input: GooglePayInput!) {
  googlePay(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function usePayWithGooglePayMutation() {
  return Urql.useMutation<PayWithGooglePayMutation, PayWithGooglePayMutationVariables>(PayWithGooglePayDocument);
};
export const CancelGooglePayDocument = gql`
    mutation CancelGooglePay($input: CancelGooglePayInput!) {
  cancelGooglePay(input: $input) {
    id
  }
}
    `;

export function useCancelGooglePayMutation() {
  return Urql.useMutation<CancelGooglePayMutation, CancelGooglePayMutationVariables>(CancelGooglePayDocument);
};
export const PayWithPayPalDocument = gql`
    mutation PayWithPayPal($input: PayPalInput!) {
  payPal(input: $input) {
    token
    url
    action
    orderNo
  }
}
    `;

export function usePayWithPayPalMutation() {
  return Urql.useMutation<PayWithPayPalMutation, PayWithPayPalMutationVariables>(PayWithPayPalDocument);
};
export const ConfirmPayPalDocument = gql`
    mutation ConfirmPayPal($input: ConfirmPayPalInput!) {
  confirmPayPal(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmPayPalMutation() {
  return Urql.useMutation<ConfirmPayPalMutation, ConfirmPayPalMutationVariables>(ConfirmPayPalDocument);
};
export const UpdatePayPalDocument = gql`
    mutation UpdatePayPal($input: ConfirmPayPalInput!) {
  updatePayPal(input: $input) {
    subTotal
    shippingCosts
    shippingSurcharge {
      amount
      label
      tooltip
    }
    orderAdjustments {
      promotionId
      itemText
      price
      couponCode
    }
    shippingAdjustments {
      promotionId
      itemText
      price
      couponCode
    }
    orderNo
    taxTotal
    taxation
    estimatedTotal
    status
    orderStatus {
      code
      label
    }
    createdAt
    products {
      ...productCartItemFields
    }
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${ProductCartItemFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useUpdatePayPalMutation() {
  return Urql.useMutation<UpdatePayPalMutation, UpdatePayPalMutationVariables>(UpdatePayPalDocument);
};
export const PayWithPayPayDocument = gql`
    mutation PayWithPayPay($input: PayPayInput!) {
  payPay(input: $input) {
    url
    orderNo
  }
}
    `;

export function usePayWithPayPayMutation() {
  return Urql.useMutation<PayWithPayPayMutation, PayWithPayPayMutationVariables>(PayWithPayPayDocument);
};
export const ConfirmPayPayDocument = gql`
    mutation ConfirmPayPay($input: ConfirmPayPayInput!) {
  confirmPayPay(input: $input) {
    orderNo
    status
    ...orderPaymentInstrumentFields
    ...orderConfirmationFields
  }
}
    ${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmPayPayMutation() {
  return Urql.useMutation<ConfirmPayPayMutation, ConfirmPayPayMutationVariables>(ConfirmPayPayDocument);
};
export const PayWithPayPayInCartDocument = gql`
    mutation PayWithPayPayInCart($input: AddPayPayToCartInput!) {
  addPayPayPaymentMethodToCart(input: $input) {
    ... on Cart {
      id
      estimatedTotal
      amountRemaining
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      paymentInstruments {
        ... on CreditCard {
          id
          amount
          __typename
        }
      }
    }
  }
}
    `;

export function usePayWithPayPayInCartMutation() {
  return Urql.useMutation<PayWithPayPayInCartMutation, PayWithPayPayInCartMutationVariables>(PayWithPayPayInCartDocument);
};
export const PayWithPayTmDocument = gql`
    mutation PayWithPayTm($basketId: String!) {
  payTm(basketId: $basketId) {
    orderNo
    url
  }
}
    `;

export function usePayWithPayTmMutation() {
  return Urql.useMutation<PayWithPayTmMutation, PayWithPayTmMutationVariables>(PayWithPayTmDocument);
};
export const ConfirmPayTmDocument = gql`
    mutation ConfirmPayTm($orderNo: String!) {
  confirmPayTm(orderNo: $orderNo) {
    orderNo
    ...orderConfirmationFields
  }
}
    ${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmPayTmMutation() {
  return Urql.useMutation<ConfirmPayTmMutation, ConfirmPayTmMutationVariables>(ConfirmPayTmDocument);
};
export const StartRazorPayDocument = gql`
    mutation StartRazorPay($input: StartRazorPayInput!) {
  startRazorPay(input: $input) {
    razorPayOrderId
    order {
      orderNo
    }
  }
}
    `;

export function useStartRazorPayMutation() {
  return Urql.useMutation<StartRazorPayMutation, StartRazorPayMutationVariables>(StartRazorPayDocument);
};
export const ConfirmRazorPayDocument = gql`
    mutation ConfirmRazorPay($input: ConfirmRazorPayInput!) {
  confirmRazorPay(input: $input) {
    order {
      orderNo
    }
  }
}
    `;

export function useConfirmRazorPayMutation() {
  return Urql.useMutation<ConfirmRazorPayMutation, ConfirmRazorPayMutationVariables>(ConfirmRazorPayDocument);
};
export const PayWithWalletDocument = gql`
    mutation PayWithWallet($input: WalletInput!) {
  wallet(input: $input) {
    url
    orderNo
  }
}
    `;

export function usePayWithWalletMutation() {
  return Urql.useMutation<PayWithWalletMutation, PayWithWalletMutationVariables>(PayWithWalletDocument);
};
export const ConfirmWalletDocument = gql`
    mutation ConfirmWallet($orderNo: String!) {
  confirmWallet(orderNo: $orderNo) {
    orderNo
    ...orderConfirmationFields
  }
}
    ${OrderConfirmationFieldsFragmentDoc}`;

export function useConfirmWalletMutation() {
  return Urql.useMutation<ConfirmWalletMutation, ConfirmWalletMutationVariables>(ConfirmWalletDocument);
};
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $phoneNumber: String, $birthday: String, $gender: String) {
  updateProfile(
    input: {firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, phoneNumber: $phoneNumber, birthday: $birthday, gender: $gender}
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

export function useUpdateProfileMutation() {
  return Urql.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument);
};
export const RegisterDocument = gql`
    mutation Register($firstName: String!, $lastName: String!, $firstNamePronunciation: String, $lastNamePronunciation: String, $birthday: String, $email: String!, $password: String!, $inflowCode: String, $orderNo: String, $phoneNo: String, $otpVerifyToken: String) {
  register(
    input: {firstName: $firstName, lastName: $lastName, firstNamePronunciation: $firstNamePronunciation, lastNamePronunciation: $lastNamePronunciation, birthday: $birthday, email: $email, password: $password, inflowCode: $inflowCode, orderNo: $orderNo, phoneNumber: $phoneNo, otpVerifyToken: $otpVerifyToken}
  ) {
    ...authPayload
  }
}
    ${AuthPayloadFragmentDoc}`;

export function useRegisterMutation() {
  return Urql.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument);
};
export const CreateReviewDocument = gql`
    mutation CreateReview($input: ReviewInput!) {
  createReview(input: $input) {
    id
    nickname
    email
    isRecommended
    date
    location
    rating
    title
    text
    pros
    cons
    prosInputted
    consInputted
    aspects {
      width
      comfort
      size
    }
    helpfulVotes
    preview
    terms
    notification
  }
}
    `;

export function useCreateReviewMutation() {
  return Urql.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument);
};
export const TrackAppLinkClickDocument = gql`
    mutation TrackAppLinkClick($link: String!) {
  trackUserEvent(input: {event: ON_APP_LINK_CLICK, payload: {link: $link}})
}
    `;

export function useTrackAppLinkClickMutation() {
  return Urql.useMutation<TrackAppLinkClickMutation, TrackAppLinkClickMutationVariables>(TrackAppLinkClickDocument);
};
export const TrackLanguageChangeDocument = gql`
    mutation TrackLanguageChange($language: String!) {
  trackUserEvent(
    input: {event: ON_LANGUAGE_CHANGE, payload: {language: $language}}
  )
}
    `;

export function useTrackLanguageChangeMutation() {
  return Urql.useMutation<TrackLanguageChangeMutation, TrackLanguageChangeMutationVariables>(TrackLanguageChangeDocument);
};
export const TrackLiveChatStartDocument = gql`
    mutation TrackLiveChatStart($email: String, $firstName: String, $lastName: String) {
  trackUserEvent(
    input: {event: ON_LIVE_CHAT_START, payload: {email: $email, firstName: $firstName, lastName: $lastName}}
  )
}
    `;

export function useTrackLiveChatStartMutation() {
  return Urql.useMutation<TrackLiveChatStartMutation, TrackLiveChatStartMutationVariables>(TrackLiveChatStartDocument);
};
export const TrackOrderConfirmationDocument = gql`
    mutation TrackOrderConfirmation($cartProducts: [UserEventTrackingCartProduct!]!, $email: String, $orderNo: String!) {
  trackUserEvent(
    input: {event: ON_ORDER_CONFIRMATION, payload: {cartProducts: $cartProducts, email: $email, orderNo: $orderNo}}
  )
}
    `;

export function useTrackOrderConfirmationMutation() {
  return Urql.useMutation<TrackOrderConfirmationMutation, TrackOrderConfirmationMutationVariables>(TrackOrderConfirmationDocument);
};
export const TrackRecommendationClickDocument = gql`
    mutation TrackRecommendationClick($masterId: String!, $swatch: String!, $recommenderId: String!, $recommenderName: String!) {
  trackUserEvent(
    input: {event: ON_RECOMMENDATION_CLICK, payload: {masterId: $masterId, swatch: $swatch, recommenderId: $recommenderId, recommenderName: $recommenderName}}
  )
}
    `;

export function useTrackRecommendationClickMutation() {
  return Urql.useMutation<TrackRecommendationClickMutation, TrackRecommendationClickMutationVariables>(TrackRecommendationClickDocument);
};
export const TrackProductViewDocument = gql`
    mutation TrackProductView($masterId: String!) {
  trackUserEvent(input: {event: ON_PRODUCT_VIEW, payload: {masterId: $masterId}})
}
    `;

export function useTrackProductViewMutation() {
  return Urql.useMutation<TrackProductViewMutation, TrackProductViewMutationVariables>(TrackProductViewDocument);
};
export const AddItemToWishListDocument = gql`
    mutation AddItemToWishList($input: AddItemToWishListInput!) {
  addItemToWishList(input: $input) {
    ...wishListFields
  }
}
    ${WishListFieldsFragmentDoc}`;

export function useAddItemToWishListMutation() {
  return Urql.useMutation<AddItemToWishListMutation, AddItemToWishListMutationVariables>(AddItemToWishListDocument);
};
export const UpdateItemInWishListDocument = gql`
    mutation UpdateItemInWishList($input: UpdateItemInWishListInput!) {
  updateItemInWishList(input: $input) {
    ...wishListFields
  }
}
    ${WishListFieldsFragmentDoc}`;

export function useUpdateItemInWishListMutation() {
  return Urql.useMutation<UpdateItemInWishListMutation, UpdateItemInWishListMutationVariables>(UpdateItemInWishListDocument);
};
export const RemoveItemFromWishListDocument = gql`
    mutation RemoveItemFromWishList($input: RemoveItemFromWishListInput!) {
  removeItemFromWishList(input: $input)
}
    `;

export function useRemoveItemFromWishListMutation() {
  return Urql.useMutation<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>(RemoveItemFromWishListDocument);
};
export const AddressDocument = gql`
    query Address($id: ID!) {
  address(id: $id) {
    ...addressFields
  }
}
    ${AddressFieldsFragmentDoc}`;

export function useAddressQuery(options: Omit<Urql.UseQueryArgs<AddressQueryVariables>, 'query'>) {
  return Urql.useQuery<AddressQuery, AddressQueryVariables>({ query: AddressDocument, ...options });
};
export const AfterPayConfigDocument = gql`
    query AfterPayConfig {
  afterPayConfig {
    min
    max
  }
}
    `;

export function useAfterPayConfigQuery(options?: Omit<Urql.UseQueryArgs<AfterPayConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<AfterPayConfigQuery, AfterPayConfigQueryVariables>({ query: AfterPayConfigDocument, ...options });
};
export const AllCustomerGroupsDocument = gql`
    query AllCustomerGroups {
  allCustomerGroups
}
    `;

export function useAllCustomerGroupsQuery(options?: Omit<Urql.UseQueryArgs<AllCustomerGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCustomerGroupsQuery, AllCustomerGroupsQueryVariables>({ query: AllCustomerGroupsDocument, ...options });
};
export const CheckAmbassadorCardBalanceDocument = gql`
    query CheckAmbassadorCardBalance($paymentInstrumentId: String, $cardNumber: String, $pin: String!) {
  checkAmbassadorBalance(
    paymentInstrumentId: $paymentInstrumentId
    cardNumber: $cardNumber
    pin: $pin
  )
}
    `;

export function useCheckAmbassadorCardBalanceQuery(options: Omit<Urql.UseQueryArgs<CheckAmbassadorCardBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckAmbassadorCardBalanceQuery, CheckAmbassadorCardBalanceQueryVariables>({ query: CheckAmbassadorCardBalanceDocument, ...options });
};
export const CartDocument = gql`
    query Cart {
  activeCart {
    ...cartFields
    availablePaymentMethods {
      ...availablePaymentMethodsFields
    }
    isMixedCartAllowed
  }
}
    ${CartFieldsFragmentDoc}
${AvailablePaymentMethodsFieldsFragmentDoc}`;

export function useCartQuery(options?: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'>) {
  return Urql.useQuery<CartQuery, CartQueryVariables>({ query: CartDocument, ...options });
};
export const CategoryByIdDocument = gql`
    query CategoryById($id: String!) {
  categoryById(id: $id) {
    ...category
    parentCategory {
      ...category
      parentCategory {
        ...category
        parentCategory {
          ...category
          parentCategory {
            ...category
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}`;

export function useCategoryByIdQuery(options: Omit<Urql.UseQueryArgs<CategoryByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryByIdQuery, CategoryByIdQueryVariables>({ query: CategoryByIdDocument, ...options });
};
export const CategorySizeChartDocument = gql`
    query CategorySizeChart($id: String!) {
  categoryById(id: $id) {
    id
    sizeCharts {
      id
      name
      body
    }
  }
}
    `;

export function useCategorySizeChartQuery(options: Omit<Urql.UseQueryArgs<CategorySizeChartQueryVariables>, 'query'>) {
  return Urql.useQuery<CategorySizeChartQuery, CategorySizeChartQueryVariables>({ query: CategorySizeChartDocument, ...options });
};
export const MainFooterMinimalDocument = gql`
    query MainFooterMinimal($isDraft: String) {
  mainFooter(isDraft: $isDraft) {
    id
    minimalLinks {
      ...ctaFields
    }
  }
}
    ${CtaFieldsFragmentDoc}`;

export function useMainFooterMinimalQuery(options?: Omit<Urql.UseQueryArgs<MainFooterMinimalQueryVariables>, 'query'>) {
  return Urql.useQuery<MainFooterMinimalQuery, MainFooterMinimalQueryVariables>({ query: MainFooterMinimalDocument, ...options });
};
export const MainFooterDocument = gql`
    query MainFooter($isDraft: String) {
  mainFooter(isDraft: $isDraft) {
    id
    supportLinks {
      ...ctaFields
    }
    aboutLinks {
      ...ctaFields
    }
    legalLinks {
      ...ctaFields
    }
    signUpForm {
      ...signUpFormFields
    }
    signUpForms {
      ...signUpFormFields
    }
  }
}
    ${CtaFieldsFragmentDoc}
${SignUpFormFieldsFragmentDoc}`;

export function useMainFooterQuery(options?: Omit<Urql.UseQueryArgs<MainFooterQueryVariables>, 'query'>) {
  return Urql.useQuery<MainFooterQuery, MainFooterQueryVariables>({ query: MainFooterDocument, ...options });
};
export const FrontendConfigurationDocument = gql`
    query FrontendConfiguration {
  frontendConfiguration {
    featureFlags {
      afterPayEnabled
      applePayEnabled
      googlePayEnabled
      giftCardEnabled
      amazonPayEnabled
      payPayEnabled
      googleAddressLookupEnabled
      klarnaEnabled
      googleReversePostalCodeLookup
      myCustomizerEnabled
      nestedOrdersEnabled
      payPalEnabled
      pincodeServiceabilityEnabled
      ratingsAndReviewsEnabled
      addressResumeInCheckoutEnabled
      simplifiedAddressResumeInCheckoutEnabled
      useSavedCardsEnabled
      myAccountOrderDetailsContactInfoEnabled
      myAccountOrderDetailsBillingInfoEnabled
      additionalPriceTextForSaleEnabled
      returnOrderEnabled
      myAccountEditPasswordShowAdditionalCancelButtonEnabled
      myAccountEditPasswordUseLabelInsteadOfPlaceholderEnabled
      myAccountDashboardMembershipSectionEnabled
      createAccountInCheckoutEnabled
      showUserRegistrationOnCheckoutEnabled
      saveAddressCheckboxEnabled
      cartSummaryPromoCodeExpandedOnMobile
      myAccountLeaveResetPasswordConfirmPopupOpenEnabled
      showSaleBadgeOnProductImageEnabled
      desiredDeliveryDateEnabled
      autoShowNewsletterPopupEnabled
      showProductKeywordsEnabled
      scShowCartAbandonmentModalEnabled
      miniCartSeparateViewAndCheckoutButtons
      otpLoginEnabled
      registerOTPVerificationEnabled
      phoneInProfileEnabled
      myAccountShowAdditionalFieldsInEditEnabled
      priceWithDataEnabled
      showOnlyOrderableSizesEnabled
      myAccountHideNotificationSettingsInDashboard
      myAccountHideNewsletterSettingsInDashboard
      collapsableOrderDetailsIsCollapsedOnLoad
      simplifiedGoogleShoppingPdpEnabled
      showDynamicTaxMessage
      hideYourSavings
      paymentPromotionEnabled
      showDiscountAmountAndTextEnabled
      promoCodeAccordionIsExpandedByDefault
      opluxEnabled
      outfitsEnabled
      storeCreditsEnabled
    }
    environment {
      webInMaintenanceMode
      abTestingScript
      adyenClientKey
      adyenEnv
      adyenPayPalIntent
      adyenPayPalMerchantId
      adyenStatusUrl
      afterpaySDKSource
      bazaarVoiceReviewFormScriptUrl
      bazaarVoiceReviewFormScriptUrl
      bloomreachAccountId
      bloomreachSEOAccountId
      branchKey
      configureIdApiKey
      configureIdScriptUrl
      fitAnalyticsOrderConfirmationUrl
      fitAnalyticsPdpUrl
      googleApiKey
      googleOptimizeContainerId
      googleTagManagerId
      freshChatToken
      freshChatHost
      idMeClientId
      klarnaDataClientId
      klarnaScriptUrl
      myCustomizerDomain
      myCustomizerShopId
      pixleeApiKey
      radialFingerprint
      radialStoreId
      returnUrl
      sanityDataset
      sanitySiteId
      sanityProjectId
      storeRocketId
      styliticsUsername
      forterSiteId
      gmoShopId
      gmoSource
      emarsysSignupURL
      emplifiTurnToSite
      payPayReloadCount
      payPayRetryWaitingTime
      amazonPayMerchantId
      amazonPayClientId
      amazonPayScope
      amazonPayMode
      amazonPayButtonSize
      amazonPayButtonColor
      amazonPayPublicKeyId
      amazonPayStoreId
      oneTrustApiKey
      googlePayEnvironment
      googlePayPaymentGateway
      googlePayPaymentGatewayMerchantId
      googlePayMerchantId
      googlePayMerchantName
      sanitySiteId
      dynamicYieldStaticUrl
      dynamicYieldDynamicUrl
      razorPaySdkKey
      yottaaScriptUrl
    }
    siteConfig {
      freeShippingThreshold
      maxDaysForReturn
      scheduledFreeShippingThresholds {
        availableFrom
        availableTo
        threshold
      }
      deliveryDateDays {
        endDeliveryDateDay
        startDeliveryDateDay
      }
    }
  }
}
    `;

export function useFrontendConfigurationQuery(options?: Omit<Urql.UseQueryArgs<FrontendConfigurationQueryVariables>, 'query'>) {
  return Urql.useQuery<FrontendConfigurationQuery, FrontendConfigurationQueryVariables>({ query: FrontendConfigurationDocument, ...options });
};
export const CheckGiftCardBalanceDocument = gql`
    query CheckGiftCardBalance($cardNumber: String!, $pin: String!, $countryCode: String) {
  checkGiftCardBalance(
    cardNumber: $cardNumber
    pin: $pin
    countryCode: $countryCode
  )
}
    `;

export function useCheckGiftCardBalanceQuery(options: Omit<Urql.UseQueryArgs<CheckGiftCardBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckGiftCardBalanceQuery, CheckGiftCardBalanceQueryVariables>({ query: CheckGiftCardBalanceDocument, ...options });
};
export const GiftCardDocument = gql`
    query GiftCard {
  giftCard {
    id
    name
    valueOptions
    defaultValue
    image
  }
}
    `;

export function useGiftCardQuery(options?: Omit<Urql.UseQueryArgs<GiftCardQueryVariables>, 'query'>) {
  return Urql.useQuery<GiftCardQuery, GiftCardQueryVariables>({ query: GiftCardDocument, ...options });
};
export const GlossaryPageDocument = gql`
    query GlossaryPage($slug: String!) {
  glossaryPage(slug: $slug) {
    categories {
      label
      value
    }
    headerBackgroundImage {
      ...sanityImageFields
    }
    headerIntroduction
    id
    puid
    seo {
      pageDescription
      pageTitle
    }
    terms {
      categories
      definition
      id
      puid
      image {
        ...sanityImageFields
      }
      mediaType
      term
      video {
        ...sanityVideoFields
      }
    }
    title
    url
  }
}
    ${SanityImageFieldsFragmentDoc}
${SanityVideoFieldsFragmentDoc}`;

export function useGlossaryPageQuery(options: Omit<Urql.UseQueryArgs<GlossaryPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GlossaryPageQuery, GlossaryPageQueryVariables>({ query: GlossaryPageDocument, ...options });
};
export const InventoryDocument = gql`
    query Inventory($id: ID!) {
  inventory(id: $id) {
    id
    quantity
    limitedAvailability
  }
}
    `;

export function useInventoryQuery(options: Omit<Urql.UseQueryArgs<InventoryQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryQuery, InventoryQueryVariables>({ query: InventoryDocument, ...options });
};
export const WishListTotalsDocument = gql`
    query WishListTotals {
  wishList {
    id
    items {
      id
      quantity
    }
  }
}
    `;

export function useWishListTotalsQuery(options?: Omit<Urql.UseQueryArgs<WishListTotalsQueryVariables>, 'query'>) {
  return Urql.useQuery<WishListTotalsQuery, WishListTotalsQueryVariables>({ query: WishListTotalsDocument, ...options });
};
export const MeDocument = gql`
    query Me($includeAddresses: Boolean = false, $includeOrders: Boolean = false, $includeAmbassadorCards: Boolean = false, $includeSavedCards: Boolean = false, $includeGroups: Boolean = false, $includeNewsletter: Boolean = false, $includeStoreCredit: Boolean = false) {
  me {
    ...userFields
    newsletterSubscription @include(if: $includeNewsletter) {
      firstName
      lastName
      firstNamePronunciation
      lastNamePronunciation
      email
      gender
      memberId
      dob {
        day
        month
        year
      }
      emailPreference
      shoppingPreference
      iframeURL
      isConfirmed
    }
    addresses @include(if: $includeAddresses) {
      ...addressFields
    }
    orders(limit: 5) @include(if: $includeOrders) {
      nodes {
        ...orderPreviewFields
      }
    }
    ambassadorCards @include(if: $includeAmbassadorCards) {
      ...ambassadorCardFields
    }
    savedCards @include(if: $includeSavedCards) {
      ...savedCreditCard
    }
    storeCredit @include(if: $includeStoreCredit) {
      ...storeCreditFields
    }
    groups @include(if: $includeGroups)
  }
}
    ${UserFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${OrderPreviewFieldsFragmentDoc}
${AmbassadorCardFieldsFragmentDoc}
${SavedCreditCardFragmentDoc}
${StoreCreditFieldsFragmentDoc}`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};
export const NotificationPreferencesDocument = gql`
    query NotificationPreferences {
  notificationsPreferences {
    phoneNumber
    marketingSmsOptIn
    customerSmsOptIn
  }
}
    `;

export function useNotificationPreferencesQuery(options?: Omit<Urql.UseQueryArgs<NotificationPreferencesQueryVariables>, 'query'>) {
  return Urql.useQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>({ query: NotificationPreferencesDocument, ...options });
};
export const OrderDocument = gql`
    query Order($orderNo: String!, $includeProductAnalyticsDetails: Boolean = false) {
  order(orderNo: $orderNo) {
    ... on StandardOrder {
      subTotal
      shippingCosts
      shippingSurcharge {
        amount
        label
        tooltip
      }
      orderAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      shippingAdjustments {
        promotionId
        itemText
        price
        couponCode
      }
      couponItems {
        code
        couponItemId
        statusCode
        valid
      }
      orderNo
      taxTotal
      taxation
      estimatedTotal
      promoDiscountValue
      revenue @include(if: $includeProductAnalyticsDetails)
      orderStatus {
        code
        label
      }
      __typename
      refundInformation
      createdAt
      products {
        ...productCartItemFields
        ...productCartItemAnalyticsDimensionsFields @include(if: $includeProductAnalyticsDetails)
      }
      ...orderPaymentInstrumentFields
      ...orderConfirmationFields
      payPayAsyncResultNoticed
    }
  }
}
    ${ProductCartItemFieldsFragmentDoc}
${ProductCartItemAnalyticsDimensionsFieldsFragmentDoc}
${OrderPaymentInstrumentFieldsFragmentDoc}
${OrderConfirmationFieldsFragmentDoc}`;

export function useOrderQuery(options: Omit<Urql.UseQueryArgs<OrderQueryVariables>, 'query'>) {
  return Urql.useQuery<OrderQuery, OrderQueryVariables>({ query: OrderDocument, ...options });
};
export const OrderDetailsDocument = gql`
    query OrderDetails($orderNo: String!) {
  order(orderNo: $orderNo) {
    ...standardOrderDetailsFields
    ...nestedOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}
${NestedOrderDetailsFieldsFragmentDoc}`;

export function useOrderDetailsQuery(options: Omit<Urql.UseQueryArgs<OrderDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrderDetailsQuery, OrderDetailsQueryVariables>({ query: OrderDetailsDocument, ...options });
};
export const OrderHistoryMeDocument = gql`
    query OrderHistoryMe($from: String, $until: String, $offset: Int, $limit: Int) {
  me {
    ...userFields
    addresses {
      ...addressFields
    }
    orders(from: $from, until: $until, offset: $offset, limit: $limit) {
      nodes {
        ...orderPreviewFields
      }
      pageInfo {
        offset
        nextOffset
        totalCount
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${OrderPreviewFieldsFragmentDoc}`;

export function useOrderHistoryMeQuery(options?: Omit<Urql.UseQueryArgs<OrderHistoryMeQueryVariables>, 'query'>) {
  return Urql.useQuery<OrderHistoryMeQuery, OrderHistoryMeQueryVariables>({ query: OrderHistoryMeDocument, ...options });
};
export const SearchOrderByPhoneDocument = gql`
    query SearchOrderByPhone($orderNo: String!, $phone: String!) {
  searchOrderByPhone(orderNo: $orderNo, phone: $phone) {
    ...standardOrderDetailsFields
    ...nestedOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}
${NestedOrderDetailsFieldsFragmentDoc}`;

export function useSearchOrderByPhoneQuery(options: Omit<Urql.UseQueryArgs<SearchOrderByPhoneQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchOrderByPhoneQuery, SearchOrderByPhoneQueryVariables>({ query: SearchOrderByPhoneDocument, ...options });
};
export const SearchOrderByEmailPostcodeDocument = gql`
    query SearchOrderByEmailPostcode($orderNo: String!, $email: String!, $postcode: String!) {
  searchOrderByEmailPostcode(
    orderNo: $orderNo
    email: $email
    postcode: $postcode
  ) {
    ...standardOrderDetailsFields
    ...nestedOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}
${NestedOrderDetailsFieldsFragmentDoc}`;

export function useSearchOrderByEmailPostcodeQuery(options: Omit<Urql.UseQueryArgs<SearchOrderByEmailPostcodeQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchOrderByEmailPostcodeQuery, SearchOrderByEmailPostcodeQueryVariables>({ query: SearchOrderByEmailPostcodeDocument, ...options });
};
export const SearchOrderByEmailDocument = gql`
    query SearchOrderByEmail($orderNo: String!, $email: String!) {
  searchOrderByEmail(orderNo: $orderNo, email: $email) {
    ...standardOrderDetailsFields
    ...nestedOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}
${NestedOrderDetailsFieldsFragmentDoc}`;

export function useSearchOrderByEmailQuery(options: Omit<Urql.UseQueryArgs<SearchOrderByEmailQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchOrderByEmailQuery, SearchOrderByEmailQueryVariables>({ query: SearchOrderByEmailDocument, ...options });
};
export const SearchOrderByEmailPhoneDocument = gql`
    query SearchOrderByEmailPhone($orderNo: String!, $phone: String!, $email: String!) {
  searchOrderByEmailPhone(orderNo: $orderNo, phone: $phone, email: $email) {
    ...standardOrderDetailsFields
    ...nestedOrderDetailsFields
  }
}
    ${StandardOrderDetailsFieldsFragmentDoc}
${NestedOrderDetailsFieldsFragmentDoc}`;

export function useSearchOrderByEmailPhoneQuery(options: Omit<Urql.UseQueryArgs<SearchOrderByEmailPhoneQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchOrderByEmailPhoneQuery, SearchOrderByEmailPhoneQueryVariables>({ query: SearchOrderByEmailPhoneDocument, ...options });
};
export const OutfitsDocument = gql`
    query Outfits($tags: String!) {
  outfits(tags: $tags) {
    id
    image {
      href
      coverImageHref
      alt
    }
    products {
      ...product
      coords {
        x
        y
        z
        height
        width
      }
      replacements {
        ...product
      }
    }
  }
}
    ${ProductFragmentDoc}`;

export function useOutfitsQuery(options: Omit<Urql.UseQueryArgs<OutfitsQueryVariables>, 'query'>) {
  return Urql.useQuery<OutfitsQuery, OutfitsQueryVariables>({ query: OutfitsDocument, ...options });
};
export const GetAmazonPayCustomerInfoDocument = gql`
    query getAmazonPayCustomerInfo($amazonPayToken: String!) {
  getAmazonPayCustomerInfo(amazonPayToken: $amazonPayToken) {
    userEmail
    registeredWithAmazon
  }
}
    `;

export function useGetAmazonPayCustomerInfoQuery(options: Omit<Urql.UseQueryArgs<GetAmazonPayCustomerInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAmazonPayCustomerInfoQuery, GetAmazonPayCustomerInfoQueryVariables>({ query: GetAmazonPayCustomerInfoDocument, ...options });
};
export const GetPayPayContentDocument = gql`
    query getPayPayContent($assetId: String!) {
  getPayPayContent(assetId: $assetId) {
    id
    name
    body
  }
}
    `;

export function useGetPayPayContentQuery(options: Omit<Urql.UseQueryArgs<GetPayPayContentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPayPayContentQuery, GetPayPayContentQueryVariables>({ query: GetPayPayContentDocument, ...options });
};
export const PincodeDocument = gql`
    query Pincode($pincode: String!) {
  pincode(pincode: $pincode) {
    expectedDate
    city
    stateCode
  }
}
    `;

export function usePincodeQuery(options: Omit<Urql.UseQueryArgs<PincodeQueryVariables>, 'query'>) {
  return Urql.useQuery<PincodeQuery, PincodeQueryVariables>({ query: PincodeDocument, ...options });
};
export const PixleeConfigDocument = gql`
    query PixleeConfig {
  pixleeConfig {
    id
    enable
    enablePDPGallery
    socialMediaIcon
    numberPicturesGallery
  }
}
    `;

export function usePixleeConfigQuery(options?: Omit<Urql.UseQueryArgs<PixleeConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<PixleeConfigQuery, PixleeConfigQueryVariables>({ query: PixleeConfigDocument, ...options });
};
export const UserGeneratedContentDocument = gql`
    query UserGeneratedContent($productId: ID!) {
  userGeneratedContentForWeb(productId: $productId) {
    source
    pixleeCdnPhotos {
      squareMediumUrl
    }
    altText
  }
}
    `;

export function useUserGeneratedContentQuery(options: Omit<Urql.UseQueryArgs<UserGeneratedContentQueryVariables>, 'query'>) {
  return Urql.useQuery<UserGeneratedContentQuery, UserGeneratedContentQueryVariables>({ query: UserGeneratedContentDocument, ...options });
};
export const CategoryPlpDocument = gql`
    query CategoryPLP($url: String!, $isDraft: String, $sort: String, $filters: [FilterInputOption!]!, $expansions: [ProductSearchExpansion!], $includeCategoryMetadata: Boolean = true, $offset: Int!, $limit: Int!, $preview: PreviewInput) {
  categoryByUrl(url: $url, preview: $preview) {
    id
    name
    url
    ...category @include(if: $includeCategoryMetadata)
    description @include(if: $includeCategoryMetadata)
    products(
      input: {sort: $sort, filters: $filters, limit: $limit, offset: $offset, expansions: $expansions, includeCategoryMetadata: $includeCategoryMetadata, isDraft: $isDraft}
    ) {
      ...PaginatedOutputNodesFragment
      ...PaginatedOutputMetadataFragment @include(if: $includeCategoryMetadata)
    }
    seo @include(if: $includeCategoryMetadata) {
      pageTitle
      pageDescription
    }
    parentCategory {
      ...category
      parentCategory {
        ...category
        parentCategory {
          ...category
          parentCategory {
            ...category
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${PaginatedOutputNodesFragmentFragmentDoc}
${PaginatedOutputMetadataFragmentFragmentDoc}`;

export function useCategoryPlpQuery(options: Omit<Urql.UseQueryArgs<CategoryPlpQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryPlpQuery, CategoryPlpQueryVariables>({ query: CategoryPlpDocument, ...options });
};
export const VariantsDocument = gql`
    query Variants($input: VariantsInput!, $includeComparisonFields: Boolean = false) {
  variants(input: $input) {
    __typename
    id
    masterId
    productPrice {
      price
      salePrice
      promotionPrice
      isSalePriceElapsed
    }
    percentageDiscountBadge
    name
    header
    subHeader
    orderable
    colorValue
    displayOutOfStock {
      displayValue
    }
    images {
      href
      alt
    }
    technology @include(if: $includeComparisonFields)
    runTerrain @include(if: $includeComparisonFields)
    weight @include(if: $includeComparisonFields)
    heelToToeDrop @include(if: $includeComparisonFields)
    fastener @include(if: $includeComparisonFields)
    pronation @include(if: $includeComparisonFields)
    refinementCushioningLevel @include(if: $includeComparisonFields)
    runnerType @include(if: $includeComparisonFields)
    mainMaterial @include(if: $includeComparisonFields)
    cupType @include(if: $includeComparisonFields)
    trouserRise @include(if: $includeComparisonFields)
    pocketType @include(if: $includeComparisonFields)
    apparelLength @include(if: $includeComparisonFields)
    characteristics @include(if: $includeComparisonFields)
    supportLevelBra @include(if: $includeComparisonFields)
    studs @include(if: $includeComparisonFields)
    playerLevel @include(if: $includeComparisonFields)
    fit @include(if: $includeComparisonFields)
  }
}
    `;

export function useVariantsQuery(options: Omit<Urql.UseQueryArgs<VariantsQueryVariables>, 'query'>) {
  return Urql.useQuery<VariantsQuery, VariantsQueryVariables>({ query: VariantsDocument, ...options });
};
export const SiblingVariantsDocument = gql`
    query SiblingVariants($input: SiblingVariantsInput!) {
  siblingVariants(input: $input) {
    ...mandatoryVariantFields
    badges {
      id
      label
    }
    percentageDiscountBadge
    salePrice
    productPrice {
      price
      salePrice
      promotionPrice
      isSalePriceElapsed
    }
    displayOutOfStock {
      soldout
      soldoutWithRecommender
      comingsoon
      backsoon
      presale
      displayValue
    }
    orderable
    promotions(page: ProductListingPage) {
      id
      calloutMessage
    }
    isAppExclusive
    appOnlyDateTimeFrom
    appOnlyDateTimeTo
  }
}
    ${MandatoryVariantFieldsFragmentDoc}`;

export function useSiblingVariantsQuery(options: Omit<Urql.UseQueryArgs<SiblingVariantsQueryVariables>, 'query'>) {
  return Urql.useQuery<SiblingVariantsQuery, SiblingVariantsQueryVariables>({ query: SiblingVariantsDocument, ...options });
};
export const VariantDocument = gql`
    query Variant($id: ID!) {
  variant(id: $id) {
    id
    masterId
    name
    colorValue
    styleNumber
    size {
      value
    }
  }
}
    `;

export function useVariantQuery(options: Omit<Urql.UseQueryArgs<VariantQueryVariables>, 'query'>) {
  return Urql.useQuery<VariantQuery, VariantQueryVariables>({ query: VariantDocument, ...options });
};
export const ProductDocument = gql`
    query Product($id: ID!) {
  product(id: $id) {
    id
    name
    header
    subHeader
    orderable
    displayOutOfStock {
      displayValue
    }
    variations {
      id
      name
      colorValue
      colorName
      preview
      price
      salePrice
      productPrice {
        price
        salePrice
        promotionPrice
      }
      orderable
      sizeGroups {
        label
        description
        sizes {
          id
          label
          value
          productId
          orderable
          maxOrderableQuantity
        }
      }
      displayOutOfStock {
        soldout
        soldoutWithRecommender
        comingsoon
        backsoon
        presale
        displayValue
        validTo
      }
      images {
        href
        alt
      }
    }
  }
}
    `;

export function useProductQuery(options: Omit<Urql.UseQueryArgs<ProductQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductQuery, ProductQueryVariables>({ query: ProductDocument, ...options });
};
export const PdpDocument = gql`
    query PDP($id: ID!, $viewAt: String) {
  product(id: $id) {
    ...mandatoryMasterFields
    productNameTranslated
    description
    primaryCategoryId
    productDivision
    brand
    sizeChartId
    promotions(page: ProductDetailsPage) {
      id
      calloutMessage
    }
    promotion {
      id
      calloutMessage
    }
    configureID {
      enabled
      productID
    }
    productStory {
      longDescription
      careInstructions
      productKeywords
    }
    productVideos
    verticalProductVideos
    promotionExclusion
    exploreMoreCTALabel
    showExploreCollectionCTA
    exploreMoreCTATargetCategoryID
    brand
    orderable
    badge
    ...sizes
    fitOptions {
      label
      masterProduct {
        id
        name
        variations {
          id
          colorValue
          orderable
        }
      }
    }
    variations {
      ...pdpMandatoryVariantFields
      isFinalSale
      returnRuleID
      promotionExclusion
      specialMessage(viewAt: $viewAt)
      ean
      validUntil
      isAppExclusive
      badges {
        id
        label
      }
      percentageDiscountBadge
      salePrice
      productPrice {
        price
        salePrice
        promotionPrice
        isSalePriceElapsed
      }
      styleNumber
      materialComposition
      displayOutOfStock {
        soldout
        soldoutWithRecommender
        comingsoon
        backsoon
        presale
        displayValue
        validTo
      }
      orderable
      modelMeasurementText
      manufacturerInfo {
        manufacturerAddress {
          label
          content
        }
        countryOfOrigin {
          label
          content
        }
      }
      myCustomizer {
        enabled
        iframeID
        startPoint
      }
      configureID {
        enabled
        productID
      }
      taxDisplayMsg
      promotions(page: ProductDetailsPage) {
        id
        calloutMessage
      }
      appOnlyDateTimeFrom
      appOnlyDateTimeTo
    }
  }
}
    ${MandatoryMasterFieldsFragmentDoc}
${SizesFragmentDoc}
${PdpMandatoryVariantFieldsFragmentDoc}`;

export function usePdpQuery(options: Omit<Urql.UseQueryArgs<PdpQueryVariables>, 'query'>) {
  return Urql.useQuery<PdpQuery, PdpQueryVariables>({ query: PdpDocument, ...options });
};
export const LazyPdpDocument = gql`
    query LazyPDP($id: ID!) {
  product(id: $id) {
    id
    variations {
      ...pdpMandatoryExtraVariantFields
      description
      productStory {
        longDescription
        materialComposition
        careInstructions
        manufacturerInfo {
          manufacturerAddress {
            label
            content
          }
          countryOfOrigin {
            label
            content
          }
        }
        productKeywords
      }
    }
  }
}
    ${PdpMandatoryExtraVariantFieldsFragmentDoc}`;

export function useLazyPdpQuery(options: Omit<Urql.UseQueryArgs<LazyPdpQueryVariables>, 'query'>) {
  return Urql.useQuery<LazyPdpQuery, LazyPdpQueryVariables>({ query: LazyPdpDocument, ...options });
};
export const ProductSizeChartDocument = gql`
    query ProductSizeChart($id: [ID!]!) {
  sizeCharts(ids: $id) {
    id
    name
    body
  }
}
    `;

export function useProductSizeChartQuery(options: Omit<Urql.UseQueryArgs<ProductSizeChartQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSizeChartQuery, ProductSizeChartQueryVariables>({ query: ProductSizeChartDocument, ...options });
};
export const ProductScoreDocument = gql`
    query ProductScore($id: ID!, $offset: Int = 0, $limit: Int = 5, $sort: String = "newest", $search: String = "", $includeReviews: Boolean! = true) {
  productScore(id: $id) {
    id
    amount
    rating
    reviews(offset: $offset, limit: $limit, sort: $sort, search: $search) @include(if: $includeReviews) {
      nodes {
        id
        rating
        title
        text
        nickname
        date
      }
    }
  }
}
    `;

export function useProductScoreQuery(options: Omit<Urql.UseQueryArgs<ProductScoreQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductScoreQuery, ProductScoreQueryVariables>({ query: ProductScoreDocument, ...options });
};
export const RecommendationsWithDetailsDocument = gql`
    query RecommendationsWithDetails($pageType: String!, $ids: [ID!]) {
  recommendationsWithDetails(pageType: $pageType, ids: $ids) {
    recommenderId
    recommenderName
    recommendations {
      ...recommendationFields
    }
  }
}
    ${RecommendationFieldsFragmentDoc}`;

export function useRecommendationsWithDetailsQuery(options: Omit<Urql.UseQueryArgs<RecommendationsWithDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<RecommendationsWithDetailsQuery, RecommendationsWithDetailsQueryVariables>({ query: RecommendationsWithDetailsDocument, ...options });
};
export const ProductReviewsDocument = gql`
    query ProductReviews($id: ID!, $offset: Int, $limit: Int, $sort: String, $search: String) {
  productScore(id: $id) {
    id
    amount
    rating
    reviews(offset: $offset, limit: $limit, sort: $sort, search: $search) {
      nodes {
        ...ReviewFields
      }
      pageInfo {
        totalCount
      }
    }
    summary {
      ...ReviewSummaryFields
    }
  }
}
    ${ReviewFieldsFragmentDoc}
${ReviewSummaryFieldsFragmentDoc}`;

export function useProductReviewsQuery(options: Omit<Urql.UseQueryArgs<ProductReviewsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductReviewsQuery, ProductReviewsQueryVariables>({ query: ProductReviewsDocument, ...options });
};
export const TrendingSearchTermsDocument = gql`
    query TrendingSearchTerms {
  trendingSearchTerms {
    searchTerm
    rank
  }
}
    `;

export function useTrendingSearchTermsQuery(options?: Omit<Urql.UseQueryArgs<TrendingSearchTermsQueryVariables>, 'query'>) {
  return Urql.useQuery<TrendingSearchTermsQuery, TrendingSearchTermsQueryVariables>({ query: TrendingSearchTermsDocument, ...options });
};
export const SearchRecommendedProductsDocument = gql`
    query SearchRecommendedProducts {
  searchFlyoutRecommendedProducts {
    __typename
    id
    variantProduct {
      id
      masterId
      colorValue
      name
      header
      subHeader
      productPrice {
        price
        salePrice
      }
      images {
        alt
        href
      }
    }
  }
}
    `;

export function useSearchRecommendedProductsQuery(options?: Omit<Urql.UseQueryArgs<SearchRecommendedProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchRecommendedProductsQuery, SearchRecommendedProductsQueryVariables>({ query: SearchRecommendedProductsDocument, ...options });
};
export const ProductSearchDocument = gql`
    query ProductSearch($q: String, $sort: String, $filters: [FilterInputOption!]!, $expansions: [ProductSearchExpansion!], $includeSearchMetadata: Boolean = true, $offset: Int!, $limit: Int!) {
  search(
    input: {q: $q, sort: $sort, filters: $filters, limit: $limit, offset: $offset, expansions: $expansions, includeSearchMetadata: $includeSearchMetadata}
  ) {
    __typename
    ...PaginatedOutputNodesFragment
    ...PaginatedOutputMetadataFragment @include(if: $includeSearchMetadata)
  }
}
    ${PaginatedOutputNodesFragmentFragmentDoc}
${PaginatedOutputMetadataFragmentFragmentDoc}`;

export function useProductSearchQuery(options: Omit<Urql.UseQueryArgs<ProductSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSearchQuery, ProductSearchQueryVariables>({ query: ProductSearchDocument, ...options });
};
export const LookDocument = gql`
    query Look($id: ID!) {
  look(id: $id) {
    id
    products {
      ...product
      coords {
        x
        y
        z
        height
        width
      }
      replacements {
        ...product
      }
    }
  }
}
    ${ProductFragmentDoc}`;

export function useLookQuery(options: Omit<Urql.UseQueryArgs<LookQueryVariables>, 'query'>) {
  return Urql.useQuery<LookQuery, LookQueryVariables>({ query: LookDocument, ...options });
};
export const SuggestionsDocument = gql`
    query Suggestions($searchTerm: String!, $preview: PreviewInput) {
  suggestions(searchTerm: $searchTerm, preview: $preview) {
    suggestedProductsSummaries {
      id
      masterId
      colorValue
      name
      header
      subHeader
      images {
        href
        alt
      }
      price
      salePrice
      isSalePriceElapsed
    }
    suggestedTerms {
      suggestion
      original
    }
    suggestedPhrases {
      suggestion
    }
    suggestedRedirect
  }
}
    `;

export function useSuggestionsQuery(options: Omit<Urql.UseQueryArgs<SuggestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<SuggestionsQuery, SuggestionsQueryVariables>({ query: SuggestionsDocument, ...options });
};
export const TermsAndConditionsConfigsDocument = gql`
    query TermsAndConditionsConfigs($isDraft: String) {
  termsAndConditionsConfigs(isDraft: $isDraft) {
    id
    tacOnCartPage {
      ...termsAndConditionsFields
    }
    tacOnItemAddedPopup {
      ...termsAndConditionsFields
    }
    tacOnCheckoutSignInArea {
      ...termsAndConditionsFields
    }
    tacOnCheckoutConfirmation {
      ...termsAndConditionsFields
    }
    tacOnCheckoutAddress {
      ...termsAndConditionsFields
    }
    tacOnCreateAccount {
      ...termsAndConditionsFields
    }
    tacOnCheckoutPayment {
      ...termsAndConditionsFields
    }
    showAbove
  }
}
    ${TermsAndConditionsFieldsFragmentDoc}`;

export function useTermsAndConditionsConfigsQuery(options?: Omit<Urql.UseQueryArgs<TermsAndConditionsConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<TermsAndConditionsConfigsQuery, TermsAndConditionsConfigsQueryVariables>({ query: TermsAndConditionsConfigsDocument, ...options });
};
export const UrlRedirectDocument = gql`
    query UrlRedirect($path: String!) {
  urlRedirectV2(path: $path) {
    availableFrom
    availableTo
    redirectType
    url
  }
}
    `;

export function useUrlRedirectQuery(options: Omit<Urql.UseQueryArgs<UrlRedirectQueryVariables>, 'query'>) {
  return Urql.useQuery<UrlRedirectQuery, UrlRedirectQueryVariables>({ query: UrlRedirectDocument, ...options });
};
export const WishListDocument = gql`
    query WishList {
  wishList {
    ...wishListFields
  }
}
    ${WishListFieldsFragmentDoc}`;

export function useWishListQuery(options?: Omit<Urql.UseQueryArgs<WishListQueryVariables>, 'query'>) {
  return Urql.useQuery<WishListQuery, WishListQueryVariables>({ query: WishListDocument, ...options });
};

























































































































































export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    GuestLogon(variables?: GuestLogonMutationVariables, options?: C): Promise<GuestLogonMutation> {
      return requester<GuestLogonMutation, GuestLogonMutationVariables>(Operations.GuestLogonDocument, variables, options) as Promise<GuestLogonMutation>;
    },
    RefreshLogon(variables: RefreshLogonMutationVariables, options?: C): Promise<RefreshLogonMutation> {
      return requester<RefreshLogonMutation, RefreshLogonMutationVariables>(Operations.RefreshLogonDocument, variables, options) as Promise<RefreshLogonMutation>;
    },
    UpdatePassword(variables: UpdatePasswordMutationVariables, options?: C): Promise<UpdatePasswordMutation> {
      return requester<UpdatePasswordMutation, UpdatePasswordMutationVariables>(Operations.UpdatePasswordDocument, variables, options) as Promise<UpdatePasswordMutation>;
    },
    UpdatePhone(variables: UpdatePhoneMutationVariables, options?: C): Promise<UpdatePhoneMutation> {
      return requester<UpdatePhoneMutation, UpdatePhoneMutationVariables>(Operations.UpdatePhoneDocument, variables, options) as Promise<UpdatePhoneMutation>;
    },
    ConfirmUpdatePhone(variables: ConfirmUpdatePhoneMutationVariables, options?: C): Promise<ConfirmUpdatePhoneMutation> {
      return requester<ConfirmUpdatePhoneMutation, ConfirmUpdatePhoneMutationVariables>(Operations.ConfirmUpdatePhoneDocument, variables, options) as Promise<ConfirmUpdatePhoneMutation>;
    },
    ResetPassword(variables: ResetPasswordMutationVariables, options?: C): Promise<ResetPasswordMutation> {
      return requester<ResetPasswordMutation, ResetPasswordMutationVariables>(Operations.ResetPasswordDocument, variables, options) as Promise<ResetPasswordMutation>;
    },
    CompleteResetPassword(variables: CompleteResetPasswordMutationVariables, options?: C): Promise<CompleteResetPasswordMutation> {
      return requester<CompleteResetPasswordMutation, CompleteResetPasswordMutationVariables>(Operations.CompleteResetPasswordDocument, variables, options) as Promise<CompleteResetPasswordMutation>;
    },
    CreateShopperContext(variables: CreateShopperContextMutationVariables, options?: C): Promise<CreateShopperContextMutation> {
      return requester<CreateShopperContextMutation, CreateShopperContextMutationVariables>(Operations.CreateShopperContextDocument, variables, options) as Promise<CreateShopperContextMutation>;
    },
    VerifyUserAffiliations(variables: VerifyUserAffiliationsMutationVariables, options?: C): Promise<VerifyUserAffiliationsMutation> {
      return requester<VerifyUserAffiliationsMutation, VerifyUserAffiliationsMutationVariables>(Operations.VerifyUserAffiliationsDocument, variables, options) as Promise<VerifyUserAffiliationsMutation>;
    },
    AddAddress(variables: AddAddressMutationVariables, options?: C): Promise<AddAddressMutation> {
      return requester<AddAddressMutation, AddAddressMutationVariables>(Operations.AddAddressDocument, variables, options) as Promise<AddAddressMutation>;
    },
    UpdateAddress(variables: UpdateAddressMutationVariables, options?: C): Promise<UpdateAddressMutation> {
      return requester<UpdateAddressMutation, UpdateAddressMutationVariables>(Operations.UpdateAddressDocument, variables, options) as Promise<UpdateAddressMutation>;
    },
    DeleteAddress(variables: DeleteAddressMutationVariables, options?: C): Promise<DeleteAddressMutation> {
      return requester<DeleteAddressMutation, DeleteAddressMutationVariables>(Operations.DeleteAddressDocument, variables, options) as Promise<DeleteAddressMutation>;
    },
    SaveAmbassadorCard(variables: SaveAmbassadorCardMutationVariables, options?: C): Promise<SaveAmbassadorCardMutation> {
      return requester<SaveAmbassadorCardMutation, SaveAmbassadorCardMutationVariables>(Operations.SaveAmbassadorCardDocument, variables, options) as Promise<SaveAmbassadorCardMutation>;
    },
    DeleteAmbassadorCard(variables: DeleteAmbassadorCardMutationVariables, options?: C): Promise<DeleteAmbassadorCardMutation> {
      return requester<DeleteAmbassadorCardMutation, DeleteAmbassadorCardMutationVariables>(Operations.DeleteAmbassadorCardDocument, variables, options) as Promise<DeleteAmbassadorCardMutation>;
    },
    UpdateAmbassadorCards(variables: UpdateAmbassadorCardsMutationVariables, options?: C): Promise<UpdateAmbassadorCardsMutation> {
      return requester<UpdateAmbassadorCardsMutation, UpdateAmbassadorCardsMutationVariables>(Operations.UpdateAmbassadorCardsDocument, variables, options) as Promise<UpdateAmbassadorCardsMutation>;
    },
    AddItemsToCart(variables: AddItemsToCartMutationVariables, options?: C): Promise<AddItemsToCartMutation> {
      return requester<AddItemsToCartMutation, AddItemsToCartMutationVariables>(Operations.AddItemsToCartDocument, variables, options) as Promise<AddItemsToCartMutation>;
    },
    UpdateItemInCart(variables: UpdateItemInCartMutationVariables, options?: C): Promise<UpdateItemInCartMutation> {
      return requester<UpdateItemInCartMutation, UpdateItemInCartMutationVariables>(Operations.UpdateItemInCartDocument, variables, options) as Promise<UpdateItemInCartMutation>;
    },
    RemoveItemFromCart(variables: RemoveItemFromCartMutationVariables, options?: C): Promise<RemoveItemFromCartMutation> {
      return requester<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(Operations.RemoveItemFromCartDocument, variables, options) as Promise<RemoveItemFromCartMutation>;
    },
    AddGiftCardToCart(variables: AddGiftCardToCartMutationVariables, options?: C): Promise<AddGiftCardToCartMutation> {
      return requester<AddGiftCardToCartMutation, AddGiftCardToCartMutationVariables>(Operations.AddGiftCardToCartDocument, variables, options) as Promise<AddGiftCardToCartMutation>;
    },
    RemoveGiftCardFromCart(variables: RemoveGiftCardFromCartMutationVariables, options?: C): Promise<RemoveGiftCardFromCartMutation> {
      return requester<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>(Operations.RemoveGiftCardFromCartDocument, variables, options) as Promise<RemoveGiftCardFromCartMutation>;
    },
    AddGiftCard(variables: AddGiftCardMutationVariables, options?: C): Promise<AddGiftCardMutation> {
      return requester<AddGiftCardMutation, AddGiftCardMutationVariables>(Operations.AddGiftCardDocument, variables, options) as Promise<AddGiftCardMutation>;
    },
    RemoveGiftCard(variables: RemoveGiftCardMutationVariables, options?: C): Promise<RemoveGiftCardMutation> {
      return requester<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>(Operations.RemoveGiftCardDocument, variables, options) as Promise<RemoveGiftCardMutation>;
    },
    UpdateShippingAddress(variables: UpdateShippingAddressMutationVariables, options?: C): Promise<UpdateShippingAddressMutation> {
      return requester<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>(Operations.UpdateShippingAddressDocument, variables, options) as Promise<UpdateShippingAddressMutation>;
    },
    UpdateShipmentMethod(variables: UpdateShipmentMethodMutationVariables, options?: C): Promise<UpdateShipmentMethodMutation> {
      return requester<UpdateShipmentMethodMutation, UpdateShipmentMethodMutationVariables>(Operations.UpdateShipmentMethodDocument, variables, options) as Promise<UpdateShipmentMethodMutation>;
    },
    UpdateBillingAddress(variables: UpdateBillingAddressMutationVariables, options?: C): Promise<UpdateBillingAddressMutation> {
      return requester<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>(Operations.UpdateBillingAddressDocument, variables, options) as Promise<UpdateBillingAddressMutation>;
    },
    RemoveCouponFromCart(variables: RemoveCouponFromCartMutationVariables, options?: C): Promise<RemoveCouponFromCartMutation> {
      return requester<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(Operations.RemoveCouponFromCartDocument, variables, options) as Promise<RemoveCouponFromCartMutation>;
    },
    AddCouponToCart(variables: AddCouponToCartMutationVariables, options?: C): Promise<AddCouponToCartMutation> {
      return requester<AddCouponToCartMutation, AddCouponToCartMutationVariables>(Operations.AddCouponToCartDocument, variables, options) as Promise<AddCouponToCartMutation>;
    },
    AddPaymentPromotion(variables: AddPaymentPromotionMutationVariables, options?: C): Promise<AddPaymentPromotionMutation> {
      return requester<AddPaymentPromotionMutation, AddPaymentPromotionMutationVariables>(Operations.AddPaymentPromotionDocument, variables, options) as Promise<AddPaymentPromotionMutation>;
    },
    AddAmbassadorCardToCart(variables: AddAmbassadorCardToCartMutationVariables, options?: C): Promise<AddAmbassadorCardToCartMutation> {
      return requester<AddAmbassadorCardToCartMutation, AddAmbassadorCardToCartMutationVariables>(Operations.AddAmbassadorCardToCartDocument, variables, options) as Promise<AddAmbassadorCardToCartMutation>;
    },
    RemoveAmbassadorCardFromCart(variables: RemoveAmbassadorCardFromCartMutationVariables, options?: C): Promise<RemoveAmbassadorCardFromCartMutation> {
      return requester<RemoveAmbassadorCardFromCartMutation, RemoveAmbassadorCardFromCartMutationVariables>(Operations.RemoveAmbassadorCardFromCartDocument, variables, options) as Promise<RemoveAmbassadorCardFromCartMutation>;
    },
    AddStoreCredits(variables: AddStoreCreditsMutationVariables, options?: C): Promise<AddStoreCreditsMutation> {
      return requester<AddStoreCreditsMutation, AddStoreCreditsMutationVariables>(Operations.AddStoreCreditsDocument, variables, options) as Promise<AddStoreCreditsMutation>;
    },
    RemoveStoreCredits(variables: RemoveStoreCreditsMutationVariables, options?: C): Promise<RemoveStoreCreditsMutation> {
      return requester<RemoveStoreCreditsMutation, RemoveStoreCreditsMutationVariables>(Operations.RemoveStoreCreditsDocument, variables, options) as Promise<RemoveStoreCreditsMutation>;
    },
    UpdateContact(variables: UpdateContactMutationVariables, options?: C): Promise<UpdateContactMutation> {
      return requester<UpdateContactMutation, UpdateContactMutationVariables>(Operations.UpdateContactDocument, variables, options) as Promise<UpdateContactMutation>;
    },
    Klarna(variables: KlarnaMutationVariables, options?: C): Promise<KlarnaMutation> {
      return requester<KlarnaMutation, KlarnaMutationVariables>(Operations.KlarnaDocument, variables, options) as Promise<KlarnaMutation>;
    },
    ConfirmKlarna(variables: ConfirmKlarnaMutationVariables, options?: C): Promise<ConfirmKlarnaMutation> {
      return requester<ConfirmKlarnaMutation, ConfirmKlarnaMutationVariables>(Operations.ConfirmKlarnaDocument, variables, options) as Promise<ConfirmKlarnaMutation>;
    },
    CancelKlarna(variables: CancelKlarnaMutationVariables, options?: C): Promise<CancelKlarnaMutation> {
      return requester<CancelKlarnaMutation, CancelKlarnaMutationVariables>(Operations.CancelKlarnaDocument, variables, options) as Promise<CancelKlarnaMutation>;
    },
    startKlarnaPayment(variables: StartKlarnaPaymentMutationVariables, options?: C): Promise<StartKlarnaPaymentMutation> {
      return requester<StartKlarnaPaymentMutation, StartKlarnaPaymentMutationVariables>(Operations.StartKlarnaPaymentDocument, variables, options) as Promise<StartKlarnaPaymentMutation>;
    },
    confirmKlarnaPayment(variables: ConfirmKlarnaPaymentMutationVariables, options?: C): Promise<ConfirmKlarnaPaymentMutation> {
      return requester<ConfirmKlarnaPaymentMutation, ConfirmKlarnaPaymentMutationVariables>(Operations.ConfirmKlarnaPaymentDocument, variables, options) as Promise<ConfirmKlarnaPaymentMutation>;
    },
    LoginWithEmailAndPassword(variables: LoginWithEmailAndPasswordMutationVariables, options?: C): Promise<LoginWithEmailAndPasswordMutation> {
      return requester<LoginWithEmailAndPasswordMutation, LoginWithEmailAndPasswordMutationVariables>(Operations.LoginWithEmailAndPasswordDocument, variables, options) as Promise<LoginWithEmailAndPasswordMutation>;
    },
    VerifyLoginWithOTP(variables: VerifyLoginWithOtpMutationVariables, options?: C): Promise<VerifyLoginWithOtpMutation> {
      return requester<VerifyLoginWithOtpMutation, VerifyLoginWithOtpMutationVariables>(Operations.VerifyLoginWithOtpDocument, variables, options) as Promise<VerifyLoginWithOtpMutation>;
    },
    LoginWithOTP(variables: LoginWithOtpMutationVariables, options?: C): Promise<LoginWithOtpMutation> {
      return requester<LoginWithOtpMutation, LoginWithOtpMutationVariables>(Operations.LoginWithOtpDocument, variables, options) as Promise<LoginWithOtpMutation>;
    },
    LoginWithPhone(variables: LoginWithPhoneMutationVariables, options?: C): Promise<LoginWithPhoneMutation> {
      return requester<LoginWithPhoneMutation, LoginWithPhoneMutationVariables>(Operations.LoginWithPhoneDocument, variables, options) as Promise<LoginWithPhoneMutation>;
    },
    ResendOTP(variables: ResendOtpMutationVariables, options?: C): Promise<ResendOtpMutation> {
      return requester<ResendOtpMutation, ResendOtpMutationVariables>(Operations.ResendOtpDocument, variables, options) as Promise<ResendOtpMutation>;
    },
    Logout(variables?: LogoutMutationVariables, options?: C): Promise<LogoutMutation> {
      return requester<LogoutMutation, LogoutMutationVariables>(Operations.LogoutDocument, variables, options) as Promise<LogoutMutation>;
    },
    ManageCustomerLevelNotification(variables: ManageCustomerLevelNotificationMutationVariables, options?: C): Promise<ManageCustomerLevelNotificationMutation> {
      return requester<ManageCustomerLevelNotificationMutation, ManageCustomerLevelNotificationMutationVariables>(Operations.ManageCustomerLevelNotificationDocument, variables, options) as Promise<ManageCustomerLevelNotificationMutation>;
    },
    SaveNotificationPreferences(variables: SaveNotificationPreferencesMutationVariables, options?: C): Promise<SaveNotificationPreferencesMutation> {
      return requester<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>(Operations.SaveNotificationPreferencesDocument, variables, options) as Promise<SaveNotificationPreferencesMutation>;
    },
    ManageOrderLevelNotification(variables: ManageOrderLevelNotificationMutationVariables, options?: C): Promise<ManageOrderLevelNotificationMutation> {
      return requester<ManageOrderLevelNotificationMutation, ManageOrderLevelNotificationMutationVariables>(Operations.ManageOrderLevelNotificationDocument, variables, options) as Promise<ManageOrderLevelNotificationMutation>;
    },
    CreateContact(variables: CreateContactMutationVariables, options?: C): Promise<CreateContactMutation> {
      return requester<CreateContactMutation, CreateContactMutationVariables>(Operations.CreateContactDocument, variables, options) as Promise<CreateContactMutation>;
    },
    OpluxFraudDetection(variables: OpluxFraudDetectionMutationVariables, options?: C): Promise<OpluxFraudDetectionMutation> {
      return requester<OpluxFraudDetectionMutation, OpluxFraudDetectionMutationVariables>(Operations.OpluxFraudDetectionDocument, variables, options) as Promise<OpluxFraudDetectionMutation>;
    },
    StartAdyenPayment(variables: StartAdyenPaymentMutationVariables, options?: C): Promise<StartAdyenPaymentMutation> {
      return requester<StartAdyenPaymentMutation, StartAdyenPaymentMutationVariables>(Operations.StartAdyenPaymentDocument, variables, options) as Promise<StartAdyenPaymentMutation>;
    },
    CompleteAdyenPayment(variables: CompleteAdyenPaymentMutationVariables, options?: C): Promise<CompleteAdyenPaymentMutation> {
      return requester<CompleteAdyenPaymentMutation, CompleteAdyenPaymentMutationVariables>(Operations.CompleteAdyenPaymentDocument, variables, options) as Promise<CompleteAdyenPaymentMutation>;
    },
    PayWithAfterPay(variables: PayWithAfterPayMutationVariables, options?: C): Promise<PayWithAfterPayMutation> {
      return requester<PayWithAfterPayMutation, PayWithAfterPayMutationVariables>(Operations.PayWithAfterPayDocument, variables, options) as Promise<PayWithAfterPayMutation>;
    },
    ConfirmAfterPay(variables: ConfirmAfterPayMutationVariables, options?: C): Promise<ConfirmAfterPayMutation> {
      return requester<ConfirmAfterPayMutation, ConfirmAfterPayMutationVariables>(Operations.ConfirmAfterPayDocument, variables, options) as Promise<ConfirmAfterPayMutation>;
    },
    AmazonPayPaymentDescriptor(variables: AmazonPayPaymentDescriptorQueryVariables, options?: C): Promise<AmazonPayPaymentDescriptorQuery> {
      return requester<AmazonPayPaymentDescriptorQuery, AmazonPayPaymentDescriptorQueryVariables>(Operations.AmazonPayPaymentDescriptorDocument, variables, options) as Promise<AmazonPayPaymentDescriptorQuery>;
    },
    SignAmazonPayload(variables: SignAmazonPayloadMutationVariables, options?: C): Promise<SignAmazonPayloadMutation> {
      return requester<SignAmazonPayloadMutation, SignAmazonPayloadMutationVariables>(Operations.SignAmazonPayloadDocument, variables, options) as Promise<SignAmazonPayloadMutation>;
    },
    StartAmazonPayment(variables: StartAmazonPaymentMutationVariables, options?: C): Promise<StartAmazonPaymentMutation> {
      return requester<StartAmazonPaymentMutation, StartAmazonPaymentMutationVariables>(Operations.StartAmazonPaymentDocument, variables, options) as Promise<StartAmazonPaymentMutation>;
    },
    StartAmazonProcessOrderPayment(variables: StartAmazonProcessOrderPaymentMutationVariables, options?: C): Promise<StartAmazonProcessOrderPaymentMutation> {
      return requester<StartAmazonProcessOrderPaymentMutation, StartAmazonProcessOrderPaymentMutationVariables>(Operations.StartAmazonProcessOrderPaymentDocument, variables, options) as Promise<StartAmazonProcessOrderPaymentMutation>;
    },
    CompleteAmazonPayment(variables: CompleteAmazonPaymentMutationVariables, options?: C): Promise<CompleteAmazonPaymentMutation> {
      return requester<CompleteAmazonPaymentMutation, CompleteAmazonPaymentMutationVariables>(Operations.CompleteAmazonPaymentDocument, variables, options) as Promise<CompleteAmazonPaymentMutation>;
    },
    RegisterAmazonPayment(variables: RegisterAmazonPaymentMutationVariables, options?: C): Promise<RegisterAmazonPaymentMutation> {
      return requester<RegisterAmazonPaymentMutation, RegisterAmazonPaymentMutationVariables>(Operations.RegisterAmazonPaymentDocument, variables, options) as Promise<RegisterAmazonPaymentMutation>;
    },
    PayWithAmbassadorCard(variables: PayWithAmbassadorCardMutationVariables, options?: C): Promise<PayWithAmbassadorCardMutation> {
      return requester<PayWithAmbassadorCardMutation, PayWithAmbassadorCardMutationVariables>(Operations.PayWithAmbassadorCardDocument, variables, options) as Promise<PayWithAmbassadorCardMutation>;
    },
    PayWithApplePay(variables: PayWithApplePayMutationVariables, options?: C): Promise<PayWithApplePayMutation> {
      return requester<PayWithApplePayMutation, PayWithApplePayMutationVariables>(Operations.PayWithApplePayDocument, variables, options) as Promise<PayWithApplePayMutation>;
    },
    ValidateApplePayMerchant(variables: ValidateApplePayMerchantMutationVariables, options?: C): Promise<ValidateApplePayMerchantMutation> {
      return requester<ValidateApplePayMerchantMutation, ValidateApplePayMerchantMutationVariables>(Operations.ValidateApplePayMerchantDocument, variables, options) as Promise<ValidateApplePayMerchantMutation>;
    },
    ConfirmApplePay(variables: ConfirmApplePayMutationVariables, options?: C): Promise<ConfirmApplePayMutation> {
      return requester<ConfirmApplePayMutation, ConfirmApplePayMutationVariables>(Operations.ConfirmApplePayDocument, variables, options) as Promise<ConfirmApplePayMutation>;
    },
    CancelApplePay(variables: CancelApplePayMutationVariables, options?: C): Promise<CancelApplePayMutation> {
      return requester<CancelApplePayMutation, CancelApplePayMutationVariables>(Operations.CancelApplePayDocument, variables, options) as Promise<CancelApplePayMutation>;
    },
    CancelOrder(variables: CancelOrderMutationVariables, options?: C): Promise<CancelOrderMutation> {
      return requester<CancelOrderMutation, CancelOrderMutationVariables>(Operations.CancelOrderDocument, variables, options) as Promise<CancelOrderMutation>;
    },
    PayWithCashOnDelivery(variables: PayWithCashOnDeliveryMutationVariables, options?: C): Promise<PayWithCashOnDeliveryMutation> {
      return requester<PayWithCashOnDeliveryMutation, PayWithCashOnDeliveryMutationVariables>(Operations.PayWithCashOnDeliveryDocument, variables, options) as Promise<PayWithCashOnDeliveryMutation>;
    },
    PayWithCashOnDeliveryInCart(variables: PayWithCashOnDeliveryInCartMutationVariables, options?: C): Promise<PayWithCashOnDeliveryInCartMutation> {
      return requester<PayWithCashOnDeliveryInCartMutation, PayWithCashOnDeliveryInCartMutationVariables>(Operations.PayWithCashOnDeliveryInCartDocument, variables, options) as Promise<PayWithCashOnDeliveryInCartMutation>;
    },
    ConfirmCashOnDelivery(variables: ConfirmCashOnDeliveryMutationVariables, options?: C): Promise<ConfirmCashOnDeliveryMutation> {
      return requester<ConfirmCashOnDeliveryMutation, ConfirmCashOnDeliveryMutationVariables>(Operations.ConfirmCashOnDeliveryDocument, variables, options) as Promise<ConfirmCashOnDeliveryMutation>;
    },
    PayWithCreditCard(variables: PayWithCreditCardMutationVariables, options?: C): Promise<PayWithCreditCardMutation> {
      return requester<PayWithCreditCardMutation, PayWithCreditCardMutationVariables>(Operations.PayWithCreditCardDocument, variables, options) as Promise<PayWithCreditCardMutation>;
    },
    PayWithCreditCardInCart(variables: PayWithCreditCardInCartMutationVariables, options?: C): Promise<PayWithCreditCardInCartMutation> {
      return requester<PayWithCreditCardInCartMutation, PayWithCreditCardInCartMutationVariables>(Operations.PayWithCreditCardInCartDocument, variables, options) as Promise<PayWithCreditCardInCartMutation>;
    },
    ConfirmCreditCard(variables: ConfirmCreditCardMutationVariables, options?: C): Promise<ConfirmCreditCardMutation> {
      return requester<ConfirmCreditCardMutation, ConfirmCreditCardMutationVariables>(Operations.ConfirmCreditCardDocument, variables, options) as Promise<ConfirmCreditCardMutation>;
    },
    SaveCreditCard(variables: SaveCreditCardMutationVariables, options?: C): Promise<SaveCreditCardMutation> {
      return requester<SaveCreditCardMutation, SaveCreditCardMutationVariables>(Operations.SaveCreditCardDocument, variables, options) as Promise<SaveCreditCardMutation>;
    },
    DeleteCreditCard(variables: DeleteCreditCardMutationVariables, options?: C): Promise<DeleteCreditCardMutation> {
      return requester<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(Operations.DeleteCreditCardDocument, variables, options) as Promise<DeleteCreditCardMutation>;
    },
    StartCreditCardPayment(variables: StartCreditCardPaymentMutationVariables, options?: C): Promise<StartCreditCardPaymentMutation> {
      return requester<StartCreditCardPaymentMutation, StartCreditCardPaymentMutationVariables>(Operations.StartCreditCardPaymentDocument, variables, options) as Promise<StartCreditCardPaymentMutation>;
    },
    GmoConfirmCreditCard(variables: GmoConfirmCreditCardMutationVariables, options?: C): Promise<GmoConfirmCreditCardMutation> {
      return requester<GmoConfirmCreditCardMutation, GmoConfirmCreditCardMutationVariables>(Operations.GmoConfirmCreditCardDocument, variables, options) as Promise<GmoConfirmCreditCardMutation>;
    },
    PlaceOrder(variables: PlaceOrderMutationVariables, options?: C): Promise<PlaceOrderMutation> {
      return requester<PlaceOrderMutation, PlaceOrderMutationVariables>(Operations.PlaceOrderDocument, variables, options) as Promise<PlaceOrderMutation>;
    },
    PayWithGiftCard(variables: PayWithGiftCardMutationVariables, options?: C): Promise<PayWithGiftCardMutation> {
      return requester<PayWithGiftCardMutation, PayWithGiftCardMutationVariables>(Operations.PayWithGiftCardDocument, variables, options) as Promise<PayWithGiftCardMutation>;
    },
    PayWithGooglePay(variables: PayWithGooglePayMutationVariables, options?: C): Promise<PayWithGooglePayMutation> {
      return requester<PayWithGooglePayMutation, PayWithGooglePayMutationVariables>(Operations.PayWithGooglePayDocument, variables, options) as Promise<PayWithGooglePayMutation>;
    },
    CancelGooglePay(variables: CancelGooglePayMutationVariables, options?: C): Promise<CancelGooglePayMutation> {
      return requester<CancelGooglePayMutation, CancelGooglePayMutationVariables>(Operations.CancelGooglePayDocument, variables, options) as Promise<CancelGooglePayMutation>;
    },
    PayWithPayPal(variables: PayWithPayPalMutationVariables, options?: C): Promise<PayWithPayPalMutation> {
      return requester<PayWithPayPalMutation, PayWithPayPalMutationVariables>(Operations.PayWithPayPalDocument, variables, options) as Promise<PayWithPayPalMutation>;
    },
    ConfirmPayPal(variables: ConfirmPayPalMutationVariables, options?: C): Promise<ConfirmPayPalMutation> {
      return requester<ConfirmPayPalMutation, ConfirmPayPalMutationVariables>(Operations.ConfirmPayPalDocument, variables, options) as Promise<ConfirmPayPalMutation>;
    },
    UpdatePayPal(variables: UpdatePayPalMutationVariables, options?: C): Promise<UpdatePayPalMutation> {
      return requester<UpdatePayPalMutation, UpdatePayPalMutationVariables>(Operations.UpdatePayPalDocument, variables, options) as Promise<UpdatePayPalMutation>;
    },
    PayWithPayPay(variables: PayWithPayPayMutationVariables, options?: C): Promise<PayWithPayPayMutation> {
      return requester<PayWithPayPayMutation, PayWithPayPayMutationVariables>(Operations.PayWithPayPayDocument, variables, options) as Promise<PayWithPayPayMutation>;
    },
    ConfirmPayPay(variables: ConfirmPayPayMutationVariables, options?: C): Promise<ConfirmPayPayMutation> {
      return requester<ConfirmPayPayMutation, ConfirmPayPayMutationVariables>(Operations.ConfirmPayPayDocument, variables, options) as Promise<ConfirmPayPayMutation>;
    },
    PayWithPayPayInCart(variables: PayWithPayPayInCartMutationVariables, options?: C): Promise<PayWithPayPayInCartMutation> {
      return requester<PayWithPayPayInCartMutation, PayWithPayPayInCartMutationVariables>(Operations.PayWithPayPayInCartDocument, variables, options) as Promise<PayWithPayPayInCartMutation>;
    },
    PayWithPayTm(variables: PayWithPayTmMutationVariables, options?: C): Promise<PayWithPayTmMutation> {
      return requester<PayWithPayTmMutation, PayWithPayTmMutationVariables>(Operations.PayWithPayTmDocument, variables, options) as Promise<PayWithPayTmMutation>;
    },
    ConfirmPayTm(variables: ConfirmPayTmMutationVariables, options?: C): Promise<ConfirmPayTmMutation> {
      return requester<ConfirmPayTmMutation, ConfirmPayTmMutationVariables>(Operations.ConfirmPayTmDocument, variables, options) as Promise<ConfirmPayTmMutation>;
    },
    StartRazorPay(variables: StartRazorPayMutationVariables, options?: C): Promise<StartRazorPayMutation> {
      return requester<StartRazorPayMutation, StartRazorPayMutationVariables>(Operations.StartRazorPayDocument, variables, options) as Promise<StartRazorPayMutation>;
    },
    ConfirmRazorPay(variables: ConfirmRazorPayMutationVariables, options?: C): Promise<ConfirmRazorPayMutation> {
      return requester<ConfirmRazorPayMutation, ConfirmRazorPayMutationVariables>(Operations.ConfirmRazorPayDocument, variables, options) as Promise<ConfirmRazorPayMutation>;
    },
    PayWithWallet(variables: PayWithWalletMutationVariables, options?: C): Promise<PayWithWalletMutation> {
      return requester<PayWithWalletMutation, PayWithWalletMutationVariables>(Operations.PayWithWalletDocument, variables, options) as Promise<PayWithWalletMutation>;
    },
    ConfirmWallet(variables: ConfirmWalletMutationVariables, options?: C): Promise<ConfirmWalletMutation> {
      return requester<ConfirmWalletMutation, ConfirmWalletMutationVariables>(Operations.ConfirmWalletDocument, variables, options) as Promise<ConfirmWalletMutation>;
    },
    UpdateProfile(variables: UpdateProfileMutationVariables, options?: C): Promise<UpdateProfileMutation> {
      return requester<UpdateProfileMutation, UpdateProfileMutationVariables>(Operations.UpdateProfileDocument, variables, options) as Promise<UpdateProfileMutation>;
    },
    Register(variables: RegisterMutationVariables, options?: C): Promise<RegisterMutation> {
      return requester<RegisterMutation, RegisterMutationVariables>(Operations.RegisterDocument, variables, options) as Promise<RegisterMutation>;
    },
    CreateReview(variables: CreateReviewMutationVariables, options?: C): Promise<CreateReviewMutation> {
      return requester<CreateReviewMutation, CreateReviewMutationVariables>(Operations.CreateReviewDocument, variables, options) as Promise<CreateReviewMutation>;
    },
    TrackAppLinkClick(variables: TrackAppLinkClickMutationVariables, options?: C): Promise<TrackAppLinkClickMutation> {
      return requester<TrackAppLinkClickMutation, TrackAppLinkClickMutationVariables>(Operations.TrackAppLinkClickDocument, variables, options) as Promise<TrackAppLinkClickMutation>;
    },
    TrackLanguageChange(variables: TrackLanguageChangeMutationVariables, options?: C): Promise<TrackLanguageChangeMutation> {
      return requester<TrackLanguageChangeMutation, TrackLanguageChangeMutationVariables>(Operations.TrackLanguageChangeDocument, variables, options) as Promise<TrackLanguageChangeMutation>;
    },
    TrackLiveChatStart(variables?: TrackLiveChatStartMutationVariables, options?: C): Promise<TrackLiveChatStartMutation> {
      return requester<TrackLiveChatStartMutation, TrackLiveChatStartMutationVariables>(Operations.TrackLiveChatStartDocument, variables, options) as Promise<TrackLiveChatStartMutation>;
    },
    TrackOrderConfirmation(variables: TrackOrderConfirmationMutationVariables, options?: C): Promise<TrackOrderConfirmationMutation> {
      return requester<TrackOrderConfirmationMutation, TrackOrderConfirmationMutationVariables>(Operations.TrackOrderConfirmationDocument, variables, options) as Promise<TrackOrderConfirmationMutation>;
    },
    TrackRecommendationClick(variables: TrackRecommendationClickMutationVariables, options?: C): Promise<TrackRecommendationClickMutation> {
      return requester<TrackRecommendationClickMutation, TrackRecommendationClickMutationVariables>(Operations.TrackRecommendationClickDocument, variables, options) as Promise<TrackRecommendationClickMutation>;
    },
    TrackProductView(variables: TrackProductViewMutationVariables, options?: C): Promise<TrackProductViewMutation> {
      return requester<TrackProductViewMutation, TrackProductViewMutationVariables>(Operations.TrackProductViewDocument, variables, options) as Promise<TrackProductViewMutation>;
    },
    AddItemToWishList(variables: AddItemToWishListMutationVariables, options?: C): Promise<AddItemToWishListMutation> {
      return requester<AddItemToWishListMutation, AddItemToWishListMutationVariables>(Operations.AddItemToWishListDocument, variables, options) as Promise<AddItemToWishListMutation>;
    },
    UpdateItemInWishList(variables: UpdateItemInWishListMutationVariables, options?: C): Promise<UpdateItemInWishListMutation> {
      return requester<UpdateItemInWishListMutation, UpdateItemInWishListMutationVariables>(Operations.UpdateItemInWishListDocument, variables, options) as Promise<UpdateItemInWishListMutation>;
    },
    RemoveItemFromWishList(variables: RemoveItemFromWishListMutationVariables, options?: C): Promise<RemoveItemFromWishListMutation> {
      return requester<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>(Operations.RemoveItemFromWishListDocument, variables, options) as Promise<RemoveItemFromWishListMutation>;
    },
    Address(variables: AddressQueryVariables, options?: C): Promise<AddressQuery> {
      return requester<AddressQuery, AddressQueryVariables>(Operations.AddressDocument, variables, options) as Promise<AddressQuery>;
    },
    AfterPayConfig(variables?: AfterPayConfigQueryVariables, options?: C): Promise<AfterPayConfigQuery> {
      return requester<AfterPayConfigQuery, AfterPayConfigQueryVariables>(Operations.AfterPayConfigDocument, variables, options) as Promise<AfterPayConfigQuery>;
    },
    AllCustomerGroups(variables?: AllCustomerGroupsQueryVariables, options?: C): Promise<AllCustomerGroupsQuery> {
      return requester<AllCustomerGroupsQuery, AllCustomerGroupsQueryVariables>(Operations.AllCustomerGroupsDocument, variables, options) as Promise<AllCustomerGroupsQuery>;
    },
    CheckAmbassadorCardBalance(variables: CheckAmbassadorCardBalanceQueryVariables, options?: C): Promise<CheckAmbassadorCardBalanceQuery> {
      return requester<CheckAmbassadorCardBalanceQuery, CheckAmbassadorCardBalanceQueryVariables>(Operations.CheckAmbassadorCardBalanceDocument, variables, options) as Promise<CheckAmbassadorCardBalanceQuery>;
    },
    Cart(variables?: CartQueryVariables, options?: C): Promise<CartQuery> {
      return requester<CartQuery, CartQueryVariables>(Operations.CartDocument, variables, options) as Promise<CartQuery>;
    },
    CategoryById(variables: CategoryByIdQueryVariables, options?: C): Promise<CategoryByIdQuery> {
      return requester<CategoryByIdQuery, CategoryByIdQueryVariables>(Operations.CategoryByIdDocument, variables, options) as Promise<CategoryByIdQuery>;
    },
    CategorySizeChart(variables: CategorySizeChartQueryVariables, options?: C): Promise<CategorySizeChartQuery> {
      return requester<CategorySizeChartQuery, CategorySizeChartQueryVariables>(Operations.CategorySizeChartDocument, variables, options) as Promise<CategorySizeChartQuery>;
    },
    MainFooterMinimal(variables?: MainFooterMinimalQueryVariables, options?: C): Promise<MainFooterMinimalQuery> {
      return requester<MainFooterMinimalQuery, MainFooterMinimalQueryVariables>(Operations.MainFooterMinimalDocument, variables, options) as Promise<MainFooterMinimalQuery>;
    },
    MainFooter(variables?: MainFooterQueryVariables, options?: C): Promise<MainFooterQuery> {
      return requester<MainFooterQuery, MainFooterQueryVariables>(Operations.MainFooterDocument, variables, options) as Promise<MainFooterQuery>;
    },
    FrontendConfiguration(variables?: FrontendConfigurationQueryVariables, options?: C): Promise<FrontendConfigurationQuery> {
      return requester<FrontendConfigurationQuery, FrontendConfigurationQueryVariables>(Operations.FrontendConfigurationDocument, variables, options) as Promise<FrontendConfigurationQuery>;
    },
    CheckGiftCardBalance(variables: CheckGiftCardBalanceQueryVariables, options?: C): Promise<CheckGiftCardBalanceQuery> {
      return requester<CheckGiftCardBalanceQuery, CheckGiftCardBalanceQueryVariables>(Operations.CheckGiftCardBalanceDocument, variables, options) as Promise<CheckGiftCardBalanceQuery>;
    },
    GiftCard(variables?: GiftCardQueryVariables, options?: C): Promise<GiftCardQuery> {
      return requester<GiftCardQuery, GiftCardQueryVariables>(Operations.GiftCardDocument, variables, options) as Promise<GiftCardQuery>;
    },
    GlossaryPage(variables: GlossaryPageQueryVariables, options?: C): Promise<GlossaryPageQuery> {
      return requester<GlossaryPageQuery, GlossaryPageQueryVariables>(Operations.GlossaryPageDocument, variables, options) as Promise<GlossaryPageQuery>;
    },
    Inventory(variables: InventoryQueryVariables, options?: C): Promise<InventoryQuery> {
      return requester<InventoryQuery, InventoryQueryVariables>(Operations.InventoryDocument, variables, options) as Promise<InventoryQuery>;
    },
    WishListTotals(variables?: WishListTotalsQueryVariables, options?: C): Promise<WishListTotalsQuery> {
      return requester<WishListTotalsQuery, WishListTotalsQueryVariables>(Operations.WishListTotalsDocument, variables, options) as Promise<WishListTotalsQuery>;
    },
    Me(variables?: MeQueryVariables, options?: C): Promise<MeQuery> {
      return requester<MeQuery, MeQueryVariables>(Operations.MeDocument, variables, options) as Promise<MeQuery>;
    },
    NotificationPreferences(variables?: NotificationPreferencesQueryVariables, options?: C): Promise<NotificationPreferencesQuery> {
      return requester<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(Operations.NotificationPreferencesDocument, variables, options) as Promise<NotificationPreferencesQuery>;
    },
    Order(variables: OrderQueryVariables, options?: C): Promise<OrderQuery> {
      return requester<OrderQuery, OrderQueryVariables>(Operations.OrderDocument, variables, options) as Promise<OrderQuery>;
    },
    OrderDetails(variables: OrderDetailsQueryVariables, options?: C): Promise<OrderDetailsQuery> {
      return requester<OrderDetailsQuery, OrderDetailsQueryVariables>(Operations.OrderDetailsDocument, variables, options) as Promise<OrderDetailsQuery>;
    },
    OrderHistoryMe(variables?: OrderHistoryMeQueryVariables, options?: C): Promise<OrderHistoryMeQuery> {
      return requester<OrderHistoryMeQuery, OrderHistoryMeQueryVariables>(Operations.OrderHistoryMeDocument, variables, options) as Promise<OrderHistoryMeQuery>;
    },
    SearchOrderByPhone(variables: SearchOrderByPhoneQueryVariables, options?: C): Promise<SearchOrderByPhoneQuery> {
      return requester<SearchOrderByPhoneQuery, SearchOrderByPhoneQueryVariables>(Operations.SearchOrderByPhoneDocument, variables, options) as Promise<SearchOrderByPhoneQuery>;
    },
    SearchOrderByEmailPostcode(variables: SearchOrderByEmailPostcodeQueryVariables, options?: C): Promise<SearchOrderByEmailPostcodeQuery> {
      return requester<SearchOrderByEmailPostcodeQuery, SearchOrderByEmailPostcodeQueryVariables>(Operations.SearchOrderByEmailPostcodeDocument, variables, options) as Promise<SearchOrderByEmailPostcodeQuery>;
    },
    SearchOrderByEmail(variables: SearchOrderByEmailQueryVariables, options?: C): Promise<SearchOrderByEmailQuery> {
      return requester<SearchOrderByEmailQuery, SearchOrderByEmailQueryVariables>(Operations.SearchOrderByEmailDocument, variables, options) as Promise<SearchOrderByEmailQuery>;
    },
    SearchOrderByEmailPhone(variables: SearchOrderByEmailPhoneQueryVariables, options?: C): Promise<SearchOrderByEmailPhoneQuery> {
      return requester<SearchOrderByEmailPhoneQuery, SearchOrderByEmailPhoneQueryVariables>(Operations.SearchOrderByEmailPhoneDocument, variables, options) as Promise<SearchOrderByEmailPhoneQuery>;
    },
    Outfits(variables: OutfitsQueryVariables, options?: C): Promise<OutfitsQuery> {
      return requester<OutfitsQuery, OutfitsQueryVariables>(Operations.OutfitsDocument, variables, options) as Promise<OutfitsQuery>;
    },
    getAmazonPayCustomerInfo(variables: GetAmazonPayCustomerInfoQueryVariables, options?: C): Promise<GetAmazonPayCustomerInfoQuery> {
      return requester<GetAmazonPayCustomerInfoQuery, GetAmazonPayCustomerInfoQueryVariables>(Operations.GetAmazonPayCustomerInfoDocument, variables, options) as Promise<GetAmazonPayCustomerInfoQuery>;
    },
    getPayPayContent(variables: GetPayPayContentQueryVariables, options?: C): Promise<GetPayPayContentQuery> {
      return requester<GetPayPayContentQuery, GetPayPayContentQueryVariables>(Operations.GetPayPayContentDocument, variables, options) as Promise<GetPayPayContentQuery>;
    },
    Pincode(variables: PincodeQueryVariables, options?: C): Promise<PincodeQuery> {
      return requester<PincodeQuery, PincodeQueryVariables>(Operations.PincodeDocument, variables, options) as Promise<PincodeQuery>;
    },
    PixleeConfig(variables?: PixleeConfigQueryVariables, options?: C): Promise<PixleeConfigQuery> {
      return requester<PixleeConfigQuery, PixleeConfigQueryVariables>(Operations.PixleeConfigDocument, variables, options) as Promise<PixleeConfigQuery>;
    },
    UserGeneratedContent(variables: UserGeneratedContentQueryVariables, options?: C): Promise<UserGeneratedContentQuery> {
      return requester<UserGeneratedContentQuery, UserGeneratedContentQueryVariables>(Operations.UserGeneratedContentDocument, variables, options) as Promise<UserGeneratedContentQuery>;
    },
    CategoryPLP(variables: CategoryPlpQueryVariables, options?: C): Promise<CategoryPlpQuery> {
      return requester<CategoryPlpQuery, CategoryPlpQueryVariables>(Operations.CategoryPlpDocument, variables, options) as Promise<CategoryPlpQuery>;
    },
    Variants(variables: VariantsQueryVariables, options?: C): Promise<VariantsQuery> {
      return requester<VariantsQuery, VariantsQueryVariables>(Operations.VariantsDocument, variables, options) as Promise<VariantsQuery>;
    },
    SiblingVariants(variables: SiblingVariantsQueryVariables, options?: C): Promise<SiblingVariantsQuery> {
      return requester<SiblingVariantsQuery, SiblingVariantsQueryVariables>(Operations.SiblingVariantsDocument, variables, options) as Promise<SiblingVariantsQuery>;
    },
    Variant(variables: VariantQueryVariables, options?: C): Promise<VariantQuery> {
      return requester<VariantQuery, VariantQueryVariables>(Operations.VariantDocument, variables, options) as Promise<VariantQuery>;
    },
    Product(variables: ProductQueryVariables, options?: C): Promise<ProductQuery> {
      return requester<ProductQuery, ProductQueryVariables>(Operations.ProductDocument, variables, options) as Promise<ProductQuery>;
    },
    PDP(variables: PdpQueryVariables, options?: C): Promise<PdpQuery> {
      return requester<PdpQuery, PdpQueryVariables>(Operations.PdpDocument, variables, options) as Promise<PdpQuery>;
    },
    LazyPDP(variables: LazyPdpQueryVariables, options?: C): Promise<LazyPdpQuery> {
      return requester<LazyPdpQuery, LazyPdpQueryVariables>(Operations.LazyPdpDocument, variables, options) as Promise<LazyPdpQuery>;
    },
    ProductSizeChart(variables: ProductSizeChartQueryVariables, options?: C): Promise<ProductSizeChartQuery> {
      return requester<ProductSizeChartQuery, ProductSizeChartQueryVariables>(Operations.ProductSizeChartDocument, variables, options) as Promise<ProductSizeChartQuery>;
    },
    ProductScore(variables: ProductScoreQueryVariables, options?: C): Promise<ProductScoreQuery> {
      return requester<ProductScoreQuery, ProductScoreQueryVariables>(Operations.ProductScoreDocument, variables, options) as Promise<ProductScoreQuery>;
    },
    RecommendationsWithDetails(variables: RecommendationsWithDetailsQueryVariables, options?: C): Promise<RecommendationsWithDetailsQuery> {
      return requester<RecommendationsWithDetailsQuery, RecommendationsWithDetailsQueryVariables>(Operations.RecommendationsWithDetailsDocument, variables, options) as Promise<RecommendationsWithDetailsQuery>;
    },
    ProductReviews(variables: ProductReviewsQueryVariables, options?: C): Promise<ProductReviewsQuery> {
      return requester<ProductReviewsQuery, ProductReviewsQueryVariables>(Operations.ProductReviewsDocument, variables, options) as Promise<ProductReviewsQuery>;
    },
    TrendingSearchTerms(variables?: TrendingSearchTermsQueryVariables, options?: C): Promise<TrendingSearchTermsQuery> {
      return requester<TrendingSearchTermsQuery, TrendingSearchTermsQueryVariables>(Operations.TrendingSearchTermsDocument, variables, options) as Promise<TrendingSearchTermsQuery>;
    },
    SearchRecommendedProducts(variables?: SearchRecommendedProductsQueryVariables, options?: C): Promise<SearchRecommendedProductsQuery> {
      return requester<SearchRecommendedProductsQuery, SearchRecommendedProductsQueryVariables>(Operations.SearchRecommendedProductsDocument, variables, options) as Promise<SearchRecommendedProductsQuery>;
    },
    ProductSearch(variables: ProductSearchQueryVariables, options?: C): Promise<ProductSearchQuery> {
      return requester<ProductSearchQuery, ProductSearchQueryVariables>(Operations.ProductSearchDocument, variables, options) as Promise<ProductSearchQuery>;
    },
    Look(variables: LookQueryVariables, options?: C): Promise<LookQuery> {
      return requester<LookQuery, LookQueryVariables>(Operations.LookDocument, variables, options) as Promise<LookQuery>;
    },
    Suggestions(variables: SuggestionsQueryVariables, options?: C): Promise<SuggestionsQuery> {
      return requester<SuggestionsQuery, SuggestionsQueryVariables>(Operations.SuggestionsDocument, variables, options) as Promise<SuggestionsQuery>;
    },
    TermsAndConditionsConfigs(variables?: TermsAndConditionsConfigsQueryVariables, options?: C): Promise<TermsAndConditionsConfigsQuery> {
      return requester<TermsAndConditionsConfigsQuery, TermsAndConditionsConfigsQueryVariables>(Operations.TermsAndConditionsConfigsDocument, variables, options) as Promise<TermsAndConditionsConfigsQuery>;
    },
    UrlRedirect(variables: UrlRedirectQueryVariables, options?: C): Promise<UrlRedirectQuery> {
      return requester<UrlRedirectQuery, UrlRedirectQueryVariables>(Operations.UrlRedirectDocument, variables, options) as Promise<UrlRedirectQuery>;
    },
    WishList(variables?: WishListQueryVariables, options?: C): Promise<WishListQuery> {
      return requester<WishListQuery, WishListQueryVariables>(Operations.WishListDocument, variables, options) as Promise<WishListQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;